/*!
 * 
 *   IMPORTANT NOTE:
 * 
 *   Hello little developer! This file contains the theme's
 *   unminified Javascript. This file is not referenced in the
 *   theme.liquid. It is bundled here for your convenience.
 *   After making changes to this file, you will need to re-minify
 *   it, upload it, and then reference it in the "theme.liquid."
 * 
 *   We cannot provide support for customizations. If you get your
 *   leg torn off, or break everything on the night before launch,
 *   it's up to you to fix it. Using our theme with custom Javascript
 *   voids all warranties. Nevertheless, we are actively working to
 *   make our themes better for developers just like you. If you'd
 *   like to get in touch with us, we've setup a separate line:
 *   developers@fluorescent.co.
 * 
 */
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 61);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

    var arrayWithoutHoles = __webpack_require__(26);

    var iterableToArray = __webpack_require__(27);
    
    var unsupportedIterableToArray = __webpack_require__(28);
    
    var nonIterableSpread = __webpack_require__(29);
    
    function _toConsumableArray(arr) {
      return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
    }
    
    module.exports = _toConsumableArray;
    
    /***/ }),
    /* 1 */
    /***/ (function(module, exports, __webpack_require__) {
    
    var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
     * Flickity v2.2.2
     * Touch, responsive, flickable carousels
     *
     * Licensed GPLv3 for open source use
     * or Flickity Commercial License for commercial use
     *
     * https://flickity.metafizzy.co
     * Copyright 2015-2021 Metafizzy
     */
    
    ( function( window, factory ) {
      // universal module definition
      if ( true ) {
        // AMD
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
          __webpack_require__(6),
          __webpack_require__(40),
          __webpack_require__(42),
          __webpack_require__(43),
          __webpack_require__(44),
          __webpack_require__(45),
          __webpack_require__(46),
        ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
                    __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
                    (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
                    __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
      } else {}
    
    } )( window, function factory( Flickity ) {
      return Flickity;
    } );
    
    
    /***/ }),
    /* 2 */
    /***/ (function(module, exports) {
    
    function _defineProperty(obj, key, value) {
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }
    
      return obj;
    }
    
    module.exports = _defineProperty;
    
    /***/ }),
    /* 3 */
    /***/ (function(module, exports, __webpack_require__) {
    
    (function(window, factory) {
        var lazySizes = factory(window, window.document, Date);
        window.lazySizes = lazySizes;
        if( true && module.exports){
            module.exports = lazySizes;
        }
    }(typeof window != 'undefined' ?
          window : {}, function l(window, document, Date) { // Pass in the windoe Date function also for SSR because the Date class can be lost
        'use strict';
        /*jshint eqnull:true */
    
        var lazysizes, lazySizesCfg;
    
        (function(){
            var prop;
    
            var lazySizesDefaults = {
                lazyClass: 'lazyload',
                loadedClass: 'lazyloaded',
                loadingClass: 'lazyloading',
                preloadClass: 'lazypreload',
                errorClass: 'lazyerror',
                //strictClass: 'lazystrict',
                autosizesClass: 'lazyautosizes',
                srcAttr: 'data-src',
                srcsetAttr: 'data-srcset',
                sizesAttr: 'data-sizes',
                //preloadAfterLoad: false,
                minSize: 40,
                customMedia: {},
                init: true,
                expFactor: 1.5,
                hFac: 0.8,
                loadMode: 2,
                loadHidden: true,
                ricTimeout: 0,
                throttleDelay: 125,
            };
    
            lazySizesCfg = window.lazySizesConfig || window.lazysizesConfig || {};
    
            for(prop in lazySizesDefaults){
                if(!(prop in lazySizesCfg)){
                    lazySizesCfg[prop] = lazySizesDefaults[prop];
                }
            }
        })();
    
        if (!document || !document.getElementsByClassName) {
            return {
                init: function () {},
                cfg: lazySizesCfg,
                noSupport: true,
            };
        }
    
        var docElem = document.documentElement;
    
        var supportPicture = window.HTMLPictureElement;
    
        var _addEventListener = 'addEventListener';
    
        var _getAttribute = 'getAttribute';
    
        /**
         * Update to bind to window because 'this' becomes null during SSR
         * builds.
         */
        var addEventListener = window[_addEventListener].bind(window);
    
        var setTimeout = window.setTimeout;
    
        var requestAnimationFrame = window.requestAnimationFrame || setTimeout;
    
        var requestIdleCallback = window.requestIdleCallback;
    
        var regPicture = /^picture$/i;
    
        var loadEvents = ['load', 'error', 'lazyincluded', '_lazyloaded'];
    
        var regClassCache = {};
    
        var forEach = Array.prototype.forEach;
    
        var hasClass = function(ele, cls) {
            if(!regClassCache[cls]){
                regClassCache[cls] = new RegExp('(\\s|^)'+cls+'(\\s|$)');
            }
            return regClassCache[cls].test(ele[_getAttribute]('class') || '') && regClassCache[cls];
        };
    
        var addClass = function(ele, cls) {
            if (!hasClass(ele, cls)){
                ele.setAttribute('class', (ele[_getAttribute]('class') || '').trim() + ' ' + cls);
            }
        };
    
        var removeClass = function(ele, cls) {
            var reg;
            if ((reg = hasClass(ele,cls))) {
                ele.setAttribute('class', (ele[_getAttribute]('class') || '').replace(reg, ' '));
            }
        };
    
        var addRemoveLoadEvents = function(dom, fn, add){
            var action = add ? _addEventListener : 'removeEventListener';
            if(add){
                addRemoveLoadEvents(dom, fn);
            }
            loadEvents.forEach(function(evt){
                dom[action](evt, fn);
            });
        };
    
        var triggerEvent = function(elem, name, detail, noBubbles, noCancelable){
            var event = document.createEvent('Event');
    
            if(!detail){
                detail = {};
            }
    
            detail.instance = lazysizes;
    
            event.initEvent(name, !noBubbles, !noCancelable);
    
            event.detail = detail;
    
            elem.dispatchEvent(event);
            return event;
        };
    
        var updatePolyfill = function (el, full){
            var polyfill;
            if( !supportPicture && ( polyfill = (window.picturefill || lazySizesCfg.pf) ) ){
                if(full && full.src && !el[_getAttribute]('srcset')){
                    el.setAttribute('srcset', full.src);
                }
                polyfill({reevaluate: true, elements: [el]});
            } else if(full && full.src){
                el.src = full.src;
            }
        };
    
        var getCSS = function (elem, style){
            return (getComputedStyle(elem, null) || {})[style];
        };
    
        var getWidth = function(elem, parent, width){
            width = width || elem.offsetWidth;
    
            while(width < lazySizesCfg.minSize && parent && !elem._lazysizesWidth){
                width =  parent.offsetWidth;
                parent = parent.parentNode;
            }
    
            return width;
        };
    
        var rAF = (function(){
            var running, waiting;
            var firstFns = [];
            var secondFns = [];
            var fns = firstFns;
    
            var run = function(){
                var runFns = fns;
    
                fns = firstFns.length ? secondFns : firstFns;
    
                running = true;
                waiting = false;
    
                while(runFns.length){
                    runFns.shift()();
                }
    
                running = false;
            };
    
            var rafBatch = function(fn, queue){
                if(running && !queue){
                    fn.apply(this, arguments);
                } else {
                    fns.push(fn);
    
                    if(!waiting){
                        waiting = true;
                        (document.hidden ? setTimeout : requestAnimationFrame)(run);
                    }
                }
            };
    
            rafBatch._lsFlush = run;
    
            return rafBatch;
        })();
    
        var rAFIt = function(fn, simple){
            return simple ?
                function() {
                    rAF(fn);
                } :
                function(){
                    var that = this;
                    var args = arguments;
                    rAF(function(){
                        fn.apply(that, args);
                    });
                }
            ;
        };
    
        var throttle = function(fn){
            var running;
            var lastTime = 0;
            var gDelay = lazySizesCfg.throttleDelay;
            var rICTimeout = lazySizesCfg.ricTimeout;
            var run = function(){
                running = false;
                lastTime = Date.now();
                fn();
            };
            var idleCallback = requestIdleCallback && rICTimeout > 49 ?
                function(){
                    requestIdleCallback(run, {timeout: rICTimeout});
    
                    if(rICTimeout !== lazySizesCfg.ricTimeout){
                        rICTimeout = lazySizesCfg.ricTimeout;
                    }
                } :
                rAFIt(function(){
                    setTimeout(run);
                }, true)
            ;
    
            return function(isPriority){
                var delay;
    
                if((isPriority = isPriority === true)){
                    rICTimeout = 33;
                }
    
                if(running){
                    return;
                }
    
                running =  true;
    
                delay = gDelay - (Date.now() - lastTime);
    
                if(delay < 0){
                    delay = 0;
                }
    
                if(isPriority || delay < 9){
                    idleCallback();
                } else {
                    setTimeout(idleCallback, delay);
                }
            };
        };
    
        //based on http://modernjavascript.blogspot.de/2013/08/building-better-debounce.html
        var debounce = function(func) {
            var timeout, timestamp;
            var wait = 99;
            var run = function(){
                timeout = null;
                func();
            };
            var later = function() {
                var last = Date.now() - timestamp;
    
                if (last < wait) {
                    setTimeout(later, wait - last);
                } else {
                    (requestIdleCallback || run)(run);
                }
            };
    
            return function() {
                timestamp = Date.now();
    
                if (!timeout) {
                    timeout = setTimeout(later, wait);
                }
            };
        };
    
        var loader = (function(){
            var preloadElems, isCompleted, resetPreloadingTimer, loadMode, started;
    
            var eLvW, elvH, eLtop, eLleft, eLright, eLbottom, isBodyHidden;
    
            var regImg = /^img$/i;
            var regIframe = /^iframe$/i;
    
            var supportScroll = ('onscroll' in window) && !(/(gle|ing)bot/.test(navigator.userAgent));
    
            var shrinkExpand = 0;
            var currentExpand = 0;
    
            var isLoading = 0;
            var lowRuns = -1;
    
            var resetPreloading = function(e){
                isLoading--;
                if(!e || isLoading < 0 || !e.target){
                    isLoading = 0;
                }
            };
    
            var isVisible = function (elem) {
                if (isBodyHidden == null) {
                    isBodyHidden = getCSS(document.body, 'visibility') == 'hidden';
                }
    
                return isBodyHidden || !(getCSS(elem.parentNode, 'visibility') == 'hidden' && getCSS(elem, 'visibility') == 'hidden');
            };
    
            var isNestedVisible = function(elem, elemExpand){
                var outerRect;
                var parent = elem;
                var visible = isVisible(elem);
    
                eLtop -= elemExpand;
                eLbottom += elemExpand;
                eLleft -= elemExpand;
                eLright += elemExpand;
    
                while(visible && (parent = parent.offsetParent) && parent != document.body && parent != docElem){
                    visible = ((getCSS(parent, 'opacity') || 1) > 0);
    
                    if(visible && getCSS(parent, 'overflow') != 'visible'){
                        outerRect = parent.getBoundingClientRect();
                        visible = eLright > outerRect.left &&
                            eLleft < outerRect.right &&
                            eLbottom > outerRect.top - 1 &&
                            eLtop < outerRect.bottom + 1
                        ;
                    }
                }
    
                return visible;
            };
    
            var checkElements = function() {
                var eLlen, i, rect, autoLoadElem, loadedSomething, elemExpand, elemNegativeExpand, elemExpandVal,
                    beforeExpandVal, defaultExpand, preloadExpand, hFac;
                var lazyloadElems = lazysizes.elements;
    
                if((loadMode = lazySizesCfg.loadMode) && isLoading < 8 && (eLlen = lazyloadElems.length)){
    
                    i = 0;
    
                    lowRuns++;
    
                    for(; i < eLlen; i++){
    
                        if(!lazyloadElems[i] || lazyloadElems[i]._lazyRace){continue;}
    
                        if(!supportScroll || (lazysizes.prematureUnveil && lazysizes.prematureUnveil(lazyloadElems[i]))){unveilElement(lazyloadElems[i]);continue;}
    
                        if(!(elemExpandVal = lazyloadElems[i][_getAttribute]('data-expand')) || !(elemExpand = elemExpandVal * 1)){
                            elemExpand = currentExpand;
                        }
    
                        if (!defaultExpand) {
                            defaultExpand = (!lazySizesCfg.expand || lazySizesCfg.expand < 1) ?
                                docElem.clientHeight > 500 && docElem.clientWidth > 500 ? 500 : 370 :
                                lazySizesCfg.expand;
    
                            lazysizes._defEx = defaultExpand;
    
                            preloadExpand = defaultExpand * lazySizesCfg.expFactor;
                            hFac = lazySizesCfg.hFac;
                            isBodyHidden = null;
    
                            if(currentExpand < preloadExpand && isLoading < 1 && lowRuns > 2 && loadMode > 2 && !document.hidden){
                                currentExpand = preloadExpand;
                                lowRuns = 0;
                            } else if(loadMode > 1 && lowRuns > 1 && isLoading < 6){
                                currentExpand = defaultExpand;
                            } else {
                                currentExpand = shrinkExpand;
                            }
                        }
    
                        if(beforeExpandVal !== elemExpand){
                            eLvW = innerWidth + (elemExpand * hFac);
                            elvH = innerHeight + elemExpand;
                            elemNegativeExpand = elemExpand * -1;
                            beforeExpandVal = elemExpand;
                        }
    
                        rect = lazyloadElems[i].getBoundingClientRect();
    
                        if ((eLbottom = rect.bottom) >= elemNegativeExpand &&
                            (eLtop = rect.top) <= elvH &&
                            (eLright = rect.right) >= elemNegativeExpand * hFac &&
                            (eLleft = rect.left) <= eLvW &&
                            (eLbottom || eLright || eLleft || eLtop) &&
                            (lazySizesCfg.loadHidden || isVisible(lazyloadElems[i])) &&
                            ((isCompleted && isLoading < 3 && !elemExpandVal && (loadMode < 3 || lowRuns < 4)) || isNestedVisible(lazyloadElems[i], elemExpand))){
                            unveilElement(lazyloadElems[i]);
                            loadedSomething = true;
                            if(isLoading > 9){break;}
                        } else if(!loadedSomething && isCompleted && !autoLoadElem &&
                            isLoading < 4 && lowRuns < 4 && loadMode > 2 &&
                            (preloadElems[0] || lazySizesCfg.preloadAfterLoad) &&
                            (preloadElems[0] || (!elemExpandVal && ((eLbottom || eLright || eLleft || eLtop) || lazyloadElems[i][_getAttribute](lazySizesCfg.sizesAttr) != 'auto')))){
                            autoLoadElem = preloadElems[0] || lazyloadElems[i];
                        }
                    }
    
                    if(autoLoadElem && !loadedSomething){
                        unveilElement(autoLoadElem);
                    }
                }
            };
    
            var throttledCheckElements = throttle(checkElements);
    
            var switchLoadingClass = function(e){
                var elem = e.target;
    
                if (elem._lazyCache) {
                    delete elem._lazyCache;
                    return;
                }
    
                resetPreloading(e);
                addClass(elem, lazySizesCfg.loadedClass);
                removeClass(elem, lazySizesCfg.loadingClass);
                addRemoveLoadEvents(elem, rafSwitchLoadingClass);
                triggerEvent(elem, 'lazyloaded');
            };
            var rafedSwitchLoadingClass = rAFIt(switchLoadingClass);
            var rafSwitchLoadingClass = function(e){
                rafedSwitchLoadingClass({target: e.target});
            };
    
            var changeIframeSrc = function(elem, src){
                try {
                    elem.contentWindow.location.replace(src);
                } catch(e){
                    elem.src = src;
                }
            };
    
            var handleSources = function(source){
                var customMedia;
    
                var sourceSrcset = source[_getAttribute](lazySizesCfg.srcsetAttr);
    
                if( (customMedia = lazySizesCfg.customMedia[source[_getAttribute]('data-media') || source[_getAttribute]('media')]) ){
                    source.setAttribute('media', customMedia);
                }
    
                if(sourceSrcset){
                    source.setAttribute('srcset', sourceSrcset);
                }
            };
    
            var lazyUnveil = rAFIt(function (elem, detail, isAuto, sizes, isImg){
                var src, srcset, parent, isPicture, event, firesLoad;
    
                if(!(event = triggerEvent(elem, 'lazybeforeunveil', detail)).defaultPrevented){
    
                    if(sizes){
                        if(isAuto){
                            addClass(elem, lazySizesCfg.autosizesClass);
                        } else {
                            elem.setAttribute('sizes', sizes);
                        }
                    }
    
                    srcset = elem[_getAttribute](lazySizesCfg.srcsetAttr);
                    src = elem[_getAttribute](lazySizesCfg.srcAttr);
    
                    if(isImg) {
                        parent = elem.parentNode;
                        isPicture = parent && regPicture.test(parent.nodeName || '');
                    }
    
                    firesLoad = detail.firesLoad || (('src' in elem) && (srcset || src || isPicture));
    
                    event = {target: elem};
    
                    addClass(elem, lazySizesCfg.loadingClass);
    
                    if(firesLoad){
                        clearTimeout(resetPreloadingTimer);
                        resetPreloadingTimer = setTimeout(resetPreloading, 2500);
                        addRemoveLoadEvents(elem, rafSwitchLoadingClass, true);
                    }
    
                    if(isPicture){
                        forEach.call(parent.getElementsByTagName('source'), handleSources);
                    }
    
                    if(srcset){
                        elem.setAttribute('srcset', srcset);
                    } else if(src && !isPicture){
                        if(regIframe.test(elem.nodeName)){
                            changeIframeSrc(elem, src);
                        } else {
                            elem.src = src;
                        }
                    }
    
                    if(isImg && (srcset || isPicture)){
                        updatePolyfill(elem, {src: src});
                    }
                }
    
                if(elem._lazyRace){
                    delete elem._lazyRace;
                }
                removeClass(elem, lazySizesCfg.lazyClass);
    
                rAF(function(){
                    // Part of this can be removed as soon as this fix is older: https://bugs.chromium.org/p/chromium/issues/detail?id=7731 (2015)
                    var isLoaded = elem.complete && elem.naturalWidth > 1;
    
                    if( !firesLoad || isLoaded){
                        if (isLoaded) {
                            addClass(elem, 'ls-is-cached');
                        }
                        switchLoadingClass(event);
                        elem._lazyCache = true;
                        setTimeout(function(){
                            if ('_lazyCache' in elem) {
                                delete elem._lazyCache;
                            }
                        }, 9);
                    }
                    if (elem.loading == 'lazy') {
                        isLoading--;
                    }
                }, true);
            });
    
            var unveilElement = function (elem){
                if (elem._lazyRace) {return;}
                var detail;
    
                var isImg = regImg.test(elem.nodeName);
    
                //allow using sizes="auto", but don't use. it's invalid. Use data-sizes="auto" or a valid value for sizes instead (i.e.: sizes="80vw")
                var sizes = isImg && (elem[_getAttribute](lazySizesCfg.sizesAttr) || elem[_getAttribute]('sizes'));
                var isAuto = sizes == 'auto';
    
                if( (isAuto || !isCompleted) && isImg && (elem[_getAttribute]('src') || elem.srcset) && !elem.complete && !hasClass(elem, lazySizesCfg.errorClass) && hasClass(elem, lazySizesCfg.lazyClass)){return;}
    
                detail = triggerEvent(elem, 'lazyunveilread').detail;
    
                if(isAuto){
                     autoSizer.updateElem(elem, true, elem.offsetWidth);
                }
    
                elem._lazyRace = true;
                isLoading++;
    
                lazyUnveil(elem, detail, isAuto, sizes, isImg);
            };
    
            var afterScroll = debounce(function(){
                lazySizesCfg.loadMode = 3;
                throttledCheckElements();
            });
    
            var altLoadmodeScrollListner = function(){
                if(lazySizesCfg.loadMode == 3){
                    lazySizesCfg.loadMode = 2;
                }
                afterScroll();
            };
    
            var onload = function(){
                if(isCompleted){return;}
                if(Date.now() - started < 999){
                    setTimeout(onload, 999);
                    return;
                }
    
    
                isCompleted = true;
    
                lazySizesCfg.loadMode = 3;
    
                throttledCheckElements();
    
                addEventListener('scroll', altLoadmodeScrollListner, true);
            };
    
            return {
                _: function(){
                    started = Date.now();
    
                    lazysizes.elements = document.getElementsByClassName(lazySizesCfg.lazyClass);
                    preloadElems = document.getElementsByClassName(lazySizesCfg.lazyClass + ' ' + lazySizesCfg.preloadClass);
    
                    addEventListener('scroll', throttledCheckElements, true);
    
                    addEventListener('resize', throttledCheckElements, true);
    
                    addEventListener('pageshow', function (e) {
                        if (e.persisted) {
                            var loadingElements = document.querySelectorAll('.' + lazySizesCfg.loadingClass);
    
                            if (loadingElements.length && loadingElements.forEach) {
                                requestAnimationFrame(function () {
                                    loadingElements.forEach( function (img) {
                                        if (img.complete) {
                                            unveilElement(img);
                                        }
                                    });
                                });
                            }
                        }
                    });
    
                    if(window.MutationObserver){
                        new MutationObserver( throttledCheckElements ).observe( docElem, {childList: true, subtree: true, attributes: true} );
                    } else {
                        docElem[_addEventListener]('DOMNodeInserted', throttledCheckElements, true);
                        docElem[_addEventListener]('DOMAttrModified', throttledCheckElements, true);
                        setInterval(throttledCheckElements, 999);
                    }
    
                    addEventListener('hashchange', throttledCheckElements, true);
    
                    //, 'fullscreenchange'
                    ['focus', 'mouseover', 'click', 'load', 'transitionend', 'animationend'].forEach(function(name){
                        document[_addEventListener](name, throttledCheckElements, true);
                    });
    
                    if((/d$|^c/.test(document.readyState))){
                        onload();
                    } else {
                        addEventListener('load', onload);
                        document[_addEventListener]('DOMContentLoaded', throttledCheckElements);
                        setTimeout(onload, 20000);
                    }
    
                    if(lazysizes.elements.length){
                        checkElements();
                        rAF._lsFlush();
                    } else {
                        throttledCheckElements();
                    }
                },
                checkElems: throttledCheckElements,
                unveil: unveilElement,
                _aLSL: altLoadmodeScrollListner,
            };
        })();
    
    
        var autoSizer = (function(){
            var autosizesElems;
    
            var sizeElement = rAFIt(function(elem, parent, event, width){
                var sources, i, len;
                elem._lazysizesWidth = width;
                width += 'px';
    
                elem.setAttribute('sizes', width);
    
                if(regPicture.test(parent.nodeName || '')){
                    sources = parent.getElementsByTagName('source');
                    for(i = 0, len = sources.length; i < len; i++){
                        sources[i].setAttribute('sizes', width);
                    }
                }
    
                if(!event.detail.dataAttr){
                    updatePolyfill(elem, event.detail);
                }
            });
            var getSizeElement = function (elem, dataAttr, width){
                var event;
                var parent = elem.parentNode;
    
                if(parent){
                    width = getWidth(elem, parent, width);
                    event = triggerEvent(elem, 'lazybeforesizes', {width: width, dataAttr: !!dataAttr});
    
                    if(!event.defaultPrevented){
                        width = event.detail.width;
    
                        if(width && width !== elem._lazysizesWidth){
                            sizeElement(elem, parent, event, width);
                        }
                    }
                }
            };
    
            var updateElementsSizes = function(){
                var i;
                var len = autosizesElems.length;
                if(len){
                    i = 0;
    
                    for(; i < len; i++){
                        getSizeElement(autosizesElems[i]);
                    }
                }
            };
    
            var debouncedUpdateElementsSizes = debounce(updateElementsSizes);
    
            return {
                _: function(){
                    autosizesElems = document.getElementsByClassName(lazySizesCfg.autosizesClass);
                    addEventListener('resize', debouncedUpdateElementsSizes);
                },
                checkElems: debouncedUpdateElementsSizes,
                updateElem: getSizeElement
            };
        })();
    
        var init = function(){
            if(!init.i && document.getElementsByClassName){
                init.i = true;
                autoSizer._();
                loader._();
            }
        };
    
        setTimeout(function(){
            if(lazySizesCfg.init){
                init();
            }
        });
    
        lazysizes = {
            cfg: lazySizesCfg,
            autoSizer: autoSizer,
            loader: loader,
            init: init,
            uP: updatePolyfill,
            aC: addClass,
            rC: removeClass,
            hC: hasClass,
            fire: triggerEvent,
            gW: getWidth,
            rAF: rAF,
        };
    
        return lazysizes;
    }
    ));
    
    
    /***/ }),
    /* 4 */
    /***/ (function(module, exports, __webpack_require__) {
    
    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
     * Fizzy UI utils v2.0.7
     * MIT license
     */
    
    /*jshint browser: true, undef: true, unused: true, strict: true */
    
    ( function( window, factory ) {
      // universal module definition
      /*jshint strict: false */ /*globals define, module, require */
    
      if ( true ) {
        // AMD
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
          __webpack_require__(36)
        ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( matchesSelector ) {
          return factory( window, matchesSelector );
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
                    __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
      } else {}
    
    }( window, function factory( window, matchesSelector ) {
    
    'use strict';
    
    var utils = {};
    
    // ----- extend ----- //
    
    // extends objects
    utils.extend = function( a, b ) {
      for ( var prop in b ) {
        a[ prop ] = b[ prop ];
      }
      return a;
    };
    
    // ----- modulo ----- //
    
    utils.modulo = function( num, div ) {
      return ( ( num % div ) + div ) % div;
    };
    
    // ----- makeArray ----- //
    
    var arraySlice = Array.prototype.slice;
    
    // turn element or nodeList into an array
    utils.makeArray = function( obj ) {
      if ( Array.isArray( obj ) ) {
        // use object if already an array
        return obj;
      }
      // return empty array if undefined or null. #6
      if ( obj === null || obj === undefined ) {
        return [];
      }
    
      var isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
      if ( isArrayLike ) {
        // convert nodeList to array
        return arraySlice.call( obj );
      }
    
      // array of single index
      return [ obj ];
    };
    
    // ----- removeFrom ----- //
    
    utils.removeFrom = function( ary, obj ) {
      var index = ary.indexOf( obj );
      if ( index != -1 ) {
        ary.splice( index, 1 );
      }
    };
    
    // ----- getParent ----- //
    
    utils.getParent = function( elem, selector ) {
      while ( elem.parentNode && elem != document.body ) {
        elem = elem.parentNode;
        if ( matchesSelector( elem, selector ) ) {
          return elem;
        }
      }
    };
    
    // ----- getQueryElement ----- //
    
    // use element as selector string
    utils.getQueryElement = function( elem ) {
      if ( typeof elem == 'string' ) {
        return document.querySelector( elem );
      }
      return elem;
    };
    
    // ----- handleEvent ----- //
    
    // enable .ontype to trigger from .addEventListener( elem, 'type' )
    utils.handleEvent = function( event ) {
      var method = 'on' + event.type;
      if ( this[ method ] ) {
        this[ method ]( event );
      }
    };
    
    // ----- filterFindElements ----- //
    
    utils.filterFindElements = function( elems, selector ) {
      // make array of elems
      elems = utils.makeArray( elems );
      var ffElems = [];
    
      elems.forEach( function( elem ) {
        // check that elem is an actual element
        if ( !( elem instanceof HTMLElement ) ) {
          return;
        }
        // add elem if no selector
        if ( !selector ) {
          ffElems.push( elem );
          return;
        }
        // filter & find items if we have a selector
        // filter
        if ( matchesSelector( elem, selector ) ) {
          ffElems.push( elem );
        }
        // find children
        var childElems = elem.querySelectorAll( selector );
        // concat childElems to filterFound array
        for ( var i=0; i < childElems.length; i++ ) {
          ffElems.push( childElems[i] );
        }
      });
    
      return ffElems;
    };
    
    // ----- debounceMethod ----- //
    
    utils.debounceMethod = function( _class, methodName, threshold ) {
      threshold = threshold || 100;
      // original method
      var method = _class.prototype[ methodName ];
      var timeoutName = methodName + 'Timeout';
    
      _class.prototype[ methodName ] = function() {
        var timeout = this[ timeoutName ];
        clearTimeout( timeout );
    
        var args = arguments;
        var _this = this;
        this[ timeoutName ] = setTimeout( function() {
          method.apply( _this, args );
          delete _this[ timeoutName ];
        }, threshold );
      };
    };
    
    // ----- docReady ----- //
    
    utils.docReady = function( callback ) {
      var readyState = document.readyState;
      if ( readyState == 'complete' || readyState == 'interactive' ) {
        // do async to allow for other scripts to run. metafizzy/flickity#441
        setTimeout( callback );
      } else {
        document.addEventListener( 'DOMContentLoaded', callback );
      }
    };
    
    // ----- htmlInit ----- //
    
    // http://jamesroberts.name/blog/2010/02/22/string-functions-for-javascript-trim-to-camel-case-to-dashed-and-to-underscore/
    utils.toDashed = function( str ) {
      return str.replace( /(.)([A-Z])/g, function( match, $1, $2 ) {
        return $1 + '-' + $2;
      }).toLowerCase();
    };
    
    var console = window.console;
    /**
     * allow user to initialize classes via [data-namespace] or .js-namespace class
     * htmlInit( Widget, 'widgetName' )
     * options are parsed from data-namespace-options
     */
    utils.htmlInit = function( WidgetClass, namespace ) {
      utils.docReady( function() {
        var dashedNamespace = utils.toDashed( namespace );
        var dataAttr = 'data-' + dashedNamespace;
        var dataAttrElems = document.querySelectorAll( '[' + dataAttr + ']' );
        var jsDashElems = document.querySelectorAll( '.js-' + dashedNamespace );
        var elems = utils.makeArray( dataAttrElems )
          .concat( utils.makeArray( jsDashElems ) );
        var dataOptionsAttr = dataAttr + '-options';
        var jQuery = window.jQuery;
    
        elems.forEach( function( elem ) {
          var attr = elem.getAttribute( dataAttr ) ||
            elem.getAttribute( dataOptionsAttr );
          var options;
          try {
            options = attr && JSON.parse( attr );
          } catch ( error ) {
            // log error, do not initialize
            if ( console ) {
              console.error( 'Error parsing ' + dataAttr + ' on ' + elem.className +
              ': ' + error );
            }
            return;
          }
          // initialize
          var instance = new WidgetClass( elem, options );
          // make available via $().data('namespace')
          if ( jQuery ) {
            jQuery.data( elem, namespace, instance );
          }
        });
    
      });
    };
    
    // -----  ----- //
    
    return utils;
    
    }));
    
    
    /***/ }),
    /* 5 */
    /***/ (function(module, exports, __webpack_require__) {
    
    "use strict";
    
    
    module.exports = isMobile
    module.exports.isMobile = isMobile
    module.exports.default = isMobile
    
    var mobileRE = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i
    
    var tabletRE = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino|android|ipad|playbook|silk/i
    
    function isMobile (opts) {
      if (!opts) opts = {}
      var ua = opts.ua
      if (!ua && typeof navigator !== 'undefined') ua = navigator.userAgent
      if (ua && ua.headers && typeof ua.headers['user-agent'] === 'string') {
        ua = ua.headers['user-agent']
      }
      if (typeof ua !== 'string') return false
    
      var result = opts.tablet ? tabletRE.test(ua) : mobileRE.test(ua)
    
      if (
        !result &&
        opts.tablet &&
        opts.featureDetect &&
        navigator &&
        navigator.maxTouchPoints > 1 &&
        ua.indexOf('Macintosh') !== -1 &&
        ua.indexOf('Safari') !== -1
      ) {
        result = true
      }
    
      return result
    }
    
    
    /***/ }),
    /* 6 */
    /***/ (function(module, exports, __webpack_require__) {
    
    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Flickity main
    /* eslint-disable max-params */
    ( function( window, factory ) {
      // universal module definition
      if ( true ) {
        // AMD
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
          __webpack_require__(12),
          __webpack_require__(18),
          __webpack_require__(4),
          __webpack_require__(37),
          __webpack_require__(38),
          __webpack_require__(39),
        ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( EvEmitter, getSize, utils, Cell, Slide, animatePrototype ) {
          return factory( window, EvEmitter, getSize, utils, Cell, Slide, animatePrototype );
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
                    __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
      } else { var _Flickity; }
    
    }( window, function factory( window, EvEmitter, getSize,
        utils, Cell, Slide, animatePrototype ) {
    
    /* eslint-enable max-params */
    'use strict';
    
    // vars
    var jQuery = window.jQuery;
    var getComputedStyle = window.getComputedStyle;
    var console = window.console;
    
    function moveElements( elems, toElem ) {
      elems = utils.makeArray( elems );
      while ( elems.length ) {
        toElem.appendChild( elems.shift() );
      }
    }
    
    // -------------------------- Flickity -------------------------- //
    
    // globally unique identifiers
    var GUID = 0;
    // internal store of all Flickity intances
    var instances = {};
    
    function Flickity( element, options ) {
      var queryElement = utils.getQueryElement( element );
      if ( !queryElement ) {
        if ( console ) {
          console.error( 'Bad element for Flickity: ' + ( queryElement || element ) );
        }
        return;
      }
      this.element = queryElement;
      // do not initialize twice on same element
      if ( this.element.flickityGUID ) {
        var instance = instances[ this.element.flickityGUID ];
        if ( instance ) instance.option( options );
        return instance;
      }
    
      // add jQuery
      if ( jQuery ) {
        this.$element = jQuery( this.element );
      }
      // options
      this.options = utils.extend( {}, this.constructor.defaults );
      this.option( options );
    
      // kick things off
      this._create();
    }
    
    Flickity.defaults = {
      accessibility: true,
      // adaptiveHeight: false,
      cellAlign: 'center',
      // cellSelector: undefined,
      // contain: false,
      freeScrollFriction: 0.075, // friction when free-scrolling
      friction: 0.28, // friction when selecting
      namespaceJQueryEvents: true,
      // initialIndex: 0,
      percentPosition: true,
      resize: true,
      selectedAttraction: 0.025,
      setGallerySize: true,
      wrapAround: true,
      // watchCSS: false
    };
    
    // hash of methods triggered on _create()
    Flickity.createMethods = [];
    
    var proto = Flickity.prototype;
    // inherit EventEmitter
    utils.extend( proto, EvEmitter.prototype );
    
    proto._create = function() {
      // add id for Flickity.data
      var id = this.guid = ++GUID;
      this.element.flickityGUID = id; // expando
      instances[ id ] = this; // associate via id
      // initial properties
      this.selectedIndex = 0;
      // how many frames slider has been in same position
      this.restingFrames = 0;
      // initial physics properties
      this.x = 0;
      this.velocity = 0;
      this.originSide = this.options.rightToLeft ? 'right' : 'left';
      // create viewport & slider
      this.viewport = document.createElement('div');
      this.viewport.className = 'flickity-viewport';
      this._createSlider();
    
      if ( this.options.resize || this.options.watchCSS ) {
        window.addEventListener( 'resize', this );
      }
    
      // add listeners from on option
      for ( var eventName in this.options.on ) {
        var listener = this.options.on[ eventName ];
        this.on( eventName, listener );
      }
    
      Flickity.createMethods.forEach( function( method ) {
        this[ method ]();
      }, this );
    
      if ( this.options.watchCSS ) {
        this.watchCSS();
      } else {
        this.activate();
      }
    
    };
    
    /**
     * set options
     * @param {Object} opts - options to extend
     */
    proto.option = function( opts ) {
      utils.extend( this.options, opts );
    };
    
    proto.activate = function() {
      if ( this.isActive ) {
        return;
      }
      this.isActive = true;
      this.element.classList.add('flickity-enabled');
      if ( this.options.rightToLeft ) {
        this.element.classList.add('flickity-rtl');
      }
    
      this.getSize();
      // move initial cell elements so they can be loaded as cells
      var cellElems = this._filterFindCellElements( this.element.children );
      moveElements( cellElems, this.slider );
      this.viewport.appendChild( this.slider );
      this.element.appendChild( this.viewport );
      // get cells from children
      this.reloadCells();
    
      if ( this.options.accessibility ) {
        // allow element to focusable
        this.element.tabIndex = 0;
        // listen for key presses
        this.element.addEventListener( 'keydown', this );
      }
    
      this.emitEvent('activate');
      this.selectInitialIndex();
      // flag for initial activation, for using initialIndex
      this.isInitActivated = true;
      // ready event. #493
      this.dispatchEvent('ready');
    };
    
    // slider positions the cells
    proto._createSlider = function() {
      // slider element does all the positioning
      var slider = document.createElement('div');
      slider.className = 'flickity-slider';
      slider.style[ this.originSide ] = 0;
      this.slider = slider;
    };
    
    proto._filterFindCellElements = function( elems ) {
      return utils.filterFindElements( elems, this.options.cellSelector );
    };
    
    // goes through all children
    proto.reloadCells = function() {
      // collection of item elements
      this.cells = this._makeCells( this.slider.children );
      this.positionCells();
      this._getWrapShiftCells();
      this.setGallerySize();
    };
    
    /**
     * turn elements into Flickity.Cells
     * @param {[Array, NodeList, HTMLElement]} elems - elements to make into cells
     * @returns {Array} items - collection of new Flickity Cells
     */
    proto._makeCells = function( elems ) {
      var cellElems = this._filterFindCellElements( elems );
    
      // create new Flickity for collection
      var cells = cellElems.map( function( cellElem ) {
        return new Cell( cellElem, this );
      }, this );
    
      return cells;
    };
    
    proto.getLastCell = function() {
      return this.cells[ this.cells.length - 1 ];
    };
    
    proto.getLastSlide = function() {
      return this.slides[ this.slides.length - 1 ];
    };
    
    // positions all cells
    proto.positionCells = function() {
      // size all cells
      this._sizeCells( this.cells );
      // position all cells
      this._positionCells( 0 );
    };
    
    /**
     * position certain cells
     * @param {Integer} index - which cell to start with
     */
    proto._positionCells = function( index ) {
      index = index || 0;
      // also measure maxCellHeight
      // start 0 if positioning all cells
      this.maxCellHeight = index ? this.maxCellHeight || 0 : 0;
      var cellX = 0;
      // get cellX
      if ( index > 0 ) {
        var startCell = this.cells[ index - 1 ];
        cellX = startCell.x + startCell.size.outerWidth;
      }
      var len = this.cells.length;
      for ( var i = index; i < len; i++ ) {
        var cell = this.cells[i];
        cell.setPosition( cellX );
        cellX += cell.size.outerWidth;
        this.maxCellHeight = Math.max( cell.size.outerHeight, this.maxCellHeight );
      }
      // keep track of cellX for wrap-around
      this.slideableWidth = cellX;
      // slides
      this.updateSlides();
      // contain slides target
      this._containSlides();
      // update slidesWidth
      this.slidesWidth = len ? this.getLastSlide().target - this.slides[0].target : 0;
    };
    
    /**
     * cell.getSize() on multiple cells
     * @param {Array} cells - cells to size
     */
    proto._sizeCells = function( cells ) {
      cells.forEach( function( cell ) {
        cell.getSize();
      } );
    };
    
    // --------------------------  -------------------------- //
    
    proto.updateSlides = function() {
      this.slides = [];
      if ( !this.cells.length ) {
        return;
      }
    
      var slide = new Slide( this );
      this.slides.push( slide );
      var isOriginLeft = this.originSide == 'left';
      var nextMargin = isOriginLeft ? 'marginRight' : 'marginLeft';
    
      var canCellFit = this._getCanCellFit();
    
      this.cells.forEach( function( cell, i ) {
        // just add cell if first cell in slide
        if ( !slide.cells.length ) {
          slide.addCell( cell );
          return;
        }
    
        var slideWidth = ( slide.outerWidth - slide.firstMargin ) +
          ( cell.size.outerWidth - cell.size[ nextMargin ] );
    
        if ( canCellFit.call( this, i, slideWidth ) ) {
          slide.addCell( cell );
        } else {
          // doesn't fit, new slide
          slide.updateTarget();
    
          slide = new Slide( this );
          this.slides.push( slide );
          slide.addCell( cell );
        }
      }, this );
      // last slide
      slide.updateTarget();
      // update .selectedSlide
      this.updateSelectedSlide();
    };
    
    proto._getCanCellFit = function() {
      var groupCells = this.options.groupCells;
      if ( !groupCells ) {
        return function() {
          return false;
        };
      } else if ( typeof groupCells == 'number' ) {
        // group by number. 3 -> [0,1,2], [3,4,5], ...
        var number = parseInt( groupCells, 10 );
        return function( i ) {
          return ( i % number ) !== 0;
        };
      }
      // default, group by width of slide
      // parse '75%
      var percentMatch = typeof groupCells == 'string' &&
        groupCells.match( /^(\d+)%$/ );
      var percent = percentMatch ? parseInt( percentMatch[1], 10 ) / 100 : 1;
      return function( i, slideWidth ) {
        /* eslint-disable-next-line no-invalid-this */
        return slideWidth <= ( this.size.innerWidth + 1 ) * percent;
      };
    };
    
    // alias _init for jQuery plugin .flickity()
    proto._init =
    proto.reposition = function() {
      this.positionCells();
      this.positionSliderAtSelected();
    };
    
    proto.getSize = function() {
      this.size = getSize( this.element );
      this.setCellAlign();
      this.cursorPosition = this.size.innerWidth * this.cellAlign;
    };
    
    var cellAlignShorthands = {
      // cell align, then based on origin side
      center: {
        left: 0.5,
        right: 0.5,
      },
      left: {
        left: 0,
        right: 1,
      },
      right: {
        right: 0,
        left: 1,
      },
    };
    
    proto.setCellAlign = function() {
      var shorthand = cellAlignShorthands[ this.options.cellAlign ];
      this.cellAlign = shorthand ? shorthand[ this.originSide ] : this.options.cellAlign;
    };
    
    proto.setGallerySize = function() {
      if ( this.options.setGallerySize ) {
        var height = this.options.adaptiveHeight && this.selectedSlide ?
          this.selectedSlide.height : this.maxCellHeight;
        this.viewport.style.height = height + 'px';
      }
    };
    
    proto._getWrapShiftCells = function() {
      // only for wrap-around
      if ( !this.options.wrapAround ) {
        return;
      }
      // unshift previous cells
      this._unshiftCells( this.beforeShiftCells );
      this._unshiftCells( this.afterShiftCells );
      // get before cells
      // initial gap
      var gapX = this.cursorPosition;
      var cellIndex = this.cells.length - 1;
      this.beforeShiftCells = this._getGapCells( gapX, cellIndex, -1 );
      // get after cells
      // ending gap between last cell and end of gallery viewport
      gapX = this.size.innerWidth - this.cursorPosition;
      // start cloning at first cell, working forwards
      this.afterShiftCells = this._getGapCells( gapX, 0, 1 );
    };
    
    proto._getGapCells = function( gapX, cellIndex, increment ) {
      // keep adding cells until the cover the initial gap
      var cells = [];
      while ( gapX > 0 ) {
        var cell = this.cells[ cellIndex ];
        if ( !cell ) {
          break;
        }
        cells.push( cell );
        cellIndex += increment;
        gapX -= cell.size.outerWidth;
      }
      return cells;
    };
    
    // ----- contain ----- //
    
    // contain cell targets so no excess sliding
    proto._containSlides = function() {
      if ( !this.options.contain || this.options.wrapAround || !this.cells.length ) {
        return;
      }
      var isRightToLeft = this.options.rightToLeft;
      var beginMargin = isRightToLeft ? 'marginRight' : 'marginLeft';
      var endMargin = isRightToLeft ? 'marginLeft' : 'marginRight';
      var contentWidth = this.slideableWidth - this.getLastCell().size[ endMargin ];
      // content is less than gallery size
      var isContentSmaller = contentWidth < this.size.innerWidth;
      // bounds
      var beginBound = this.cursorPosition + this.cells[0].size[ beginMargin ];
      var endBound = contentWidth - this.size.innerWidth * ( 1 - this.cellAlign );
      // contain each cell target
      this.slides.forEach( function( slide ) {
        if ( isContentSmaller ) {
          // all cells fit inside gallery
          slide.target = contentWidth * this.cellAlign;
        } else {
          // contain to bounds
          slide.target = Math.max( slide.target, beginBound );
          slide.target = Math.min( slide.target, endBound );
        }
      }, this );
    };
    
    // -----  ----- //
    
    /**
     * emits events via eventEmitter and jQuery events
     * @param {String} type - name of event
     * @param {Event} event - original event
     * @param {Array} args - extra arguments
     */
    proto.dispatchEvent = function( type, event, args ) {
      var emitArgs = event ? [ event ].concat( args ) : args;
      this.emitEvent( type, emitArgs );
    
      if ( jQuery && this.$element ) {
        // default trigger with type if no event
        type += this.options.namespaceJQueryEvents ? '.flickity' : '';
        var $event = type;
        if ( event ) {
          // create jQuery event
          var jQEvent = new jQuery.Event( event );
          jQEvent.type = type;
          $event = jQEvent;
        }
        this.$element.trigger( $event, args );
      }
    };
    
    // -------------------------- select -------------------------- //
    
    /**
     * @param {Integer} index - index of the slide
     * @param {Boolean} isWrap - will wrap-around to last/first if at the end
     * @param {Boolean} isInstant - will immediately set position at selected cell
     */
    proto.select = function( index, isWrap, isInstant ) {
      if ( !this.isActive ) {
        return;
      }
      index = parseInt( index, 10 );
      this._wrapSelect( index );
    
      if ( this.options.wrapAround || isWrap ) {
        index = utils.modulo( index, this.slides.length );
      }
      // bail if invalid index
      if ( !this.slides[ index ] ) {
        return;
      }
      var prevIndex = this.selectedIndex;
      this.selectedIndex = index;
      this.updateSelectedSlide();
      if ( isInstant ) {
        this.positionSliderAtSelected();
      } else {
        this.startAnimation();
      }
      if ( this.options.adaptiveHeight ) {
        this.setGallerySize();
      }
      // events
      this.dispatchEvent( 'select', null, [ index ] );
      // change event if new index
      if ( index != prevIndex ) {
        this.dispatchEvent( 'change', null, [ index ] );
      }
      // old v1 event name, remove in v3
      this.dispatchEvent('cellSelect');
    };
    
    // wraps position for wrapAround, to move to closest slide. #113
    proto._wrapSelect = function( index ) {
      var len = this.slides.length;
      var isWrapping = this.options.wrapAround && len > 1;
      if ( !isWrapping ) {
        return index;
      }
      var wrapIndex = utils.modulo( index, len );
      // go to shortest
      var delta = Math.abs( wrapIndex - this.selectedIndex );
      var backWrapDelta = Math.abs( ( wrapIndex + len ) - this.selectedIndex );
      var forewardWrapDelta = Math.abs( ( wrapIndex - len ) - this.selectedIndex );
      if ( !this.isDragSelect && backWrapDelta < delta ) {
        index += len;
      } else if ( !this.isDragSelect && forewardWrapDelta < delta ) {
        index -= len;
      }
      // wrap position so slider is within normal area
      if ( index < 0 ) {
        this.x -= this.slideableWidth;
      } else if ( index >= len ) {
        this.x += this.slideableWidth;
      }
    };
    
    proto.previous = function( isWrap, isInstant ) {
      this.select( this.selectedIndex - 1, isWrap, isInstant );
    };
    
    proto.next = function( isWrap, isInstant ) {
      this.select( this.selectedIndex + 1, isWrap, isInstant );
    };
    
    proto.updateSelectedSlide = function() {
      var slide = this.slides[ this.selectedIndex ];
      // selectedIndex could be outside of slides, if triggered before resize()
      if ( !slide ) {
        return;
      }
      // unselect previous selected slide
      this.unselectSelectedSlide();
      // update new selected slide
      this.selectedSlide = slide;
      slide.select();
      this.selectedCells = slide.cells;
      this.selectedElements = slide.getCellElements();
      // HACK: selectedCell & selectedElement is first cell in slide, backwards compatibility
      // Remove in v3?
      this.selectedCell = slide.cells[0];
      this.selectedElement = this.selectedElements[0];
    };
    
    proto.unselectSelectedSlide = function() {
      if ( this.selectedSlide ) {
        this.selectedSlide.unselect();
      }
    };
    
    proto.selectInitialIndex = function() {
      var initialIndex = this.options.initialIndex;
      // already activated, select previous selectedIndex
      if ( this.isInitActivated ) {
        this.select( this.selectedIndex, false, true );
        return;
      }
      // select with selector string
      if ( initialIndex && typeof initialIndex == 'string' ) {
        var cell = this.queryCell( initialIndex );
        if ( cell ) {
          this.selectCell( initialIndex, false, true );
          return;
        }
      }
    
      var index = 0;
      // select with number
      if ( initialIndex && this.slides[ initialIndex ] ) {
        index = initialIndex;
      }
      // select instantly
      this.select( index, false, true );
    };
    
    /**
     * select slide from number or cell element
     * @param {[Element, Number]} value - zero-based index or element to select
     * @param {Boolean} isWrap - enables wrapping around for extra index
     * @param {Boolean} isInstant - disables slide animation
     */
    proto.selectCell = function( value, isWrap, isInstant ) {
      // get cell
      var cell = this.queryCell( value );
      if ( !cell ) {
        return;
      }
    
      var index = this.getCellSlideIndex( cell );
      this.select( index, isWrap, isInstant );
    };
    
    proto.getCellSlideIndex = function( cell ) {
      // get index of slides that has cell
      for ( var i = 0; i < this.slides.length; i++ ) {
        var slide = this.slides[i];
        var index = slide.cells.indexOf( cell );
        if ( index != -1 ) {
          return i;
        }
      }
    };
    
    // -------------------------- get cells -------------------------- //
    
    /**
     * get Flickity.Cell, given an Element
     * @param {Element} elem - matching cell element
     * @returns {Flickity.Cell} cell - matching cell
     */
    proto.getCell = function( elem ) {
      // loop through cells to get the one that matches
      for ( var i = 0; i < this.cells.length; i++ ) {
        var cell = this.cells[i];
        if ( cell.element == elem ) {
          return cell;
        }
      }
    };
    
    /**
     * get collection of Flickity.Cells, given Elements
     * @param {[Element, Array, NodeList]} elems - multiple elements
     * @returns {Array} cells - Flickity.Cells
     */
    proto.getCells = function( elems ) {
      elems = utils.makeArray( elems );
      var cells = [];
      elems.forEach( function( elem ) {
        var cell = this.getCell( elem );
        if ( cell ) {
          cells.push( cell );
        }
      }, this );
      return cells;
    };
    
    /**
     * get cell elements
     * @returns {Array} cellElems
     */
    proto.getCellElements = function() {
      return this.cells.map( function( cell ) {
        return cell.element;
      } );
    };
    
    /**
     * get parent cell from an element
     * @param {Element} elem - child element
     * @returns {Flickit.Cell} cell - parent cell
     */
    proto.getParentCell = function( elem ) {
      // first check if elem is cell
      var cell = this.getCell( elem );
      if ( cell ) {
        return cell;
      }
      // try to get parent cell elem
      elem = utils.getParent( elem, '.flickity-slider > *' );
      return this.getCell( elem );
    };
    
    /**
     * get cells adjacent to a slide
     * @param {Integer} adjCount - number of adjacent slides
     * @param {Integer} index - index of slide to start
     * @returns {Array} cells - array of Flickity.Cells
     */
    proto.getAdjacentCellElements = function( adjCount, index ) {
      if ( !adjCount ) {
        return this.selectedSlide.getCellElements();
      }
      index = index === undefined ? this.selectedIndex : index;
    
      var len = this.slides.length;
      if ( 1 + ( adjCount * 2 ) >= len ) {
        return this.getCellElements();
      }
    
      var cellElems = [];
      for ( var i = index - adjCount; i <= index + adjCount; i++ ) {
        var slideIndex = this.options.wrapAround ? utils.modulo( i, len ) : i;
        var slide = this.slides[ slideIndex ];
        if ( slide ) {
          cellElems = cellElems.concat( slide.getCellElements() );
        }
      }
      return cellElems;
    };
    
    /**
     * select slide from number or cell element
     * @param {[Element, String, Number]} selector - element, selector string, or index
     * @returns {Flickity.Cell} - matching cell
     */
    proto.queryCell = function( selector ) {
      if ( typeof selector == 'number' ) {
        // use number as index
        return this.cells[ selector ];
      }
      if ( typeof selector == 'string' ) {
        // do not select invalid selectors from hash: #123, #/. #791
        if ( selector.match( /^[#.]?[\d/]/ ) ) {
          return;
        }
        // use string as selector, get element
        selector = this.element.querySelector( selector );
      }
      // get cell from element
      return this.getCell( selector );
    };
    
    proto.checkVisibility = function() {
      var viewportX = this.viewport.getBoundingClientRect().x;
      var viewportWidth = this.viewport.offsetWidth;
    
      // Lorenza pulls content that should be out of the viewport in to
      // force slides on either side of the viewport. We need to offset
      // the viewport by the maximum amount it can be pulled in 4px.
      if (this.options.wrapAround) {
        viewportWidth = viewportWidth - 4;
      }
    
      this.cells.forEach(function (cell) {
        var cellX = cell.element.getBoundingClientRect().x - viewportX;
        var isVisible = (
            (cellX > -1 && cellX < 1) ||
            (cellX + cell.size.innerWidth > viewportX) && (cellX + cell.size.innerWidth < viewportWidth) ||
            (cellX > viewportX) && (cellX < viewportWidth)
        );
    
        if (isVisible) {
          cell.element.classList.add('is-visible');
          cell.element.removeAttribute('aria-hidden');
        } else {
          cell.element.classList.remove('is-visible');
          cell.element.setAttribute('aria-hidden', true);
        }
      });
    };
    
    // -------------------------- events -------------------------- //
    
    proto.uiChange = function() {
      this.emitEvent('uiChange');
    };
    
    // keep focus on element when child UI elements are clicked
    proto.childUIPointerDown = function( event ) {
      // HACK iOS does not allow touch events to bubble up?!
      if ( event.type != 'touchstart' ) {
        event.preventDefault();
      }
      this.focus();
    };
    
    // ----- resize ----- //
    
    proto.onresize = function() {
      this.watchCSS();
      this.resize();
    };
    
    utils.debounceMethod( Flickity, 'onresize', 150 );
    
    proto.resize = function() {
      if ( !this.isActive ) {
        return;
      }
      this.getSize();
      // wrap values
      if ( this.options.wrapAround ) {
        this.x = utils.modulo( this.x, this.slideableWidth );
      }
      this.positionCells();
      this._getWrapShiftCells();
      this.setGallerySize();
      this.emitEvent('resize');
      // update selected index for group slides, instant
      // TODO: position can be lost between groups of various numbers
      var selectedElement = this.selectedElements && this.selectedElements[0];
      this.selectCell( selectedElement, false, true );
    };
    
    // watches the :after property, activates/deactivates
    proto.watchCSS = function() {
      var watchOption = this.options.watchCSS;
      if ( !watchOption ) {
        return;
      }
    
      var afterContent = getComputedStyle( this.element, ':after' ).content;
      // activate if :after { content: 'flickity' }
      if ( afterContent.indexOf('flickity') != -1 ) {
        this.activate();
      } else {
        this.deactivate();
      }
    };
    
    // ----- keydown ----- //
    
    // go previous/next if left/right keys pressed
    proto.onkeydown = function( event ) {
      // only work if element is in focus
      var isNotFocused = document.activeElement && document.activeElement != this.element;
      if ( !this.options.accessibility || isNotFocused ) {
        return;
      }
    
      var handler = Flickity.keyboardHandlers[ event.keyCode ];
      if ( handler ) {
        handler.call( this );
      }
    };
    
    Flickity.keyboardHandlers = {
      // left arrow
      37: function() {
        var leftMethod = this.options.rightToLeft ? 'next' : 'previous';
        this.uiChange();
        this[ leftMethod ]();
      },
      // right arrow
      39: function() {
        var rightMethod = this.options.rightToLeft ? 'previous' : 'next';
        this.uiChange();
        this[ rightMethod ]();
      },
    };
    
    // ----- focus ----- //
    
    proto.focus = function() {
      // TODO remove scrollTo once focus options gets more support
      // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus ...
      //    #Browser_compatibility
      var prevScrollY = window.pageYOffset;
      this.element.focus({ preventScroll: true });
      // hack to fix scroll jump after focus, #76
      if ( window.pageYOffset != prevScrollY ) {
        window.scrollTo( window.pageXOffset, prevScrollY );
      }
    };
    
    // -------------------------- destroy -------------------------- //
    
    // deactivate all Flickity functionality, but keep stuff available
    proto.deactivate = function() {
      if ( !this.isActive ) {
        return;
      }
      this.element.classList.remove('flickity-enabled');
      this.element.classList.remove('flickity-rtl');
      this.unselectSelectedSlide();
      // destroy cells
      this.cells.forEach( function( cell ) {
        cell.destroy();
      } );
      this.element.removeChild( this.viewport );
      // move child elements back into element
      moveElements( this.slider.children, this.element );
      if ( this.options.accessibility ) {
        this.element.removeAttribute('tabIndex');
        this.element.removeEventListener( 'keydown', this );
      }
      // set flags
      this.isActive = false;
      this.emitEvent('deactivate');
    };
    
    proto.destroy = function() {
      this.deactivate();
      window.removeEventListener( 'resize', this );
      this.allOff();
      this.emitEvent('destroy');
      if ( jQuery && this.$element ) {
        jQuery.removeData( this.element, 'flickity' );
      }
      delete this.element.flickityGUID;
      delete instances[ this.guid ];
    };
    
    // -------------------------- prototype -------------------------- //
    
    utils.extend( proto, animatePrototype );
    
    // -------------------------- extras -------------------------- //
    
    /**
     * get Flickity instance from element
     * @param {[Element, String]} elem - element or selector string
     * @returns {Flickity} - Flickity instance
     */
    Flickity.data = function( elem ) {
      elem = utils.getQueryElement( elem );
      var id = elem && elem.flickityGUID;
      return id && instances[ id ];
    };
    
    utils.htmlInit( Flickity, 'flickity' );
    
    if ( jQuery && jQuery.bridget ) {
      jQuery.bridget( 'flickity', Flickity );
    }
    
    // set internal jQuery, for Webpack + jQuery v3, #478
    Flickity.setJQuery = function( jq ) {
      jQuery = jq;
    };
    
    Flickity.Cell = Cell;
    Flickity.Slide = Slide;
    
    return Flickity;
    
    } ) );
    
    
    /***/ }),
    /* 7 */
    /***/ (function(module, exports, __webpack_require__) {
    
    "use strict";
    
    
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.formatMoney = formatMoney;
    /**
     * Currency Helpers
     * -----------------------------------------------------------------------------
     * A collection of useful functions that help with currency formatting
     *
     * Current contents
     * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
     *
     */
    
    var moneyFormat = '${{amount}}';
    
    /**
     * Format money values based on your shop currency settings
     * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
     * or 3.00 dollars
     * @param  {String} format - shop money_format setting
     * @return {String} value - formatted value
     */
    function formatMoney(cents, format) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = format || moneyFormat;
    
      function formatWithDelimiters(number) {
        var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
        var thousands = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ',';
        var decimal = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';
    
        if (isNaN(number) || number == null) {
          return 0;
        }
    
        number = (number / 100.0).toFixed(precision);
    
        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var centsAmount = parts[1] ? decimal + parts[1] : '';
    
        return dollarsAmount + centsAmount;
      }
    
      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
      }
    
      return formatString.replace(placeholderRegex, value);
    }
    
    
    /***/ }),
    /* 8 */
    /***/ (function(module, exports, __webpack_require__) {
    
    "use strict";
    
    
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = void 0;
    
    /**
     * DOM event delegator
     *
     * The delegator will listen
     * for events that bubble up
     * to the root node.
     *
     * @constructor
     * @param {Node|string} [root] The root node or a selector string matching the root node
     */
    function Delegate(root) {
      /**
       * Maintain a map of listener
       * lists, keyed by event name.
       *
       * @type Object
       */
      this.listenerMap = [{}, {}];
    
      if (root) {
        this.root(root);
      }
      /** @type function() */
    
    
      this.handle = Delegate.prototype.handle.bind(this); // Cache of event listeners removed during an event cycle
    
      this._removedListeners = [];
    }
    /**
     * Start listening for events
     * on the provided DOM element
     *
     * @param  {Node|string} [root] The root node or a selector string matching the root node
     * @returns {Delegate} This method is chainable
     */
    
    
    Delegate.prototype.root = function (root) {
      var listenerMap = this.listenerMap;
      var eventType; // Remove master event listeners
    
      if (this.rootElement) {
        for (eventType in listenerMap[1]) {
          if (listenerMap[1].hasOwnProperty(eventType)) {
            this.rootElement.removeEventListener(eventType, this.handle, true);
          }
        }
    
        for (eventType in listenerMap[0]) {
          if (listenerMap[0].hasOwnProperty(eventType)) {
            this.rootElement.removeEventListener(eventType, this.handle, false);
          }
        }
      } // If no root or root is not
      // a dom node, then remove internal
      // root reference and exit here
    
    
      if (!root || !root.addEventListener) {
        if (this.rootElement) {
          delete this.rootElement;
        }
    
        return this;
      }
      /**
       * The root node at which
       * listeners are attached.
       *
       * @type Node
       */
    
    
      this.rootElement = root; // Set up master event listeners
    
      for (eventType in listenerMap[1]) {
        if (listenerMap[1].hasOwnProperty(eventType)) {
          this.rootElement.addEventListener(eventType, this.handle, true);
        }
      }
    
      for (eventType in listenerMap[0]) {
        if (listenerMap[0].hasOwnProperty(eventType)) {
          this.rootElement.addEventListener(eventType, this.handle, false);
        }
      }
    
      return this;
    };
    /**
     * @param {string} eventType
     * @returns boolean
     */
    
    
    Delegate.prototype.captureForType = function (eventType) {
      return ['blur', 'error', 'focus', 'load', 'resize', 'scroll'].indexOf(eventType) !== -1;
    };
    /**
     * Attach a handler to one
     * event for all elements
     * that match the selector,
     * now or in the future
     *
     * The handler function receives
     * three arguments: the DOM event
     * object, the node that matched
     * the selector while the event
     * was bubbling and a reference
     * to itself. Within the handler,
     * 'this' is equal to the second
     * argument.
     *
     * The node that actually received
     * the event can be accessed via
     * 'event.target'.
     *
     * @param {string} eventType Listen for these events
     * @param {string|undefined} selector Only handle events on elements matching this selector, if undefined match root element
     * @param {function()} handler Handler function - event data passed here will be in event.data
     * @param {boolean} [useCapture] see 'useCapture' in <https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener>
     * @returns {Delegate} This method is chainable
     */
    
    
    Delegate.prototype.on = function (eventType, selector, handler, useCapture) {
      var root;
      var listenerMap;
      var matcher;
      var matcherParam;
    
      if (!eventType) {
        throw new TypeError('Invalid event type: ' + eventType);
      } // handler can be passed as
      // the second or third argument
    
    
      if (typeof selector === 'function') {
        useCapture = handler;
        handler = selector;
        selector = null;
      } // Fallback to sensible defaults
      // if useCapture not set
    
    
      if (useCapture === undefined) {
        useCapture = this.captureForType(eventType);
      }
    
      if (typeof handler !== 'function') {
        throw new TypeError('Handler must be a type of Function');
      }
    
      root = this.rootElement;
      listenerMap = this.listenerMap[useCapture ? 1 : 0]; // Add master handler for type if not created yet
    
      if (!listenerMap[eventType]) {
        if (root) {
          root.addEventListener(eventType, this.handle, useCapture);
        }
    
        listenerMap[eventType] = [];
      }
    
      if (!selector) {
        matcherParam = null; // COMPLEX - matchesRoot needs to have access to
        // this.rootElement, so bind the function to this.
    
        matcher = matchesRoot.bind(this); // Compile a matcher for the given selector
      } else if (/^[a-z]+$/i.test(selector)) {
        matcherParam = selector;
        matcher = matchesTag;
      } else if (/^#[a-z0-9\-_]+$/i.test(selector)) {
        matcherParam = selector.slice(1);
        matcher = matchesId;
      } else {
        matcherParam = selector;
        matcher = Element.prototype.matches;
      } // Add to the list of listeners
    
    
      listenerMap[eventType].push({
        selector: selector,
        handler: handler,
        matcher: matcher,
        matcherParam: matcherParam
      });
      return this;
    };
    /**
     * Remove an event handler
     * for elements that match
     * the selector, forever
     *
     * @param {string} [eventType] Remove handlers for events matching this type, considering the other parameters
     * @param {string} [selector] If this parameter is omitted, only handlers which match the other two will be removed
     * @param {function()} [handler] If this parameter is omitted, only handlers which match the previous two will be removed
     * @returns {Delegate} This method is chainable
     */
    
    
    Delegate.prototype.off = function (eventType, selector, handler, useCapture) {
      var i;
      var listener;
      var listenerMap;
      var listenerList;
      var singleEventType; // Handler can be passed as
      // the second or third argument
    
      if (typeof selector === 'function') {
        useCapture = handler;
        handler = selector;
        selector = null;
      } // If useCapture not set, remove
      // all event listeners
    
    
      if (useCapture === undefined) {
        this.off(eventType, selector, handler, true);
        this.off(eventType, selector, handler, false);
        return this;
      }
    
      listenerMap = this.listenerMap[useCapture ? 1 : 0];
    
      if (!eventType) {
        for (singleEventType in listenerMap) {
          if (listenerMap.hasOwnProperty(singleEventType)) {
            this.off(singleEventType, selector, handler);
          }
        }
    
        return this;
      }
    
      listenerList = listenerMap[eventType];
    
      if (!listenerList || !listenerList.length) {
        return this;
      } // Remove only parameter matches
      // if specified
    
    
      for (i = listenerList.length - 1; i >= 0; i--) {
        listener = listenerList[i];
    
        if ((!selector || selector === listener.selector) && (!handler || handler === listener.handler)) {
          this._removedListeners.push(listener);
    
          listenerList.splice(i, 1);
        }
      } // All listeners removed
    
    
      if (!listenerList.length) {
        delete listenerMap[eventType]; // Remove the main handler
    
        if (this.rootElement) {
          this.rootElement.removeEventListener(eventType, this.handle, useCapture);
        }
      }
    
      return this;
    };
    /**
     * Handle an arbitrary event.
     *
     * @param {Event} event
     */
    
    
    Delegate.prototype.handle = function (event) {
      var i;
      var l;
      var type = event.type;
      var root;
      var phase;
      var listener;
      var returned;
      var listenerList = [];
      var target;
      var eventIgnore = 'ftLabsDelegateIgnore';
    
      if (event[eventIgnore] === true) {
        return;
      }
    
      target = event.target; // Hardcode value of Node.TEXT_NODE
      // as not defined in IE8
    
      if (target.nodeType === 3) {
        target = target.parentNode;
      } // Handle SVG <use> elements in IE
    
    
      if (target.correspondingUseElement) {
        target = target.correspondingUseElement;
      }
    
      root = this.rootElement;
      phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2); // eslint-disable-next-line default-case
    
      switch (phase) {
        case 1:
          //Event.CAPTURING_PHASE:
          listenerList = this.listenerMap[1][type];
          break;
    
        case 2:
          //Event.AT_TARGET:
          if (this.listenerMap[0] && this.listenerMap[0][type]) {
            listenerList = listenerList.concat(this.listenerMap[0][type]);
          }
    
          if (this.listenerMap[1] && this.listenerMap[1][type]) {
            listenerList = listenerList.concat(this.listenerMap[1][type]);
          }
    
          break;
    
        case 3:
          //Event.BUBBLING_PHASE:
          listenerList = this.listenerMap[0][type];
          break;
      }
    
      var toFire = []; // Need to continuously check
      // that the specific list is
      // still populated in case one
      // of the callbacks actually
      // causes the list to be destroyed.
    
      l = listenerList.length;
    
      while (target && l) {
        for (i = 0; i < l; i++) {
          listener = listenerList[i]; // Bail from this loop if
          // the length changed and
          // no more listeners are
          // defined between i and l.
    
          if (!listener) {
            break;
          }
    
          if (target.tagName && ["button", "input", "select", "textarea"].indexOf(target.tagName.toLowerCase()) > -1 && target.hasAttribute("disabled")) {
            // Remove things that have previously fired
            toFire = [];
          } // Check for match and fire
          // the event if there's one
          //
          // TODO:MCG:20120117: Need a way
          // to check if event#stopImmediatePropagation
          // was called. If so, break both loops.
          else if (listener.matcher.call(target, listener.matcherParam, target)) {
              toFire.push([event, target, listener]);
            }
        } // TODO:MCG:20120117: Need a way to
        // check if event#stopPropagation
        // was called. If so, break looping
        // through the DOM. Stop if the
        // delegation root has been reached
    
    
        if (target === root) {
          break;
        }
    
        l = listenerList.length; // Fall back to parentNode since SVG children have no parentElement in IE
    
        target = target.parentElement || target.parentNode; // Do not traverse up to document root when using parentNode, though
    
        if (target instanceof HTMLDocument) {
          break;
        }
      }
    
      var ret;
    
      for (i = 0; i < toFire.length; i++) {
        // Has it been removed during while the event function was fired
        if (this._removedListeners.indexOf(toFire[i][2]) > -1) {
          continue;
        }
    
        returned = this.fire.apply(this, toFire[i]); // Stop propagation to subsequent
        // callbacks if the callback returned
        // false
    
        if (returned === false) {
          toFire[i][0][eventIgnore] = true;
          toFire[i][0].preventDefault();
          ret = false;
          break;
        }
      }
    
      return ret;
    };
    /**
     * Fire a listener on a target.
     *
     * @param {Event} event
     * @param {Node} target
     * @param {Object} listener
     * @returns {boolean}
     */
    
    
    Delegate.prototype.fire = function (event, target, listener) {
      return listener.handler.call(target, event, target);
    };
    /**
     * Check whether an element
     * matches a tag selector.
     *
     * Tags are NOT case-sensitive,
     * except in XML (and XML-based
     * languages such as XHTML).
     *
     * @param {string} tagName The tag name to test against
     * @param {Element} element The element to test with
     * @returns boolean
     */
    
    
    function matchesTag(tagName, element) {
      return tagName.toLowerCase() === element.tagName.toLowerCase();
    }
    /**
     * Check whether an element
     * matches the root.
     *
     * @param {?String} selector In this case this is always passed through as null and not used
     * @param {Element} element The element to test with
     * @returns boolean
     */
    
    
    function matchesRoot(selector, element) {
      if (this.rootElement === window) {
        return (// Match the outer document (dispatched from document)
          element === document || // The <html> element (dispatched from document.body or document.documentElement)
          element === document.documentElement || // Or the window itself (dispatched from window)
          element === window
        );
      }
    
      return this.rootElement === element;
    }
    /**
     * Check whether the ID of
     * the element in 'this'
     * matches the given ID.
     *
     * IDs are case-sensitive.
     *
     * @param {string} id The ID to test against
     * @param {Element} element The element to test with
     * @returns boolean
     */
    
    
    function matchesId(id, element) {
      return id === element.id;
    }
    /**
     * Short hand for off()
     * and root(), ie both
     * with no parameters
     *
     * @return void
     */
    
    
    Delegate.prototype.destroy = function () {
      this.off();
      this.root();
    };
    
    var _default = Delegate;
    exports.default = _default;
    module.exports = exports.default;
    
    /***/ }),
    /* 9 */
    /***/ (function(module, exports, __webpack_require__) {
    
    var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
    
        if (root === null) {
            throw new Error('Google-maps package can be used only in browser');
        }
    
        if (true) {
            !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
                    __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
                    (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
                    __WEBPACK_AMD_DEFINE_FACTORY__),
                    __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else {}
    
    })(typeof window !== 'undefined' ? window : null, function() {
    
    
        'use strict';
    
    
        var googleVersion = '3.31';
    
        var script = null;
    
        var google = null;
    
        var loading = false;
    
        var callbacks = [];
    
        var onLoadEvents = [];
    
        var originalCreateLoaderMethod = null;
    
    
        var GoogleMapsLoader = {};
    
    
        GoogleMapsLoader.URL = 'https://maps.googleapis.com/maps/api/js';
    
        GoogleMapsLoader.KEY = null;
    
        GoogleMapsLoader.LIBRARIES = [];
    
        GoogleMapsLoader.CLIENT = null;
    
        GoogleMapsLoader.CHANNEL = null;
    
        GoogleMapsLoader.LANGUAGE = null;
    
        GoogleMapsLoader.REGION = null;
    
        GoogleMapsLoader.VERSION = googleVersion;
    
        GoogleMapsLoader.WINDOW_CALLBACK_NAME = '__google_maps_api_provider_initializator__';
    
    
        GoogleMapsLoader._googleMockApiObject = {};
    
    
        GoogleMapsLoader.load = function(fn) {
            if (google === null) {
                if (loading === true) {
                    if (fn) {
                        callbacks.push(fn);
                    }
                } else {
                    loading = true;
    
                    window[GoogleMapsLoader.WINDOW_CALLBACK_NAME] = function() {
                        ready(fn);
                    };
    
                    GoogleMapsLoader.createLoader();
                }
            } else if (fn) {
                fn(google);
            }
        };
    
    
        GoogleMapsLoader.createLoader = function() {
            script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = GoogleMapsLoader.createUrl();
    
            document.body.appendChild(script);
        };
    
    
        GoogleMapsLoader.isLoaded = function() {
            return google !== null;
        };
    
    
        GoogleMapsLoader.createUrl = function() {
            var url = GoogleMapsLoader.URL;
    
            url += '?callback=' + GoogleMapsLoader.WINDOW_CALLBACK_NAME;
    
            if (GoogleMapsLoader.KEY) {
                url += '&key=' + GoogleMapsLoader.KEY;
            }
    
            if (GoogleMapsLoader.LIBRARIES.length > 0) {
                url += '&libraries=' + GoogleMapsLoader.LIBRARIES.join(',');
            }
    
            if (GoogleMapsLoader.CLIENT) {
                url += '&client=' + GoogleMapsLoader.CLIENT;
            }
    
            if (GoogleMapsLoader.CHANNEL) {
                url += '&channel=' + GoogleMapsLoader.CHANNEL;
            }
    
            if (GoogleMapsLoader.LANGUAGE) {
                url += '&language=' + GoogleMapsLoader.LANGUAGE;
            }
    
            if (GoogleMapsLoader.REGION) {
                url += '&region=' + GoogleMapsLoader.REGION;
            }
    
            if (GoogleMapsLoader.VERSION) {
                url += '&v=' + GoogleMapsLoader.VERSION;
            }
    
            return url;
        };
    
    
        GoogleMapsLoader.release = function(fn) {
            var release = function() {
                GoogleMapsLoader.KEY = null;
                GoogleMapsLoader.LIBRARIES = [];
                GoogleMapsLoader.CLIENT = null;
                GoogleMapsLoader.CHANNEL = null;
                GoogleMapsLoader.LANGUAGE = null;
                GoogleMapsLoader.REGION = null;
                GoogleMapsLoader.VERSION = googleVersion;
    
                google = null;
                loading = false;
                callbacks = [];
                onLoadEvents = [];
    
                if (typeof window.google !== 'undefined') {
                    delete window.google;
                }
    
                if (typeof window[GoogleMapsLoader.WINDOW_CALLBACK_NAME] !== 'undefined') {
                    delete window[GoogleMapsLoader.WINDOW_CALLBACK_NAME];
                }
    
                if (originalCreateLoaderMethod !== null) {
                    GoogleMapsLoader.createLoader = originalCreateLoaderMethod;
                    originalCreateLoaderMethod = null;
                }
    
                if (script !== null) {
                    script.parentElement.removeChild(script);
                    script = null;
                }
    
                if (fn) {
                    fn();
                }
            };
    
            if (loading) {
                GoogleMapsLoader.load(function() {
                    release();
                });
            } else {
                release();
            }
        };
    
    
        GoogleMapsLoader.onLoad = function(fn) {
            onLoadEvents.push(fn);
        };
    
    
        GoogleMapsLoader.makeMock = function() {
            originalCreateLoaderMethod = GoogleMapsLoader.createLoader;
    
            GoogleMapsLoader.createLoader = function() {
                window.google = GoogleMapsLoader._googleMockApiObject;
                window[GoogleMapsLoader.WINDOW_CALLBACK_NAME]();
            };
        };
    
    
        var ready = function(fn) {
            var i;
    
            loading = false;
    
            if (google === null) {
                google = window.google;
            }
    
            for (i = 0; i < onLoadEvents.length; i++) {
                onLoadEvents[i](google);
            }
    
            if (fn) {
                fn(google);
            }
    
            for (i = 0; i < callbacks.length; i++) {
                callbacks[i](google);
            }
    
            callbacks = [];
        };
    
    
        return GoogleMapsLoader;
    
    });
    
    
    /***/ }),
    /* 10 */
    /***/ (function(module, exports) {
    
    var g;
    
    // This works in non-strict mode
    g = (function() {
        return this;
    })();
    
    try {
        // This works if eval is allowed (see CSP)
        g = g || new Function("return this")();
    } catch (e) {
        // This works if the window reference is available
        if (typeof window === "object") g = window;
    }
    
    // g can still be undefined, but nothing to do about it...
    // We return undefined, instead of nothing here, so it's
    // easier to handle this case. if(!global) { ...}
    
    module.exports = g;
    
    
    /***/ }),
    /* 11 */
    /***/ (function(module, exports, __webpack_require__) {
    
    /* WEBPACK VAR INJECTION */(function(global) {/**
     * string-strip-html
     * Strips HTML tags from strings. No parser, accepts mixed sources.
     * Version: 4.5.1
     * Author: Roy Revelt, Codsen Ltd
     * License: MIT
     * Homepage: https://gitlab.com/codsen/codsen/tree/master/packages/string-strip-html
     */
    
    !function(r,e){ true?module.exports=e():undefined}(this,(function(){"use strict";function r(e){return(r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(r){return typeof r}:function(r){return r&&"function"==typeof Symbol&&r.constructor===Symbol&&r!==Symbol.prototype?"symbol":typeof r})(e)}function e(r,e){for(var t=0;t<e.length;t++){var n=e[t];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(r,n.key,n)}}function t(r,e,t){return e in r?Object.defineProperty(r,e,{value:t,enumerable:!0,configurable:!0,writable:!0}):r[e]=t,r}function n(r,e){var t=Object.keys(r);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(r);e&&(n=n.filter((function(e){return Object.getOwnPropertyDescriptor(r,e).enumerable}))),t.push.apply(t,n)}return t}function a(r){for(var e=1;e<arguments.length;e++){var a=null!=arguments[e]?arguments[e]:{};e%2?n(Object(a),!0).forEach((function(e){t(r,e,a[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(r,Object.getOwnPropertyDescriptors(a)):n(Object(a)).forEach((function(e){Object.defineProperty(r,e,Object.getOwnPropertyDescriptor(a,e))}))}return r}function o(r){return function(r){if(Array.isArray(r))return i(r)}(r)||function(r){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(r))return Array.from(r)}(r)||function(r,e){if(!r)return;if("string"==typeof r)return i(r,e);var t=Object.prototype.toString.call(r).slice(8,-1);"Object"===t&&r.constructor&&(t=r.constructor.name);if("Map"===t||"Set"===t)return Array.from(r);if("Arguments"===t||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))return i(r,e)}(r)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function i(r,e){(null==e||e>r.length)&&(e=r.length);for(var t=0,n=new Array(e);t<e;t++)n[t]=r[t];return n}function s(r,e){if(!Array.isArray(r)||!r.length)return r;var t,n,o=a(a({},{strictlyTwoElementsInRangeArrays:!1,progressFn:null}),e);if(o.strictlyTwoElementsInRangeArrays&&!r.every((function(r,e){return 2===r.length||(t=e,n=r.length,!1)})))throw new TypeError("ranges-sort: [THROW_ID_03] The first argument should be an array and must consist of arrays which are natural number indexes representing TWO string index ranges. However, ".concat(t,"th range (").concat(JSON.stringify(r[t],null,4),") has not two but ").concat(n," elements!"));if(!r.every((function(r,e){return!(!Number.isInteger(r[0])||r[0]<0||!Number.isInteger(r[1])||r[1]<0)||(t=e,!1)})))throw new TypeError("ranges-sort: [THROW_ID_04] The first argument should be an array and must consist of arrays which are natural number indexes representing string index ranges. However, ".concat(t,"th range (").concat(JSON.stringify(r[t],null,4),") does not consist of only natural numbers!"));var i=r.length*r.length,s=0;return Array.from(r).sort((function(r,e){return o.progressFn&&(s+=1,o.progressFn(Math.floor(100*s/i))),r[0]===e[0]?r[1]<e[1]?-1:r[1]>e[1]?1:0:r[0]<e[0]?-1:1}))}function c(e,t){function n(r){return"string"==typeof r}function i(e){return e&&"object"===r(e)&&!Array.isArray(e)}if(!Array.isArray(e)||!e.length)return e;var c,l={mergeType:1,progressFn:null,joinRangesThatTouchEdges:!0};if(t){if(!i(t))throw new Error("emlint: [THROW_ID_03] the second input argument must be a plain object. It was given as:\n".concat(JSON.stringify(t,null,4)," (type ").concat(r(t),")"));if((c=a(a({},l),t)).progressFn&&i(c.progressFn)&&!Object.keys(c.progressFn).length)c.progressFn=null;else if(c.progressFn&&"function"!=typeof c.progressFn)throw new Error('ranges-merge: [THROW_ID_01] opts.progressFn must be a function! It was given of a type: "'.concat(r(c.progressFn),'", equal to ').concat(JSON.stringify(c.progressFn,null,4)));if(c.mergeType&&1!==c.mergeType&&2!==c.mergeType)if(n(c.mergeType)&&"1"===c.mergeType.trim())c.mergeType=1;else{if(!n(c.mergeType)||"2"!==c.mergeType.trim())throw new Error('ranges-merge: [THROW_ID_02] opts.mergeType was customised to a wrong thing! It was given of a type: "'.concat(r(c.mergeType),'", equal to ').concat(JSON.stringify(c.mergeType,null,4)));c.mergeType=2}if("boolean"!=typeof c.joinRangesThatTouchEdges)throw new Error('ranges-merge: [THROW_ID_04] opts.joinRangesThatTouchEdges was customised to a wrong thing! It was given of a type: "'.concat(r(c.joinRangesThatTouchEdges),'", equal to ').concat(JSON.stringify(c.joinRangesThatTouchEdges,null,4)))}else c=a({},l);for(var u,p,f,g=e.map((function(r){return o(r)})).filter((function(r){return void 0!==r[2]||r[0]!==r[1]})),d=(u=c.progressFn?s(g,{progressFn:function(r){(f=Math.floor(r/5))!==p&&(p=f,c.progressFn(f))}}):s(g)).length-1,h=d;h>0;h--)c.progressFn&&(f=Math.floor(78*(1-h/d))+21)!==p&&f>p&&(p=f,c.progressFn(f)),(u[h][0]<=u[h-1][0]||!c.joinRangesThatTouchEdges&&u[h][0]<u[h-1][1]||c.joinRangesThatTouchEdges&&u[h][0]<=u[h-1][1])&&(u[h-1][0]=Math.min(u[h][0],u[h-1][0]),u[h-1][1]=Math.max(u[h][1],u[h-1][1]),void 0!==u[h][2]&&(u[h-1][0]>=u[h][0]||u[h-1][1]<=u[h][1])&&null!==u[h-1][2]&&(null===u[h][2]&&null!==u[h-1][2]?u[h-1][2]=null:void 0!==u[h-1][2]?2===c.mergeType&&u[h-1][0]===u[h][0]?u[h-1][2]=u[h][2]:u[h-1][2]+=u[h][2]:u[h-1][2]=u[h][2]),u.splice(h,1),h=u.length);return u}function l(r){return null!=r}function u(r){return"string"==typeof r}function p(e,t,n){var a,o=0,i=0;if(0===arguments.length)throw new Error("ranges-apply: [THROW_ID_01] inputs missing!");if(!u(e))throw new TypeError("ranges-apply: [THROW_ID_02] first input argument must be a string! Currently it's: ".concat(r(e),", equal to: ").concat(JSON.stringify(e,null,4)));if(null===t)return e;if(!Array.isArray(t))throw new TypeError("ranges-apply: [THROW_ID_03] second input argument must be an array (or null)! Currently it's: ".concat(r(t),", equal to: ").concat(JSON.stringify(t,null,4)));if(n&&"function"!=typeof n)throw new TypeError("ranges-apply: [THROW_ID_04] the third input argument must be a function (or falsey)! Currently it's: ".concat(r(n),", equal to: ").concat(JSON.stringify(n,null,4)));var s=(a=Array.isArray(t)&&(Number.isInteger(t[0])&&t[0]>=0||/^\d*$/.test(t[0]))&&(Number.isInteger(t[1])&&t[1]>=0||/^\d*$/.test(t[1]))?[Array.from(t)]:Array.from(t)).length,p=0;a.forEach((function(e,t){if(n&&(o=Math.floor(p/s*10))!==i&&(i=o,n(o)),!Array.isArray(e))throw new TypeError("ranges-apply: [THROW_ID_05] ranges array, second input arg., has ".concat(t,"th element not an array: ").concat(JSON.stringify(e,null,4),", which is ").concat(r(e)));if(!Number.isInteger(e[0])||e[0]<0){if(!/^\d*$/.test(e[0]))throw new TypeError("ranges-apply: [THROW_ID_06] ranges array, second input arg. has ".concat(t,"th element, array [").concat(e[0],",").concat(e[1],"]. That array has first element not an integer, but ").concat(r(e[0]),", equal to: ").concat(JSON.stringify(e[0],null,4),". Computer doesn't like this."));a[t][0]=Number.parseInt(a[t][0],10)}if(!Number.isInteger(e[1])){if(!/^\d*$/.test(e[1]))throw new TypeError("ranges-apply: [THROW_ID_07] ranges array, second input arg. has ".concat(t,"th element, array [").concat(e[0],",").concat(e[1],"]. That array has second element not an integer, but ").concat(r(e[1]),", equal to: ").concat(JSON.stringify(e[1],null,4),". Computer doesn't like this."));a[t][1]=Number.parseInt(a[t][1],10)}p+=1}));var f=c(a,{progressFn:function(r){n&&(o=10+Math.floor(r/10))!==i&&(i=o,n(o))}}),g=f.length;if(g>0){var d=e.slice(f[g-1][1]);e=f.reduce((function(r,t,a,s){n&&(o=20+Math.floor(a/g*80))!==i&&(i=o,n(o));var c=0===a?0:s[a-1][1],u=s[a][0];return r+e.slice(c,u)+(l(s[a][2])?s[a][2]:"")}),""),e+=d}return e}function f(r){var e=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],t=arguments.length>2?arguments[2]:void 0;if(!(t.trim()||r.length&&"\n"!==t&&" "!==t&&" "===(e?r[r.length-1]:r[0])||r.length&&"\n"===(e?r[r.length-1]:r[0])&&"\n"!==t&&" "!==t))if(e){if(("\n"===t||" "===t)&&r.length&&" "===r[r.length-1])for(;r.length&&" "===r[r.length-1];)r.pop();r.push(" "===t||"\n"===t?t:" ")}else{if(("\n"===t||" "===t)&&r.length&&" "===r[0])for(;r.length&&" "===r[0];)r.shift();r.unshift(" "===t||"\n"===t?t:" ")}}function g(r,e){if("string"==typeof r&&r.length){var t,n,a=!1;if(r.includes("\r\n")&&(a=!0),t=e&&"number"==typeof e?e:1,""===r.trim()){var o=[];for(n=t,Array.from(r).forEach((function(r){("\n"!==r||n)&&("\n"===r&&(n-=1),f(o,!0,r))}));o.length>1&&" "===o[o.length-1];)o.pop();return o.join("")}var i=[];if(n=t,""===r[0].trim())for(var s=0,c=r.length;s<c&&!r[s].trim();s++)("\n"!==r[s]||n)&&("\n"===r[s]&&(n-=1),f(i,!0,r[s]));var l=[];if(n=t,""===r.slice(-1).trim())for(var u=r.length;u--&&!r[u].trim();)("\n"!==r[u]||n)&&("\n"===r[u]&&(n-=1),f(l,!1,r[u]));return a?"".concat(i.join("")).concat(r.trim()).concat(l.join("")).replace(/\n/g,"\r\n"):i.join("")+r.trim()+l.join("")}return r}function d(r){return null!=r}function h(r){return Number.isInteger(r)&&r>=0}function m(r){return"string"==typeof r}function b(r){return/^\d*$/.test(r)?parseInt(r,10):r}var y=function(){function t(e){!function(r,e){if(!(r instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t);var n=a(a({},{limitToBeAddedWhitespace:!1,limitLinebreaksCount:1,mergeType:1}),e);if(n.mergeType&&1!==n.mergeType&&2!==n.mergeType)if(m(n.mergeType)&&"1"===n.mergeType.trim())n.mergeType=1;else{if(!m(n.mergeType)||"2"!==n.mergeType.trim())throw new Error('ranges-push: [THROW_ID_02] opts.mergeType was customised to a wrong thing! It was given of a type: "'.concat(r(n.mergeType),'", equal to ').concat(JSON.stringify(n.mergeType,null,4)));n.mergeType=2}this.opts=n}var n,i,s;return n=t,(i=[{key:"add",value:function(e,t,n){for(var a=this,i=arguments.length,s=new Array(i>3?i-3:0),c=3;c<i;c++)s[c-3]=arguments[c];if(s.length>0)throw new TypeError("ranges-push/Ranges/add(): [THROW_ID_03] Please don't overload the add() method. From the 4th input argument onwards we see these redundant arguments: ".concat(JSON.stringify(s,null,4)));if(d(e)||d(t)){if(d(e)&&!d(t)){if(Array.isArray(e)){if(e.length){if(e.some((function(r){return Array.isArray(r)})))return void e.forEach((function(r){Array.isArray(r)&&a.add.apply(a,o(r))}));e.length>1&&h(b(e[0]))&&h(b(e[1]))&&this.add.apply(this,o(e))}return}throw new TypeError('ranges-push/Ranges/add(): [THROW_ID_12] the first input argument, "from" is set ('.concat(JSON.stringify(e,null,0),') but second-one, "to" is not (').concat(JSON.stringify(t,null,0),")"))}if(!d(e)&&d(t))throw new TypeError('ranges-push/Ranges/add(): [THROW_ID_13] the second input argument, "to" is set ('.concat(JSON.stringify(t,null,0),') but first-one, "from" is not (').concat(JSON.stringify(e,null,0),")"));var l=/^\d*$/.test(e)?parseInt(e,10):e,u=/^\d*$/.test(t)?parseInt(t,10):t;if(h(n)&&(n=String(n)),!h(l)||!h(u))throw h(l)&&l>=0?new TypeError('ranges-push/Ranges/add(): [THROW_ID_10] "to" value, the second input argument, must be a natural number or zero! Currently it\'s of a type "'.concat(r(u),'" equal to: ').concat(JSON.stringify(u,null,4))):new TypeError('ranges-push/Ranges/add(): [THROW_ID_09] "from" value, the first input argument, must be a natural number or zero! Currently it\'s of a type "'.concat(r(l),'" equal to: ').concat(JSON.stringify(l,null,4)));if(d(n)&&!m(n)&&!h(n))throw new TypeError("ranges-push/Ranges/add(): [THROW_ID_08] The third argument, the value to add, was given not as string but ".concat(r(n),", equal to:\n").concat(JSON.stringify(n,null,4)));if(d(this.slices)&&Array.isArray(this.last())&&l===this.last()[1]){if(this.last()[1]=u,this.last()[2],null!==this.last()[2]&&d(n)){var p=!(d(this.last()[2])&&this.last()[2].length>0)||this.opts&&this.opts.mergeType&&1!==this.opts.mergeType?n:this.last()[2]+n;this.opts.limitToBeAddedWhitespace&&(p=g(p,this.opts.limitLinebreaksCount)),m(p)&&!p.length||(this.last()[2]=p)}}else{this.slices||(this.slices=[]);var f=void 0===n||m(n)&&!n.length?[l,u]:[l,u,this.opts.limitToBeAddedWhitespace?g(n,this.opts.limitLinebreaksCount):n];this.slices.push(f)}}}},{key:"push",value:function(r,e,t){for(var n=arguments.length,a=new Array(n>3?n-3:0),o=3;o<n;o++)a[o-3]=arguments[o];this.add.apply(this,[r,e,t].concat(a))}},{key:"current",value:function(){var r=this;return null!=this.slices?(this.slices=c(this.slices,{mergeType:this.opts.mergeType}),this.opts.limitToBeAddedWhitespace?this.slices.map((function(e){return d(e[2])?[e[0],e[1],g(e[2],r.opts.limitLinebreaksCount)]:e})):this.slices):null}},{key:"wipe",value:function(){this.slices=void 0}},{key:"replace",value:function(r){if(Array.isArray(r)&&r.length){if(!Array.isArray(r[0])||!h(r[0][0]))throw new Error("ranges-push/Ranges/replace(): [THROW_ID_11] Single range was given but we expected array of arrays! The first element, ".concat(JSON.stringify(r[0],null,4)," should be an array and its first element should be an integer, a string index."));this.slices=Array.from(r)}else this.slices=void 0}},{key:"last",value:function(){return void 0!==this.slices&&Array.isArray(this.slices)?this.slices[this.slices.length-1]:null}}])&&e(n.prototype,i),s&&e(n,s),t}();var v,w,q=Function.prototype,A=Object.prototype,T=q.toString,E=A.hasOwnProperty,k=T.call(Object),O=A.toString,S=(v=Object.getPrototypeOf,w=Object,function(r){return v(w(r))});var _=function(e){if(!function(e){return!!e&&"object"==r(e)}(e)||"[object Object]"!=O.call(e)||function(r){var e=!1;if(null!=r&&"function"!=typeof r.toString)try{e=!!(r+"")}catch(r){}return e}(e))return!1;var t=S(e);if(null===t)return!0;var n=E.call(t,"constructor")&&t.constructor;return"function"==typeof n&&n instanceof n&&T.call(n)==k},x="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};function D(r){return r&&r.default||r}var L=/^\s+|\s+$/g,j="[\\ud800-\\udfff]",R="[\\u0300-\\u036f\\ufe20-\\ufe23\\u20d0-\\u20f0]",N="\\ud83c[\\udffb-\\udfff]",C="[^\\ud800-\\udfff]",I="(?:\\ud83c[\\udde6-\\uddff]){2}",B="[\\ud800-\\udbff][\\udc00-\\udfff]",H="(?:"+R+"|"+N+")"+"?",U="[\\ufe0e\\ufe0f]?"+H+("(?:\\u200d(?:"+[C,I,B].join("|")+")[\\ufe0e\\ufe0f]?"+H+")*"),V="(?:"+[C+R+"?",R,I,B,j].join("|")+")",P=RegExp(N+"(?="+N+")|"+V+U,"g"),W=RegExp("[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe23\\u20d0-\\u20f0\\ufe0e\\ufe0f]"),F="object"==r(x)&&x&&x.Object===Object&&x,G="object"==("undefined"==typeof self?"undefined":r(self))&&self&&self.Object===Object&&self,z=F||G||Function("return this")();function J(r,e,t){if(e!=e)return function(r,e,t,n){for(var a=r.length,o=t+(n?1:-1);n?o--:++o<a;)if(e(r[o],o,r))return o;return-1}(r,M,t);for(var n=t-1,a=r.length;++n<a;)if(r[n]===e)return n;return-1}function M(r){return r!=r}function $(r){return function(r){return W.test(r)}(r)?function(r){return r.match(P)||[]}(r):function(r){return r.split("")}(r)}var Y=Object.prototype.toString,Z=z.Symbol,K=Z?Z.prototype:void 0,Q=K?K.toString:void 0;function X(e){if("string"==typeof e)return e;if(function(e){return"symbol"==r(e)||function(e){return!!e&&"object"==r(e)}(e)&&"[object Symbol]"==Y.call(e)}(e))return Q?Q.call(e):"";var t=e+"";return"0"==t&&1/e==-1/0?"-0":t}function rr(r,e,t){var n=r.length;return t=void 0===t?n:t,!e&&t>=n?r:function(r,e,t){var n=-1,a=r.length;e<0&&(e=-e>a?0:a+e),(t=t>a?a:t)<0&&(t+=a),a=e>t?0:t-e>>>0,e>>>=0;for(var o=Array(a);++n<a;)o[n]=r[n+e];return o}(r,e,t)}var er=function(r,e,t){var n;if((r=null==(n=r)?"":X(n))&&(t||void 0===e))return r.replace(L,"");if(!r||!(e=X(e)))return r;var a=$(r),o=$(e);return rr(a,function(r,e){for(var t=-1,n=r.length;++t<n&&J(e,r[t],0)>-1;);return t}(a,o),function(r,e){for(var t=r.length;t--&&J(e,r[t],0)>-1;);return t}(a,o)+1).join("")},tr=/^\[object .+?Constructor\]$/,nr="object"==r(x)&&x&&x.Object===Object&&x,ar="object"==("undefined"==typeof self?"undefined":r(self))&&self&&self.Object===Object&&self,or=nr||ar||Function("return this")();function ir(r,e,t){switch(t.length){case 0:return r.call(e);case 1:return r.call(e,t[0]);case 2:return r.call(e,t[0],t[1]);case 3:return r.call(e,t[0],t[1],t[2])}return r.apply(e,t)}function sr(r,e){return!!(r?r.length:0)&&function(r,e,t){if(e!=e)return function(r,e,t,n){var a=r.length,o=t+(n?1:-1);for(;n?o--:++o<a;)if(e(r[o],o,r))return o;return-1}(r,lr,t);var n=t-1,a=r.length;for(;++n<a;)if(r[n]===e)return n;return-1}(r,e,0)>-1}function cr(r,e,t){for(var n=-1,a=r?r.length:0;++n<a;)if(t(e,r[n]))return!0;return!1}function lr(r){return r!=r}function ur(r,e){return r.has(e)}var pr,fr=Array.prototype,gr=Function.prototype,dr=Object.prototype,hr=or["__core-js_shared__"],mr=(pr=/[^.]+$/.exec(hr&&hr.keys&&hr.keys.IE_PROTO||""))?"Symbol(src)_1."+pr:"",br=gr.toString,yr=dr.hasOwnProperty,vr=dr.toString,wr=RegExp("^"+br.call(yr).replace(/[\\^$.*+?()[\]{}|]/g,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$"),qr=fr.splice,Ar=Math.max,Tr=Rr(or,"Map"),Er=Rr(Object,"create");function kr(r){var e=-1,t=r?r.length:0;for(this.clear();++e<t;){var n=r[e];this.set(n[0],n[1])}}function Or(r){var e=-1,t=r?r.length:0;for(this.clear();++e<t;){var n=r[e];this.set(n[0],n[1])}}function Sr(r){var e=-1,t=r?r.length:0;for(this.clear();++e<t;){var n=r[e];this.set(n[0],n[1])}}function _r(r){var e=-1,t=r?r.length:0;for(this.__data__=new Sr;++e<t;)this.add(r[e])}function xr(r,e){for(var t,n,a=r.length;a--;)if((t=r[a][0])===(n=e)||t!=t&&n!=n)return a;return-1}function Dr(r,e,t,n){var a=-1,o=sr,i=!0,s=r.length,c=[],l=e.length;if(!s)return c;t&&(e=function(r,e){for(var t=-1,n=r?r.length:0,a=Array(n);++t<n;)a[t]=e(r[t],t,r);return a}(e,function(r){return function(e){return r(e)}}(t))),n?(o=cr,i=!1):e.length>=200&&(o=ur,i=!1,e=new _r(e));r:for(;++a<s;){var u=r[a],p=t?t(u):u;if(u=n||0!==u?u:0,i&&p==p){for(var f=l;f--;)if(e[f]===p)continue r;c.push(u)}else o(e,p,n)||c.push(u)}return c}function Lr(r){return!(!Cr(r)||function(r){return!!mr&&mr in r}(r))&&(Nr(r)||function(r){var e=!1;if(null!=r&&"function"!=typeof r.toString)try{e=!!(r+"")}catch(r){}return e}(r)?wr:tr).test(function(r){if(null!=r){try{return br.call(r)}catch(r){}try{return r+""}catch(r){}}return""}(r))}function jr(e,t){var n,a,o=e.__data__;return("string"==(a=r(n=t))||"number"==a||"symbol"==a||"boolean"==a?"__proto__"!==n:null===n)?o["string"==typeof t?"string":"hash"]:o.map}function Rr(r,e){var t=function(r,e){return null==r?void 0:r[e]}(r,e);return Lr(t)?t:void 0}function Nr(r){var e=Cr(r)?vr.call(r):"";return"[object Function]"==e||"[object GeneratorFunction]"==e}function Cr(e){var t=r(e);return!!e&&("object"==t||"function"==t)}kr.prototype.clear=function(){this.__data__=Er?Er(null):{}},kr.prototype.delete=function(r){return this.has(r)&&delete this.__data__[r]},kr.prototype.get=function(r){var e=this.__data__;if(Er){var t=e[r];return"__lodash_hash_undefined__"===t?void 0:t}return yr.call(e,r)?e[r]:void 0},kr.prototype.has=function(r){var e=this.__data__;return Er?void 0!==e[r]:yr.call(e,r)},kr.prototype.set=function(r,e){return this.__data__[r]=Er&&void 0===e?"__lodash_hash_undefined__":e,this},Or.prototype.clear=function(){this.__data__=[]},Or.prototype.delete=function(r){var e=this.__data__,t=xr(e,r);return!(t<0)&&(t==e.length-1?e.pop():qr.call(e,t,1),!0)},Or.prototype.get=function(r){var e=this.__data__,t=xr(e,r);return t<0?void 0:e[t][1]},Or.prototype.has=function(r){return xr(this.__data__,r)>-1},Or.prototype.set=function(r,e){var t=this.__data__,n=xr(t,r);return n<0?t.push([r,e]):t[n][1]=e,this},Sr.prototype.clear=function(){this.__data__={hash:new kr,map:new(Tr||Or),string:new kr}},Sr.prototype.delete=function(r){return jr(this,r).delete(r)},Sr.prototype.get=function(r){return jr(this,r).get(r)},Sr.prototype.has=function(r){return jr(this,r).has(r)},Sr.prototype.set=function(r,e){return jr(this,r).set(r,e),this},_r.prototype.add=_r.prototype.push=function(r){return this.__data__.set(r,"__lodash_hash_undefined__"),this},_r.prototype.has=function(r){return this.__data__.has(r)};var Ir=function(r,e){return e=Ar(void 0===e?r.length-1:e,0),function(){for(var t=arguments,n=-1,a=Ar(t.length-e,0),o=Array(a);++n<a;)o[n]=t[e+n];n=-1;for(var i=Array(e+1);++n<e;)i[n]=t[n];return i[e]=o,ir(r,this,i)}}((function(e,t){return function(e){return!!e&&"object"==r(e)}(n=e)&&function(r){return null!=r&&function(r){return"number"==typeof r&&r>-1&&r%1==0&&r<=9007199254740991}(r.length)&&!Nr(r)}(n)?Dr(e,t):[];var n})),Br=2147483647,Hr=/^xn--/,Ur=/[^\x20-\x7E]/,Vr=/[\x2E\u3002\uFF0E\uFF61]/g,Pr={overflow:"Overflow: input needs wider integers to process","not-basic":"Illegal input >= 0x80 (not a basic code point)","invalid-input":"Invalid input"},Wr=Math.floor,Fr=String.fromCharCode;
    /*! https://mths.be/punycode v1.4.1 by @mathias */function Gr(r){throw new RangeError(Pr[r])}function zr(r,e){for(var t=r.length,n=[];t--;)n[t]=e(r[t]);return n}function Jr(r,e){var t=r.split("@"),n="";return t.length>1&&(n=t[0]+"@",r=t[1]),n+zr((r=r.replace(Vr,".")).split("."),e).join(".")}function Mr(r){for(var e,t,n=[],a=0,o=r.length;a<o;)(e=r.charCodeAt(a++))>=55296&&e<=56319&&a<o?56320==(64512&(t=r.charCodeAt(a++)))?n.push(((1023&e)<<10)+(1023&t)+65536):(n.push(e),a--):n.push(e);return n}function $r(r){return zr(r,(function(r){var e="";return r>65535&&(e+=Fr((r-=65536)>>>10&1023|55296),r=56320|1023&r),e+=Fr(r)})).join("")}function Yr(r,e){return r+22+75*(r<26)-((0!=e)<<5)}function Zr(r,e,t){var n=0;for(r=t?Wr(r/700):r>>1,r+=Wr(r/e);r>455;n+=36)r=Wr(r/35);return Wr(n+36*r/(r+38))}function Kr(r){var e,t,n,a,o,i,s,c,l,u,p,f=[],g=r.length,d=0,h=128,m=72;for((t=r.lastIndexOf("-"))<0&&(t=0),n=0;n<t;++n)r.charCodeAt(n)>=128&&Gr("not-basic"),f.push(r.charCodeAt(n));for(a=t>0?t+1:0;a<g;){for(o=d,i=1,s=36;a>=g&&Gr("invalid-input"),((c=(p=r.charCodeAt(a++))-48<10?p-22:p-65<26?p-65:p-97<26?p-97:36)>=36||c>Wr((Br-d)/i))&&Gr("overflow"),d+=c*i,!(c<(l=s<=m?1:s>=m+26?26:s-m));s+=36)i>Wr(Br/(u=36-l))&&Gr("overflow"),i*=u;m=Zr(d-o,e=f.length+1,0==o),Wr(d/e)>Br-h&&Gr("overflow"),h+=Wr(d/e),d%=e,f.splice(d++,0,h)}return $r(f)}function Qr(r){var e,t,n,a,o,i,s,c,l,u,p,f,g,d,h,m=[];for(f=(r=Mr(r)).length,e=128,t=0,o=72,i=0;i<f;++i)(p=r[i])<128&&m.push(Fr(p));for(n=a=m.length,a&&m.push("-");n<f;){for(s=Br,i=0;i<f;++i)(p=r[i])>=e&&p<s&&(s=p);for(s-e>Wr((Br-t)/(g=n+1))&&Gr("overflow"),t+=(s-e)*g,e=s,i=0;i<f;++i)if((p=r[i])<e&&++t>Br&&Gr("overflow"),p==e){for(c=t,l=36;!(c<(u=l<=o?1:l>=o+26?26:l-o));l+=36)h=c-u,d=36-u,m.push(Fr(Yr(u+h%d,0))),c=Wr(h/d);m.push(Fr(Yr(c,0))),o=Zr(t,g,n==a),t=0,++n}++t,++e}return m.join("")}var Xr={version:"1.4.1",ucs2:{decode:Mr,encode:$r},toASCII:function(r){return Jr(r,(function(r){return Ur.test(r)?"xn--"+Qr(r):r}))},toUnicode:function(r){return Jr(r,(function(r){return Hr.test(r)?Kr(r.slice(4).toLowerCase()):r}))},encode:Qr,decode:Kr},re=D(Object.freeze({__proto__:null,default:{9:"Tab;",10:"NewLine;",33:"excl;",34:"quot;",35:"num;",36:"dollar;",37:"percnt;",38:"amp;",39:"apos;",40:"lpar;",41:"rpar;",42:"midast;",43:"plus;",44:"comma;",46:"period;",47:"sol;",58:"colon;",59:"semi;",60:"lt;",61:"equals;",62:"gt;",63:"quest;",64:"commat;",91:"lsqb;",92:"bsol;",93:"rsqb;",94:"Hat;",95:"UnderBar;",96:"grave;",123:"lcub;",124:"VerticalLine;",125:"rcub;",160:"NonBreakingSpace;",161:"iexcl;",162:"cent;",163:"pound;",164:"curren;",165:"yen;",166:"brvbar;",167:"sect;",168:"uml;",169:"copy;",170:"ordf;",171:"laquo;",172:"not;",173:"shy;",174:"reg;",175:"strns;",176:"deg;",177:"pm;",178:"sup2;",179:"sup3;",180:"DiacriticalAcute;",181:"micro;",182:"para;",183:"middot;",184:"Cedilla;",185:"sup1;",186:"ordm;",187:"raquo;",188:"frac14;",189:"half;",190:"frac34;",191:"iquest;",192:"Agrave;",193:"Aacute;",194:"Acirc;",195:"Atilde;",196:"Auml;",197:"Aring;",198:"AElig;",199:"Ccedil;",200:"Egrave;",201:"Eacute;",202:"Ecirc;",203:"Euml;",204:"Igrave;",205:"Iacute;",206:"Icirc;",207:"Iuml;",208:"ETH;",209:"Ntilde;",210:"Ograve;",211:"Oacute;",212:"Ocirc;",213:"Otilde;",214:"Ouml;",215:"times;",216:"Oslash;",217:"Ugrave;",218:"Uacute;",219:"Ucirc;",220:"Uuml;",221:"Yacute;",222:"THORN;",223:"szlig;",224:"agrave;",225:"aacute;",226:"acirc;",227:"atilde;",228:"auml;",229:"aring;",230:"aelig;",231:"ccedil;",232:"egrave;",233:"eacute;",234:"ecirc;",235:"euml;",236:"igrave;",237:"iacute;",238:"icirc;",239:"iuml;",240:"eth;",241:"ntilde;",242:"ograve;",243:"oacute;",244:"ocirc;",245:"otilde;",246:"ouml;",247:"divide;",248:"oslash;",249:"ugrave;",250:"uacute;",251:"ucirc;",252:"uuml;",253:"yacute;",254:"thorn;",255:"yuml;",256:"Amacr;",257:"amacr;",258:"Abreve;",259:"abreve;",260:"Aogon;",261:"aogon;",262:"Cacute;",263:"cacute;",264:"Ccirc;",265:"ccirc;",266:"Cdot;",267:"cdot;",268:"Ccaron;",269:"ccaron;",270:"Dcaron;",271:"dcaron;",272:"Dstrok;",273:"dstrok;",274:"Emacr;",275:"emacr;",278:"Edot;",279:"edot;",280:"Eogon;",281:"eogon;",282:"Ecaron;",283:"ecaron;",284:"Gcirc;",285:"gcirc;",286:"Gbreve;",287:"gbreve;",288:"Gdot;",289:"gdot;",290:"Gcedil;",292:"Hcirc;",293:"hcirc;",294:"Hstrok;",295:"hstrok;",296:"Itilde;",297:"itilde;",298:"Imacr;",299:"imacr;",302:"Iogon;",303:"iogon;",304:"Idot;",305:"inodot;",306:"IJlig;",307:"ijlig;",308:"Jcirc;",309:"jcirc;",310:"Kcedil;",311:"kcedil;",312:"kgreen;",313:"Lacute;",314:"lacute;",315:"Lcedil;",316:"lcedil;",317:"Lcaron;",318:"lcaron;",319:"Lmidot;",320:"lmidot;",321:"Lstrok;",322:"lstrok;",323:"Nacute;",324:"nacute;",325:"Ncedil;",326:"ncedil;",327:"Ncaron;",328:"ncaron;",329:"napos;",330:"ENG;",331:"eng;",332:"Omacr;",333:"omacr;",336:"Odblac;",337:"odblac;",338:"OElig;",339:"oelig;",340:"Racute;",341:"racute;",342:"Rcedil;",343:"rcedil;",344:"Rcaron;",345:"rcaron;",346:"Sacute;",347:"sacute;",348:"Scirc;",349:"scirc;",350:"Scedil;",351:"scedil;",352:"Scaron;",353:"scaron;",354:"Tcedil;",355:"tcedil;",356:"Tcaron;",357:"tcaron;",358:"Tstrok;",359:"tstrok;",360:"Utilde;",361:"utilde;",362:"Umacr;",363:"umacr;",364:"Ubreve;",365:"ubreve;",366:"Uring;",367:"uring;",368:"Udblac;",369:"udblac;",370:"Uogon;",371:"uogon;",372:"Wcirc;",373:"wcirc;",374:"Ycirc;",375:"ycirc;",376:"Yuml;",377:"Zacute;",378:"zacute;",379:"Zdot;",380:"zdot;",381:"Zcaron;",382:"zcaron;",402:"fnof;",437:"imped;",501:"gacute;",567:"jmath;",710:"circ;",711:"Hacek;",728:"breve;",729:"dot;",730:"ring;",731:"ogon;",732:"tilde;",733:"DiacriticalDoubleAcute;",785:"DownBreve;",913:"Alpha;",914:"Beta;",915:"Gamma;",916:"Delta;",917:"Epsilon;",918:"Zeta;",919:"Eta;",920:"Theta;",921:"Iota;",922:"Kappa;",923:"Lambda;",924:"Mu;",925:"Nu;",926:"Xi;",927:"Omicron;",928:"Pi;",929:"Rho;",931:"Sigma;",932:"Tau;",933:"Upsilon;",934:"Phi;",935:"Chi;",936:"Psi;",937:"Omega;",945:"alpha;",946:"beta;",947:"gamma;",948:"delta;",949:"epsilon;",950:"zeta;",951:"eta;",952:"theta;",953:"iota;",954:"kappa;",955:"lambda;",956:"mu;",957:"nu;",958:"xi;",959:"omicron;",960:"pi;",961:"rho;",962:"varsigma;",963:"sigma;",964:"tau;",965:"upsilon;",966:"phi;",967:"chi;",968:"psi;",969:"omega;",977:"vartheta;",978:"upsih;",981:"varphi;",982:"varpi;",988:"Gammad;",989:"gammad;",1008:"varkappa;",1009:"varrho;",1013:"varepsilon;",1014:"bepsi;",1025:"IOcy;",1026:"DJcy;",1027:"GJcy;",1028:"Jukcy;",1029:"DScy;",1030:"Iukcy;",1031:"YIcy;",1032:"Jsercy;",1033:"LJcy;",1034:"NJcy;",1035:"TSHcy;",1036:"KJcy;",1038:"Ubrcy;",1039:"DZcy;",1040:"Acy;",1041:"Bcy;",1042:"Vcy;",1043:"Gcy;",1044:"Dcy;",1045:"IEcy;",1046:"ZHcy;",1047:"Zcy;",1048:"Icy;",1049:"Jcy;",1050:"Kcy;",1051:"Lcy;",1052:"Mcy;",1053:"Ncy;",1054:"Ocy;",1055:"Pcy;",1056:"Rcy;",1057:"Scy;",1058:"Tcy;",1059:"Ucy;",1060:"Fcy;",1061:"KHcy;",1062:"TScy;",1063:"CHcy;",1064:"SHcy;",1065:"SHCHcy;",1066:"HARDcy;",1067:"Ycy;",1068:"SOFTcy;",1069:"Ecy;",1070:"YUcy;",1071:"YAcy;",1072:"acy;",1073:"bcy;",1074:"vcy;",1075:"gcy;",1076:"dcy;",1077:"iecy;",1078:"zhcy;",1079:"zcy;",1080:"icy;",1081:"jcy;",1082:"kcy;",1083:"lcy;",1084:"mcy;",1085:"ncy;",1086:"ocy;",1087:"pcy;",1088:"rcy;",1089:"scy;",1090:"tcy;",1091:"ucy;",1092:"fcy;",1093:"khcy;",1094:"tscy;",1095:"chcy;",1096:"shcy;",1097:"shchcy;",1098:"hardcy;",1099:"ycy;",1100:"softcy;",1101:"ecy;",1102:"yucy;",1103:"yacy;",1105:"iocy;",1106:"djcy;",1107:"gjcy;",1108:"jukcy;",1109:"dscy;",1110:"iukcy;",1111:"yicy;",1112:"jsercy;",1113:"ljcy;",1114:"njcy;",1115:"tshcy;",1116:"kjcy;",1118:"ubrcy;",1119:"dzcy;",8194:"ensp;",8195:"emsp;",8196:"emsp13;",8197:"emsp14;",8199:"numsp;",8200:"puncsp;",8201:"ThinSpace;",8202:"VeryThinSpace;",8203:"ZeroWidthSpace;",8204:"zwnj;",8205:"zwj;",8206:"lrm;",8207:"rlm;",8208:"hyphen;",8211:"ndash;",8212:"mdash;",8213:"horbar;",8214:"Vert;",8216:"OpenCurlyQuote;",8217:"rsquor;",8218:"sbquo;",8220:"OpenCurlyDoubleQuote;",8221:"rdquor;",8222:"ldquor;",8224:"dagger;",8225:"ddagger;",8226:"bullet;",8229:"nldr;",8230:"mldr;",8240:"permil;",8241:"pertenk;",8242:"prime;",8243:"Prime;",8244:"tprime;",8245:"bprime;",8249:"lsaquo;",8250:"rsaquo;",8254:"OverBar;",8257:"caret;",8259:"hybull;",8260:"frasl;",8271:"bsemi;",8279:"qprime;",8287:"MediumSpace;",8288:"NoBreak;",8289:"ApplyFunction;",8290:"it;",8291:"InvisibleComma;",8364:"euro;",8411:"TripleDot;",8412:"DotDot;",8450:"Copf;",8453:"incare;",8458:"gscr;",8459:"Hscr;",8460:"Poincareplane;",8461:"quaternions;",8462:"planckh;",8463:"plankv;",8464:"Iscr;",8465:"imagpart;",8466:"Lscr;",8467:"ell;",8469:"Nopf;",8470:"numero;",8471:"copysr;",8472:"wp;",8473:"primes;",8474:"rationals;",8475:"Rscr;",8476:"Rfr;",8477:"Ropf;",8478:"rx;",8482:"trade;",8484:"Zopf;",8487:"mho;",8488:"Zfr;",8489:"iiota;",8492:"Bscr;",8493:"Cfr;",8495:"escr;",8496:"expectation;",8497:"Fscr;",8499:"phmmat;",8500:"oscr;",8501:"aleph;",8502:"beth;",8503:"gimel;",8504:"daleth;",8517:"DD;",8518:"DifferentialD;",8519:"exponentiale;",8520:"ImaginaryI;",8531:"frac13;",8532:"frac23;",8533:"frac15;",8534:"frac25;",8535:"frac35;",8536:"frac45;",8537:"frac16;",8538:"frac56;",8539:"frac18;",8540:"frac38;",8541:"frac58;",8542:"frac78;",8592:"slarr;",8593:"uparrow;",8594:"srarr;",8595:"ShortDownArrow;",8596:"leftrightarrow;",8597:"varr;",8598:"UpperLeftArrow;",8599:"UpperRightArrow;",8600:"searrow;",8601:"swarrow;",8602:"nleftarrow;",8603:"nrightarrow;",8605:"rightsquigarrow;",8606:"twoheadleftarrow;",8607:"Uarr;",8608:"twoheadrightarrow;",8609:"Darr;",8610:"leftarrowtail;",8611:"rightarrowtail;",8612:"mapstoleft;",8613:"UpTeeArrow;",8614:"RightTeeArrow;",8615:"mapstodown;",8617:"larrhk;",8618:"rarrhk;",8619:"looparrowleft;",8620:"rarrlp;",8621:"leftrightsquigarrow;",8622:"nleftrightarrow;",8624:"lsh;",8625:"rsh;",8626:"ldsh;",8627:"rdsh;",8629:"crarr;",8630:"curvearrowleft;",8631:"curvearrowright;",8634:"olarr;",8635:"orarr;",8636:"lharu;",8637:"lhard;",8638:"upharpoonright;",8639:"upharpoonleft;",8640:"RightVector;",8641:"rightharpoondown;",8642:"RightDownVector;",8643:"LeftDownVector;",8644:"rlarr;",8645:"UpArrowDownArrow;",8646:"lrarr;",8647:"llarr;",8648:"uuarr;",8649:"rrarr;",8650:"downdownarrows;",8651:"ReverseEquilibrium;",8652:"rlhar;",8653:"nLeftarrow;",8654:"nLeftrightarrow;",8655:"nRightarrow;",8656:"Leftarrow;",8657:"Uparrow;",8658:"Rightarrow;",8659:"Downarrow;",8660:"Leftrightarrow;",8661:"vArr;",8662:"nwArr;",8663:"neArr;",8664:"seArr;",8665:"swArr;",8666:"Lleftarrow;",8667:"Rrightarrow;",8669:"zigrarr;",8676:"LeftArrowBar;",8677:"RightArrowBar;",8693:"duarr;",8701:"loarr;",8702:"roarr;",8703:"hoarr;",8704:"forall;",8705:"complement;",8706:"PartialD;",8707:"Exists;",8708:"NotExists;",8709:"varnothing;",8711:"nabla;",8712:"isinv;",8713:"notinva;",8715:"SuchThat;",8716:"NotReverseElement;",8719:"Product;",8720:"Coproduct;",8721:"sum;",8722:"minus;",8723:"mp;",8724:"plusdo;",8726:"ssetmn;",8727:"lowast;",8728:"SmallCircle;",8730:"Sqrt;",8733:"vprop;",8734:"infin;",8735:"angrt;",8736:"angle;",8737:"measuredangle;",8738:"angsph;",8739:"VerticalBar;",8740:"nsmid;",8741:"spar;",8742:"nspar;",8743:"wedge;",8744:"vee;",8745:"cap;",8746:"cup;",8747:"Integral;",8748:"Int;",8749:"tint;",8750:"oint;",8751:"DoubleContourIntegral;",8752:"Cconint;",8753:"cwint;",8754:"cwconint;",8755:"CounterClockwiseContourIntegral;",8756:"therefore;",8757:"because;",8758:"ratio;",8759:"Proportion;",8760:"minusd;",8762:"mDDot;",8763:"homtht;",8764:"Tilde;",8765:"bsim;",8766:"mstpos;",8767:"acd;",8768:"wreath;",8769:"nsim;",8770:"esim;",8771:"TildeEqual;",8772:"nsimeq;",8773:"TildeFullEqual;",8774:"simne;",8775:"NotTildeFullEqual;",8776:"TildeTilde;",8777:"NotTildeTilde;",8778:"approxeq;",8779:"apid;",8780:"bcong;",8781:"CupCap;",8782:"HumpDownHump;",8783:"HumpEqual;",8784:"esdot;",8785:"eDot;",8786:"fallingdotseq;",8787:"risingdotseq;",8788:"coloneq;",8789:"eqcolon;",8790:"eqcirc;",8791:"cire;",8793:"wedgeq;",8794:"veeeq;",8796:"trie;",8799:"questeq;",8800:"NotEqual;",8801:"equiv;",8802:"NotCongruent;",8804:"leq;",8805:"GreaterEqual;",8806:"LessFullEqual;",8807:"GreaterFullEqual;",8808:"lneqq;",8809:"gneqq;",8810:"NestedLessLess;",8811:"NestedGreaterGreater;",8812:"twixt;",8813:"NotCupCap;",8814:"NotLess;",8815:"NotGreater;",8816:"NotLessEqual;",8817:"NotGreaterEqual;",8818:"lsim;",8819:"gtrsim;",8820:"NotLessTilde;",8821:"NotGreaterTilde;",8822:"lg;",8823:"gtrless;",8824:"ntlg;",8825:"ntgl;",8826:"Precedes;",8827:"Succeeds;",8828:"PrecedesSlantEqual;",8829:"SucceedsSlantEqual;",8830:"prsim;",8831:"succsim;",8832:"nprec;",8833:"nsucc;",8834:"subset;",8835:"supset;",8836:"nsub;",8837:"nsup;",8838:"SubsetEqual;",8839:"supseteq;",8840:"nsubseteq;",8841:"nsupseteq;",8842:"subsetneq;",8843:"supsetneq;",8845:"cupdot;",8846:"uplus;",8847:"SquareSubset;",8848:"SquareSuperset;",8849:"SquareSubsetEqual;",8850:"SquareSupersetEqual;",8851:"SquareIntersection;",8852:"SquareUnion;",8853:"oplus;",8854:"ominus;",8855:"otimes;",8856:"osol;",8857:"odot;",8858:"ocir;",8859:"oast;",8861:"odash;",8862:"plusb;",8863:"minusb;",8864:"timesb;",8865:"sdotb;",8866:"vdash;",8867:"LeftTee;",8868:"top;",8869:"UpTee;",8871:"models;",8872:"vDash;",8873:"Vdash;",8874:"Vvdash;",8875:"VDash;",8876:"nvdash;",8877:"nvDash;",8878:"nVdash;",8879:"nVDash;",8880:"prurel;",8882:"vltri;",8883:"vrtri;",8884:"trianglelefteq;",8885:"trianglerighteq;",8886:"origof;",8887:"imof;",8888:"mumap;",8889:"hercon;",8890:"intercal;",8891:"veebar;",8893:"barvee;",8894:"angrtvb;",8895:"lrtri;",8896:"xwedge;",8897:"xvee;",8898:"xcap;",8899:"xcup;",8900:"diamond;",8901:"sdot;",8902:"Star;",8903:"divonx;",8904:"bowtie;",8905:"ltimes;",8906:"rtimes;",8907:"lthree;",8908:"rthree;",8909:"bsime;",8910:"cuvee;",8911:"cuwed;",8912:"Subset;",8913:"Supset;",8914:"Cap;",8915:"Cup;",8916:"pitchfork;",8917:"epar;",8918:"ltdot;",8919:"gtrdot;",8920:"Ll;",8921:"ggg;",8922:"LessEqualGreater;",8923:"gtreqless;",8926:"curlyeqprec;",8927:"curlyeqsucc;",8928:"nprcue;",8929:"nsccue;",8930:"nsqsube;",8931:"nsqsupe;",8934:"lnsim;",8935:"gnsim;",8936:"prnsim;",8937:"succnsim;",8938:"ntriangleleft;",8939:"ntriangleright;",8940:"ntrianglelefteq;",8941:"ntrianglerighteq;",8942:"vellip;",8943:"ctdot;",8944:"utdot;",8945:"dtdot;",8946:"disin;",8947:"isinsv;",8948:"isins;",8949:"isindot;",8950:"notinvc;",8951:"notinvb;",8953:"isinE;",8954:"nisd;",8955:"xnis;",8956:"nis;",8957:"notnivc;",8958:"notnivb;",8965:"barwedge;",8966:"doublebarwedge;",8968:"LeftCeiling;",8969:"RightCeiling;",8970:"lfloor;",8971:"RightFloor;",8972:"drcrop;",8973:"dlcrop;",8974:"urcrop;",8975:"ulcrop;",8976:"bnot;",8978:"profline;",8979:"profsurf;",8981:"telrec;",8982:"target;",8988:"ulcorner;",8989:"urcorner;",8990:"llcorner;",8991:"lrcorner;",8994:"sfrown;",8995:"ssmile;",9005:"cylcty;",9006:"profalar;",9014:"topbot;",9021:"ovbar;",9023:"solbar;",9084:"angzarr;",9136:"lmoustache;",9137:"rmoustache;",9140:"tbrk;",9141:"UnderBracket;",9142:"bbrktbrk;",9180:"OverParenthesis;",9181:"UnderParenthesis;",9182:"OverBrace;",9183:"UnderBrace;",9186:"trpezium;",9191:"elinters;",9251:"blank;",9416:"oS;",9472:"HorizontalLine;",9474:"boxv;",9484:"boxdr;",9488:"boxdl;",9492:"boxur;",9496:"boxul;",9500:"boxvr;",9508:"boxvl;",9516:"boxhd;",9524:"boxhu;",9532:"boxvh;",9552:"boxH;",9553:"boxV;",9554:"boxdR;",9555:"boxDr;",9556:"boxDR;",9557:"boxdL;",9558:"boxDl;",9559:"boxDL;",9560:"boxuR;",9561:"boxUr;",9562:"boxUR;",9563:"boxuL;",9564:"boxUl;",9565:"boxUL;",9566:"boxvR;",9567:"boxVr;",9568:"boxVR;",9569:"boxvL;",9570:"boxVl;",9571:"boxVL;",9572:"boxHd;",9573:"boxhD;",9574:"boxHD;",9575:"boxHu;",9576:"boxhU;",9577:"boxHU;",9578:"boxvH;",9579:"boxVh;",9580:"boxVH;",9600:"uhblk;",9604:"lhblk;",9608:"block;",9617:"blk14;",9618:"blk12;",9619:"blk34;",9633:"square;",9642:"squf;",9643:"EmptyVerySmallSquare;",9645:"rect;",9646:"marker;",9649:"fltns;",9651:"xutri;",9652:"utrif;",9653:"utri;",9656:"rtrif;",9657:"triangleright;",9661:"xdtri;",9662:"dtrif;",9663:"triangledown;",9666:"ltrif;",9667:"triangleleft;",9674:"lozenge;",9675:"cir;",9708:"tridot;",9711:"xcirc;",9720:"ultri;",9721:"urtri;",9722:"lltri;",9723:"EmptySmallSquare;",9724:"FilledSmallSquare;",9733:"starf;",9734:"star;",9742:"phone;",9792:"female;",9794:"male;",9824:"spadesuit;",9827:"clubsuit;",9829:"heartsuit;",9830:"diams;",9834:"sung;",9837:"flat;",9838:"natural;",9839:"sharp;",10003:"checkmark;",10007:"cross;",10016:"maltese;",10038:"sext;",10072:"VerticalSeparator;",10098:"lbbrk;",10099:"rbbrk;",10184:"bsolhsub;",10185:"suphsol;",10214:"lobrk;",10215:"robrk;",10216:"LeftAngleBracket;",10217:"RightAngleBracket;",10218:"Lang;",10219:"Rang;",10220:"loang;",10221:"roang;",10229:"xlarr;",10230:"xrarr;",10231:"xharr;",10232:"xlArr;",10233:"xrArr;",10234:"xhArr;",10236:"xmap;",10239:"dzigrarr;",10498:"nvlArr;",10499:"nvrArr;",10500:"nvHarr;",10501:"Map;",10508:"lbarr;",10509:"rbarr;",10510:"lBarr;",10511:"rBarr;",10512:"RBarr;",10513:"DDotrahd;",10514:"UpArrowBar;",10515:"DownArrowBar;",10518:"Rarrtl;",10521:"latail;",10522:"ratail;",10523:"lAtail;",10524:"rAtail;",10525:"larrfs;",10526:"rarrfs;",10527:"larrbfs;",10528:"rarrbfs;",10531:"nwarhk;",10532:"nearhk;",10533:"searhk;",10534:"swarhk;",10535:"nwnear;",10536:"toea;",10537:"tosa;",10538:"swnwar;",10547:"rarrc;",10549:"cudarrr;",10550:"ldca;",10551:"rdca;",10552:"cudarrl;",10553:"larrpl;",10556:"curarrm;",10557:"cularrp;",10565:"rarrpl;",10568:"harrcir;",10569:"Uarrocir;",10570:"lurdshar;",10571:"ldrushar;",10574:"LeftRightVector;",10575:"RightUpDownVector;",10576:"DownLeftRightVector;",10577:"LeftUpDownVector;",10578:"LeftVectorBar;",10579:"RightVectorBar;",10580:"RightUpVectorBar;",10581:"RightDownVectorBar;",10582:"DownLeftVectorBar;",10583:"DownRightVectorBar;",10584:"LeftUpVectorBar;",10585:"LeftDownVectorBar;",10586:"LeftTeeVector;",10587:"RightTeeVector;",10588:"RightUpTeeVector;",10589:"RightDownTeeVector;",10590:"DownLeftTeeVector;",10591:"DownRightTeeVector;",10592:"LeftUpTeeVector;",10593:"LeftDownTeeVector;",10594:"lHar;",10595:"uHar;",10596:"rHar;",10597:"dHar;",10598:"luruhar;",10599:"ldrdhar;",10600:"ruluhar;",10601:"rdldhar;",10602:"lharul;",10603:"llhard;",10604:"rharul;",10605:"lrhard;",10606:"UpEquilibrium;",10607:"ReverseUpEquilibrium;",10608:"RoundImplies;",10609:"erarr;",10610:"simrarr;",10611:"larrsim;",10612:"rarrsim;",10613:"rarrap;",10614:"ltlarr;",10616:"gtrarr;",10617:"subrarr;",10619:"suplarr;",10620:"lfisht;",10621:"rfisht;",10622:"ufisht;",10623:"dfisht;",10629:"lopar;",10630:"ropar;",10635:"lbrke;",10636:"rbrke;",10637:"lbrkslu;",10638:"rbrksld;",10639:"lbrksld;",10640:"rbrkslu;",10641:"langd;",10642:"rangd;",10643:"lparlt;",10644:"rpargt;",10645:"gtlPar;",10646:"ltrPar;",10650:"vzigzag;",10652:"vangrt;",10653:"angrtvbd;",10660:"ange;",10661:"range;",10662:"dwangle;",10663:"uwangle;",10664:"angmsdaa;",10665:"angmsdab;",10666:"angmsdac;",10667:"angmsdad;",10668:"angmsdae;",10669:"angmsdaf;",10670:"angmsdag;",10671:"angmsdah;",10672:"bemptyv;",10673:"demptyv;",10674:"cemptyv;",10675:"raemptyv;",10676:"laemptyv;",10677:"ohbar;",10678:"omid;",10679:"opar;",10681:"operp;",10683:"olcross;",10684:"odsold;",10686:"olcir;",10687:"ofcir;",10688:"olt;",10689:"ogt;",10690:"cirscir;",10691:"cirE;",10692:"solb;",10693:"bsolb;",10697:"boxbox;",10701:"trisb;",10702:"rtriltri;",10703:"LeftTriangleBar;",10704:"RightTriangleBar;",10716:"iinfin;",10717:"infintie;",10718:"nvinfin;",10723:"eparsl;",10724:"smeparsl;",10725:"eqvparsl;",10731:"lozf;",10740:"RuleDelayed;",10742:"dsol;",10752:"xodot;",10753:"xoplus;",10754:"xotime;",10756:"xuplus;",10758:"xsqcup;",10764:"qint;",10765:"fpartint;",10768:"cirfnint;",10769:"awint;",10770:"rppolint;",10771:"scpolint;",10772:"npolint;",10773:"pointint;",10774:"quatint;",10775:"intlarhk;",10786:"pluscir;",10787:"plusacir;",10788:"simplus;",10789:"plusdu;",10790:"plussim;",10791:"plustwo;",10793:"mcomma;",10794:"minusdu;",10797:"loplus;",10798:"roplus;",10799:"Cross;",10800:"timesd;",10801:"timesbar;",10803:"smashp;",10804:"lotimes;",10805:"rotimes;",10806:"otimesas;",10807:"Otimes;",10808:"odiv;",10809:"triplus;",10810:"triminus;",10811:"tritime;",10812:"iprod;",10815:"amalg;",10816:"capdot;",10818:"ncup;",10819:"ncap;",10820:"capand;",10821:"cupor;",10822:"cupcap;",10823:"capcup;",10824:"cupbrcap;",10825:"capbrcup;",10826:"cupcup;",10827:"capcap;",10828:"ccups;",10829:"ccaps;",10832:"ccupssm;",10835:"And;",10836:"Or;",10837:"andand;",10838:"oror;",10839:"orslope;",10840:"andslope;",10842:"andv;",10843:"orv;",10844:"andd;",10845:"ord;",10847:"wedbar;",10854:"sdote;",10858:"simdot;",10861:"congdot;",10862:"easter;",10863:"apacir;",10864:"apE;",10865:"eplus;",10866:"pluse;",10867:"Esim;",10868:"Colone;",10869:"Equal;",10871:"eDDot;",10872:"equivDD;",10873:"ltcir;",10874:"gtcir;",10875:"ltquest;",10876:"gtquest;",10877:"LessSlantEqual;",10878:"GreaterSlantEqual;",10879:"lesdot;",10880:"gesdot;",10881:"lesdoto;",10882:"gesdoto;",10883:"lesdotor;",10884:"gesdotol;",10885:"lessapprox;",10886:"gtrapprox;",10887:"lneq;",10888:"gneq;",10889:"lnapprox;",10890:"gnapprox;",10891:"lesseqqgtr;",10892:"gtreqqless;",10893:"lsime;",10894:"gsime;",10895:"lsimg;",10896:"gsiml;",10897:"lgE;",10898:"glE;",10899:"lesges;",10900:"gesles;",10901:"eqslantless;",10902:"eqslantgtr;",10903:"elsdot;",10904:"egsdot;",10905:"el;",10906:"eg;",10909:"siml;",10910:"simg;",10911:"simlE;",10912:"simgE;",10913:"LessLess;",10914:"GreaterGreater;",10916:"glj;",10917:"gla;",10918:"ltcc;",10919:"gtcc;",10920:"lescc;",10921:"gescc;",10922:"smt;",10923:"lat;",10924:"smte;",10925:"late;",10926:"bumpE;",10927:"preceq;",10928:"succeq;",10931:"prE;",10932:"scE;",10933:"prnE;",10934:"succneqq;",10935:"precapprox;",10936:"succapprox;",10937:"prnap;",10938:"succnapprox;",10939:"Pr;",10940:"Sc;",10941:"subdot;",10942:"supdot;",10943:"subplus;",10944:"supplus;",10945:"submult;",10946:"supmult;",10947:"subedot;",10948:"supedot;",10949:"subseteqq;",10950:"supseteqq;",10951:"subsim;",10952:"supsim;",10955:"subsetneqq;",10956:"supsetneqq;",10959:"csub;",10960:"csup;",10961:"csube;",10962:"csupe;",10963:"subsup;",10964:"supsub;",10965:"subsub;",10966:"supsup;",10967:"suphsub;",10968:"supdsub;",10969:"forkv;",10970:"topfork;",10971:"mlcp;",10980:"DoubleLeftTee;",10982:"Vdashl;",10983:"Barv;",10984:"vBar;",10985:"vBarv;",10987:"Vbar;",10988:"Not;",10989:"bNot;",10990:"rnmid;",10991:"cirmid;",10992:"midcir;",10993:"topcir;",10994:"nhpar;",10995:"parsim;",11005:"parsl;",64256:"fflig;",64257:"filig;",64258:"fllig;",64259:"ffilig;",64260:"ffllig;"}})),ee=function(r,e){if("string"!=typeof r)throw new TypeError("Expected a String");e||(e={});var t=!0;e.named&&(t=!1);void 0!==e.numeric&&(t=e.numeric);for(var n=e.special||{'"':!0,"'":!0,"<":!0,">":!0,"&":!0},a=Xr.ucs2.decode(r),o=[],i=0;i<a.length;i++){var s=a[i],c=Xr.ucs2.encode([s]),l=re[s];l&&(s>=127||n[c])&&!t?o.push("&"+(/;$/.test(l)?l:l+";")):s<32||s>=127||n[c]?o.push("&#"+s+";"):o.push(c)}return o.join("")};var te={"Aacute;":"Á",Aacute:"Á","aacute;":"á",aacute:"á","Abreve;":"Ă","abreve;":"ă","ac;":"∾","acd;":"∿","acE;":"∾̳","Acirc;":"Â",Acirc:"Â","acirc;":"â",acirc:"â","acute;":"´",acute:"´","Acy;":"А","acy;":"а","AElig;":"Æ",AElig:"Æ","aelig;":"æ",aelig:"æ","af;":"⁡","Afr;":"𝔄","afr;":"𝔞","Agrave;":"À",Agrave:"À","agrave;":"à",agrave:"à","alefsym;":"ℵ","aleph;":"ℵ","Alpha;":"Α","alpha;":"α","Amacr;":"Ā","amacr;":"ā","amalg;":"⨿","AMP;":"&",AMP:"&","amp;":"&",amp:"&","And;":"⩓","and;":"∧","andand;":"⩕","andd;":"⩜","andslope;":"⩘","andv;":"⩚","ang;":"∠","ange;":"⦤","angle;":"∠","angmsd;":"∡","angmsdaa;":"⦨","angmsdab;":"⦩","angmsdac;":"⦪","angmsdad;":"⦫","angmsdae;":"⦬","angmsdaf;":"⦭","angmsdag;":"⦮","angmsdah;":"⦯","angrt;":"∟","angrtvb;":"⊾","angrtvbd;":"⦝","angsph;":"∢","angst;":"Å","angzarr;":"⍼","Aogon;":"Ą","aogon;":"ą","Aopf;":"𝔸","aopf;":"𝕒","ap;":"≈","apacir;":"⩯","apE;":"⩰","ape;":"≊","apid;":"≋","apos;":"'","ApplyFunction;":"⁡","approx;":"≈","approxeq;":"≊","Aring;":"Å",Aring:"Å","aring;":"å",aring:"å","Ascr;":"𝒜","ascr;":"𝒶","Assign;":"≔","ast;":"*","asymp;":"≈","asympeq;":"≍","Atilde;":"Ã",Atilde:"Ã","atilde;":"ã",atilde:"ã","Auml;":"Ä",Auml:"Ä","auml;":"ä",auml:"ä","awconint;":"∳","awint;":"⨑","backcong;":"≌","backepsilon;":"϶","backprime;":"‵","backsim;":"∽","backsimeq;":"⋍","Backslash;":"∖","Barv;":"⫧","barvee;":"⊽","Barwed;":"⌆","barwed;":"⌅","barwedge;":"⌅","bbrk;":"⎵","bbrktbrk;":"⎶","bcong;":"≌","Bcy;":"Б","bcy;":"б","bdquo;":"„","becaus;":"∵","Because;":"∵","because;":"∵","bemptyv;":"⦰","bepsi;":"϶","bernou;":"ℬ","Bernoullis;":"ℬ","Beta;":"Β","beta;":"β","beth;":"ℶ","between;":"≬","Bfr;":"𝔅","bfr;":"𝔟","bigcap;":"⋂","bigcirc;":"◯","bigcup;":"⋃","bigodot;":"⨀","bigoplus;":"⨁","bigotimes;":"⨂","bigsqcup;":"⨆","bigstar;":"★","bigtriangledown;":"▽","bigtriangleup;":"△","biguplus;":"⨄","bigvee;":"⋁","bigwedge;":"⋀","bkarow;":"⤍","blacklozenge;":"⧫","blacksquare;":"▪","blacktriangle;":"▴","blacktriangledown;":"▾","blacktriangleleft;":"◂","blacktriangleright;":"▸","blank;":"␣","blk12;":"▒","blk14;":"░","blk34;":"▓","block;":"█","bne;":"=⃥","bnequiv;":"≡⃥","bNot;":"⫭","bnot;":"⌐","Bopf;":"𝔹","bopf;":"𝕓","bot;":"⊥","bottom;":"⊥","bowtie;":"⋈","boxbox;":"⧉","boxDL;":"╗","boxDl;":"╖","boxdL;":"╕","boxdl;":"┐","boxDR;":"╔","boxDr;":"╓","boxdR;":"╒","boxdr;":"┌","boxH;":"═","boxh;":"─","boxHD;":"╦","boxHd;":"╤","boxhD;":"╥","boxhd;":"┬","boxHU;":"╩","boxHu;":"╧","boxhU;":"╨","boxhu;":"┴","boxminus;":"⊟","boxplus;":"⊞","boxtimes;":"⊠","boxUL;":"╝","boxUl;":"╜","boxuL;":"╛","boxul;":"┘","boxUR;":"╚","boxUr;":"╙","boxuR;":"╘","boxur;":"└","boxV;":"║","boxv;":"│","boxVH;":"╬","boxVh;":"╫","boxvH;":"╪","boxvh;":"┼","boxVL;":"╣","boxVl;":"╢","boxvL;":"╡","boxvl;":"┤","boxVR;":"╠","boxVr;":"╟","boxvR;":"╞","boxvr;":"├","bprime;":"‵","Breve;":"˘","breve;":"˘","brvbar;":"¦",brvbar:"¦","Bscr;":"ℬ","bscr;":"𝒷","bsemi;":"⁏","bsim;":"∽","bsime;":"⋍","bsol;":"\\","bsolb;":"⧅","bsolhsub;":"⟈","bull;":"•","bullet;":"•","bump;":"≎","bumpE;":"⪮","bumpe;":"≏","Bumpeq;":"≎","bumpeq;":"≏","Cacute;":"Ć","cacute;":"ć","Cap;":"⋒","cap;":"∩","capand;":"⩄","capbrcup;":"⩉","capcap;":"⩋","capcup;":"⩇","capdot;":"⩀","CapitalDifferentialD;":"ⅅ","caps;":"∩︀","caret;":"⁁","caron;":"ˇ","Cayleys;":"ℭ","ccaps;":"⩍","Ccaron;":"Č","ccaron;":"č","Ccedil;":"Ç",Ccedil:"Ç","ccedil;":"ç",ccedil:"ç","Ccirc;":"Ĉ","ccirc;":"ĉ","Cconint;":"∰","ccups;":"⩌","ccupssm;":"⩐","Cdot;":"Ċ","cdot;":"ċ","cedil;":"¸",cedil:"¸","Cedilla;":"¸","cemptyv;":"⦲","cent;":"¢",cent:"¢","CenterDot;":"·","centerdot;":"·","Cfr;":"ℭ","cfr;":"𝔠","CHcy;":"Ч","chcy;":"ч","check;":"✓","checkmark;":"✓","Chi;":"Χ","chi;":"χ","cir;":"○","circ;":"ˆ","circeq;":"≗","circlearrowleft;":"↺","circlearrowright;":"↻","circledast;":"⊛","circledcirc;":"⊚","circleddash;":"⊝","CircleDot;":"⊙","circledR;":"®","circledS;":"Ⓢ","CircleMinus;":"⊖","CirclePlus;":"⊕","CircleTimes;":"⊗","cirE;":"⧃","cire;":"≗","cirfnint;":"⨐","cirmid;":"⫯","cirscir;":"⧂","ClockwiseContourIntegral;":"∲","CloseCurlyDoubleQuote;":"”","CloseCurlyQuote;":"’","clubs;":"♣","clubsuit;":"♣","Colon;":"∷","colon;":":","Colone;":"⩴","colone;":"≔","coloneq;":"≔","comma;":",","commat;":"@","comp;":"∁","compfn;":"∘","complement;":"∁","complexes;":"ℂ","cong;":"≅","congdot;":"⩭","Congruent;":"≡","Conint;":"∯","conint;":"∮","ContourIntegral;":"∮","Copf;":"ℂ","copf;":"𝕔","coprod;":"∐","Coproduct;":"∐","COPY;":"©",COPY:"©","copy;":"©",copy:"©","copysr;":"℗","CounterClockwiseContourIntegral;":"∳","crarr;":"↵","Cross;":"⨯","cross;":"✗","Cscr;":"𝒞","cscr;":"𝒸","csub;":"⫏","csube;":"⫑","csup;":"⫐","csupe;":"⫒","ctdot;":"⋯","cudarrl;":"⤸","cudarrr;":"⤵","cuepr;":"⋞","cuesc;":"⋟","cularr;":"↶","cularrp;":"⤽","Cup;":"⋓","cup;":"∪","cupbrcap;":"⩈","CupCap;":"≍","cupcap;":"⩆","cupcup;":"⩊","cupdot;":"⊍","cupor;":"⩅","cups;":"∪︀","curarr;":"↷","curarrm;":"⤼","curlyeqprec;":"⋞","curlyeqsucc;":"⋟","curlyvee;":"⋎","curlywedge;":"⋏","curren;":"¤",curren:"¤","curvearrowleft;":"↶","curvearrowright;":"↷","cuvee;":"⋎","cuwed;":"⋏","cwconint;":"∲","cwint;":"∱","cylcty;":"⌭","Dagger;":"‡","dagger;":"†","daleth;":"ℸ","Darr;":"↡","dArr;":"⇓","darr;":"↓","dash;":"‐","Dashv;":"⫤","dashv;":"⊣","dbkarow;":"⤏","dblac;":"˝","Dcaron;":"Ď","dcaron;":"ď","Dcy;":"Д","dcy;":"д","DD;":"ⅅ","dd;":"ⅆ","ddagger;":"‡","ddarr;":"⇊","DDotrahd;":"⤑","ddotseq;":"⩷","deg;":"°",deg:"°","Del;":"∇","Delta;":"Δ","delta;":"δ","demptyv;":"⦱","dfisht;":"⥿","Dfr;":"𝔇","dfr;":"𝔡","dHar;":"⥥","dharl;":"⇃","dharr;":"⇂","DiacriticalAcute;":"´","DiacriticalDot;":"˙","DiacriticalDoubleAcute;":"˝","DiacriticalGrave;":"`","DiacriticalTilde;":"˜","diam;":"⋄","Diamond;":"⋄","diamond;":"⋄","diamondsuit;":"♦","diams;":"♦","die;":"¨","DifferentialD;":"ⅆ","digamma;":"ϝ","disin;":"⋲","div;":"÷","divide;":"÷",divide:"÷","divideontimes;":"⋇","divonx;":"⋇","DJcy;":"Ђ","djcy;":"ђ","dlcorn;":"⌞","dlcrop;":"⌍","dollar;":"$","Dopf;":"𝔻","dopf;":"𝕕","Dot;":"¨","dot;":"˙","DotDot;":"⃜","doteq;":"≐","doteqdot;":"≑","DotEqual;":"≐","dotminus;":"∸","dotplus;":"∔","dotsquare;":"⊡","doublebarwedge;":"⌆","DoubleContourIntegral;":"∯","DoubleDot;":"¨","DoubleDownArrow;":"⇓","DoubleLeftArrow;":"⇐","DoubleLeftRightArrow;":"⇔","DoubleLeftTee;":"⫤","DoubleLongLeftArrow;":"⟸","DoubleLongLeftRightArrow;":"⟺","DoubleLongRightArrow;":"⟹","DoubleRightArrow;":"⇒","DoubleRightTee;":"⊨","DoubleUpArrow;":"⇑","DoubleUpDownArrow;":"⇕","DoubleVerticalBar;":"∥","DownArrow;":"↓","Downarrow;":"⇓","downarrow;":"↓","DownArrowBar;":"⤓","DownArrowUpArrow;":"⇵","DownBreve;":"̑","downdownarrows;":"⇊","downharpoonleft;":"⇃","downharpoonright;":"⇂","DownLeftRightVector;":"⥐","DownLeftTeeVector;":"⥞","DownLeftVector;":"↽","DownLeftVectorBar;":"⥖","DownRightTeeVector;":"⥟","DownRightVector;":"⇁","DownRightVectorBar;":"⥗","DownTee;":"⊤","DownTeeArrow;":"↧","drbkarow;":"⤐","drcorn;":"⌟","drcrop;":"⌌","Dscr;":"𝒟","dscr;":"𝒹","DScy;":"Ѕ","dscy;":"ѕ","dsol;":"⧶","Dstrok;":"Đ","dstrok;":"đ","dtdot;":"⋱","dtri;":"▿","dtrif;":"▾","duarr;":"⇵","duhar;":"⥯","dwangle;":"⦦","DZcy;":"Џ","dzcy;":"џ","dzigrarr;":"⟿","Eacute;":"É",Eacute:"É","eacute;":"é",eacute:"é","easter;":"⩮","Ecaron;":"Ě","ecaron;":"ě","ecir;":"≖","Ecirc;":"Ê",Ecirc:"Ê","ecirc;":"ê",ecirc:"ê","ecolon;":"≕","Ecy;":"Э","ecy;":"э","eDDot;":"⩷","Edot;":"Ė","eDot;":"≑","edot;":"ė","ee;":"ⅇ","efDot;":"≒","Efr;":"𝔈","efr;":"𝔢","eg;":"⪚","Egrave;":"È",Egrave:"È","egrave;":"è",egrave:"è","egs;":"⪖","egsdot;":"⪘","el;":"⪙","Element;":"∈","elinters;":"⏧","ell;":"ℓ","els;":"⪕","elsdot;":"⪗","Emacr;":"Ē","emacr;":"ē","empty;":"∅","emptyset;":"∅","EmptySmallSquare;":"◻","emptyv;":"∅","EmptyVerySmallSquare;":"▫","emsp;":" ","emsp13;":" ","emsp14;":" ","ENG;":"Ŋ","eng;":"ŋ","ensp;":" ","Eogon;":"Ę","eogon;":"ę","Eopf;":"𝔼","eopf;":"𝕖","epar;":"⋕","eparsl;":"⧣","eplus;":"⩱","epsi;":"ε","Epsilon;":"Ε","epsilon;":"ε","epsiv;":"ϵ","eqcirc;":"≖","eqcolon;":"≕","eqsim;":"≂","eqslantgtr;":"⪖","eqslantless;":"⪕","Equal;":"⩵","equals;":"=","EqualTilde;":"≂","equest;":"≟","Equilibrium;":"⇌","equiv;":"≡","equivDD;":"⩸","eqvparsl;":"⧥","erarr;":"⥱","erDot;":"≓","Escr;":"ℰ","escr;":"ℯ","esdot;":"≐","Esim;":"⩳","esim;":"≂","Eta;":"Η","eta;":"η","ETH;":"Ð",ETH:"Ð","eth;":"ð",eth:"ð","Euml;":"Ë",Euml:"Ë","euml;":"ë",euml:"ë","euro;":"€","excl;":"!","exist;":"∃","Exists;":"∃","expectation;":"ℰ","ExponentialE;":"ⅇ","exponentiale;":"ⅇ","fallingdotseq;":"≒","Fcy;":"Ф","fcy;":"ф","female;":"♀","ffilig;":"ﬃ","fflig;":"ﬀ","ffllig;":"ﬄ","Ffr;":"𝔉","ffr;":"𝔣","filig;":"ﬁ","FilledSmallSquare;":"◼","FilledVerySmallSquare;":"▪","fjlig;":"fj","flat;":"♭","fllig;":"ﬂ","fltns;":"▱","fnof;":"ƒ","Fopf;":"𝔽","fopf;":"𝕗","ForAll;":"∀","forall;":"∀","fork;":"⋔","forkv;":"⫙","Fouriertrf;":"ℱ","fpartint;":"⨍","frac12;":"½",frac12:"½","frac13;":"⅓","frac14;":"¼",frac14:"¼","frac15;":"⅕","frac16;":"⅙","frac18;":"⅛","frac23;":"⅔","frac25;":"⅖","frac34;":"¾",frac34:"¾","frac35;":"⅗","frac38;":"⅜","frac45;":"⅘","frac56;":"⅚","frac58;":"⅝","frac78;":"⅞","frasl;":"⁄","frown;":"⌢","Fscr;":"ℱ","fscr;":"𝒻","gacute;":"ǵ","Gamma;":"Γ","gamma;":"γ","Gammad;":"Ϝ","gammad;":"ϝ","gap;":"⪆","Gbreve;":"Ğ","gbreve;":"ğ","Gcedil;":"Ģ","Gcirc;":"Ĝ","gcirc;":"ĝ","Gcy;":"Г","gcy;":"г","Gdot;":"Ġ","gdot;":"ġ","gE;":"≧","ge;":"≥","gEl;":"⪌","gel;":"⋛","geq;":"≥","geqq;":"≧","geqslant;":"⩾","ges;":"⩾","gescc;":"⪩","gesdot;":"⪀","gesdoto;":"⪂","gesdotol;":"⪄","gesl;":"⋛︀","gesles;":"⪔","Gfr;":"𝔊","gfr;":"𝔤","Gg;":"⋙","gg;":"≫","ggg;":"⋙","gimel;":"ℷ","GJcy;":"Ѓ","gjcy;":"ѓ","gl;":"≷","gla;":"⪥","glE;":"⪒","glj;":"⪤","gnap;":"⪊","gnapprox;":"⪊","gnE;":"≩","gne;":"⪈","gneq;":"⪈","gneqq;":"≩","gnsim;":"⋧","Gopf;":"𝔾","gopf;":"𝕘","grave;":"`","GreaterEqual;":"≥","GreaterEqualLess;":"⋛","GreaterFullEqual;":"≧","GreaterGreater;":"⪢","GreaterLess;":"≷","GreaterSlantEqual;":"⩾","GreaterTilde;":"≳","Gscr;":"𝒢","gscr;":"ℊ","gsim;":"≳","gsime;":"⪎","gsiml;":"⪐","GT;":">",GT:">","Gt;":"≫","gt;":">",gt:">","gtcc;":"⪧","gtcir;":"⩺","gtdot;":"⋗","gtlPar;":"⦕","gtquest;":"⩼","gtrapprox;":"⪆","gtrarr;":"⥸","gtrdot;":"⋗","gtreqless;":"⋛","gtreqqless;":"⪌","gtrless;":"≷","gtrsim;":"≳","gvertneqq;":"≩︀","gvnE;":"≩︀","Hacek;":"ˇ","hairsp;":" ","half;":"½","hamilt;":"ℋ","HARDcy;":"Ъ","hardcy;":"ъ","hArr;":"⇔","harr;":"↔","harrcir;":"⥈","harrw;":"↭","Hat;":"^","hbar;":"ℏ","Hcirc;":"Ĥ","hcirc;":"ĥ","hearts;":"♥","heartsuit;":"♥","hellip;":"…","hercon;":"⊹","Hfr;":"ℌ","hfr;":"𝔥","HilbertSpace;":"ℋ","hksearow;":"⤥","hkswarow;":"⤦","hoarr;":"⇿","homtht;":"∻","hookleftarrow;":"↩","hookrightarrow;":"↪","Hopf;":"ℍ","hopf;":"𝕙","horbar;":"―","HorizontalLine;":"─","Hscr;":"ℋ","hscr;":"𝒽","hslash;":"ℏ","Hstrok;":"Ħ","hstrok;":"ħ","HumpDownHump;":"≎","HumpEqual;":"≏","hybull;":"⁃","hyphen;":"‐","Iacute;":"Í",Iacute:"Í","iacute;":"í",iacute:"í","ic;":"⁣","Icirc;":"Î",Icirc:"Î","icirc;":"î",icirc:"î","Icy;":"И","icy;":"и","Idot;":"İ","IEcy;":"Е","iecy;":"е","iexcl;":"¡",iexcl:"¡","iff;":"⇔","Ifr;":"ℑ","ifr;":"𝔦","Igrave;":"Ì",Igrave:"Ì","igrave;":"ì",igrave:"ì","ii;":"ⅈ","iiiint;":"⨌","iiint;":"∭","iinfin;":"⧜","iiota;":"℩","IJlig;":"Ĳ","ijlig;":"ĳ","Im;":"ℑ","Imacr;":"Ī","imacr;":"ī","image;":"ℑ","ImaginaryI;":"ⅈ","imagline;":"ℐ","imagpart;":"ℑ","imath;":"ı","imof;":"⊷","imped;":"Ƶ","Implies;":"⇒","in;":"∈","incare;":"℅","infin;":"∞","infintie;":"⧝","inodot;":"ı","Int;":"∬","int;":"∫","intcal;":"⊺","integers;":"ℤ","Integral;":"∫","intercal;":"⊺","Intersection;":"⋂","intlarhk;":"⨗","intprod;":"⨼","InvisibleComma;":"⁣","InvisibleTimes;":"⁢","IOcy;":"Ё","iocy;":"ё","Iogon;":"Į","iogon;":"į","Iopf;":"𝕀","iopf;":"𝕚","Iota;":"Ι","iota;":"ι","iprod;":"⨼","iquest;":"¿",iquest:"¿","Iscr;":"ℐ","iscr;":"𝒾","isin;":"∈","isindot;":"⋵","isinE;":"⋹","isins;":"⋴","isinsv;":"⋳","isinv;":"∈","it;":"⁢","Itilde;":"Ĩ","itilde;":"ĩ","Iukcy;":"І","iukcy;":"і","Iuml;":"Ï",Iuml:"Ï","iuml;":"ï",iuml:"ï","Jcirc;":"Ĵ","jcirc;":"ĵ","Jcy;":"Й","jcy;":"й","Jfr;":"𝔍","jfr;":"𝔧","jmath;":"ȷ","Jopf;":"𝕁","jopf;":"𝕛","Jscr;":"𝒥","jscr;":"𝒿","Jsercy;":"Ј","jsercy;":"ј","Jukcy;":"Є","jukcy;":"є","Kappa;":"Κ","kappa;":"κ","kappav;":"ϰ","Kcedil;":"Ķ","kcedil;":"ķ","Kcy;":"К","kcy;":"к","Kfr;":"𝔎","kfr;":"𝔨","kgreen;":"ĸ","KHcy;":"Х","khcy;":"х","KJcy;":"Ќ","kjcy;":"ќ","Kopf;":"𝕂","kopf;":"𝕜","Kscr;":"𝒦","kscr;":"𝓀","lAarr;":"⇚","Lacute;":"Ĺ","lacute;":"ĺ","laemptyv;":"⦴","lagran;":"ℒ","Lambda;":"Λ","lambda;":"λ","Lang;":"⟪","lang;":"⟨","langd;":"⦑","langle;":"⟨","lap;":"⪅","Laplacetrf;":"ℒ","laquo;":"«",laquo:"«","Larr;":"↞","lArr;":"⇐","larr;":"←","larrb;":"⇤","larrbfs;":"⤟","larrfs;":"⤝","larrhk;":"↩","larrlp;":"↫","larrpl;":"⤹","larrsim;":"⥳","larrtl;":"↢","lat;":"⪫","lAtail;":"⤛","latail;":"⤙","late;":"⪭","lates;":"⪭︀","lBarr;":"⤎","lbarr;":"⤌","lbbrk;":"❲","lbrace;":"{","lbrack;":"[","lbrke;":"⦋","lbrksld;":"⦏","lbrkslu;":"⦍","Lcaron;":"Ľ","lcaron;":"ľ","Lcedil;":"Ļ","lcedil;":"ļ","lceil;":"⌈","lcub;":"{","Lcy;":"Л","lcy;":"л","ldca;":"⤶","ldquo;":"“","ldquor;":"„","ldrdhar;":"⥧","ldrushar;":"⥋","ldsh;":"↲","lE;":"≦","le;":"≤","LeftAngleBracket;":"⟨","LeftArrow;":"←","Leftarrow;":"⇐","leftarrow;":"←","LeftArrowBar;":"⇤","LeftArrowRightArrow;":"⇆","leftarrowtail;":"↢","LeftCeiling;":"⌈","LeftDoubleBracket;":"⟦","LeftDownTeeVector;":"⥡","LeftDownVector;":"⇃","LeftDownVectorBar;":"⥙","LeftFloor;":"⌊","leftharpoondown;":"↽","leftharpoonup;":"↼","leftleftarrows;":"⇇","LeftRightArrow;":"↔","Leftrightarrow;":"⇔","leftrightarrow;":"↔","leftrightarrows;":"⇆","leftrightharpoons;":"⇋","leftrightsquigarrow;":"↭","LeftRightVector;":"⥎","LeftTee;":"⊣","LeftTeeArrow;":"↤","LeftTeeVector;":"⥚","leftthreetimes;":"⋋","LeftTriangle;":"⊲","LeftTriangleBar;":"⧏","LeftTriangleEqual;":"⊴","LeftUpDownVector;":"⥑","LeftUpTeeVector;":"⥠","LeftUpVector;":"↿","LeftUpVectorBar;":"⥘","LeftVector;":"↼","LeftVectorBar;":"⥒","lEg;":"⪋","leg;":"⋚","leq;":"≤","leqq;":"≦","leqslant;":"⩽","les;":"⩽","lescc;":"⪨","lesdot;":"⩿","lesdoto;":"⪁","lesdotor;":"⪃","lesg;":"⋚︀","lesges;":"⪓","lessapprox;":"⪅","lessdot;":"⋖","lesseqgtr;":"⋚","lesseqqgtr;":"⪋","LessEqualGreater;":"⋚","LessFullEqual;":"≦","LessGreater;":"≶","lessgtr;":"≶","LessLess;":"⪡","lesssim;":"≲","LessSlantEqual;":"⩽","LessTilde;":"≲","lfisht;":"⥼","lfloor;":"⌊","Lfr;":"𝔏","lfr;":"𝔩","lg;":"≶","lgE;":"⪑","lHar;":"⥢","lhard;":"↽","lharu;":"↼","lharul;":"⥪","lhblk;":"▄","LJcy;":"Љ","ljcy;":"љ","Ll;":"⋘","ll;":"≪","llarr;":"⇇","llcorner;":"⌞","Lleftarrow;":"⇚","llhard;":"⥫","lltri;":"◺","Lmidot;":"Ŀ","lmidot;":"ŀ","lmoust;":"⎰","lmoustache;":"⎰","lnap;":"⪉","lnapprox;":"⪉","lnE;":"≨","lne;":"⪇","lneq;":"⪇","lneqq;":"≨","lnsim;":"⋦","loang;":"⟬","loarr;":"⇽","lobrk;":"⟦","LongLeftArrow;":"⟵","Longleftarrow;":"⟸","longleftarrow;":"⟵","LongLeftRightArrow;":"⟷","Longleftrightarrow;":"⟺","longleftrightarrow;":"⟷","longmapsto;":"⟼","LongRightArrow;":"⟶","Longrightarrow;":"⟹","longrightarrow;":"⟶","looparrowleft;":"↫","looparrowright;":"↬","lopar;":"⦅","Lopf;":"𝕃","lopf;":"𝕝","loplus;":"⨭","lotimes;":"⨴","lowast;":"∗","lowbar;":"_","LowerLeftArrow;":"↙","LowerRightArrow;":"↘","loz;":"◊","lozenge;":"◊","lozf;":"⧫","lpar;":"(","lparlt;":"⦓","lrarr;":"⇆","lrcorner;":"⌟","lrhar;":"⇋","lrhard;":"⥭","lrm;":"‎","lrtri;":"⊿","lsaquo;":"‹","Lscr;":"ℒ","lscr;":"𝓁","Lsh;":"↰","lsh;":"↰","lsim;":"≲","lsime;":"⪍","lsimg;":"⪏","lsqb;":"[","lsquo;":"‘","lsquor;":"‚","Lstrok;":"Ł","lstrok;":"ł","LT;":"<",LT:"<","Lt;":"≪","lt;":"<",lt:"<","ltcc;":"⪦","ltcir;":"⩹","ltdot;":"⋖","lthree;":"⋋","ltimes;":"⋉","ltlarr;":"⥶","ltquest;":"⩻","ltri;":"◃","ltrie;":"⊴","ltrif;":"◂","ltrPar;":"⦖","lurdshar;":"⥊","luruhar;":"⥦","lvertneqq;":"≨︀","lvnE;":"≨︀","macr;":"¯",macr:"¯","male;":"♂","malt;":"✠","maltese;":"✠","Map;":"⤅","map;":"↦","mapsto;":"↦","mapstodown;":"↧","mapstoleft;":"↤","mapstoup;":"↥","marker;":"▮","mcomma;":"⨩","Mcy;":"М","mcy;":"м","mdash;":"—","mDDot;":"∺","measuredangle;":"∡","MediumSpace;":" ","Mellintrf;":"ℳ","Mfr;":"𝔐","mfr;":"𝔪","mho;":"℧","micro;":"µ",micro:"µ","mid;":"∣","midast;":"*","midcir;":"⫰","middot;":"·",middot:"·","minus;":"−","minusb;":"⊟","minusd;":"∸","minusdu;":"⨪","MinusPlus;":"∓","mlcp;":"⫛","mldr;":"…","mnplus;":"∓","models;":"⊧","Mopf;":"𝕄","mopf;":"𝕞","mp;":"∓","Mscr;":"ℳ","mscr;":"𝓂","mstpos;":"∾","Mu;":"Μ","mu;":"μ","multimap;":"⊸","mumap;":"⊸","nabla;":"∇","Nacute;":"Ń","nacute;":"ń","nang;":"∠⃒","nap;":"≉","napE;":"⩰̸","napid;":"≋̸","napos;":"ŉ","napprox;":"≉","natur;":"♮","natural;":"♮","naturals;":"ℕ","nbsp;":" ",nbsp:" ","nbump;":"≎̸","nbumpe;":"≏̸","ncap;":"⩃","Ncaron;":"Ň","ncaron;":"ň","Ncedil;":"Ņ","ncedil;":"ņ","ncong;":"≇","ncongdot;":"⩭̸","ncup;":"⩂","Ncy;":"Н","ncy;":"н","ndash;":"–","ne;":"≠","nearhk;":"⤤","neArr;":"⇗","nearr;":"↗","nearrow;":"↗","nedot;":"≐̸","NegativeMediumSpace;":"​","NegativeThickSpace;":"​","NegativeThinSpace;":"​","NegativeVeryThinSpace;":"​","nequiv;":"≢","nesear;":"⤨","nesim;":"≂̸","NestedGreaterGreater;":"≫","NestedLessLess;":"≪","NewLine;":"\n","nexist;":"∄","nexists;":"∄","Nfr;":"𝔑","nfr;":"𝔫","ngE;":"≧̸","nge;":"≱","ngeq;":"≱","ngeqq;":"≧̸","ngeqslant;":"⩾̸","nges;":"⩾̸","nGg;":"⋙̸","ngsim;":"≵","nGt;":"≫⃒","ngt;":"≯","ngtr;":"≯","nGtv;":"≫̸","nhArr;":"⇎","nharr;":"↮","nhpar;":"⫲","ni;":"∋","nis;":"⋼","nisd;":"⋺","niv;":"∋","NJcy;":"Њ","njcy;":"њ","nlArr;":"⇍","nlarr;":"↚","nldr;":"‥","nlE;":"≦̸","nle;":"≰","nLeftarrow;":"⇍","nleftarrow;":"↚","nLeftrightarrow;":"⇎","nleftrightarrow;":"↮","nleq;":"≰","nleqq;":"≦̸","nleqslant;":"⩽̸","nles;":"⩽̸","nless;":"≮","nLl;":"⋘̸","nlsim;":"≴","nLt;":"≪⃒","nlt;":"≮","nltri;":"⋪","nltrie;":"⋬","nLtv;":"≪̸","nmid;":"∤","NoBreak;":"⁠","NonBreakingSpace;":" ","Nopf;":"ℕ","nopf;":"𝕟","Not;":"⫬","not;":"¬",not:"¬","NotCongruent;":"≢","NotCupCap;":"≭","NotDoubleVerticalBar;":"∦","NotElement;":"∉","NotEqual;":"≠","NotEqualTilde;":"≂̸","NotExists;":"∄","NotGreater;":"≯","NotGreaterEqual;":"≱","NotGreaterFullEqual;":"≧̸","NotGreaterGreater;":"≫̸","NotGreaterLess;":"≹","NotGreaterSlantEqual;":"⩾̸","NotGreaterTilde;":"≵","NotHumpDownHump;":"≎̸","NotHumpEqual;":"≏̸","notin;":"∉","notindot;":"⋵̸","notinE;":"⋹̸","notinva;":"∉","notinvb;":"⋷","notinvc;":"⋶","NotLeftTriangle;":"⋪","NotLeftTriangleBar;":"⧏̸","NotLeftTriangleEqual;":"⋬","NotLess;":"≮","NotLessEqual;":"≰","NotLessGreater;":"≸","NotLessLess;":"≪̸","NotLessSlantEqual;":"⩽̸","NotLessTilde;":"≴","NotNestedGreaterGreater;":"⪢̸","NotNestedLessLess;":"⪡̸","notni;":"∌","notniva;":"∌","notnivb;":"⋾","notnivc;":"⋽","NotPrecedes;":"⊀","NotPrecedesEqual;":"⪯̸","NotPrecedesSlantEqual;":"⋠","NotReverseElement;":"∌","NotRightTriangle;":"⋫","NotRightTriangleBar;":"⧐̸","NotRightTriangleEqual;":"⋭","NotSquareSubset;":"⊏̸","NotSquareSubsetEqual;":"⋢","NotSquareSuperset;":"⊐̸","NotSquareSupersetEqual;":"⋣","NotSubset;":"⊂⃒","NotSubsetEqual;":"⊈","NotSucceeds;":"⊁","NotSucceedsEqual;":"⪰̸","NotSucceedsSlantEqual;":"⋡","NotSucceedsTilde;":"≿̸","NotSuperset;":"⊃⃒","NotSupersetEqual;":"⊉","NotTilde;":"≁","NotTildeEqual;":"≄","NotTildeFullEqual;":"≇","NotTildeTilde;":"≉","NotVerticalBar;":"∤","npar;":"∦","nparallel;":"∦","nparsl;":"⫽⃥","npart;":"∂̸","npolint;":"⨔","npr;":"⊀","nprcue;":"⋠","npre;":"⪯̸","nprec;":"⊀","npreceq;":"⪯̸","nrArr;":"⇏","nrarr;":"↛","nrarrc;":"⤳̸","nrarrw;":"↝̸","nRightarrow;":"⇏","nrightarrow;":"↛","nrtri;":"⋫","nrtrie;":"⋭","nsc;":"⊁","nsccue;":"⋡","nsce;":"⪰̸","Nscr;":"𝒩","nscr;":"𝓃","nshortmid;":"∤","nshortparallel;":"∦","nsim;":"≁","nsime;":"≄","nsimeq;":"≄","nsmid;":"∤","nspar;":"∦","nsqsube;":"⋢","nsqsupe;":"⋣","nsub;":"⊄","nsubE;":"⫅̸","nsube;":"⊈","nsubset;":"⊂⃒","nsubseteq;":"⊈","nsubseteqq;":"⫅̸","nsucc;":"⊁","nsucceq;":"⪰̸","nsup;":"⊅","nsupE;":"⫆̸","nsupe;":"⊉","nsupset;":"⊃⃒","nsupseteq;":"⊉","nsupseteqq;":"⫆̸","ntgl;":"≹","Ntilde;":"Ñ",Ntilde:"Ñ","ntilde;":"ñ",ntilde:"ñ","ntlg;":"≸","ntriangleleft;":"⋪","ntrianglelefteq;":"⋬","ntriangleright;":"⋫","ntrianglerighteq;":"⋭","Nu;":"Ν","nu;":"ν","num;":"#","numero;":"№","numsp;":" ","nvap;":"≍⃒","nVDash;":"⊯","nVdash;":"⊮","nvDash;":"⊭","nvdash;":"⊬","nvge;":"≥⃒","nvgt;":">⃒","nvHarr;":"⤄","nvinfin;":"⧞","nvlArr;":"⤂","nvle;":"≤⃒","nvlt;":"<⃒","nvltrie;":"⊴⃒","nvrArr;":"⤃","nvrtrie;":"⊵⃒","nvsim;":"∼⃒","nwarhk;":"⤣","nwArr;":"⇖","nwarr;":"↖","nwarrow;":"↖","nwnear;":"⤧","Oacute;":"Ó",Oacute:"Ó","oacute;":"ó",oacute:"ó","oast;":"⊛","ocir;":"⊚","Ocirc;":"Ô",Ocirc:"Ô","ocirc;":"ô",ocirc:"ô","Ocy;":"О","ocy;":"о","odash;":"⊝","Odblac;":"Ő","odblac;":"ő","odiv;":"⨸","odot;":"⊙","odsold;":"⦼","OElig;":"Œ","oelig;":"œ","ofcir;":"⦿","Ofr;":"𝔒","ofr;":"𝔬","ogon;":"˛","Ograve;":"Ò",Ograve:"Ò","ograve;":"ò",ograve:"ò","ogt;":"⧁","ohbar;":"⦵","ohm;":"Ω","oint;":"∮","olarr;":"↺","olcir;":"⦾","olcross;":"⦻","oline;":"‾","olt;":"⧀","Omacr;":"Ō","omacr;":"ō","Omega;":"Ω","omega;":"ω","Omicron;":"Ο","omicron;":"ο","omid;":"⦶","ominus;":"⊖","Oopf;":"𝕆","oopf;":"𝕠","opar;":"⦷","OpenCurlyDoubleQuote;":"“","OpenCurlyQuote;":"‘","operp;":"⦹","oplus;":"⊕","Or;":"⩔","or;":"∨","orarr;":"↻","ord;":"⩝","order;":"ℴ","orderof;":"ℴ","ordf;":"ª",ordf:"ª","ordm;":"º",ordm:"º","origof;":"⊶","oror;":"⩖","orslope;":"⩗","orv;":"⩛","oS;":"Ⓢ","Oscr;":"𝒪","oscr;":"ℴ","Oslash;":"Ø",Oslash:"Ø","oslash;":"ø",oslash:"ø","osol;":"⊘","Otilde;":"Õ",Otilde:"Õ","otilde;":"õ",otilde:"õ","Otimes;":"⨷","otimes;":"⊗","otimesas;":"⨶","Ouml;":"Ö",Ouml:"Ö","ouml;":"ö",ouml:"ö","ovbar;":"⌽","OverBar;":"‾","OverBrace;":"⏞","OverBracket;":"⎴","OverParenthesis;":"⏜","par;":"∥","para;":"¶",para:"¶","parallel;":"∥","parsim;":"⫳","parsl;":"⫽","part;":"∂","PartialD;":"∂","Pcy;":"П","pcy;":"п","percnt;":"%","period;":".","permil;":"‰","perp;":"⊥","pertenk;":"‱","Pfr;":"𝔓","pfr;":"𝔭","Phi;":"Φ","phi;":"φ","phiv;":"ϕ","phmmat;":"ℳ","phone;":"☎","Pi;":"Π","pi;":"π","pitchfork;":"⋔","piv;":"ϖ","planck;":"ℏ","planckh;":"ℎ","plankv;":"ℏ","plus;":"+","plusacir;":"⨣","plusb;":"⊞","pluscir;":"⨢","plusdo;":"∔","plusdu;":"⨥","pluse;":"⩲","PlusMinus;":"±","plusmn;":"±",plusmn:"±","plussim;":"⨦","plustwo;":"⨧","pm;":"±","Poincareplane;":"ℌ","pointint;":"⨕","Popf;":"ℙ","popf;":"𝕡","pound;":"£",pound:"£","Pr;":"⪻","pr;":"≺","prap;":"⪷","prcue;":"≼","prE;":"⪳","pre;":"⪯","prec;":"≺","precapprox;":"⪷","preccurlyeq;":"≼","Precedes;":"≺","PrecedesEqual;":"⪯","PrecedesSlantEqual;":"≼","PrecedesTilde;":"≾","preceq;":"⪯","precnapprox;":"⪹","precneqq;":"⪵","precnsim;":"⋨","precsim;":"≾","Prime;":"″","prime;":"′","primes;":"ℙ","prnap;":"⪹","prnE;":"⪵","prnsim;":"⋨","prod;":"∏","Product;":"∏","profalar;":"⌮","profline;":"⌒","profsurf;":"⌓","prop;":"∝","Proportion;":"∷","Proportional;":"∝","propto;":"∝","prsim;":"≾","prurel;":"⊰","Pscr;":"𝒫","pscr;":"𝓅","Psi;":"Ψ","psi;":"ψ","puncsp;":" ","Qfr;":"𝔔","qfr;":"𝔮","qint;":"⨌","Qopf;":"ℚ","qopf;":"𝕢","qprime;":"⁗","Qscr;":"𝒬","qscr;":"𝓆","quaternions;":"ℍ","quatint;":"⨖","quest;":"?","questeq;":"≟","QUOT;":'"',QUOT:'"',"quot;":'"',quot:'"',"rAarr;":"⇛","race;":"∽̱","Racute;":"Ŕ","racute;":"ŕ","radic;":"√","raemptyv;":"⦳","Rang;":"⟫","rang;":"⟩","rangd;":"⦒","range;":"⦥","rangle;":"⟩","raquo;":"»",raquo:"»","Rarr;":"↠","rArr;":"⇒","rarr;":"→","rarrap;":"⥵","rarrb;":"⇥","rarrbfs;":"⤠","rarrc;":"⤳","rarrfs;":"⤞","rarrhk;":"↪","rarrlp;":"↬","rarrpl;":"⥅","rarrsim;":"⥴","Rarrtl;":"⤖","rarrtl;":"↣","rarrw;":"↝","rAtail;":"⤜","ratail;":"⤚","ratio;":"∶","rationals;":"ℚ","RBarr;":"⤐","rBarr;":"⤏","rbarr;":"⤍","rbbrk;":"❳","rbrace;":"}","rbrack;":"]","rbrke;":"⦌","rbrksld;":"⦎","rbrkslu;":"⦐","Rcaron;":"Ř","rcaron;":"ř","Rcedil;":"Ŗ","rcedil;":"ŗ","rceil;":"⌉","rcub;":"}","Rcy;":"Р","rcy;":"р","rdca;":"⤷","rdldhar;":"⥩","rdquo;":"”","rdquor;":"”","rdsh;":"↳","Re;":"ℜ","real;":"ℜ","realine;":"ℛ","realpart;":"ℜ","reals;":"ℝ","rect;":"▭","REG;":"®",REG:"®","reg;":"®",reg:"®","ReverseElement;":"∋","ReverseEquilibrium;":"⇋","ReverseUpEquilibrium;":"⥯","rfisht;":"⥽","rfloor;":"⌋","Rfr;":"ℜ","rfr;":"𝔯","rHar;":"⥤","rhard;":"⇁","rharu;":"⇀","rharul;":"⥬","Rho;":"Ρ","rho;":"ρ","rhov;":"ϱ","RightAngleBracket;":"⟩","RightArrow;":"→","Rightarrow;":"⇒","rightarrow;":"→","RightArrowBar;":"⇥","RightArrowLeftArrow;":"⇄","rightarrowtail;":"↣","RightCeiling;":"⌉","RightDoubleBracket;":"⟧","RightDownTeeVector;":"⥝","RightDownVector;":"⇂","RightDownVectorBar;":"⥕","RightFloor;":"⌋","rightharpoondown;":"⇁","rightharpoonup;":"⇀","rightleftarrows;":"⇄","rightleftharpoons;":"⇌","rightrightarrows;":"⇉","rightsquigarrow;":"↝","RightTee;":"⊢","RightTeeArrow;":"↦","RightTeeVector;":"⥛","rightthreetimes;":"⋌","RightTriangle;":"⊳","RightTriangleBar;":"⧐","RightTriangleEqual;":"⊵","RightUpDownVector;":"⥏","RightUpTeeVector;":"⥜","RightUpVector;":"↾","RightUpVectorBar;":"⥔","RightVector;":"⇀","RightVectorBar;":"⥓","ring;":"˚","risingdotseq;":"≓","rlarr;":"⇄","rlhar;":"⇌","rlm;":"‏","rmoust;":"⎱","rmoustache;":"⎱","rnmid;":"⫮","roang;":"⟭","roarr;":"⇾","robrk;":"⟧","ropar;":"⦆","Ropf;":"ℝ","ropf;":"𝕣","roplus;":"⨮","rotimes;":"⨵","RoundImplies;":"⥰","rpar;":")","rpargt;":"⦔","rppolint;":"⨒","rrarr;":"⇉","Rrightarrow;":"⇛","rsaquo;":"›","Rscr;":"ℛ","rscr;":"𝓇","Rsh;":"↱","rsh;":"↱","rsqb;":"]","rsquo;":"’","rsquor;":"’","rthree;":"⋌","rtimes;":"⋊","rtri;":"▹","rtrie;":"⊵","rtrif;":"▸","rtriltri;":"⧎","RuleDelayed;":"⧴","ruluhar;":"⥨","rx;":"℞","Sacute;":"Ś","sacute;":"ś","sbquo;":"‚","Sc;":"⪼","sc;":"≻","scap;":"⪸","Scaron;":"Š","scaron;":"š","sccue;":"≽","scE;":"⪴","sce;":"⪰","Scedil;":"Ş","scedil;":"ş","Scirc;":"Ŝ","scirc;":"ŝ","scnap;":"⪺","scnE;":"⪶","scnsim;":"⋩","scpolint;":"⨓","scsim;":"≿","Scy;":"С","scy;":"с","sdot;":"⋅","sdotb;":"⊡","sdote;":"⩦","searhk;":"⤥","seArr;":"⇘","searr;":"↘","searrow;":"↘","sect;":"§",sect:"§","semi;":";","seswar;":"⤩","setminus;":"∖","setmn;":"∖","sext;":"✶","Sfr;":"𝔖","sfr;":"𝔰","sfrown;":"⌢","sharp;":"♯","SHCHcy;":"Щ","shchcy;":"щ","SHcy;":"Ш","shcy;":"ш","ShortDownArrow;":"↓","ShortLeftArrow;":"←","shortmid;":"∣","shortparallel;":"∥","ShortRightArrow;":"→","ShortUpArrow;":"↑","shy;":"­",shy:"­","Sigma;":"Σ","sigma;":"σ","sigmaf;":"ς","sigmav;":"ς","sim;":"∼","simdot;":"⩪","sime;":"≃","simeq;":"≃","simg;":"⪞","simgE;":"⪠","siml;":"⪝","simlE;":"⪟","simne;":"≆","simplus;":"⨤","simrarr;":"⥲","slarr;":"←","SmallCircle;":"∘","smallsetminus;":"∖","smashp;":"⨳","smeparsl;":"⧤","smid;":"∣","smile;":"⌣","smt;":"⪪","smte;":"⪬","smtes;":"⪬︀","SOFTcy;":"Ь","softcy;":"ь","sol;":"/","solb;":"⧄","solbar;":"⌿","Sopf;":"𝕊","sopf;":"𝕤","spades;":"♠","spadesuit;":"♠","spar;":"∥","sqcap;":"⊓","sqcaps;":"⊓︀","sqcup;":"⊔","sqcups;":"⊔︀","Sqrt;":"√","sqsub;":"⊏","sqsube;":"⊑","sqsubset;":"⊏","sqsubseteq;":"⊑","sqsup;":"⊐","sqsupe;":"⊒","sqsupset;":"⊐","sqsupseteq;":"⊒","squ;":"□","Square;":"□","square;":"□","SquareIntersection;":"⊓","SquareSubset;":"⊏","SquareSubsetEqual;":"⊑","SquareSuperset;":"⊐","SquareSupersetEqual;":"⊒","SquareUnion;":"⊔","squarf;":"▪","squf;":"▪","srarr;":"→","Sscr;":"𝒮","sscr;":"𝓈","ssetmn;":"∖","ssmile;":"⌣","sstarf;":"⋆","Star;":"⋆","star;":"☆","starf;":"★","straightepsilon;":"ϵ","straightphi;":"ϕ","strns;":"¯","Sub;":"⋐","sub;":"⊂","subdot;":"⪽","subE;":"⫅","sube;":"⊆","subedot;":"⫃","submult;":"⫁","subnE;":"⫋","subne;":"⊊","subplus;":"⪿","subrarr;":"⥹","Subset;":"⋐","subset;":"⊂","subseteq;":"⊆","subseteqq;":"⫅","SubsetEqual;":"⊆","subsetneq;":"⊊","subsetneqq;":"⫋","subsim;":"⫇","subsub;":"⫕","subsup;":"⫓","succ;":"≻","succapprox;":"⪸","succcurlyeq;":"≽","Succeeds;":"≻","SucceedsEqual;":"⪰","SucceedsSlantEqual;":"≽","SucceedsTilde;":"≿","succeq;":"⪰","succnapprox;":"⪺","succneqq;":"⪶","succnsim;":"⋩","succsim;":"≿","SuchThat;":"∋","Sum;":"∑","sum;":"∑","sung;":"♪","Sup;":"⋑","sup;":"⊃","sup1;":"¹",sup1:"¹","sup2;":"²",sup2:"²","sup3;":"³",sup3:"³","supdot;":"⪾","supdsub;":"⫘","supE;":"⫆","supe;":"⊇","supedot;":"⫄","Superset;":"⊃","SupersetEqual;":"⊇","suphsol;":"⟉","suphsub;":"⫗","suplarr;":"⥻","supmult;":"⫂","supnE;":"⫌","supne;":"⊋","supplus;":"⫀","Supset;":"⋑","supset;":"⊃","supseteq;":"⊇","supseteqq;":"⫆","supsetneq;":"⊋","supsetneqq;":"⫌","supsim;":"⫈","supsub;":"⫔","supsup;":"⫖","swarhk;":"⤦","swArr;":"⇙","swarr;":"↙","swarrow;":"↙","swnwar;":"⤪","szlig;":"ß",szlig:"ß","Tab;":"\t","target;":"⌖","Tau;":"Τ","tau;":"τ","tbrk;":"⎴","Tcaron;":"Ť","tcaron;":"ť","Tcedil;":"Ţ","tcedil;":"ţ","Tcy;":"Т","tcy;":"т","tdot;":"⃛","telrec;":"⌕","Tfr;":"𝔗","tfr;":"𝔱","there4;":"∴","Therefore;":"∴","therefore;":"∴","Theta;":"Θ","theta;":"θ","thetasym;":"ϑ","thetav;":"ϑ","thickapprox;":"≈","thicksim;":"∼","ThickSpace;":"  ","thinsp;":" ","ThinSpace;":" ","thkap;":"≈","thksim;":"∼","THORN;":"Þ",THORN:"Þ","thorn;":"þ",thorn:"þ","Tilde;":"∼","tilde;":"˜","TildeEqual;":"≃","TildeFullEqual;":"≅","TildeTilde;":"≈","times;":"×",times:"×","timesb;":"⊠","timesbar;":"⨱","timesd;":"⨰","tint;":"∭","toea;":"⤨","top;":"⊤","topbot;":"⌶","topcir;":"⫱","Topf;":"𝕋","topf;":"𝕥","topfork;":"⫚","tosa;":"⤩","tprime;":"‴","TRADE;":"™","trade;":"™","triangle;":"▵","triangledown;":"▿","triangleleft;":"◃","trianglelefteq;":"⊴","triangleq;":"≜","triangleright;":"▹","trianglerighteq;":"⊵","tridot;":"◬","trie;":"≜","triminus;":"⨺","TripleDot;":"⃛","triplus;":"⨹","trisb;":"⧍","tritime;":"⨻","trpezium;":"⏢","Tscr;":"𝒯","tscr;":"𝓉","TScy;":"Ц","tscy;":"ц","TSHcy;":"Ћ","tshcy;":"ћ","Tstrok;":"Ŧ","tstrok;":"ŧ","twixt;":"≬","twoheadleftarrow;":"↞","twoheadrightarrow;":"↠","Uacute;":"Ú",Uacute:"Ú","uacute;":"ú",uacute:"ú","Uarr;":"↟","uArr;":"⇑","uarr;":"↑","Uarrocir;":"⥉","Ubrcy;":"Ў","ubrcy;":"ў","Ubreve;":"Ŭ","ubreve;":"ŭ","Ucirc;":"Û",Ucirc:"Û","ucirc;":"û",ucirc:"û","Ucy;":"У","ucy;":"у","udarr;":"⇅","Udblac;":"Ű","udblac;":"ű","udhar;":"⥮","ufisht;":"⥾","Ufr;":"𝔘","ufr;":"𝔲","Ugrave;":"Ù",Ugrave:"Ù","ugrave;":"ù",ugrave:"ù","uHar;":"⥣","uharl;":"↿","uharr;":"↾","uhblk;":"▀","ulcorn;":"⌜","ulcorner;":"⌜","ulcrop;":"⌏","ultri;":"◸","Umacr;":"Ū","umacr;":"ū","uml;":"¨",uml:"¨","UnderBar;":"_","UnderBrace;":"⏟","UnderBracket;":"⎵","UnderParenthesis;":"⏝","Union;":"⋃","UnionPlus;":"⊎","Uogon;":"Ų","uogon;":"ų","Uopf;":"𝕌","uopf;":"𝕦","UpArrow;":"↑","Uparrow;":"⇑","uparrow;":"↑","UpArrowBar;":"⤒","UpArrowDownArrow;":"⇅","UpDownArrow;":"↕","Updownarrow;":"⇕","updownarrow;":"↕","UpEquilibrium;":"⥮","upharpoonleft;":"↿","upharpoonright;":"↾","uplus;":"⊎","UpperLeftArrow;":"↖","UpperRightArrow;":"↗","Upsi;":"ϒ","upsi;":"υ","upsih;":"ϒ","Upsilon;":"Υ","upsilon;":"υ","UpTee;":"⊥","UpTeeArrow;":"↥","upuparrows;":"⇈","urcorn;":"⌝","urcorner;":"⌝","urcrop;":"⌎","Uring;":"Ů","uring;":"ů","urtri;":"◹","Uscr;":"𝒰","uscr;":"𝓊","utdot;":"⋰","Utilde;":"Ũ","utilde;":"ũ","utri;":"▵","utrif;":"▴","uuarr;":"⇈","Uuml;":"Ü",Uuml:"Ü","uuml;":"ü",uuml:"ü","uwangle;":"⦧","vangrt;":"⦜","varepsilon;":"ϵ","varkappa;":"ϰ","varnothing;":"∅","varphi;":"ϕ","varpi;":"ϖ","varpropto;":"∝","vArr;":"⇕","varr;":"↕","varrho;":"ϱ","varsigma;":"ς","varsubsetneq;":"⊊︀","varsubsetneqq;":"⫋︀","varsupsetneq;":"⊋︀","varsupsetneqq;":"⫌︀","vartheta;":"ϑ","vartriangleleft;":"⊲","vartriangleright;":"⊳","Vbar;":"⫫","vBar;":"⫨","vBarv;":"⫩","Vcy;":"В","vcy;":"в","VDash;":"⊫","Vdash;":"⊩","vDash;":"⊨","vdash;":"⊢","Vdashl;":"⫦","Vee;":"⋁","vee;":"∨","veebar;":"⊻","veeeq;":"≚","vellip;":"⋮","Verbar;":"‖","verbar;":"|","Vert;":"‖","vert;":"|","VerticalBar;":"∣","VerticalLine;":"|","VerticalSeparator;":"❘","VerticalTilde;":"≀","VeryThinSpace;":" ","Vfr;":"𝔙","vfr;":"𝔳","vltri;":"⊲","vnsub;":"⊂⃒","vnsup;":"⊃⃒","Vopf;":"𝕍","vopf;":"𝕧","vprop;":"∝","vrtri;":"⊳","Vscr;":"𝒱","vscr;":"𝓋","vsubnE;":"⫋︀","vsubne;":"⊊︀","vsupnE;":"⫌︀","vsupne;":"⊋︀","Vvdash;":"⊪","vzigzag;":"⦚","Wcirc;":"Ŵ","wcirc;":"ŵ","wedbar;":"⩟","Wedge;":"⋀","wedge;":"∧","wedgeq;":"≙","weierp;":"℘","Wfr;":"𝔚","wfr;":"𝔴","Wopf;":"𝕎","wopf;":"𝕨","wp;":"℘","wr;":"≀","wreath;":"≀","Wscr;":"𝒲","wscr;":"𝓌","xcap;":"⋂","xcirc;":"◯","xcup;":"⋃","xdtri;":"▽","Xfr;":"𝔛","xfr;":"𝔵","xhArr;":"⟺","xharr;":"⟷","Xi;":"Ξ","xi;":"ξ","xlArr;":"⟸","xlarr;":"⟵","xmap;":"⟼","xnis;":"⋻","xodot;":"⨀","Xopf;":"𝕏","xopf;":"𝕩","xoplus;":"⨁","xotime;":"⨂","xrArr;":"⟹","xrarr;":"⟶","Xscr;":"𝒳","xscr;":"𝓍","xsqcup;":"⨆","xuplus;":"⨄","xutri;":"△","xvee;":"⋁","xwedge;":"⋀","Yacute;":"Ý",Yacute:"Ý","yacute;":"ý",yacute:"ý","YAcy;":"Я","yacy;":"я","Ycirc;":"Ŷ","ycirc;":"ŷ","Ycy;":"Ы","ycy;":"ы","yen;":"¥",yen:"¥","Yfr;":"𝔜","yfr;":"𝔶","YIcy;":"Ї","yicy;":"ї","Yopf;":"𝕐","yopf;":"𝕪","Yscr;":"𝒴","yscr;":"𝓎","YUcy;":"Ю","yucy;":"ю","Yuml;":"Ÿ","yuml;":"ÿ",yuml:"ÿ","Zacute;":"Ź","zacute;":"ź","Zcaron;":"Ž","zcaron;":"ž","Zcy;":"З","zcy;":"з","Zdot;":"Ż","zdot;":"ż","zeetrf;":"ℨ","ZeroWidthSpace;":"​","Zeta;":"Ζ","zeta;":"ζ","Zfr;":"ℨ","zfr;":"𝔷","ZHcy;":"Ж","zhcy;":"ж","zigrarr;":"⇝","Zopf;":"ℤ","zopf;":"𝕫","Zscr;":"𝒵","zscr;":"𝓏","zwj;":"‍","zwnj;":"‌"},ne=D(Object.freeze({__proto__:null,Aacute:"Á",aacute:"á",Acirc:"Â",acirc:"â",acute:"´",AElig:"Æ",aelig:"æ",Agrave:"À",agrave:"à",AMP:"&",amp:"&",Aring:"Å",aring:"å",Atilde:"Ã",atilde:"ã",Auml:"Ä",auml:"ä",brvbar:"¦",Ccedil:"Ç",ccedil:"ç",cedil:"¸",cent:"¢",COPY:"©",copy:"©",curren:"¤",deg:"°",divide:"÷",Eacute:"É",eacute:"é",Ecirc:"Ê",ecirc:"ê",Egrave:"È",egrave:"è",ETH:"Ð",eth:"ð",Euml:"Ë",euml:"ë",frac12:"½",frac14:"¼",frac34:"¾",GT:">",gt:">",Iacute:"Í",iacute:"í",Icirc:"Î",icirc:"î",iexcl:"¡",Igrave:"Ì",igrave:"ì",iquest:"¿",Iuml:"Ï",iuml:"ï",laquo:"«",LT:"<",lt:"<",macr:"¯",micro:"µ",middot:"·",nbsp:" ",not:"¬",Ntilde:"Ñ",ntilde:"ñ",Oacute:"Ó",oacute:"ó",Ocirc:"Ô",ocirc:"ô",Ograve:"Ò",ograve:"ò",ordf:"ª",ordm:"º",Oslash:"Ø",oslash:"ø",Otilde:"Õ",otilde:"õ",Ouml:"Ö",ouml:"ö",para:"¶",plusmn:"±",pound:"£",QUOT:'"',quot:'"',raquo:"»",REG:"®",reg:"®",sect:"§",shy:"­",sup1:"¹",sup2:"²",sup3:"³",szlig:"ß",THORN:"Þ",thorn:"þ",times:"×",Uacute:"Ú",uacute:"ú",Ucirc:"Û",ucirc:"û",Ugrave:"Ù",ugrave:"ù",uml:"¨",Uuml:"Ü",uuml:"ü",Yacute:"Ý",yacute:"ý",yen:"¥",yuml:"ÿ",default:te}));var ae={encode:ee,decode:function(r){if("string"!=typeof r)throw new TypeError("Expected a String");return r.replace(/&(#?[^;\W]+;?)/g,(function(r,e){var t;if(t=/^#(\d+);?$/.exec(e))return Xr.ucs2.encode([parseInt(t[1],10)]);if(t=/^#[Xx]([A-Fa-f0-9]+);?/.exec(e))return Xr.ucs2.encode([parseInt(t[1],16)]);var n=/;$/.test(e),a=n?e.replace(/;$/,""):e,o=ne[a]||n&&ne[e];return"number"==typeof o?Xr.ucs2.encode([o]):"string"==typeof o?o:"&"+e}))}};!function(r,e,t){r(t={path:e,exports:{},require:function(r,e){return function(){throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs")}(null==e&&t.path)}},t.exports),t.exports}((function(e,t){var n="[object Arguments]",a="[object Function]",o="[object GeneratorFunction]",i="[object Map]",s="[object Set]",c=/\w*$/,l=/^\[object .+?Constructor\]$/,u=/^(?:0|[1-9]\d*)$/,p={};p[n]=p["[object Array]"]=p["[object ArrayBuffer]"]=p["[object DataView]"]=p["[object Boolean]"]=p["[object Date]"]=p["[object Float32Array]"]=p["[object Float64Array]"]=p["[object Int8Array]"]=p["[object Int16Array]"]=p["[object Int32Array]"]=p[i]=p["[object Number]"]=p["[object Object]"]=p["[object RegExp]"]=p[s]=p["[object String]"]=p["[object Symbol]"]=p["[object Uint8Array]"]=p["[object Uint8ClampedArray]"]=p["[object Uint16Array]"]=p["[object Uint32Array]"]=!0,p["[object Error]"]=p[a]=p["[object WeakMap]"]=!1;var f="object"==r(x)&&x&&x.Object===Object&&x,g="object"==("undefined"==typeof self?"undefined":r(self))&&self&&self.Object===Object&&self,d=f||g||Function("return this")(),h=t&&!t.nodeType&&t,m=h&&e&&!e.nodeType&&e,b=m&&m.exports===h;function y(r,e){return r.set(e[0],e[1]),r}function v(r,e){return r.add(e),r}function w(r,e,t,n){var a=-1,o=r?r.length:0;for(n&&o&&(t=r[++a]);++a<o;)t=e(t,r[a],a,r);return t}function q(r){var e=!1;if(null!=r&&"function"!=typeof r.toString)try{e=!!(r+"")}catch(r){}return e}function A(r){var e=-1,t=Array(r.size);return r.forEach((function(r,n){t[++e]=[n,r]})),t}function T(r,e){return function(t){return r(e(t))}}function E(r){var e=-1,t=Array(r.size);return r.forEach((function(r){t[++e]=r})),t}var k=Array.prototype,O=Function.prototype,S=Object.prototype,_=d["__core-js_shared__"],D=function(){var r=/[^.]+$/.exec(_&&_.keys&&_.keys.IE_PROTO||"");return r?"Symbol(src)_1."+r:""}(),L=O.toString,j=S.hasOwnProperty,R=S.toString,N=RegExp("^"+L.call(j).replace(/[\\^$.*+?()[\]{}|]/g,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$"),C=b?d.Buffer:void 0,I=d.Symbol,B=d.Uint8Array,H=T(Object.getPrototypeOf,Object),U=Object.create,V=S.propertyIsEnumerable,P=k.splice,W=Object.getOwnPropertySymbols,F=C?C.isBuffer:void 0,G=T(Object.keys,Object),z=mr(d,"DataView"),J=mr(d,"Map"),M=mr(d,"Promise"),$=mr(d,"Set"),Y=mr(d,"WeakMap"),Z=mr(Object,"create"),K=qr(z),Q=qr(J),X=qr(M),rr=qr($),er=qr(Y),tr=I?I.prototype:void 0,nr=tr?tr.valueOf:void 0;function ar(r){var e=-1,t=r?r.length:0;for(this.clear();++e<t;){var n=r[e];this.set(n[0],n[1])}}function or(r){var e=-1,t=r?r.length:0;for(this.clear();++e<t;){var n=r[e];this.set(n[0],n[1])}}function ir(r){var e=-1,t=r?r.length:0;for(this.clear();++e<t;){var n=r[e];this.set(n[0],n[1])}}function sr(r){this.__data__=new or(r)}function cr(e,t){var a=Tr(e)||function(e){return function(e){return function(e){return!!e&&"object"==r(e)}(e)&&Er(e)}(e)&&j.call(e,"callee")&&(!V.call(e,"callee")||R.call(e)==n)}(e)?function(r,e){for(var t=-1,n=Array(r);++t<r;)n[t]=e(t);return n}(e.length,String):[],o=a.length,i=!!o;for(var s in e)!t&&!j.call(e,s)||i&&("length"==s||vr(s,o))||a.push(s);return a}function lr(r,e,t){var n=r[e];j.call(r,e)&&Ar(n,t)&&(void 0!==t||e in r)||(r[e]=t)}function ur(r,e){for(var t=r.length;t--;)if(Ar(r[t][0],e))return t;return-1}function pr(r,e,t,l,u,f,g){var d;if(l&&(d=f?l(r,u,f,g):l(r)),void 0!==d)return d;if(!Sr(r))return r;var h=Tr(r);if(h){if(d=function(r){var e=r.length,t=r.constructor(e);e&&"string"==typeof r[0]&&j.call(r,"index")&&(t.index=r.index,t.input=r.input);return t}(r),!e)return function(r,e){var t=-1,n=r.length;e||(e=Array(n));for(;++t<n;)e[t]=r[t];return e}(r,d)}else{var m=yr(r),b=m==a||m==o;if(kr(r))return function(r,e){if(e)return r.slice();var t=new r.constructor(r.length);return r.copy(t),t}(r,e);if("[object Object]"==m||m==n||b&&!f){if(q(r))return f?r:{};if(d=function(r){return"function"!=typeof r.constructor||wr(r)?{}:(e=H(r),Sr(e)?U(e):{});var e}(b?{}:r),!e)return function(r,e){return dr(r,br(r),e)}(r,function(r,e){return r&&dr(e,_r(e),r)}(d,r))}else{if(!p[m])return f?r:{};d=function(r,e,t,n){var a=r.constructor;switch(e){case"[object ArrayBuffer]":return gr(r);case"[object Boolean]":case"[object Date]":return new a(+r);case"[object DataView]":return function(r,e){var t=e?gr(r.buffer):r.buffer;return new r.constructor(t,r.byteOffset,r.byteLength)}(r,n);case"[object Float32Array]":case"[object Float64Array]":case"[object Int8Array]":case"[object Int16Array]":case"[object Int32Array]":case"[object Uint8Array]":case"[object Uint8ClampedArray]":case"[object Uint16Array]":case"[object Uint32Array]":return function(r,e){var t=e?gr(r.buffer):r.buffer;return new r.constructor(t,r.byteOffset,r.length)}(r,n);case i:return function(r,e,t){return w(e?t(A(r),!0):A(r),y,new r.constructor)}(r,n,t);case"[object Number]":case"[object String]":return new a(r);case"[object RegExp]":return function(r){var e=new r.constructor(r.source,c.exec(r));return e.lastIndex=r.lastIndex,e}(r);case s:return function(r,e,t){return w(e?t(E(r),!0):E(r),v,new r.constructor)}(r,n,t);case"[object Symbol]":return o=r,nr?Object(nr.call(o)):{}}var o}(r,m,pr,e)}}g||(g=new sr);var T=g.get(r);if(T)return T;if(g.set(r,d),!h)var k=t?function(r){return function(r,e,t){var n=e(r);return Tr(r)?n:function(r,e){for(var t=-1,n=e.length,a=r.length;++t<n;)r[a+t]=e[t];return r}(n,t(r))}(r,_r,br)}(r):_r(r);return function(r,e){for(var t=-1,n=r?r.length:0;++t<n&&!1!==e(r[t],t,r););}(k||r,(function(n,a){k&&(n=r[a=n]),lr(d,a,pr(n,e,t,l,a,r,g))})),d}function fr(r){return!(!Sr(r)||function(r){return!!D&&D in r}(r))&&(Or(r)||q(r)?N:l).test(qr(r))}function gr(r){var e=new r.constructor(r.byteLength);return new B(e).set(new B(r)),e}function dr(r,e,t,n){t||(t={});for(var a=-1,o=e.length;++a<o;){var i=e[a],s=n?n(t[i],r[i],i,t,r):void 0;lr(t,i,void 0===s?r[i]:s)}return t}function hr(e,t){var n,a,o=e.__data__;return("string"==(a=r(n=t))||"number"==a||"symbol"==a||"boolean"==a?"__proto__"!==n:null===n)?o["string"==typeof t?"string":"hash"]:o.map}function mr(r,e){var t=function(r,e){return null==r?void 0:r[e]}(r,e);return fr(t)?t:void 0}ar.prototype.clear=function(){this.__data__=Z?Z(null):{}},ar.prototype.delete=function(r){return this.has(r)&&delete this.__data__[r]},ar.prototype.get=function(r){var e=this.__data__;if(Z){var t=e[r];return"__lodash_hash_undefined__"===t?void 0:t}return j.call(e,r)?e[r]:void 0},ar.prototype.has=function(r){var e=this.__data__;return Z?void 0!==e[r]:j.call(e,r)},ar.prototype.set=function(r,e){return this.__data__[r]=Z&&void 0===e?"__lodash_hash_undefined__":e,this},or.prototype.clear=function(){this.__data__=[]},or.prototype.delete=function(r){var e=this.__data__,t=ur(e,r);return!(t<0)&&(t==e.length-1?e.pop():P.call(e,t,1),!0)},or.prototype.get=function(r){var e=this.__data__,t=ur(e,r);return t<0?void 0:e[t][1]},or.prototype.has=function(r){return ur(this.__data__,r)>-1},or.prototype.set=function(r,e){var t=this.__data__,n=ur(t,r);return n<0?t.push([r,e]):t[n][1]=e,this},ir.prototype.clear=function(){this.__data__={hash:new ar,map:new(J||or),string:new ar}},ir.prototype.delete=function(r){return hr(this,r).delete(r)},ir.prototype.get=function(r){return hr(this,r).get(r)},ir.prototype.has=function(r){return hr(this,r).has(r)},ir.prototype.set=function(r,e){return hr(this,r).set(r,e),this},sr.prototype.clear=function(){this.__data__=new or},sr.prototype.delete=function(r){return this.__data__.delete(r)},sr.prototype.get=function(r){return this.__data__.get(r)},sr.prototype.has=function(r){return this.__data__.has(r)},sr.prototype.set=function(r,e){var t=this.__data__;if(t instanceof or){var n=t.__data__;if(!J||n.length<199)return n.push([r,e]),this;t=this.__data__=new ir(n)}return t.set(r,e),this};var br=W?T(W,Object):function(){return[]},yr=function(r){return R.call(r)};function vr(r,e){return!!(e=null==e?9007199254740991:e)&&("number"==typeof r||u.test(r))&&r>-1&&r%1==0&&r<e}function wr(r){var e=r&&r.constructor;return r===("function"==typeof e&&e.prototype||S)}function qr(r){if(null!=r){try{return L.call(r)}catch(r){}try{return r+""}catch(r){}}return""}function Ar(r,e){return r===e||r!=r&&e!=e}(z&&"[object DataView]"!=yr(new z(new ArrayBuffer(1)))||J&&yr(new J)!=i||M&&"[object Promise]"!=yr(M.resolve())||$&&yr(new $)!=s||Y&&"[object WeakMap]"!=yr(new Y))&&(yr=function(r){var e=R.call(r),t="[object Object]"==e?r.constructor:void 0,n=t?qr(t):void 0;if(n)switch(n){case K:return"[object DataView]";case Q:return i;case X:return"[object Promise]";case rr:return s;case er:return"[object WeakMap]"}return e});var Tr=Array.isArray;function Er(r){return null!=r&&function(r){return"number"==typeof r&&r>-1&&r%1==0&&r<=9007199254740991}(r.length)&&!Or(r)}var kr=F||function(){return!1};function Or(r){var e=Sr(r)?R.call(r):"";return e==a||e==o}function Sr(e){var t=r(e);return!!e&&("object"==t||"function"==t)}function _r(r){return Er(r)?cr(r):function(r){if(!wr(r))return G(r);var e=[];for(var t in Object(r))j.call(r,t)&&"constructor"!=t&&e.push(t);return e}(r)}e.exports=function(r){return pr(r,!0,!0)}}));function oe(r,e){return function(r,e,t){if("string"!=typeof r||!r.length)return null;if(e&&"number"==typeof e||(e=0),!r[e+1])return null;if(r[e+1]&&(!t&&r[e+1].trim()||t&&(r[e+1].trim()||"\n\r".includes(r[e+1]))))return e+1;if(r[e+2]&&(!t&&r[e+2].trim()||t&&(r[e+2].trim()||"\n\r".includes(r[e+2]))))return e+2;for(var n=e+1,a=r.length;n<a;n++)if(r[n]&&(!t&&r[n].trim()||t&&(r[n].trim()||"\n\r".includes(r[n]))))return n;return null}(r,e,!1)}function ie(e,t){if(!e)return[];if(Array.isArray(e))return e.filter((function(r){return"string"==typeof r&&r.trim()}));if("string"==typeof e)return e.trim()?[e]:[];throw new TypeError("string-strip-html/stripHtml(): [THROW_ID_03] ".concat(t," must be array containing zero or more strings or something falsey. Currently it's equal to: ").concat(e,", that a type of ").concat(r(e),"."))}return function e(t,n){var i,s=new Set(["!doctype","abbr","address","area","article","aside","audio","base","bdi","bdo","blockquote","body","br","button","canvas","caption","cite","code","col","colgroup","data","datalist","dd","del","details","dfn","dialog","div","dl","doctype","dt","em","embed","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","head","header","hgroup","hr","html","iframe","img","input","ins","kbd","keygen","label","legend","li","link","main","map","mark","math","menu","menuitem","meta","meter","nav","noscript","object","ol","optgroup","option","output","param","picture","pre","progress","rb","rp","rt","rtc","ruby","samp","script","section","select","slot","small","source","span","strong","style","sub","summary","sup","svg","table","tbody","td","template","textarea","tfoot","th","thead","time","title","tr","track","ul","var","video","wbr","xml"]),c=new Set(["a","b","i","p","q","s","u"]),l=new Set([".",",","?",";",")","…",'"',"»"]),u=new Set(["script","style","xml"]),f={attributes:[]},g=null,d=null,h=[],m={},b={},v="",w=null;function q(r,e,n){if(Array.isArray(e.stripTogetherWithTheirContents)&&e.stripTogetherWithTheirContents.includes(f.name))if(Array.isArray(h)&&h.some((function(e){return e.name===f.name&&e.lastClosingBracketAt<r}))){for(var a=h.length;a--;)if(h[a].name===f.name){l.has(t[r])?e.cb({tag:f,deleteFrom:h[a].lastOpeningBracketAt,deleteTo:r,insert:null,rangesArr:n,proposedReturn:[h[a].lastOpeningBracketAt,r,null]}):e.cb({tag:f,deleteFrom:h[a].lastOpeningBracketAt,deleteTo:r,insert:"",rangesArr:n,proposedReturn:[h[a].lastOpeningBracketAt,r,""]}),h.splice(a,1);break}}else h.push(f)}function A(r,e,t,n,a,o){var i="";if(t<a&&(i+=r.slice(t,a)),n>o+1){var s=r.slice(o+1,n);s.includes("\n")&&"<"===r[n]?i+=" ":i+=s}if(!l.has(r[e])&&"!"!==r[e]){var c=i.match(/\n/g);return Array.isArray(c)&&c.length?1===c.length?"\n":2===c.length?"\n\n":"\n\n\n":" "}return""}function T(r){if(r.dumpLinkHrefsNearby.enabled&&Object.keys(b).length&&b.tagName===f.name&&f.lastOpeningBracketAt&&(b.openingTagEnds&&f.lastOpeningBracketAt>b.openingTagEnds||!b.openingTagEnds)&&(i=!0),i){var e=r.dumpLinkHrefsNearby.putOnNewLine?"\n\n":"";v="".concat(e).concat(b.hrefValue).concat(e)}}if("string"!=typeof t)throw new TypeError("string-strip-html/stripHtml(): [THROW_ID_01] Input must be string! Currently it's: ".concat(r(t).toLowerCase(),", equal to:\n").concat(JSON.stringify(t,null,4)));if(!t||!t.trim())return t;if(null!=n&&!_(n))throw new TypeError("string-strip-html/stripHtml(): [THROW_ID_02] Optional Options Object must be a plain object! Currently it's: ".concat(r(n).toLowerCase(),", equal to:\n").concat(JSON.stringify(n,null,4)));function E(){i&&(b={},i=!1)}var k={ignoreTags:[],onlyStripTags:[],stripTogetherWithTheirContents:o(u),skipHtmlDecoding:!1,returnRangesOnly:!1,trimOnlySpaces:!1,dumpLinkHrefsNearby:{enabled:!1,putOnNewLine:!1,wrapHeads:"",wrapTails:""},cb:null},O=a(a({},k),n);O.ignoreTags=ie(O.ignoreTags,"opts.ignoreTags"),O.onlyStripTags=ie(O.onlyStripTags,"opts.onlyStripTags");var S=!!O.onlyStripTags.length;if(O.onlyStripTags.length&&O.ignoreTags.length&&(O.onlyStripTags=Ir.apply(void 0,[O.onlyStripTags].concat(o(O.ignoreTags)))),_(O.dumpLinkHrefsNearby)||(O.dumpLinkHrefsNearby=a({},k.dumpLinkHrefsNearby)),O.dumpLinkHrefsNearby=k.dumpLinkHrefsNearby,_(n)&&Object.prototype.hasOwnProperty.call(n,"dumpLinkHrefsNearby")&&null!=n.dumpLinkHrefsNearby)if(_(n.dumpLinkHrefsNearby))O.dumpLinkHrefsNearby=a(a({},k.dumpLinkHrefsNearby),n.dumpLinkHrefsNearby);else if(n.dumpLinkHrefsNearby)throw new TypeError("string-strip-html/stripHtml(): [THROW_ID_04] Optional Options Object's key dumpLinkHrefsNearby was set to ".concat(r(n.dumpLinkHrefsNearby),", equal to ").concat(JSON.stringify(n.dumpLinkHrefsNearby,null,4),". The only allowed value is a plain object. See the API reference."));O.stripTogetherWithTheirContents?"string"==typeof O.stripTogetherWithTheirContents&&O.stripTogetherWithTheirContents.length>0&&(O.stripTogetherWithTheirContents=[O.stripTogetherWithTheirContents]):O.stripTogetherWithTheirContents=[];var x={};if(O.stripTogetherWithTheirContents&&Array.isArray(O.stripTogetherWithTheirContents)&&O.stripTogetherWithTheirContents.length&&!O.stripTogetherWithTheirContents.every((function(r,e){return"string"==typeof r||(x.el=r,x.i=e,!1)})))throw new TypeError("string-strip-html/stripHtml(): [THROW_ID_06] Optional Options Object's key stripTogetherWithTheirContents was set to contain not just string elements! For example, element at index ".concat(x.i," has a value ").concat(x.el," which is not string but ").concat(r(x.el).toLowerCase(),"."));O.cb||(O.cb=function(r){var e=r.rangesArr,t=r.proposedReturn;e.push.apply(e,o(t))});var D,L=new y({limitToBeAddedWhitespace:!0,limitLinebreaksCount:2});if(!O.skipHtmlDecoding)for(;t!==ae.decode(t);)t=ae.decode(t);O.trimOnlySpaces||(t=t.trim());for(var j=0,R=t.length;j<R;j++){if(Object.keys(f).length>1&&f.lastClosingBracketAt&&f.lastClosingBracketAt<j&&" "!==t[j]&&null===w&&(w=j),">"===t[j]&&(!f||Object.keys(f).length<2)&&j>1)for(var N=j;N--;){if(void 0===t[N-1]||">"===t[N])if("break"===function(){var r=void 0===t[N-1]?N:N+1,n=t.slice(r,j+1);if(t!=="<".concat(er(n.trim(),"/>"),">")&&o(s).some((function(r){return er(n.trim().split(" ").filter((function(r){return r.trim()})).filter((function(r,e){return 0===e})),"/>").toLowerCase()===r}))&&""===e("<".concat(n.trim(),">"),O)){var a=A(t,j,r,j+1,r,j+1),i=j+1;if(t[i]&&!t[i].trim())for(var c=i;c<R;c++)if(t[c].trim()){i=c;break}O.cb({tag:f,deleteFrom:r,deleteTo:i,insert:a,rangesArr:L,proposedReturn:[r,i,a]})}return"break"}())break}if("/"!==t[j]||f.quotes&&f.quotes.value||!Number.isInteger(f.lastOpeningBracketAt)||Number.isInteger(f.lastClosingBracketAt)||(f.slashPresent=j),'"'===t[j]||"'"===t[j])if(f.nameStarts&&f.quotes&&f.quotes.value&&f.quotes.value===t[j]){m.valueEnds=j,m.value=t.slice(m.valueStarts,j),f.attributes.push(m),m={},f.quotes=void 0;var C=void 0;O.dumpLinkHrefsNearby.enabled&&f.attributes.some((function(r){if(r.name&&"href"===r.name.toLowerCase())return C="".concat(O.dumpLinkHrefsNearby.wrapHeads||"").concat(r.value).concat(O.dumpLinkHrefsNearby.wrapTails||""),!0}))&&(b={tagName:f.name,hrefValue:C})}else!f.quotes&&f.nameStarts&&(f.quotes={},f.quotes.value=t[j],f.quotes.start=j,m.nameStarts&&m.nameEnds&&m.nameEnds<j&&m.nameStarts<j&&!m.valueStarts&&(m.name=t.slice(m.nameStarts,m.nameEnds)));if(!(void 0===f.nameStarts||void 0!==f.nameEnds||t[j].trim()&&(D=t[j],/[-_A-Za-z0-9]/.test(D)))){if(f.nameEnds=j,f.name=t.slice(f.nameStarts,f.nameEnds+(">"!==t[j]&&"/"!==t[j]&&void 0===t[j+1]?1:0)),"!"!==t[f.nameStarts-1]&&!f.name.replace(/-/g,"").length||/^\d+$/.test(f.name[0])){f={};continue}if("<"===t[j]){T(O);var I=A(t,j,f.leftOuterWhitespace,j,f.lastOpeningBracketAt,j);O.cb({tag:f,deleteFrom:f.leftOuterWhitespace,deleteTo:j,insert:"".concat(I).concat(v).concat(I),rangesArr:L,proposedReturn:[f.leftOuterWhitespace,j,"".concat(I).concat(v).concat(I)]}),E(),q(j,O,L)}}if(f.quotes&&f.quotes.start&&f.quotes.start<j&&!f.quotes.end&&m.nameEnds&&m.equalsAt&&!m.valueStarts&&(m.valueStarts=j),f.quotes||!m.nameEnds||"="!==t[j]||m.valueStarts||m.equalsAt||(m.equalsAt=j),!f.quotes&&m.nameStarts&&m.nameEnds&&!m.valueStarts&&t[j].trim()&&"="!==t[j]&&(f.attributes.push(m),m={}),f.quotes||!m.nameStarts||m.nameEnds||(t[j].trim()?"="===t[j]?m.equalsAt||(m.nameEnds=j,m.equalsAt=j,m.name=t.slice(m.nameStarts,m.nameEnds)):("/"===t[j]||">"===t[j]||"<"===t[j])&&(m.nameEnds=j,m.name=t.slice(m.nameStarts,m.nameEnds),f.attributes.push(m),m={}):(m.nameEnds=j,m.name=t.slice(m.nameStarts,m.nameEnds))),f.quotes||!(f.nameEnds<j)||t[j-1].trim()||!t[j].trim()||"<>/!".includes(t[j])||m.nameStarts||f.lastClosingBracketAt||(m.nameStarts=j),null!==f.lastOpeningBracketAt&&f.lastOpeningBracketAt<j&&"/"===t[j]&&f.onlyPlausible&&(f.onlyPlausible=!1),null!==f.lastOpeningBracketAt&&f.lastOpeningBracketAt<j&&"/"!==t[j]&&(void 0===f.onlyPlausible&&(t[j].trim()&&"<"!==t[j]||f.slashPresent?f.onlyPlausible=!1:f.onlyPlausible=!0),t[j].trim()&&void 0===f.nameStarts&&"<"!==t[j]&&"/"!==t[j]&&">"!==t[j]&&"!"!==t[j]&&(f.nameStarts=j,f.nameContainsLetters=!1)),f.nameStarts&&!f.quotes&&t[j].toLowerCase()!==t[j].toUpperCase()&&(f.nameContainsLetters=!0),">"===t[j]&&void 0!==f.lastOpeningBracketAt&&(f.lastClosingBracketAt=j,w=null,Object.keys(m).length&&(f.attributes.push(m),m={}),O.dumpLinkHrefsNearby.enabled&&b.tagName&&!b.openingTagEnds&&(b.openingTagEnds=j)),void 0!==f.lastOpeningBracketAt)if(void 0===f.lastClosingBracketAt){if(f.lastOpeningBracketAt<j&&"<"!==t[j]&&(void 0===t[j+1]||"<"===t[j+1])&&f.nameContainsLetters){if(f.name=t.slice(f.nameStarts,f.nameEnds?f.nameEnds:j+1).toLowerCase(),O.ignoreTags.includes(f.name)||f.onlyPlausible&&!s.has(f.name)){f={},m={};continue}if((s.has(f.name)||c.has(f.name))&&(!1===f.onlyPlausible||!0===f.onlyPlausible&&f.attributes.length)||void 0===t[j+1]){T(O);var B=A(t,j,f.leftOuterWhitespace,j+1,f.lastOpeningBracketAt,f.lastClosingBracketAt);O.cb({tag:f,deleteFrom:f.leftOuterWhitespace,deleteTo:j+1,insert:"".concat(B).concat(v).concat(B),rangesArr:L,proposedReturn:[f.leftOuterWhitespace,j+1,"".concat(B).concat(v).concat(B)]}),E(),q(j,O,L)}}}else if(j>f.lastClosingBracketAt&&t[j].trim()||void 0===t[j+1]){var H=f.lastClosingBracketAt===j?j+1:j;if(O.trimOnlySpaces&&H===R-1&&null!==w&&w<j&&(H=w),!S&&O.ignoreTags.includes(f.name)||S&&!O.onlyStripTags.includes(f.name))O.cb({tag:f,deleteFrom:null,deleteTo:null,insert:null,rangesArr:L,proposedReturn:[]}),f={},m={};else if(!f.onlyPlausible||0===f.attributes.length&&f.name&&(s.has(f.name.toLowerCase())||c.has(f.name.toLowerCase()))||f.attributes&&f.attributes.some((function(r){return r.equalsAt}))){var U=A(t,j,f.leftOuterWhitespace,H,f.lastOpeningBracketAt,f.lastClosingBracketAt);v="",i=!1,T(O);var V=void 0;V="string"==typeof v&&v.length?"".concat(U).concat(v).concat("\n\n"===U?"\n":U):U,0!==f.leftOuterWhitespace&&oe(t,H-1)||(V=""),O.cb({tag:f,deleteFrom:f.leftOuterWhitespace,deleteTo:H,insert:V,rangesArr:L,proposedReturn:[f.leftOuterWhitespace,H,V]}),E(),q(j,O,L)}else f={};">"!==t[j]&&(f={})}if("<"===t[j]&&"<"!==t[j-1]){if(">"===t[oe(t,j)])continue;if(f.nameEnds&&f.nameEnds<j&&!f.lastClosingBracketAt&&(!0===f.onlyPlausible&&f.attributes&&f.attributes.length||!1===f.onlyPlausible)){var P=A(t,j,f.leftOuterWhitespace,j,f.lastOpeningBracketAt,j);O.cb({tag:f,deleteFrom:f.leftOuterWhitespace,deleteTo:j,insert:P,rangesArr:L,proposedReturn:[f.leftOuterWhitespace,j,P]}),q(j,O,L),f={},m={}}if(void 0!==f.lastOpeningBracketAt&&f.onlyPlausible&&f.name&&!f.quotes&&(f.lastOpeningBracketAt=void 0,f.onlyPlausible=!1),!(void 0!==f.lastOpeningBracketAt&&f.onlyPlausible||f.quotes)&&(f.lastOpeningBracketAt=j,f.slashPresent=!1,f.attributes=[],null===g?f.leftOuterWhitespace=j:O.trimOnlySpaces&&0===g?f.leftOuterWhitespace=d||j:f.leftOuterWhitespace=g,"!--"==="".concat(t[j+1]).concat(t[j+2]).concat(t[j+3])||"![CDATA["==="".concat(t[j+1]).concat(t[j+2]).concat(t[j+3]).concat(t[j+4]).concat(t[j+5]).concat(t[j+6]).concat(t[j+7]).concat(t[j+8]))){var W=!0;"-"===t[j+2]&&(W=!1);for(var F=void 0,G=j;G<R;G++)if((!F&&W&&"]]>"==="".concat(t[G-2]).concat(t[G-1]).concat(t[G])||!W&&"--\x3e"==="".concat(t[G-2]).concat(t[G-1]).concat(t[G]))&&(F=G),F&&(F<G&&t[G].trim()||void 0===t[G+1])){var z=G;(void 0===t[G+1]&&!t[G].trim()||">"===t[G])&&(z+=1);var J=A(t,G,f.leftOuterWhitespace,z,f.lastOpeningBracketAt,F);O.cb({tag:f,deleteFrom:f.leftOuterWhitespace,deleteTo:z,insert:J,rangesArr:L,proposedReturn:[f.leftOuterWhitespace,z,J]}),j=G-1,">"===t[G]&&(j=G),f={},m={};break}}}""===t[j].trim()?null===g&&(g=j,void 0!==f.lastOpeningBracketAt&&f.lastOpeningBracketAt<j&&f.nameStarts&&f.nameStarts<f.lastOpeningBracketAt&&j===f.lastOpeningBracketAt+1&&!h.some((function(r){return r.name===f.name}))&&(f.onlyPlausible=!0,f.name=void 0,f.nameStarts=void 0)):null!==g&&(!f.quotes&&m.equalsAt>g-1&&m.nameEnds&&m.equalsAt>m.nameEnds&&'"'!==t[j]&&"'"!==t[j]&&(_(m)&&f.attributes.push(m),m={},f.equalsSpottedAt=void 0),g=null)," "===t[j]?null===d&&(d=j):null!==d&&(d=null)}if(L.current()){if(O.returnRangesOnly)return L.current();var M=p(t,L.current());return O.trimOnlySpaces?er(M," "):M.trim()}return O.returnRangesOnly?[]:O.trimOnlySpaces?er(t," "):t.trim()}}));
    
    /* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(10)))
    
    /***/ }),
    /* 12 */
    /***/ (function(module, exports, __webpack_require__) {
    
    var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
     * EvEmitter v1.1.0
     * Lil' event emitter
     * MIT License
     */
    
    /* jshint unused: true, undef: true, strict: true */
    
    ( function( global, factory ) {
      // universal module definition
      /* jshint strict: false */ /* globals define, module, window */
      if ( true ) {
        // AMD - RequireJS
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
                    __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
                    (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
                    __WEBPACK_AMD_DEFINE_FACTORY__),
                    __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
      } else {}
    
    }( typeof window != 'undefined' ? window : this, function() {
    
    "use strict";
    
    function EvEmitter() {}
    
    var proto = EvEmitter.prototype;
    
    proto.on = function( eventName, listener ) {
      if ( !eventName || !listener ) {
        return;
      }
      // set events hash
      var events = this._events = this._events || {};
      // set listeners array
      var listeners = events[ eventName ] = events[ eventName ] || [];
      // only add once
      if ( listeners.indexOf( listener ) == -1 ) {
        listeners.push( listener );
      }
    
      return this;
    };
    
    proto.once = function( eventName, listener ) {
      if ( !eventName || !listener ) {
        return;
      }
      // add event
      this.on( eventName, listener );
      // set once flag
      // set onceEvents hash
      var onceEvents = this._onceEvents = this._onceEvents || {};
      // set onceListeners object
      var onceListeners = onceEvents[ eventName ] = onceEvents[ eventName ] || {};
      // set flag
      onceListeners[ listener ] = true;
    
      return this;
    };
    
    proto.off = function( eventName, listener ) {
      var listeners = this._events && this._events[ eventName ];
      if ( !listeners || !listeners.length ) {
        return;
      }
      var index = listeners.indexOf( listener );
      if ( index != -1 ) {
        listeners.splice( index, 1 );
      }
    
      return this;
    };
    
    proto.emitEvent = function( eventName, args ) {
      var listeners = this._events && this._events[ eventName ];
      if ( !listeners || !listeners.length ) {
        return;
      }
      // copy over to avoid interference if .off() in listener
      listeners = listeners.slice(0);
      args = args || [];
      // once stuff
      var onceListeners = this._onceEvents && this._onceEvents[ eventName ];
    
      for ( var i=0; i < listeners.length; i++ ) {
        var listener = listeners[i]
        var isOnce = onceListeners && onceListeners[ listener ];
        if ( isOnce ) {
          // remove listener
          // remove before trigger to prevent recursion
          this.off( eventName, listener );
          // unset once flag
          delete onceListeners[ listener ];
        }
        // trigger listener
        listener.apply( this, args );
      }
    
      return this;
    };
    
    proto.allOff = function() {
      delete this._events;
      delete this._onceEvents;
    };
    
    return EvEmitter;
    
    }));
    
    
    /***/ }),
    /* 13 */
    /***/ (function(module, exports, __webpack_require__) {
    
    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
     * Unipointer v2.3.0
     * base class for doing one thing with pointer event
     * MIT license
     */
    
    /*jshint browser: true, undef: true, unused: true, strict: true */
    
    ( function( window, factory ) {
      // universal module definition
      /* jshint strict: false */ /*global define, module, require */
      if ( true ) {
        // AMD
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
          __webpack_require__(12)
        ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( EvEmitter ) {
          return factory( window, EvEmitter );
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
                    __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
      } else {}
    
    }( window, function factory( window, EvEmitter ) {
    
    'use strict';
    
    function noop() {}
    
    function Unipointer() {}
    
    // inherit EvEmitter
    var proto = Unipointer.prototype = Object.create( EvEmitter.prototype );
    
    proto.bindStartEvent = function( elem ) {
      this._bindStartEvent( elem, true );
    };
    
    proto.unbindStartEvent = function( elem ) {
      this._bindStartEvent( elem, false );
    };
    
    /**
     * Add or remove start event
     * @param {Boolean} isAdd - remove if falsey
     */
    proto._bindStartEvent = function( elem, isAdd ) {
      // munge isAdd, default to true
      isAdd = isAdd === undefined ? true : isAdd;
      var bindMethod = isAdd ? 'addEventListener' : 'removeEventListener';
    
      // default to mouse events
      var startEvent = 'mousedown';
      if ( window.PointerEvent ) {
        // Pointer Events
        startEvent = 'pointerdown';
      } else if ( 'ontouchstart' in window ) {
        // Touch Events. iOS Safari
        startEvent = 'touchstart';
      }
      elem[ bindMethod ]( startEvent, this );
    };
    
    // trigger handler methods for events
    proto.handleEvent = function( event ) {
      var method = 'on' + event.type;
      if ( this[ method ] ) {
        this[ method ]( event );
      }
    };
    
    // returns the touch that we're keeping track of
    proto.getTouch = function( touches ) {
      for ( var i=0; i < touches.length; i++ ) {
        var touch = touches[i];
        if ( touch.identifier == this.pointerIdentifier ) {
          return touch;
        }
      }
    };
    
    // ----- start event ----- //
    
    proto.onmousedown = function( event ) {
      // dismiss clicks from right or middle buttons
      var button = event.button;
      if ( button && ( button !== 0 && button !== 1 ) ) {
        return;
      }
      this._pointerDown( event, event );
    };
    
    proto.ontouchstart = function( event ) {
      this._pointerDown( event, event.changedTouches[0] );
    };
    
    proto.onpointerdown = function( event ) {
      this._pointerDown( event, event );
    };
    
    /**
     * pointer start
     * @param {Event} event
     * @param {Event or Touch} pointer
     */
    proto._pointerDown = function( event, pointer ) {
      // dismiss right click and other pointers
      // button = 0 is okay, 1-4 not
      if ( event.button || this.isPointerDown ) {
        return;
      }
    
      this.isPointerDown = true;
      // save pointer identifier to match up touch events
      this.pointerIdentifier = pointer.pointerId !== undefined ?
        // pointerId for pointer events, touch.indentifier for touch events
        pointer.pointerId : pointer.identifier;
    
      this.pointerDown( event, pointer );
    };
    
    proto.pointerDown = function( event, pointer ) {
      this._bindPostStartEvents( event );
      this.emitEvent( 'pointerDown', [ event, pointer ] );
    };
    
    // hash of events to be bound after start event
    var postStartEvents = {
      mousedown: [ 'mousemove', 'mouseup' ],
      touchstart: [ 'touchmove', 'touchend', 'touchcancel' ],
      pointerdown: [ 'pointermove', 'pointerup', 'pointercancel' ],
    };
    
    proto._bindPostStartEvents = function( event ) {
      if ( !event ) {
        return;
      }
      // get proper events to match start event
      var events = postStartEvents[ event.type ];
      // bind events to node
      events.forEach( function( eventName ) {
        window.addEventListener( eventName, this );
      }, this );
      // save these arguments
      this._boundPointerEvents = events;
    };
    
    proto._unbindPostStartEvents = function() {
      // check for _boundEvents, in case dragEnd triggered twice (old IE8 bug)
      if ( !this._boundPointerEvents ) {
        return;
      }
      this._boundPointerEvents.forEach( function( eventName ) {
        window.removeEventListener( eventName, this );
      }, this );
    
      delete this._boundPointerEvents;
    };
    
    // ----- move event ----- //
    
    proto.onmousemove = function( event ) {
      this._pointerMove( event, event );
    };
    
    proto.onpointermove = function( event ) {
      if ( event.pointerId == this.pointerIdentifier ) {
        this._pointerMove( event, event );
      }
    };
    
    proto.ontouchmove = function( event ) {
      var touch = this.getTouch( event.changedTouches );
      if ( touch ) {
        this._pointerMove( event, touch );
      }
    };
    
    /**
     * pointer move
     * @param {Event} event
     * @param {Event or Touch} pointer
     * @private
     */
    proto._pointerMove = function( event, pointer ) {
      this.pointerMove( event, pointer );
    };
    
    // public
    proto.pointerMove = function( event, pointer ) {
      this.emitEvent( 'pointerMove', [ event, pointer ] );
    };
    
    // ----- end event ----- //
    
    
    proto.onmouseup = function( event ) {
      this._pointerUp( event, event );
    };
    
    proto.onpointerup = function( event ) {
      if ( event.pointerId == this.pointerIdentifier ) {
        this._pointerUp( event, event );
      }
    };
    
    proto.ontouchend = function( event ) {
      var touch = this.getTouch( event.changedTouches );
      if ( touch ) {
        this._pointerUp( event, touch );
      }
    };
    
    /**
     * pointer up
     * @param {Event} event
     * @param {Event or Touch} pointer
     * @private
     */
    proto._pointerUp = function( event, pointer ) {
      this._pointerDone();
      this.pointerUp( event, pointer );
    };
    
    // public
    proto.pointerUp = function( event, pointer ) {
      this.emitEvent( 'pointerUp', [ event, pointer ] );
    };
    
    // ----- pointer done ----- //
    
    // triggered on pointer up & pointer cancel
    proto._pointerDone = function() {
      this._pointerReset();
      this._unbindPostStartEvents();
      this.pointerDone();
    };
    
    proto._pointerReset = function() {
      // reset properties
      this.isPointerDown = false;
      delete this.pointerIdentifier;
    };
    
    proto.pointerDone = noop;
    
    // ----- pointer cancel ----- //
    
    proto.onpointercancel = function( event ) {
      if ( event.pointerId == this.pointerIdentifier ) {
        this._pointerCancel( event, event );
      }
    };
    
    proto.ontouchcancel = function( event ) {
      var touch = this.getTouch( event.changedTouches );
      if ( touch ) {
        this._pointerCancel( event, touch );
      }
    };
    
    /**
     * pointer cancel
     * @param {Event} event
     * @param {Event or Touch} pointer
     * @private
     */
    proto._pointerCancel = function( event, pointer ) {
      this._pointerDone();
      this.pointerCancel( event, pointer );
    };
    
    // public
    proto.pointerCancel = function( event, pointer ) {
      this.emitEvent( 'pointerCancel', [ event, pointer ] );
    };
    
    // -----  ----- //
    
    // utility function for getting x/y coords from event
    Unipointer.getPointerPoint = function( pointer ) {
      return {
        x: pointer.pageX,
        y: pointer.pageY
      };
    };
    
    // -----  ----- //
    
    return Unipointer;
    
    }));
    
    
    /***/ }),
    /* 14 */
    /***/ (function(module, exports) {
    
    // shim for using process in browser
    var process = module.exports = {};
    
    // cached from whatever global is present so that test runners that stub it
    // don't break things.  But we need to wrap it in a try catch in case it is
    // wrapped in strict mode code which doesn't define any globals.  It's inside a
    // function because try/catches deoptimize in certain engines.
    
    var cachedSetTimeout;
    var cachedClearTimeout;
    
    function defaultSetTimout() {
        throw new Error('setTimeout has not been defined');
    }
    function defaultClearTimeout () {
        throw new Error('clearTimeout has not been defined');
    }
    (function () {
        try {
            if (typeof setTimeout === 'function') {
                cachedSetTimeout = setTimeout;
            } else {
                cachedSetTimeout = defaultSetTimout;
            }
        } catch (e) {
            cachedSetTimeout = defaultSetTimout;
        }
        try {
            if (typeof clearTimeout === 'function') {
                cachedClearTimeout = clearTimeout;
            } else {
                cachedClearTimeout = defaultClearTimeout;
            }
        } catch (e) {
            cachedClearTimeout = defaultClearTimeout;
        }
    } ())
    function runTimeout(fun) {
        if (cachedSetTimeout === setTimeout) {
            //normal enviroments in sane situations
            return setTimeout(fun, 0);
        }
        // if setTimeout wasn't available but was latter defined
        if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
            cachedSetTimeout = setTimeout;
            return setTimeout(fun, 0);
        }
        try {
            // when when somebody has screwed with setTimeout but no I.E. maddness
            return cachedSetTimeout(fun, 0);
        } catch(e){
            try {
                // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
                return cachedSetTimeout.call(null, fun, 0);
            } catch(e){
                // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
                return cachedSetTimeout.call(this, fun, 0);
            }
        }
    
    
    }
    function runClearTimeout(marker) {
        if (cachedClearTimeout === clearTimeout) {
            //normal enviroments in sane situations
            return clearTimeout(marker);
        }
        // if clearTimeout wasn't available but was latter defined
        if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
            cachedClearTimeout = clearTimeout;
            return clearTimeout(marker);
        }
        try {
            // when when somebody has screwed with setTimeout but no I.E. maddness
            return cachedClearTimeout(marker);
        } catch (e){
            try {
                // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
                return cachedClearTimeout.call(null, marker);
            } catch (e){
                // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
                // Some versions of I.E. have different rules for clearTimeout vs setTimeout
                return cachedClearTimeout.call(this, marker);
            }
        }
    
    
    
    }
    var queue = [];
    var draining = false;
    var currentQueue;
    var queueIndex = -1;
    
    function cleanUpNextTick() {
        if (!draining || !currentQueue) {
            return;
        }
        draining = false;
        if (currentQueue.length) {
            queue = currentQueue.concat(queue);
        } else {
            queueIndex = -1;
        }
        if (queue.length) {
            drainQueue();
        }
    }
    
    function drainQueue() {
        if (draining) {
            return;
        }
        var timeout = runTimeout(cleanUpNextTick);
        draining = true;
    
        var len = queue.length;
        while(len) {
            currentQueue = queue;
            queue = [];
            while (++queueIndex < len) {
                if (currentQueue) {
                    currentQueue[queueIndex].run();
                }
            }
            queueIndex = -1;
            len = queue.length;
        }
        currentQueue = null;
        draining = false;
        runClearTimeout(timeout);
    }
    
    process.nextTick = function (fun) {
        var args = new Array(arguments.length - 1);
        if (arguments.length > 1) {
            for (var i = 1; i < arguments.length; i++) {
                args[i - 1] = arguments[i];
            }
        }
        queue.push(new Item(fun, args));
        if (queue.length === 1 && !draining) {
            runTimeout(drainQueue);
        }
    };
    
    // v8 likes predictible objects
    function Item(fun, array) {
        this.fun = fun;
        this.array = array;
    }
    Item.prototype.run = function () {
        this.fun.apply(null, this.array);
    };
    process.title = 'browser';
    process.browser = true;
    process.env = {};
    process.argv = [];
    process.version = ''; // empty string to avoid regexp issues
    process.versions = {};
    
    function noop() {}
    
    process.on = noop;
    process.addListener = noop;
    process.once = noop;
    process.off = noop;
    process.removeListener = noop;
    process.removeAllListeners = noop;
    process.emit = noop;
    process.prependListener = noop;
    process.prependOnceListener = noop;
    
    process.listeners = function (name) { return [] }
    
    process.binding = function (name) {
        throw new Error('process.binding is not supported');
    };
    
    process.cwd = function () { return '/' };
    process.chdir = function (dir) {
        throw new Error('process.chdir is not supported');
    };
    process.umask = function() { return 0; };
    
    
    /***/ }),
    /* 15 */
    /***/ (function(module, exports, __webpack_require__) {
    
    var objectWithoutPropertiesLoose = __webpack_require__(25);
    
    function _objectWithoutProperties(source, excluded) {
      if (source == null) return {};
      var target = objectWithoutPropertiesLoose(source, excluded);
      var key, i;
    
      if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    
        for (i = 0; i < sourceSymbolKeys.length; i++) {
          key = sourceSymbolKeys[i];
          if (excluded.indexOf(key) >= 0) continue;
          if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
          target[key] = source[key];
        }
      }
    
      return target;
    }
    
    module.exports = _objectWithoutProperties;
    
    /***/ }),
    /* 16 */
    /***/ (function(module, exports) {
    
    function _readOnlyError(name) {
      throw new Error("\"" + name + "\" is read-only");
    }
    
    module.exports = _readOnlyError;
    
    /***/ }),
    /* 17 */
    /***/ (function(module, exports) {
    
    function _arrayLikeToArray(arr, len) {
      if (len == null || len > arr.length) len = arr.length;
    
      for (var i = 0, arr2 = new Array(len); i < len; i++) {
        arr2[i] = arr[i];
      }
    
      return arr2;
    }
    
    module.exports = _arrayLikeToArray;
    
    /***/ }),
    /* 18 */
    /***/ (function(module, exports, __webpack_require__) {
    
    var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
     * getSize v2.0.3
     * measure size of elements
     * MIT license
     */
    
    /* jshint browser: true, strict: true, undef: true, unused: true */
    /* globals console: false */
    
    ( function( window, factory ) {
      /* jshint strict: false */ /* globals define, module */
      if ( true ) {
        // AMD
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
                    __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
                    (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
                    __WEBPACK_AMD_DEFINE_FACTORY__),
                    __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
      } else {}
    
    })( window, function factory() {
    'use strict';
    
    // -------------------------- helpers -------------------------- //
    
    // get a number from a string, not a percentage
    function getStyleSize( value ) {
      var num = parseFloat( value );
      // not a percent like '100%', and a number
      var isValid = value.indexOf('%') == -1 && !isNaN( num );
      return isValid && num;
    }
    
    function noop() {}
    
    var logError = typeof console == 'undefined' ? noop :
      function( message ) {
        console.error( message );
      };
    
    // -------------------------- measurements -------------------------- //
    
    var measurements = [
      'paddingLeft',
      'paddingRight',
      'paddingTop',
      'paddingBottom',
      'marginLeft',
      'marginRight',
      'marginTop',
      'marginBottom',
      'borderLeftWidth',
      'borderRightWidth',
      'borderTopWidth',
      'borderBottomWidth'
    ];
    
    var measurementsLength = measurements.length;
    
    function getZeroSize() {
      var size = {
        width: 0,
        height: 0,
        innerWidth: 0,
        innerHeight: 0,
        outerWidth: 0,
        outerHeight: 0
      };
      for ( var i=0; i < measurementsLength; i++ ) {
        var measurement = measurements[i];
        size[ measurement ] = 0;
      }
      return size;
    }
    
    // -------------------------- getStyle -------------------------- //
    
    /**
     * getStyle, get style of element, check for Firefox bug
     * https://bugzilla.mozilla.org/show_bug.cgi?id=548397
     */
    function getStyle( elem ) {
      var style = getComputedStyle( elem );
      if ( !style ) {
        logError( 'Style returned ' + style +
          '. Are you running this code in a hidden iframe on Firefox? ' +
          'See https://bit.ly/getsizebug1' );
      }
      return style;
    }
    
    // -------------------------- setup -------------------------- //
    
    var isSetup = false;
    
    var isBoxSizeOuter;
    
    /**
     * setup
     * check isBoxSizerOuter
     * do on first getSize() rather than on page load for Firefox bug
     */
    function setup() {
      // setup once
      if ( isSetup ) {
        return;
      }
      isSetup = true;
    
      // -------------------------- box sizing -------------------------- //
    
      /**
       * Chrome & Safari measure the outer-width on style.width on border-box elems
       * IE11 & Firefox<29 measures the inner-width
       */
      var div = document.createElement('div');
      div.style.width = '200px';
      div.style.padding = '1px 2px 3px 4px';
      div.style.borderStyle = 'solid';
      div.style.borderWidth = '1px 2px 3px 4px';
      div.style.boxSizing = 'border-box';
    
      var body = document.body || document.documentElement;
      body.appendChild( div );
      var style = getStyle( div );
      // round value for browser zoom. desandro/masonry#928
      isBoxSizeOuter = Math.round( getStyleSize( style.width ) ) == 200;
      getSize.isBoxSizeOuter = isBoxSizeOuter;
    
      body.removeChild( div );
    }
    
    // -------------------------- getSize -------------------------- //
    
    function getSize( elem ) {
      setup();
    
      // use querySeletor if elem is string
      if ( typeof elem == 'string' ) {
        elem = document.querySelector( elem );
      }
    
      // do not proceed on non-objects
      if ( !elem || typeof elem != 'object' || !elem.nodeType ) {
        return;
      }
    
      var style = getStyle( elem );
    
      // if hidden, everything is 0
      if ( style.display == 'none' ) {
        return getZeroSize();
      }
    
      var size = {};
      size.width = elem.offsetWidth;
      size.height = elem.offsetHeight;
    
      var isBorderBox = size.isBorderBox = style.boxSizing == 'border-box';
    
      // get all measurements
      for ( var i=0; i < measurementsLength; i++ ) {
        var measurement = measurements[i];
        var value = style[ measurement ];
        var num = parseFloat( value );
        // any 'auto', 'medium' value will be 0
        size[ measurement ] = !isNaN( num ) ? num : 0;
      }
    
      var paddingWidth = size.paddingLeft + size.paddingRight;
      var paddingHeight = size.paddingTop + size.paddingBottom;
      var marginWidth = size.marginLeft + size.marginRight;
      var marginHeight = size.marginTop + size.marginBottom;
      var borderWidth = size.borderLeftWidth + size.borderRightWidth;
      var borderHeight = size.borderTopWidth + size.borderBottomWidth;
    
      var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;
    
      // overwrite width and height if we can get it from style
      var styleWidth = getStyleSize( style.width );
      if ( styleWidth !== false ) {
        size.width = styleWidth +
          // add padding and border unless it's already including it
          ( isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth );
      }
    
      var styleHeight = getStyleSize( style.height );
      if ( styleHeight !== false ) {
        size.height = styleHeight +
          // add padding and border unless it's already including it
          ( isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight );
      }
    
      size.innerWidth = size.width - ( paddingWidth + borderWidth );
      size.innerHeight = size.height - ( paddingHeight + borderHeight );
    
      size.outerWidth = size.width + marginWidth;
      size.outerHeight = size.height + marginHeight;
    
      return size;
    }
    
    return getSize;
    
    });
    
    
    /***/ }),
    /* 19 */
    /***/ (function(module, exports, __webpack_require__) {
    
    "use strict";
    
    
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.preload = preload;
    exports.loadImage = loadImage;
    exports.imageSize = imageSize;
    exports.getSizedImageUrl = getSizedImageUrl;
    exports.removeProtocol = removeProtocol;
    /**
     * Image Helper Functions
     * -----------------------------------------------------------------------------
     * https://github.com/Shopify/slate.git.
     *
     */
    
    /**
     * Preloads an image in memory and uses the browsers cache to store it until needed.
     *
     * @param {Array} images - A list of image urls
     * @param {String} size - A shopify image size attribute
     */
    
    function preload(images, size) {
      if (typeof images === 'string') {
        images = [images];
      }
    
      for (var i = 0; i < images.length; i++) {
        var image = images[i];
        loadImage(getSizedImageUrl(image, size));
      }
    }
    
    /**
     * Loads and caches an image in the browsers cache.
     * @param {string} path - An image url
     */
    function loadImage(path) {
      new Image().src = path;
    }
    
    /**
     * Find the Shopify image attribute size
     *
     * @param {string} src
     * @returns {null}
     */
    function imageSize(src) {
      var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
    
      if (match) {
        return match[1];
      } else {
        return null;
      }
    }
    
    /**
     * Adds a Shopify size attribute to a URL
     *
     * @param src
     * @param size
     * @returns {*}
     */
    function getSizedImageUrl(src, size) {
      if (size === null) {
        return src;
      }
    
      if (size === 'master') {
        return removeProtocol(src);
      }
    
      var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
    
      if (match) {
        var prefix = src.split(match[0]);
        var suffix = match[0];
    
        return removeProtocol(prefix[0] + '_' + size + suffix);
      } else {
        return null;
      }
    }
    
    function removeProtocol(path) {
      return path.replace(/http(s)?:/, '');
    }
    
    
    /***/ }),
    /* 20 */
    /***/ (function(module, exports) {
    
    var candidateSelectors = [
      'input',
      'select',
      'textarea',
      'a[href]',
      'button',
      '[tabindex]',
      'audio[controls]',
      'video[controls]',
      '[contenteditable]:not([contenteditable="false"])',
    ];
    var candidateSelector = candidateSelectors.join(',');
    
    var matches = typeof Element === 'undefined'
      ? function () {}
      : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
    
    function tabbable(el, options) {
      options = options || {};
    
      var regularTabbables = [];
      var orderedTabbables = [];
    
      var candidates = el.querySelectorAll(candidateSelector);
    
      if (options.includeContainer) {
        if (matches.call(el, candidateSelector)) {
          candidates = Array.prototype.slice.apply(candidates);
          candidates.unshift(el);
        }
      }
    
      var i, candidate, candidateTabindex;
      for (i = 0; i < candidates.length; i++) {
        candidate = candidates[i];
    
        if (!isNodeMatchingSelectorTabbable(candidate)) continue;
    
        candidateTabindex = getTabindex(candidate);
        if (candidateTabindex === 0) {
          regularTabbables.push(candidate);
        } else {
          orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            node: candidate,
          });
        }
      }
    
      var tabbableNodes = orderedTabbables
        .sort(sortOrderedTabbables)
        .map(function(a) { return a.node })
        .concat(regularTabbables);
    
      return tabbableNodes;
    }
    
    tabbable.isTabbable = isTabbable;
    tabbable.isFocusable = isFocusable;
    
    function isNodeMatchingSelectorTabbable(node) {
      if (
        !isNodeMatchingSelectorFocusable(node)
        || isNonTabbableRadio(node)
        || getTabindex(node) < 0
      ) {
        return false;
      }
      return true;
    }
    
    function isTabbable(node) {
      if (!node) throw new Error('No node provided');
      if (matches.call(node, candidateSelector) === false) return false;
      return isNodeMatchingSelectorTabbable(node);
    }
    
    function isNodeMatchingSelectorFocusable(node) {
      if (
        node.disabled
        || isHiddenInput(node)
        || isHidden(node)
      ) {
        return false;
      }
      return true;
    }
    
    var focusableCandidateSelector = candidateSelectors.concat('iframe').join(',');
    function isFocusable(node) {
      if (!node) throw new Error('No node provided');
      if (matches.call(node, focusableCandidateSelector) === false) return false;
      return isNodeMatchingSelectorFocusable(node);
    }
    
    function getTabindex(node) {
      var tabindexAttr = parseInt(node.getAttribute('tabindex'), 10);
      if (!isNaN(tabindexAttr)) return tabindexAttr;
      // Browsers do not return `tabIndex` correctly for contentEditable nodes;
      // so if they don't have a tabindex attribute specifically set, assume it's 0.
      if (isContentEditable(node)) return 0;
      return node.tabIndex;
    }
    
    function sortOrderedTabbables(a, b) {
      return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
    }
    
    function isContentEditable(node) {
      return node.contentEditable === 'true';
    }
    
    function isInput(node) {
      return node.tagName === 'INPUT';
    }
    
    function isHiddenInput(node) {
      return isInput(node) && node.type === 'hidden';
    }
    
    function isRadio(node) {
      return isInput(node) && node.type === 'radio';
    }
    
    function isNonTabbableRadio(node) {
      return isRadio(node) && !isTabbableRadio(node);
    }
    
    function getCheckedRadio(nodes) {
      for (var i = 0; i < nodes.length; i++) {
        if (nodes[i].checked) {
          return nodes[i];
        }
      }
    }
    
    function isTabbableRadio(node) {
      if (!node.name) return true;
      // This won't account for the edge case where you have radio groups with the same
      // in separate forms on the same page.
      var radioSet = node.ownerDocument.querySelectorAll('input[type="radio"][name="' + node.name + '"]');
      var checked = getCheckedRadio(radioSet);
      return !checked || checked === node;
    }
    
    function isHidden(node) {
      // offsetParent being null will allow detecting cases where an element is invisible or inside an invisible element,
      // as long as the element does not use position: fixed. For them, their visibility has to be checked directly as well.
      return node.offsetParent === null || getComputedStyle(node).visibility === 'hidden';
    }
    
    module.exports = tabbable;
    
    
    /***/ }),
    /* 21 */
    /***/ (function(module, exports) {
    
    function _typeof(obj) {
      "@babel/helpers - typeof";
    
      if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
        module.exports = _typeof = function _typeof(obj) {
          return typeof obj;
        };
      } else {
        module.exports = _typeof = function _typeof(obj) {
          return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
      }
    
      return _typeof(obj);
    }
    
    module.exports = _typeof;
    
    /***/ }),
    /* 22 */
    /***/ (function(module, exports, __webpack_require__) {
    
    "use strict";
    
    
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    
    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
    
    var _sister = __webpack_require__(47);
    
    var _sister2 = _interopRequireDefault(_sister);
    
    var _loadYouTubeIframeApi = __webpack_require__(48);
    
    var _loadYouTubeIframeApi2 = _interopRequireDefault(_loadYouTubeIframeApi);
    
    var _YouTubePlayer = __webpack_require__(50);
    
    var _YouTubePlayer2 = _interopRequireDefault(_YouTubePlayer);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    /**
     * @typedef YT.Player
     * @see https://developers.google.com/youtube/iframe_api_reference
     * */
    
    /**
     * @see https://developers.google.com/youtube/iframe_api_reference#Loading_a_Video_Player
     */
    var youtubeIframeAPI = void 0;
    
    /**
     * A factory function used to produce an instance of YT.Player and queue function calls and proxy events of the resulting object.
     *
     * @param maybeElementId Either An existing YT.Player instance,
     * the DOM element or the id of the HTML element where the API will insert an <iframe>.
     * @param options See `options` (Ignored when using an existing YT.Player instance).
     * @param strictState A flag designating whether or not to wait for
     * an acceptable state when calling supported functions. Default: `false`.
     * See `FunctionStateMap.js` for supported functions and acceptable states.
     */
    
    exports.default = function (maybeElementId) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var strictState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    
      var emitter = (0, _sister2.default)();
    
      if (!youtubeIframeAPI) {
        youtubeIframeAPI = (0, _loadYouTubeIframeApi2.default)(emitter);
      }
    
      if (options.events) {
        throw new Error('Event handlers cannot be overwritten.');
      }
    
      if (typeof maybeElementId === 'string' && !document.getElementById(maybeElementId)) {
        throw new Error('Element "' + maybeElementId + '" does not exist.');
      }
    
      options.events = _YouTubePlayer2.default.proxyEvents(emitter);
    
      var playerAPIReady = new Promise(function (resolve) {
        if ((typeof maybeElementId === 'undefined' ? 'undefined' : _typeof(maybeElementId)) === 'object' && maybeElementId.playVideo instanceof Function) {
          var player = maybeElementId;
    
          resolve(player);
        } else {
          // asume maybeElementId can be rendered inside
          // eslint-disable-next-line promise/catch-or-return
          youtubeIframeAPI.then(function (YT) {
            // eslint-disable-line promise/prefer-await-to-then
            var player = new YT.Player(maybeElementId, options);
    
            emitter.on('ready', function () {
              resolve(player);
            });
    
            return null;
          });
        }
      });
    
      var playerApi = _YouTubePlayer2.default.promisifyPlayer(playerAPIReady, strictState);
    
      playerApi.on = emitter.on;
      playerApi.off = emitter.off;
    
      return playerApi;
    };
    
    module.exports = exports['default'];
    
    /***/ }),
    /* 23 */
    /***/ (function(module, __webpack_exports__, __webpack_require__) {
    
    "use strict";
    /* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*! @vimeo/player v2.12.2 | (c) 2020 Vimeo | MIT License | https://github.com/vimeo/player.js */
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    
    function _defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    
    function _createClass(Constructor, protoProps, staticProps) {
      if (protoProps) _defineProperties(Constructor.prototype, protoProps);
      if (staticProps) _defineProperties(Constructor, staticProps);
      return Constructor;
    }
    
    /**
     * @module lib/functions
     */
    
    /**
     * Check to see this is a node environment.
     * @type {Boolean}
     */
    
    /* global global */
    var isNode = typeof global !== 'undefined' && {}.toString.call(global) === '[object global]';
    /**
     * Get the name of the method for a given getter or setter.
     *
     * @param {string} prop The name of the property.
     * @param {string} type Either “get” or “set”.
     * @return {string}
     */
    
    function getMethodName(prop, type) {
      if (prop.indexOf(type.toLowerCase()) === 0) {
        return prop;
      }
    
      return "".concat(type.toLowerCase()).concat(prop.substr(0, 1).toUpperCase()).concat(prop.substr(1));
    }
    /**
     * Check to see if the object is a DOM Element.
     *
     * @param {*} element The object to check.
     * @return {boolean}
     */
    
    function isDomElement(element) {
      return Boolean(element && element.nodeType === 1 && 'nodeName' in element && element.ownerDocument && element.ownerDocument.defaultView);
    }
    /**
     * Check to see whether the value is a number.
     *
     * @see http://dl.dropboxusercontent.com/u/35146/js/tests/isNumber.html
     * @param {*} value The value to check.
     * @param {boolean} integer Check if the value is an integer.
     * @return {boolean}
     */
    
    function isInteger(value) {
      // eslint-disable-next-line eqeqeq
      return !isNaN(parseFloat(value)) && isFinite(value) && Math.floor(value) == value;
    }
    /**
     * Check to see if the URL is a Vimeo url.
     *
     * @param {string} url The url string.
     * @return {boolean}
     */
    
    function isVimeoUrl(url) {
      return /^(https?:)?\/\/((player|www)\.)?vimeo\.com(?=$|\/)/.test(url);
    }
    /**
     * Get the Vimeo URL from an element.
     * The element must have either a data-vimeo-id or data-vimeo-url attribute.
     *
     * @param {object} oEmbedParameters The oEmbed parameters.
     * @return {string}
     */
    
    function getVimeoUrl() {
      var oEmbedParameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var id = oEmbedParameters.id;
      var url = oEmbedParameters.url;
      var idOrUrl = id || url;
    
      if (!idOrUrl) {
        throw new Error('An id or url must be passed, either in an options object or as a data-vimeo-id or data-vimeo-url attribute.');
      }
    
      if (isInteger(idOrUrl)) {
        return "https://vimeo.com/".concat(idOrUrl);
      }
    
      if (isVimeoUrl(idOrUrl)) {
        return idOrUrl.replace('http:', 'https:');
      }
    
      if (id) {
        throw new TypeError("\u201C".concat(id, "\u201D is not a valid video id."));
      }
    
      throw new TypeError("\u201C".concat(idOrUrl, "\u201D is not a vimeo.com url."));
    }
    
    var arrayIndexOfSupport = typeof Array.prototype.indexOf !== 'undefined';
    var postMessageSupport = typeof window !== 'undefined' && typeof window.postMessage !== 'undefined';
    
    if (!isNode && (!arrayIndexOfSupport || !postMessageSupport)) {
      throw new Error('Sorry, the Vimeo Player API is not available in this browser.');
    }
    
    var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
    
    function createCommonjsModule(fn, module) {
        return module = { exports: {} }, fn(module, module.exports), module.exports;
    }
    
    /*!
     * weakmap-polyfill v2.0.1 - ECMAScript6 WeakMap polyfill
     * https://github.com/polygonplanet/weakmap-polyfill
     * Copyright (c) 2015-2020 Polygon Planet <polygon.planet.aqua@gmail.com>
     * @license MIT
     */
    (function (self) {
    
      if (self.WeakMap) {
        return;
      }
    
      var hasOwnProperty = Object.prototype.hasOwnProperty;
    
      var defineProperty = function (object, name, value) {
        if (Object.defineProperty) {
          Object.defineProperty(object, name, {
            configurable: true,
            writable: true,
            value: value
          });
        } else {
          object[name] = value;
        }
      };
    
      self.WeakMap = function () {
        // ECMA-262 23.3 WeakMap Objects
        function WeakMap() {
          if (this === void 0) {
            throw new TypeError("Constructor WeakMap requires 'new'");
          }
    
          defineProperty(this, '_id', genId('_WeakMap')); // ECMA-262 23.3.1.1 WeakMap([iterable])
    
          if (arguments.length > 0) {
            // Currently, WeakMap `iterable` argument is not supported
            throw new TypeError('WeakMap iterable is not supported');
          }
        } // ECMA-262 23.3.3.2 WeakMap.prototype.delete(key)
    
    
        defineProperty(WeakMap.prototype, 'delete', function (key) {
          checkInstance(this, 'delete');
    
          if (!isObject(key)) {
            return false;
          }
    
          var entry = key[this._id];
    
          if (entry && entry[0] === key) {
            delete key[this._id];
            return true;
          }
    
          return false;
        }); // ECMA-262 23.3.3.3 WeakMap.prototype.get(key)
    
        defineProperty(WeakMap.prototype, 'get', function (key) {
          checkInstance(this, 'get');
    
          if (!isObject(key)) {
            return void 0;
          }
    
          var entry = key[this._id];
    
          if (entry && entry[0] === key) {
            return entry[1];
          }
    
          return void 0;
        }); // ECMA-262 23.3.3.4 WeakMap.prototype.has(key)
    
        defineProperty(WeakMap.prototype, 'has', function (key) {
          checkInstance(this, 'has');
    
          if (!isObject(key)) {
            return false;
          }
    
          var entry = key[this._id];
    
          if (entry && entry[0] === key) {
            return true;
          }
    
          return false;
        }); // ECMA-262 23.3.3.5 WeakMap.prototype.set(key, value)
    
        defineProperty(WeakMap.prototype, 'set', function (key, value) {
          checkInstance(this, 'set');
    
          if (!isObject(key)) {
            throw new TypeError('Invalid value used as weak map key');
          }
    
          var entry = key[this._id];
    
          if (entry && entry[0] === key) {
            entry[1] = value;
            return this;
          }
    
          defineProperty(key, this._id, [key, value]);
          return this;
        });
    
        function checkInstance(x, methodName) {
          if (!isObject(x) || !hasOwnProperty.call(x, '_id')) {
            throw new TypeError(methodName + ' method called on incompatible receiver ' + typeof x);
          }
        }
    
        function genId(prefix) {
          return prefix + '_' + rand() + '.' + rand();
        }
    
        function rand() {
          return Math.random().toString().substring(2);
        }
    
        defineProperty(WeakMap, '_polyfill', true);
        return WeakMap;
      }();
    
      function isObject(x) {
        return Object(x) === x;
      }
    })(typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : typeof commonjsGlobal !== 'undefined' ? commonjsGlobal : commonjsGlobal);
    
    var npo_src = createCommonjsModule(function (module) {
    /*! Native Promise Only
        v0.8.1 (c) Kyle Simpson
        MIT License: http://getify.mit-license.org
    */
    (function UMD(name, context, definition) {
      // special form of UMD for polyfilling across evironments
      context[name] = context[name] || definition();
    
      if ( module.exports) {
        module.exports = context[name];
      }
    })("Promise", typeof commonjsGlobal != "undefined" ? commonjsGlobal : commonjsGlobal, function DEF() {
    
      var builtInProp,
          cycle,
          scheduling_queue,
          ToString = Object.prototype.toString,
          timer = typeof setImmediate != "undefined" ? function timer(fn) {
        return setImmediate(fn);
      } : setTimeout; // dammit, IE8.
    
      try {
        Object.defineProperty({}, "x", {});
    
        builtInProp = function builtInProp(obj, name, val, config) {
          return Object.defineProperty(obj, name, {
            value: val,
            writable: true,
            configurable: config !== false
          });
        };
      } catch (err) {
        builtInProp = function builtInProp(obj, name, val) {
          obj[name] = val;
          return obj;
        };
      } // Note: using a queue instead of array for efficiency
    
    
      scheduling_queue = function Queue() {
        var first, last, item;
    
        function Item(fn, self) {
          this.fn = fn;
          this.self = self;
          this.next = void 0;
        }
    
        return {
          add: function add(fn, self) {
            item = new Item(fn, self);
    
            if (last) {
              last.next = item;
            } else {
              first = item;
            }
    
            last = item;
            item = void 0;
          },
          drain: function drain() {
            var f = first;
            first = last = cycle = void 0;
    
            while (f) {
              f.fn.call(f.self);
              f = f.next;
            }
          }
        };
      }();
    
      function schedule(fn, self) {
        scheduling_queue.add(fn, self);
    
        if (!cycle) {
          cycle = timer(scheduling_queue.drain);
        }
      } // promise duck typing
    
    
      function isThenable(o) {
        var _then,
            o_type = typeof o;
    
        if (o != null && (o_type == "object" || o_type == "function")) {
          _then = o.then;
        }
    
        return typeof _then == "function" ? _then : false;
      }
    
      function notify() {
        for (var i = 0; i < this.chain.length; i++) {
          notifyIsolated(this, this.state === 1 ? this.chain[i].success : this.chain[i].failure, this.chain[i]);
        }
    
        this.chain.length = 0;
      } // NOTE: This is a separate function to isolate
      // the `try..catch` so that other code can be
      // optimized better
    
    
      function notifyIsolated(self, cb, chain) {
        var ret, _then;
    
        try {
          if (cb === false) {
            chain.reject(self.msg);
          } else {
            if (cb === true) {
              ret = self.msg;
            } else {
              ret = cb.call(void 0, self.msg);
            }
    
            if (ret === chain.promise) {
              chain.reject(TypeError("Promise-chain cycle"));
            } else if (_then = isThenable(ret)) {
              _then.call(ret, chain.resolve, chain.reject);
            } else {
              chain.resolve(ret);
            }
          }
        } catch (err) {
          chain.reject(err);
        }
      }
    
      function resolve(msg) {
        var _then,
            self = this; // already triggered?
    
    
        if (self.triggered) {
          return;
        }
    
        self.triggered = true; // unwrap
    
        if (self.def) {
          self = self.def;
        }
    
        try {
          if (_then = isThenable(msg)) {
            schedule(function () {
              var def_wrapper = new MakeDefWrapper(self);
    
              try {
                _then.call(msg, function $resolve$() {
                  resolve.apply(def_wrapper, arguments);
                }, function $reject$() {
                  reject.apply(def_wrapper, arguments);
                });
              } catch (err) {
                reject.call(def_wrapper, err);
              }
            });
          } else {
            self.msg = msg;
            self.state = 1;
    
            if (self.chain.length > 0) {
              schedule(notify, self);
            }
          }
        } catch (err) {
          reject.call(new MakeDefWrapper(self), err);
        }
      }
    
      function reject(msg) {
        var self = this; // already triggered?
    
        if (self.triggered) {
          return;
        }
    
        self.triggered = true; // unwrap
    
        if (self.def) {
          self = self.def;
        }
    
        self.msg = msg;
        self.state = 2;
    
        if (self.chain.length > 0) {
          schedule(notify, self);
        }
      }
    
      function iteratePromises(Constructor, arr, resolver, rejecter) {
        for (var idx = 0; idx < arr.length; idx++) {
          (function IIFE(idx) {
            Constructor.resolve(arr[idx]).then(function $resolver$(msg) {
              resolver(idx, msg);
            }, rejecter);
          })(idx);
        }
      }
    
      function MakeDefWrapper(self) {
        this.def = self;
        this.triggered = false;
      }
    
      function MakeDef(self) {
        this.promise = self;
        this.state = 0;
        this.triggered = false;
        this.chain = [];
        this.msg = void 0;
      }
    
      function Promise(executor) {
        if (typeof executor != "function") {
          throw TypeError("Not a function");
        }
    
        if (this.__NPO__ !== 0) {
          throw TypeError("Not a promise");
        } // instance shadowing the inherited "brand"
        // to signal an already "initialized" promise
    
    
        this.__NPO__ = 1;
        var def = new MakeDef(this);
    
        this["then"] = function then(success, failure) {
          var o = {
            success: typeof success == "function" ? success : true,
            failure: typeof failure == "function" ? failure : false
          }; // Note: `then(..)` itself can be borrowed to be used against
          // a different promise constructor for making the chained promise,
          // by substituting a different `this` binding.
    
          o.promise = new this.constructor(function extractChain(resolve, reject) {
            if (typeof resolve != "function" || typeof reject != "function") {
              throw TypeError("Not a function");
            }
    
            o.resolve = resolve;
            o.reject = reject;
          });
          def.chain.push(o);
    
          if (def.state !== 0) {
            schedule(notify, def);
          }
    
          return o.promise;
        };
    
        this["catch"] = function $catch$(failure) {
          return this.then(void 0, failure);
        };
    
        try {
          executor.call(void 0, function publicResolve(msg) {
            resolve.call(def, msg);
          }, function publicReject(msg) {
            reject.call(def, msg);
          });
        } catch (err) {
          reject.call(def, err);
        }
      }
    
      var PromisePrototype = builtInProp({}, "constructor", Promise,
      /*configurable=*/
      false); // Note: Android 4 cannot use `Object.defineProperty(..)` here
    
      Promise.prototype = PromisePrototype; // built-in "brand" to signal an "uninitialized" promise
    
      builtInProp(PromisePrototype, "__NPO__", 0,
      /*configurable=*/
      false);
      builtInProp(Promise, "resolve", function Promise$resolve(msg) {
        var Constructor = this; // spec mandated checks
        // note: best "isPromise" check that's practical for now
    
        if (msg && typeof msg == "object" && msg.__NPO__ === 1) {
          return msg;
        }
    
        return new Constructor(function executor(resolve, reject) {
          if (typeof resolve != "function" || typeof reject != "function") {
            throw TypeError("Not a function");
          }
    
          resolve(msg);
        });
      });
      builtInProp(Promise, "reject", function Promise$reject(msg) {
        return new this(function executor(resolve, reject) {
          if (typeof resolve != "function" || typeof reject != "function") {
            throw TypeError("Not a function");
          }
    
          reject(msg);
        });
      });
      builtInProp(Promise, "all", function Promise$all(arr) {
        var Constructor = this; // spec mandated checks
    
        if (ToString.call(arr) != "[object Array]") {
          return Constructor.reject(TypeError("Not an array"));
        }
    
        if (arr.length === 0) {
          return Constructor.resolve([]);
        }
    
        return new Constructor(function executor(resolve, reject) {
          if (typeof resolve != "function" || typeof reject != "function") {
            throw TypeError("Not a function");
          }
    
          var len = arr.length,
              msgs = Array(len),
              count = 0;
          iteratePromises(Constructor, arr, function resolver(idx, msg) {
            msgs[idx] = msg;
    
            if (++count === len) {
              resolve(msgs);
            }
          }, reject);
        });
      });
      builtInProp(Promise, "race", function Promise$race(arr) {
        var Constructor = this; // spec mandated checks
    
        if (ToString.call(arr) != "[object Array]") {
          return Constructor.reject(TypeError("Not an array"));
        }
    
        return new Constructor(function executor(resolve, reject) {
          if (typeof resolve != "function" || typeof reject != "function") {
            throw TypeError("Not a function");
          }
    
          iteratePromises(Constructor, arr, function resolver(idx, msg) {
            resolve(msg);
          }, reject);
        });
      });
      return Promise;
    });
    });
    
    /**
     * @module lib/callbacks
     */
    var callbackMap = new WeakMap();
    /**
     * Store a callback for a method or event for a player.
     *
     * @param {Player} player The player object.
     * @param {string} name The method or event name.
     * @param {(function(this:Player, *): void|{resolve: function, reject: function})} callback
     *        The callback to call or an object with resolve and reject functions for a promise.
     * @return {void}
     */
    
    function storeCallback(player, name, callback) {
      var playerCallbacks = callbackMap.get(player.element) || {};
    
      if (!(name in playerCallbacks)) {
        playerCallbacks[name] = [];
      }
    
      playerCallbacks[name].push(callback);
      callbackMap.set(player.element, playerCallbacks);
    }
    /**
     * Get the callbacks for a player and event or method.
     *
     * @param {Player} player The player object.
     * @param {string} name The method or event name
     * @return {function[]}
     */
    
    function getCallbacks(player, name) {
      var playerCallbacks = callbackMap.get(player.element) || {};
      return playerCallbacks[name] || [];
    }
    /**
     * Remove a stored callback for a method or event for a player.
     *
     * @param {Player} player The player object.
     * @param {string} name The method or event name
     * @param {function} [callback] The specific callback to remove.
     * @return {boolean} Was this the last callback?
     */
    
    function removeCallback(player, name, callback) {
      var playerCallbacks = callbackMap.get(player.element) || {};
    
      if (!playerCallbacks[name]) {
        return true;
      } // If no callback is passed, remove all callbacks for the event
    
    
      if (!callback) {
        playerCallbacks[name] = [];
        callbackMap.set(player.element, playerCallbacks);
        return true;
      }
    
      var index = playerCallbacks[name].indexOf(callback);
    
      if (index !== -1) {
        playerCallbacks[name].splice(index, 1);
      }
    
      callbackMap.set(player.element, playerCallbacks);
      return playerCallbacks[name] && playerCallbacks[name].length === 0;
    }
    /**
     * Return the first stored callback for a player and event or method.
     *
     * @param {Player} player The player object.
     * @param {string} name The method or event name.
     * @return {function} The callback, or false if there were none
     */
    
    function shiftCallbacks(player, name) {
      var playerCallbacks = getCallbacks(player, name);
    
      if (playerCallbacks.length < 1) {
        return false;
      }
    
      var callback = playerCallbacks.shift();
      removeCallback(player, name, callback);
      return callback;
    }
    /**
     * Move callbacks associated with an element to another element.
     *
     * @param {HTMLElement} oldElement The old element.
     * @param {HTMLElement} newElement The new element.
     * @return {void}
     */
    
    function swapCallbacks(oldElement, newElement) {
      var playerCallbacks = callbackMap.get(oldElement);
      callbackMap.set(newElement, playerCallbacks);
      callbackMap.delete(oldElement);
    }
    
    /**
     * @module lib/embed
     */
    var oEmbedParameters = ['autopause', 'autoplay', 'background', 'byline', 'color', 'controls', 'dnt', 'height', 'id', 'loop', 'maxheight', 'maxwidth', 'muted', 'playsinline', 'portrait', 'responsive', 'speed', 'texttrack', 'title', 'transparent', 'url', 'width'];
    /**
     * Get the 'data-vimeo'-prefixed attributes from an element as an object.
     *
     * @param {HTMLElement} element The element.
     * @param {Object} [defaults={}] The default values to use.
     * @return {Object<string, string>}
     */
    
    function getOEmbedParameters(element) {
      var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return oEmbedParameters.reduce(function (params, param) {
        var value = element.getAttribute("data-vimeo-".concat(param));
    
        if (value || value === '') {
          params[param] = value === '' ? 1 : value;
        }
    
        return params;
      }, defaults);
    }
    /**
     * Create an embed from oEmbed data inside an element.
     *
     * @param {object} data The oEmbed data.
     * @param {HTMLElement} element The element to put the iframe in.
     * @return {HTMLIFrameElement} The iframe embed.
     */
    
    function createEmbed(_ref, element) {
      var html = _ref.html;
    
      if (!element) {
        throw new TypeError('An element must be provided');
      }
    
      if (element.getAttribute('data-vimeo-initialized') !== null) {
        return element.querySelector('iframe');
      }
    
      var div = document.createElement('div');
      div.innerHTML = html;
      element.appendChild(div.firstChild);
      element.setAttribute('data-vimeo-initialized', 'true');
      return element.querySelector('iframe');
    }
    /**
     * Make an oEmbed call for the specified URL.
     *
     * @param {string} videoUrl The vimeo.com url for the video.
     * @param {Object} [params] Parameters to pass to oEmbed.
     * @param {HTMLElement} element The element.
     * @return {Promise}
     */
    
    function getOEmbedData(videoUrl) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var element = arguments.length > 2 ? arguments[2] : undefined;
      return new Promise(function (resolve, reject) {
        if (!isVimeoUrl(videoUrl)) {
          throw new TypeError("\u201C".concat(videoUrl, "\u201D is not a vimeo.com url."));
        }
    
        var url = "https://vimeo.com/api/oembed.json?url=".concat(encodeURIComponent(videoUrl));
    
        for (var param in params) {
          if (params.hasOwnProperty(param)) {
            url += "&".concat(param, "=").concat(encodeURIComponent(params[param]));
          }
        }
    
        var xhr = 'XDomainRequest' in window ? new XDomainRequest() : new XMLHttpRequest();
        xhr.open('GET', url, true);
    
        xhr.onload = function () {
          if (xhr.status === 404) {
            reject(new Error("\u201C".concat(videoUrl, "\u201D was not found.")));
            return;
          }
    
          if (xhr.status === 403) {
            reject(new Error("\u201C".concat(videoUrl, "\u201D is not embeddable.")));
            return;
          }
    
          try {
            var json = JSON.parse(xhr.responseText); // Check api response for 403 on oembed
    
            if (json.domain_status_code === 403) {
              // We still want to create the embed to give users visual feedback
              createEmbed(json, element);
              reject(new Error("\u201C".concat(videoUrl, "\u201D is not embeddable.")));
              return;
            }
    
            resolve(json);
          } catch (error) {
            reject(error);
          }
        };
    
        xhr.onerror = function () {
          var status = xhr.status ? " (".concat(xhr.status, ")") : '';
          reject(new Error("There was an error fetching the embed code from Vimeo".concat(status, ".")));
        };
    
        xhr.send();
      });
    }
    /**
     * Initialize all embeds within a specific element
     *
     * @param {HTMLElement} [parent=document] The parent element.
     * @return {void}
     */
    
    function initializeEmbeds() {
      var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
      var elements = [].slice.call(parent.querySelectorAll('[data-vimeo-id], [data-vimeo-url]'));
    
      var handleError = function handleError(error) {
        if ('console' in window && console.error) {
          console.error("There was an error creating an embed: ".concat(error));
        }
      };
    
      elements.forEach(function (element) {
        try {
          // Skip any that have data-vimeo-defer
          if (element.getAttribute('data-vimeo-defer') !== null) {
            return;
          }
    
          var params = getOEmbedParameters(element);
          var url = getVimeoUrl(params);
          getOEmbedData(url, params, element).then(function (data) {
            return createEmbed(data, element);
          }).catch(handleError);
        } catch (error) {
          handleError(error);
        }
      });
    }
    /**
     * Resize embeds when messaged by the player.
     *
     * @param {HTMLElement} [parent=document] The parent element.
     * @return {void}
     */
    
    function resizeEmbeds() {
      var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    
      // Prevent execution if users include the player.js script multiple times.
      if (window.VimeoPlayerResizeEmbeds_) {
        return;
      }
    
      window.VimeoPlayerResizeEmbeds_ = true;
    
      var onMessage = function onMessage(event) {
        if (!isVimeoUrl(event.origin)) {
          return;
        } // 'spacechange' is fired only on embeds with cards
    
    
        if (!event.data || event.data.event !== 'spacechange') {
          return;
        }
    
        var iframes = parent.querySelectorAll('iframe');
    
        for (var i = 0; i < iframes.length; i++) {
          if (iframes[i].contentWindow !== event.source) {
            continue;
          } // Change padding-bottom of the enclosing div to accommodate
          // card carousel without distorting aspect ratio
    
    
          var space = iframes[i].parentElement;
          space.style.paddingBottom = "".concat(event.data.data[0].bottom, "px");
          break;
        }
      };
    
      window.addEventListener('message', onMessage);
    }
    
    /**
     * @module lib/postmessage
     */
    /**
     * Parse a message received from postMessage.
     *
     * @param {*} data The data received from postMessage.
     * @return {object}
     */
    
    function parseMessageData(data) {
      if (typeof data === 'string') {
        try {
          data = JSON.parse(data);
        } catch (error) {
          // If the message cannot be parsed, throw the error as a warning
          console.warn(error);
          return {};
        }
      }
    
      return data;
    }
    /**
     * Post a message to the specified target.
     *
     * @param {Player} player The player object to use.
     * @param {string} method The API method to call.
     * @param {object} params The parameters to send to the player.
     * @return {void}
     */
    
    function postMessage(player, method, params) {
      if (!player.element.contentWindow || !player.element.contentWindow.postMessage) {
        return;
      }
    
      var message = {
        method: method
      };
    
      if (params !== undefined) {
        message.value = params;
      } // IE 8 and 9 do not support passing messages, so stringify them
    
    
      var ieVersion = parseFloat(navigator.userAgent.toLowerCase().replace(/^.*msie (\d+).*$/, '$1'));
    
      if (ieVersion >= 8 && ieVersion < 10) {
        message = JSON.stringify(message);
      }
    
      player.element.contentWindow.postMessage(message, player.origin);
    }
    /**
     * Parse the data received from a message event.
     *
     * @param {Player} player The player that received the message.
     * @param {(Object|string)} data The message data. Strings will be parsed into JSON.
     * @return {void}
     */
    
    function processData(player, data) {
      data = parseMessageData(data);
      var callbacks = [];
      var param;
    
      if (data.event) {
        if (data.event === 'error') {
          var promises = getCallbacks(player, data.data.method);
          promises.forEach(function (promise) {
            var error = new Error(data.data.message);
            error.name = data.data.name;
            promise.reject(error);
            removeCallback(player, data.data.method, promise);
          });
        }
    
        callbacks = getCallbacks(player, "event:".concat(data.event));
        param = data.data;
      } else if (data.method) {
        var callback = shiftCallbacks(player, data.method);
    
        if (callback) {
          callbacks.push(callback);
          param = data.value;
        }
      }
    
      callbacks.forEach(function (callback) {
        try {
          if (typeof callback === 'function') {
            callback.call(player, param);
            return;
          }
    
          callback.resolve(param);
        } catch (e) {// empty
        }
      });
    }
    
    /* MIT License
    
    Copyright (c) Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)
    
    Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
    
    The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
    
    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
    Terms */
    function initializeScreenfull() {
      var fn = function () {
        var val;
        var fnMap = [['requestFullscreen', 'exitFullscreen', 'fullscreenElement', 'fullscreenEnabled', 'fullscreenchange', 'fullscreenerror'], // New WebKit
        ['webkitRequestFullscreen', 'webkitExitFullscreen', 'webkitFullscreenElement', 'webkitFullscreenEnabled', 'webkitfullscreenchange', 'webkitfullscreenerror'], // Old WebKit
        ['webkitRequestFullScreen', 'webkitCancelFullScreen', 'webkitCurrentFullScreenElement', 'webkitCancelFullScreen', 'webkitfullscreenchange', 'webkitfullscreenerror'], ['mozRequestFullScreen', 'mozCancelFullScreen', 'mozFullScreenElement', 'mozFullScreenEnabled', 'mozfullscreenchange', 'mozfullscreenerror'], ['msRequestFullscreen', 'msExitFullscreen', 'msFullscreenElement', 'msFullscreenEnabled', 'MSFullscreenChange', 'MSFullscreenError']];
        var i = 0;
        var l = fnMap.length;
        var ret = {};
    
        for (; i < l; i++) {
          val = fnMap[i];
    
          if (val && val[1] in document) {
            for (i = 0; i < val.length; i++) {
              ret[fnMap[0][i]] = val[i];
            }
    
            return ret;
          }
        }
    
        return false;
      }();
    
      var eventNameMap = {
        fullscreenchange: fn.fullscreenchange,
        fullscreenerror: fn.fullscreenerror
      };
      var screenfull = {
        request: function request(element) {
          return new Promise(function (resolve, reject) {
            var onFullScreenEntered = function onFullScreenEntered() {
              screenfull.off('fullscreenchange', onFullScreenEntered);
              resolve();
            };
    
            screenfull.on('fullscreenchange', onFullScreenEntered);
            element = element || document.documentElement;
            var returnPromise = element[fn.requestFullscreen]();
    
            if (returnPromise instanceof Promise) {
              returnPromise.then(onFullScreenEntered).catch(reject);
            }
          });
        },
        exit: function exit() {
          return new Promise(function (resolve, reject) {
            if (!screenfull.isFullscreen) {
              resolve();
              return;
            }
    
            var onFullScreenExit = function onFullScreenExit() {
              screenfull.off('fullscreenchange', onFullScreenExit);
              resolve();
            };
    
            screenfull.on('fullscreenchange', onFullScreenExit);
            var returnPromise = document[fn.exitFullscreen]();
    
            if (returnPromise instanceof Promise) {
              returnPromise.then(onFullScreenExit).catch(reject);
            }
          });
        },
        on: function on(event, callback) {
          var eventName = eventNameMap[event];
    
          if (eventName) {
            document.addEventListener(eventName, callback);
          }
        },
        off: function off(event, callback) {
          var eventName = eventNameMap[event];
    
          if (eventName) {
            document.removeEventListener(eventName, callback);
          }
        }
      };
      Object.defineProperties(screenfull, {
        isFullscreen: {
          get: function get() {
            return Boolean(document[fn.fullscreenElement]);
          }
        },
        element: {
          enumerable: true,
          get: function get() {
            return document[fn.fullscreenElement];
          }
        },
        isEnabled: {
          enumerable: true,
          get: function get() {
            // Coerce to boolean in case of old WebKit
            return Boolean(document[fn.fullscreenEnabled]);
          }
        }
      });
      return screenfull;
    }
    
    var playerMap = new WeakMap();
    var readyMap = new WeakMap();
    var screenfull = {};
    
    var Player =
    /*#__PURE__*/
    function () {
      /**
       * Create a Player.
       *
       * @param {(HTMLIFrameElement|HTMLElement|string|jQuery)} element A reference to the Vimeo
       *        player iframe, and id, or a jQuery object.
       * @param {object} [options] oEmbed parameters to use when creating an embed in the element.
       * @return {Player}
       */
      function Player(element) {
        var _this = this;
    
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    
        _classCallCheck(this, Player);
    
        /* global jQuery */
        if (window.jQuery && element instanceof jQuery) {
          if (element.length > 1 && window.console && console.warn) {
            console.warn('A jQuery object with multiple elements was passed, using the first element.');
          }
    
          element = element[0];
        } // Find an element by ID
    
    
        if (typeof document !== 'undefined' && typeof element === 'string') {
          element = document.getElementById(element);
        } // Not an element!
    
    
        if (!isDomElement(element)) {
          throw new TypeError('You must pass either a valid element or a valid id.');
        } // Already initialized an embed in this div, so grab the iframe
    
    
        if (element.nodeName !== 'IFRAME') {
          var iframe = element.querySelector('iframe');
    
          if (iframe) {
            element = iframe;
          }
        } // iframe url is not a Vimeo url
    
    
        if (element.nodeName === 'IFRAME' && !isVimeoUrl(element.getAttribute('src') || '')) {
          throw new Error('The player element passed isn’t a Vimeo embed.');
        } // If there is already a player object in the map, return that
    
    
        if (playerMap.has(element)) {
          return playerMap.get(element);
        }
    
        this._window = element.ownerDocument.defaultView;
        this.element = element;
        this.origin = '*';
        var readyPromise = new npo_src(function (resolve, reject) {
          _this._onMessage = function (event) {
            if (!isVimeoUrl(event.origin) || _this.element.contentWindow !== event.source) {
              return;
            }
    
            if (_this.origin === '*') {
              _this.origin = event.origin;
            }
    
            var data = parseMessageData(event.data);
            var isError = data && data.event === 'error';
            var isReadyError = isError && data.data && data.data.method === 'ready';
    
            if (isReadyError) {
              var error = new Error(data.data.message);
              error.name = data.data.name;
              reject(error);
              return;
            }
    
            var isReadyEvent = data && data.event === 'ready';
            var isPingResponse = data && data.method === 'ping';
    
            if (isReadyEvent || isPingResponse) {
              _this.element.setAttribute('data-ready', 'true');
    
              resolve();
              return;
            }
    
            processData(_this, data);
          };
    
          _this._window.addEventListener('message', _this._onMessage);
    
          if (_this.element.nodeName !== 'IFRAME') {
            var params = getOEmbedParameters(element, options);
            var url = getVimeoUrl(params);
            getOEmbedData(url, params, element).then(function (data) {
              var iframe = createEmbed(data, element); // Overwrite element with the new iframe,
              // but store reference to the original element
    
              _this.element = iframe;
              _this._originalElement = element;
              swapCallbacks(element, iframe);
              playerMap.set(_this.element, _this);
              return data;
            }).catch(reject);
          }
        }); // Store a copy of this Player in the map
    
        readyMap.set(this, readyPromise);
        playerMap.set(this.element, this); // Send a ping to the iframe so the ready promise will be resolved if
        // the player is already ready.
    
        if (this.element.nodeName === 'IFRAME') {
          postMessage(this, 'ping');
        }
    
        if (screenfull.isEnabled) {
          var exitFullscreen = function exitFullscreen() {
            return screenfull.exit();
          };
    
          screenfull.on('fullscreenchange', function () {
            if (screenfull.isFullscreen) {
              storeCallback(_this, 'event:exitFullscreen', exitFullscreen);
            } else {
              removeCallback(_this, 'event:exitFullscreen', exitFullscreen);
            } // eslint-disable-next-line
    
    
            _this.ready().then(function () {
              postMessage(_this, 'fullscreenchange', screenfull.isFullscreen);
            });
          });
        }
    
        return this;
      }
      /**
       * Get a promise for a method.
       *
       * @param {string} name The API method to call.
       * @param {Object} [args={}] Arguments to send via postMessage.
       * @return {Promise}
       */
    
    
      _createClass(Player, [{
        key: "callMethod",
        value: function callMethod(name) {
          var _this2 = this;
    
          var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          return new npo_src(function (resolve, reject) {
            // We are storing the resolve/reject handlers to call later, so we
            // can’t return here.
            // eslint-disable-next-line promise/always-return
            return _this2.ready().then(function () {
              storeCallback(_this2, name, {
                resolve: resolve,
                reject: reject
              });
              postMessage(_this2, name, args);
            }).catch(reject);
          });
        }
        /**
         * Get a promise for the value of a player property.
         *
         * @param {string} name The property name
         * @return {Promise}
         */
    
      }, {
        key: "get",
        value: function get(name) {
          var _this3 = this;
    
          return new npo_src(function (resolve, reject) {
            name = getMethodName(name, 'get'); // We are storing the resolve/reject handlers to call later, so we
            // can’t return here.
            // eslint-disable-next-line promise/always-return
    
            return _this3.ready().then(function () {
              storeCallback(_this3, name, {
                resolve: resolve,
                reject: reject
              });
              postMessage(_this3, name);
            }).catch(reject);
          });
        }
        /**
         * Get a promise for setting the value of a player property.
         *
         * @param {string} name The API method to call.
         * @param {mixed} value The value to set.
         * @return {Promise}
         */
    
      }, {
        key: "set",
        value: function set(name, value) {
          var _this4 = this;
    
          return new npo_src(function (resolve, reject) {
            name = getMethodName(name, 'set');
    
            if (value === undefined || value === null) {
              throw new TypeError('There must be a value to set.');
            } // We are storing the resolve/reject handlers to call later, so we
            // can’t return here.
            // eslint-disable-next-line promise/always-return
    
    
            return _this4.ready().then(function () {
              storeCallback(_this4, name, {
                resolve: resolve,
                reject: reject
              });
              postMessage(_this4, name, value);
            }).catch(reject);
          });
        }
        /**
         * Add an event listener for the specified event. Will call the
         * callback with a single parameter, `data`, that contains the data for
         * that event.
         *
         * @param {string} eventName The name of the event.
         * @param {function(*)} callback The function to call when the event fires.
         * @return {void}
         */
    
      }, {
        key: "on",
        value: function on(eventName, callback) {
          if (!eventName) {
            throw new TypeError('You must pass an event name.');
          }
    
          if (!callback) {
            throw new TypeError('You must pass a callback function.');
          }
    
          if (typeof callback !== 'function') {
            throw new TypeError('The callback must be a function.');
          }
    
          var callbacks = getCallbacks(this, "event:".concat(eventName));
    
          if (callbacks.length === 0) {
            this.callMethod('addEventListener', eventName).catch(function () {// Ignore the error. There will be an error event fired that
              // will trigger the error callback if they are listening.
            });
          }
    
          storeCallback(this, "event:".concat(eventName), callback);
        }
        /**
         * Remove an event listener for the specified event. Will remove all
         * listeners for that event if a `callback` isn’t passed, or only that
         * specific callback if it is passed.
         *
         * @param {string} eventName The name of the event.
         * @param {function} [callback] The specific callback to remove.
         * @return {void}
         */
    
      }, {
        key: "off",
        value: function off(eventName, callback) {
          if (!eventName) {
            throw new TypeError('You must pass an event name.');
          }
    
          if (callback && typeof callback !== 'function') {
            throw new TypeError('The callback must be a function.');
          }
    
          var lastCallback = removeCallback(this, "event:".concat(eventName), callback); // If there are no callbacks left, remove the listener
    
          if (lastCallback) {
            this.callMethod('removeEventListener', eventName).catch(function (e) {// Ignore the error. There will be an error event fired that
              // will trigger the error callback if they are listening.
            });
          }
        }
        /**
         * A promise to load a new video.
         *
         * @promise LoadVideoPromise
         * @fulfill {number} The video with this id successfully loaded.
         * @reject {TypeError} The id was not a number.
         */
    
        /**
         * Load a new video into this embed. The promise will be resolved if
         * the video is successfully loaded, or it will be rejected if it could
         * not be loaded.
         *
         * @param {number|object} options The id of the video or an object with embed options.
         * @return {LoadVideoPromise}
         */
    
      }, {
        key: "loadVideo",
        value: function loadVideo(options) {
          return this.callMethod('loadVideo', options);
        }
        /**
         * A promise to perform an action when the Player is ready.
         *
         * @todo document errors
         * @promise LoadVideoPromise
         * @fulfill {void}
         */
    
        /**
         * Trigger a function when the player iframe has initialized. You do not
         * need to wait for `ready` to trigger to begin adding event listeners
         * or calling other methods.
         *
         * @return {ReadyPromise}
         */
    
      }, {
        key: "ready",
        value: function ready() {
          var readyPromise = readyMap.get(this) || new npo_src(function (resolve, reject) {
            reject(new Error('Unknown player. Probably unloaded.'));
          });
          return npo_src.resolve(readyPromise);
        }
        /**
         * A promise to add a cue point to the player.
         *
         * @promise AddCuePointPromise
         * @fulfill {string} The id of the cue point to use for removeCuePoint.
         * @reject {RangeError} the time was less than 0 or greater than the
         *         video’s duration.
         * @reject {UnsupportedError} Cue points are not supported with the current
         *         player or browser.
         */
    
        /**
         * Add a cue point to the player.
         *
         * @param {number} time The time for the cue point.
         * @param {object} [data] Arbitrary data to be returned with the cue point.
         * @return {AddCuePointPromise}
         */
    
      }, {
        key: "addCuePoint",
        value: function addCuePoint(time) {
          var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          return this.callMethod('addCuePoint', {
            time: time,
            data: data
          });
        }
        /**
         * A promise to remove a cue point from the player.
         *
         * @promise AddCuePointPromise
         * @fulfill {string} The id of the cue point that was removed.
         * @reject {InvalidCuePoint} The cue point with the specified id was not
         *         found.
         * @reject {UnsupportedError} Cue points are not supported with the current
         *         player or browser.
         */
    
        /**
         * Remove a cue point from the video.
         *
         * @param {string} id The id of the cue point to remove.
         * @return {RemoveCuePointPromise}
         */
    
      }, {
        key: "removeCuePoint",
        value: function removeCuePoint(id) {
          return this.callMethod('removeCuePoint', id);
        }
        /**
         * A representation of a text track on a video.
         *
         * @typedef {Object} VimeoTextTrack
         * @property {string} language The ISO language code.
         * @property {string} kind The kind of track it is (captions or subtitles).
         * @property {string} label The human‐readable label for the track.
         */
    
        /**
         * A promise to enable a text track.
         *
         * @promise EnableTextTrackPromise
         * @fulfill {VimeoTextTrack} The text track that was enabled.
         * @reject {InvalidTrackLanguageError} No track was available with the
         *         specified language.
         * @reject {InvalidTrackError} No track was available with the specified
         *         language and kind.
         */
    
        /**
         * Enable the text track with the specified language, and optionally the
         * specified kind (captions or subtitles).
         *
         * When set via the API, the track language will not change the viewer’s
         * stored preference.
         *
         * @param {string} language The two‐letter language code.
         * @param {string} [kind] The kind of track to enable (captions or subtitles).
         * @return {EnableTextTrackPromise}
         */
    
      }, {
        key: "enableTextTrack",
        value: function enableTextTrack(language, kind) {
          if (!language) {
            throw new TypeError('You must pass a language.');
          }
    
          return this.callMethod('enableTextTrack', {
            language: language,
            kind: kind
          });
        }
        /**
         * A promise to disable the active text track.
         *
         * @promise DisableTextTrackPromise
         * @fulfill {void} The track was disabled.
         */
    
        /**
         * Disable the currently-active text track.
         *
         * @return {DisableTextTrackPromise}
         */
    
      }, {
        key: "disableTextTrack",
        value: function disableTextTrack() {
          return this.callMethod('disableTextTrack');
        }
        /**
         * A promise to pause the video.
         *
         * @promise PausePromise
         * @fulfill {void} The video was paused.
         */
    
        /**
         * Pause the video if it’s playing.
         *
         * @return {PausePromise}
         */
    
      }, {
        key: "pause",
        value: function pause() {
          return this.callMethod('pause');
        }
        /**
         * A promise to play the video.
         *
         * @promise PlayPromise
         * @fulfill {void} The video was played.
         */
    
        /**
         * Play the video if it’s paused. **Note:** on iOS and some other
         * mobile devices, you cannot programmatically trigger play. Once the
         * viewer has tapped on the play button in the player, however, you
         * will be able to use this function.
         *
         * @return {PlayPromise}
         */
    
      }, {
        key: "play",
        value: function play() {
          return this.callMethod('play');
        }
        /**
         * Request that the player enters fullscreen.
         * @return {Promise}
         */
    
      }, {
        key: "requestFullscreen",
        value: function requestFullscreen() {
          if (screenfull.isEnabled) {
            return screenfull.request(this.element);
          }
    
          return this.callMethod('requestFullscreen');
        }
        /**
         * Request that the player exits fullscreen.
         * @return {Promise}
         */
    
      }, {
        key: "exitFullscreen",
        value: function exitFullscreen() {
          if (screenfull.isEnabled) {
            return screenfull.exit();
          }
    
          return this.callMethod('exitFullscreen');
        }
        /**
         * Returns true if the player is currently fullscreen.
         * @return {Promise}
         */
    
      }, {
        key: "getFullscreen",
        value: function getFullscreen() {
          if (screenfull.isEnabled) {
            return npo_src.resolve(screenfull.isFullscreen);
          }
    
          return this.get('fullscreen');
        }
        /**
         * A promise to unload the video.
         *
         * @promise UnloadPromise
         * @fulfill {void} The video was unloaded.
         */
    
        /**
         * Return the player to its initial state.
         *
         * @return {UnloadPromise}
         */
    
      }, {
        key: "unload",
        value: function unload() {
          return this.callMethod('unload');
        }
        /**
         * Cleanup the player and remove it from the DOM
         *
         * It won't be usable and a new one should be constructed
         *  in order to do any operations.
         *
         * @return {Promise}
         */
    
      }, {
        key: "destroy",
        value: function destroy() {
          var _this5 = this;
    
          return new npo_src(function (resolve) {
            readyMap.delete(_this5);
            playerMap.delete(_this5.element);
    
            if (_this5._originalElement) {
              playerMap.delete(_this5._originalElement);
    
              _this5._originalElement.removeAttribute('data-vimeo-initialized');
            }
    
            if (_this5.element && _this5.element.nodeName === 'IFRAME' && _this5.element.parentNode) {
              _this5.element.parentNode.removeChild(_this5.element);
            }
    
            _this5._window.removeEventListener('message', _this5._onMessage);
    
            resolve();
          });
        }
        /**
         * A promise to get the autopause behavior of the video.
         *
         * @promise GetAutopausePromise
         * @fulfill {boolean} Whether autopause is turned on or off.
         * @reject {UnsupportedError} Autopause is not supported with the current
         *         player or browser.
         */
    
        /**
         * Get the autopause behavior for this player.
         *
         * @return {GetAutopausePromise}
         */
    
      }, {
        key: "getAutopause",
        value: function getAutopause() {
          return this.get('autopause');
        }
        /**
         * A promise to set the autopause behavior of the video.
         *
         * @promise SetAutopausePromise
         * @fulfill {boolean} Whether autopause is turned on or off.
         * @reject {UnsupportedError} Autopause is not supported with the current
         *         player or browser.
         */
    
        /**
         * Enable or disable the autopause behavior of this player.
         *
         * By default, when another video is played in the same browser, this
         * player will automatically pause. Unless you have a specific reason
         * for doing so, we recommend that you leave autopause set to the
         * default (`true`).
         *
         * @param {boolean} autopause
         * @return {SetAutopausePromise}
         */
    
      }, {
        key: "setAutopause",
        value: function setAutopause(autopause) {
          return this.set('autopause', autopause);
        }
        /**
         * A promise to get the buffered property of the video.
         *
         * @promise GetBufferedPromise
         * @fulfill {Array} Buffered Timeranges converted to an Array.
         */
    
        /**
         * Get the buffered property of the video.
         *
         * @return {GetBufferedPromise}
         */
    
      }, {
        key: "getBuffered",
        value: function getBuffered() {
          return this.get('buffered');
        }
        /**
         * A representation of a chapter.
         *
         * @typedef {Object} VimeoChapter
         * @property {number} startTime The start time of the chapter.
         * @property {object} title The title of the chapter.
         * @property {number} index The place in the order of Chapters. Starts at 1.
         */
    
        /**
         * A promise to get chapters for the video.
         *
         * @promise GetChaptersPromise
         * @fulfill {VimeoChapter[]} The chapters for the video.
         */
    
        /**
         * Get an array of all the chapters for the video.
         *
         * @return {GetChaptersPromise}
         */
    
      }, {
        key: "getChapters",
        value: function getChapters() {
          return this.get('chapters');
        }
        /**
         * A promise to get the currently active chapter.
         *
         * @promise GetCurrentChaptersPromise
         * @fulfill {VimeoChapter|undefined} The current chapter for the video.
         */
    
        /**
         * Get the currently active chapter for the video.
         *
         * @return {GetCurrentChaptersPromise}
         */
    
      }, {
        key: "getCurrentChapter",
        value: function getCurrentChapter() {
          return this.get('currentChapter');
        }
        /**
         * A promise to get the color of the player.
         *
         * @promise GetColorPromise
         * @fulfill {string} The hex color of the player.
         */
    
        /**
         * Get the color for this player.
         *
         * @return {GetColorPromise}
         */
    
      }, {
        key: "getColor",
        value: function getColor() {
          return this.get('color');
        }
        /**
         * A promise to set the color of the player.
         *
         * @promise SetColorPromise
         * @fulfill {string} The color was successfully set.
         * @reject {TypeError} The string was not a valid hex or rgb color.
         * @reject {ContrastError} The color was set, but the contrast is
         *         outside of the acceptable range.
         * @reject {EmbedSettingsError} The owner of the player has chosen to
         *         use a specific color.
         */
    
        /**
         * Set the color of this player to a hex or rgb string. Setting the
         * color may fail if the owner of the video has set their embed
         * preferences to force a specific color.
         *
         * @param {string} color The hex or rgb color string to set.
         * @return {SetColorPromise}
         */
    
      }, {
        key: "setColor",
        value: function setColor(color) {
          return this.set('color', color);
        }
        /**
         * A representation of a cue point.
         *
         * @typedef {Object} VimeoCuePoint
         * @property {number} time The time of the cue point.
         * @property {object} data The data passed when adding the cue point.
         * @property {string} id The unique id for use with removeCuePoint.
         */
    
        /**
         * A promise to get the cue points of a video.
         *
         * @promise GetCuePointsPromise
         * @fulfill {VimeoCuePoint[]} The cue points added to the video.
         * @reject {UnsupportedError} Cue points are not supported with the current
         *         player or browser.
         */
    
        /**
         * Get an array of the cue points added to the video.
         *
         * @return {GetCuePointsPromise}
         */
    
      }, {
        key: "getCuePoints",
        value: function getCuePoints() {
          return this.get('cuePoints');
        }
        /**
         * A promise to get the current time of the video.
         *
         * @promise GetCurrentTimePromise
         * @fulfill {number} The current time in seconds.
         */
    
        /**
         * Get the current playback position in seconds.
         *
         * @return {GetCurrentTimePromise}
         */
    
      }, {
        key: "getCurrentTime",
        value: function getCurrentTime() {
          return this.get('currentTime');
        }
        /**
         * A promise to set the current time of the video.
         *
         * @promise SetCurrentTimePromise
         * @fulfill {number} The actual current time that was set.
         * @reject {RangeError} the time was less than 0 or greater than the
         *         video’s duration.
         */
    
        /**
         * Set the current playback position in seconds. If the player was
         * paused, it will remain paused. Likewise, if the player was playing,
         * it will resume playing once the video has buffered.
         *
         * You can provide an accurate time and the player will attempt to seek
         * to as close to that time as possible. The exact time will be the
         * fulfilled value of the promise.
         *
         * @param {number} currentTime
         * @return {SetCurrentTimePromise}
         */
    
      }, {
        key: "setCurrentTime",
        value: function setCurrentTime(currentTime) {
          return this.set('currentTime', currentTime);
        }
        /**
         * A promise to get the duration of the video.
         *
         * @promise GetDurationPromise
         * @fulfill {number} The duration in seconds.
         */
    
        /**
         * Get the duration of the video in seconds. It will be rounded to the
         * nearest second before playback begins, and to the nearest thousandth
         * of a second after playback begins.
         *
         * @return {GetDurationPromise}
         */
    
      }, {
        key: "getDuration",
        value: function getDuration() {
          return this.get('duration');
        }
        /**
         * A promise to get the ended state of the video.
         *
         * @promise GetEndedPromise
         * @fulfill {boolean} Whether or not the video has ended.
         */
    
        /**
         * Get the ended state of the video. The video has ended if
         * `currentTime === duration`.
         *
         * @return {GetEndedPromise}
         */
    
      }, {
        key: "getEnded",
        value: function getEnded() {
          return this.get('ended');
        }
        /**
         * A promise to get the loop state of the player.
         *
         * @promise GetLoopPromise
         * @fulfill {boolean} Whether or not the player is set to loop.
         */
    
        /**
         * Get the loop state of the player.
         *
         * @return {GetLoopPromise}
         */
    
      }, {
        key: "getLoop",
        value: function getLoop() {
          return this.get('loop');
        }
        /**
         * A promise to set the loop state of the player.
         *
         * @promise SetLoopPromise
         * @fulfill {boolean} The loop state that was set.
         */
    
        /**
         * Set the loop state of the player. When set to `true`, the player
         * will start over immediately once playback ends.
         *
         * @param {boolean} loop
         * @return {SetLoopPromise}
         */
    
      }, {
        key: "setLoop",
        value: function setLoop(loop) {
          return this.set('loop', loop);
        }
        /**
         * A promise to set the muted state of the player.
         *
         * @promise SetMutedPromise
         * @fulfill {boolean} The muted state that was set.
         */
    
        /**
         * Set the muted state of the player. When set to `true`, the player
         * volume will be muted.
         *
         * @param {boolean} muted
         * @return {SetMutedPromise}
         */
    
      }, {
        key: "setMuted",
        value: function setMuted(muted) {
          return this.set('muted', muted);
        }
        /**
         * A promise to get the muted state of the player.
         *
         * @promise GetMutedPromise
         * @fulfill {boolean} Whether or not the player is muted.
         */
    
        /**
         * Get the muted state of the player.
         *
         * @return {GetMutedPromise}
         */
    
      }, {
        key: "getMuted",
        value: function getMuted() {
          return this.get('muted');
        }
        /**
         * A promise to get the paused state of the player.
         *
         * @promise GetLoopPromise
         * @fulfill {boolean} Whether or not the video is paused.
         */
    
        /**
         * Get the paused state of the player.
         *
         * @return {GetLoopPromise}
         */
    
      }, {
        key: "getPaused",
        value: function getPaused() {
          return this.get('paused');
        }
        /**
         * A promise to get the playback rate of the player.
         *
         * @promise GetPlaybackRatePromise
         * @fulfill {number} The playback rate of the player on a scale from 0.5 to 2.
         */
    
        /**
         * Get the playback rate of the player on a scale from `0.5` to `2`.
         *
         * @return {GetPlaybackRatePromise}
         */
    
      }, {
        key: "getPlaybackRate",
        value: function getPlaybackRate() {
          return this.get('playbackRate');
        }
        /**
         * A promise to set the playbackrate of the player.
         *
         * @promise SetPlaybackRatePromise
         * @fulfill {number} The playback rate was set.
         * @reject {RangeError} The playback rate was less than 0.5 or greater than 2.
         */
    
        /**
         * Set the playback rate of the player on a scale from `0.5` to `2`. When set
         * via the API, the playback rate will not be synchronized to other
         * players or stored as the viewer's preference.
         *
         * @param {number} playbackRate
         * @return {SetPlaybackRatePromise}
         */
    
      }, {
        key: "setPlaybackRate",
        value: function setPlaybackRate(playbackRate) {
          return this.set('playbackRate', playbackRate);
        }
        /**
         * A promise to get the played property of the video.
         *
         * @promise GetPlayedPromise
         * @fulfill {Array} Played Timeranges converted to an Array.
         */
    
        /**
         * Get the played property of the video.
         *
         * @return {GetPlayedPromise}
         */
    
      }, {
        key: "getPlayed",
        value: function getPlayed() {
          return this.get('played');
        }
        /**
         * A promise to get the seekable property of the video.
         *
         * @promise GetSeekablePromise
         * @fulfill {Array} Seekable Timeranges converted to an Array.
         */
    
        /**
         * Get the seekable property of the video.
         *
         * @return {GetSeekablePromise}
         */
    
      }, {
        key: "getSeekable",
        value: function getSeekable() {
          return this.get('seekable');
        }
        /**
         * A promise to get the seeking property of the player.
         *
         * @promise GetSeekingPromise
         * @fulfill {boolean} Whether or not the player is currently seeking.
         */
    
        /**
         * Get if the player is currently seeking.
         *
         * @return {GetSeekingPromise}
         */
    
      }, {
        key: "getSeeking",
        value: function getSeeking() {
          return this.get('seeking');
        }
        /**
         * A promise to get the text tracks of a video.
         *
         * @promise GetTextTracksPromise
         * @fulfill {VimeoTextTrack[]} The text tracks associated with the video.
         */
    
        /**
         * Get an array of the text tracks that exist for the video.
         *
         * @return {GetTextTracksPromise}
         */
    
      }, {
        key: "getTextTracks",
        value: function getTextTracks() {
          return this.get('textTracks');
        }
        /**
         * A promise to get the embed code for the video.
         *
         * @promise GetVideoEmbedCodePromise
         * @fulfill {string} The `<iframe>` embed code for the video.
         */
    
        /**
         * Get the `<iframe>` embed code for the video.
         *
         * @return {GetVideoEmbedCodePromise}
         */
    
      }, {
        key: "getVideoEmbedCode",
        value: function getVideoEmbedCode() {
          return this.get('videoEmbedCode');
        }
        /**
         * A promise to get the id of the video.
         *
         * @promise GetVideoIdPromise
         * @fulfill {number} The id of the video.
         */
    
        /**
         * Get the id of the video.
         *
         * @return {GetVideoIdPromise}
         */
    
      }, {
        key: "getVideoId",
        value: function getVideoId() {
          return this.get('videoId');
        }
        /**
         * A promise to get the title of the video.
         *
         * @promise GetVideoTitlePromise
         * @fulfill {number} The title of the video.
         */
    
        /**
         * Get the title of the video.
         *
         * @return {GetVideoTitlePromise}
         */
    
      }, {
        key: "getVideoTitle",
        value: function getVideoTitle() {
          return this.get('videoTitle');
        }
        /**
         * A promise to get the native width of the video.
         *
         * @promise GetVideoWidthPromise
         * @fulfill {number} The native width of the video.
         */
    
        /**
         * Get the native width of the currently‐playing video. The width of
         * the highest‐resolution available will be used before playback begins.
         *
         * @return {GetVideoWidthPromise}
         */
    
      }, {
        key: "getVideoWidth",
        value: function getVideoWidth() {
          return this.get('videoWidth');
        }
        /**
         * A promise to get the native height of the video.
         *
         * @promise GetVideoHeightPromise
         * @fulfill {number} The native height of the video.
         */
    
        /**
         * Get the native height of the currently‐playing video. The height of
         * the highest‐resolution available will be used before playback begins.
         *
         * @return {GetVideoHeightPromise}
         */
    
      }, {
        key: "getVideoHeight",
        value: function getVideoHeight() {
          return this.get('videoHeight');
        }
        /**
         * A promise to get the vimeo.com url for the video.
         *
         * @promise GetVideoUrlPromise
         * @fulfill {number} The vimeo.com url for the video.
         * @reject {PrivacyError} The url isn’t available because of the video’s privacy setting.
         */
    
        /**
         * Get the vimeo.com url for the video.
         *
         * @return {GetVideoUrlPromise}
         */
    
      }, {
        key: "getVideoUrl",
        value: function getVideoUrl() {
          return this.get('videoUrl');
        }
        /**
         * A promise to get the volume level of the player.
         *
         * @promise GetVolumePromise
         * @fulfill {number} The volume level of the player on a scale from 0 to 1.
         */
    
        /**
         * Get the current volume level of the player on a scale from `0` to `1`.
         *
         * Most mobile devices do not support an independent volume from the
         * system volume. In those cases, this method will always return `1`.
         *
         * @return {GetVolumePromise}
         */
    
      }, {
        key: "getVolume",
        value: function getVolume() {
          return this.get('volume');
        }
        /**
         * A promise to set the volume level of the player.
         *
         * @promise SetVolumePromise
         * @fulfill {number} The volume was set.
         * @reject {RangeError} The volume was less than 0 or greater than 1.
         */
    
        /**
         * Set the volume of the player on a scale from `0` to `1`. When set
         * via the API, the volume level will not be synchronized to other
         * players or stored as the viewer’s preference.
         *
         * Most mobile devices do not support setting the volume. An error will
         * *not* be triggered in that situation.
         *
         * @param {number} volume
         * @return {SetVolumePromise}
         */
    
      }, {
        key: "setVolume",
        value: function setVolume(volume) {
          return this.set('volume', volume);
        }
      }]);
    
      return Player;
    }(); // Setup embed only if this is not a node environment
    
    
    if (!isNode) {
      screenfull = initializeScreenfull();
      initializeEmbeds();
      resizeEmbeds();
    }
    
    /* harmony default export */ __webpack_exports__["a"] = (Player);
    
    /* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(10), __webpack_require__(58).setImmediate))
    
    /***/ }),
    /* 24 */
    /***/ (function(module, exports, __webpack_require__) {
    
    /* WEBPACK VAR INJECTION */(function(module, global, process) {!function(t){"use strict";var y=/^[a-z]+:/,d=/[-a-z0-9]+(\.[-a-z0-9])*:\d+/i,v=/\/\/(.*?)(?::(.*?))?@/,r=/^win/i,g=/:$/,m=/^\?/,q=/^#/,w=/(.*\/)/,A=/^\/{2,}/,I=/(^\/?)/,e=/'/g,o=/%([ef][0-9a-f])%([89ab][0-9a-f])%([89ab][0-9a-f])/gi,n=/%([cd][0-9a-f])%([89ab][0-9a-f])/gi,i=/%([0-7][0-9a-f])/gi,s=/\+/g,a=/^\w:$/,C=/[^/#?]/;var p,S="undefined"==typeof window&&"undefined"!=typeof global&&"function"=="function",b=!S&&t.navigator&&t.navigator.userAgent&&~t.navigator.userAgent.indexOf("MSIE"),x=S?t.require:null,j={protocol:"protocol",host:"hostname",port:"port",path:"pathname",query:"search",hash:"hash"},z={ftp:21,gopher:70,http:80,https:443,ws:80,wss:443};function E(){return S?p=p||"file://"+(process.platform.match(r)?"/":"")+x("fs").realpathSync("."):"about:srcdoc"===document.location.href?self.parent.document.location.href:document.location.href}function h(t,r,e){var o,n,i;r=r||E(),S?o=x("url").parse(r):(o=document.createElement("a")).href=r;var a,s,p=(s={path:!0,query:!0,hash:!0},(a=r)&&y.test(a)&&(s.protocol=!0,s.host=!0,d.test(a)&&(s.port=!0),v.test(a)&&(s.user=!0,s.pass=!0)),s);for(n in i=r.match(v)||[],j)p[n]?t[n]=o[j[n]]||"":t[n]="";if(t.protocol=t.protocol.replace(g,""),t.query=t.query.replace(m,""),t.hash=F(t.hash.replace(q,"")),t.user=F(i[1]||""),t.pass=F(i[2]||""),t.port=z[t.protocol]==t.port||0==t.port?"":t.port,!p.protocol&&C.test(r.charAt(0))&&(t.path=r.split("?")[0].split("#")[0]),!p.protocol&&e){var h=new L(E().match(w)[0]),u=h.path.split("/"),c=t.path.split("/"),f=["protocol","user","pass","host","port"],l=f.length;for(u.pop(),n=0;n<l;n++)t[f[n]]=h[f[n]];for(;".."===c[0];)u.pop(),c.shift();t.path=("/"!==r.charAt(0)?u.join("/"):"")+"/"+c.join("/")}t.path=t.path.replace(A,"/"),b&&(t.path=t.path.replace(I,"/")),t.paths(t.paths()),t.query=new U(t.query)}function u(t){return encodeURIComponent(t).replace(e,"%27")}function F(t){return(t=(t=(t=t.replace(s," ")).replace(o,function(t,r,e,o){var n=parseInt(r,16)-224,i=parseInt(e,16)-128;if(0==n&&i<32)return t;var a=(n<<12)+(i<<6)+(parseInt(o,16)-128);return 65535<a?t:String.fromCharCode(a)})).replace(n,function(t,r,e){var o=parseInt(r,16)-192;if(o<2)return t;var n=parseInt(e,16)-128;return String.fromCharCode((o<<6)+n)})).replace(i,function(t,r){return String.fromCharCode(parseInt(r,16))})}function U(t){for(var r=t.split("&"),e=0,o=r.length;e<o;e++){var n=r[e].split("="),i=decodeURIComponent(n[0].replace(s," "));if(i){var a=void 0!==n[1]?F(n[1]):null;void 0===this[i]?this[i]=a:(this[i]instanceof Array||(this[i]=[this[i]]),this[i].push(a))}}}function L(t,r){h(this,t,!r)}U.prototype.toString=function(){var t,r,e="",o=u;for(t in this){var n=this[t];if(!(n instanceof Function||void 0===n))if(n instanceof Array){var i=n.length;if(!i){e+=(e?"&":"")+o(t)+"=";continue}for(r=0;r<i;r++){var a=n[r];void 0!==a&&(e+=e?"&":"",e+=o(t)+(null===a?"":"="+o(a)))}}else e+=e?"&":"",e+=o(t)+(null===n?"":"="+o(n))}return e},L.prototype.clearQuery=function(){for(var t in this.query)this.query[t]instanceof Function||delete this.query[t];return this},L.prototype.queryLength=function(){var t=0;for(var r in this.query)this.query[r]instanceof Function||t++;return t},L.prototype.isEmptyQuery=function(){return 0===this.queryLength()},L.prototype.paths=function(t){var r,e="",o=0;if(t&&t.length&&t+""!==t){for(this.isAbsolute()&&(e="/"),r=t.length;o<r;o++)t[o]=!o&&a.test(t[o])?t[o]:u(t[o]);this.path=e+t.join("/")}for(o=0,r=(t=("/"===this.path.charAt(0)?this.path.slice(1):this.path).split("/")).length;o<r;o++)t[o]=F(t[o]);return t},L.prototype.encode=u,L.prototype.decode=F,L.prototype.isAbsolute=function(){return this.protocol||"/"===this.path.charAt(0)},L.prototype.toString=function(){return(this.protocol&&this.protocol+"://")+(this.user&&u(this.user)+(this.pass&&":"+u(this.pass))+"@")+(this.host&&this.host)+(this.port&&":"+this.port)+(this.path&&this.path)+(this.query.toString()&&"?"+this.query)+(this.hash&&"#"+u(this.hash))},t[t.exports?"exports":"Url"]=L}( true&&module.exports?module:window);
    /* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(60)(module), __webpack_require__(10), __webpack_require__(14)))
    
    /***/ }),
    /* 25 */
    /***/ (function(module, exports) {
    
    function _objectWithoutPropertiesLoose(source, excluded) {
      if (source == null) return {};
      var target = {};
      var sourceKeys = Object.keys(source);
      var key, i;
    
      for (i = 0; i < sourceKeys.length; i++) {
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
      }
    
      return target;
    }
    
    module.exports = _objectWithoutPropertiesLoose;
    
    /***/ }),
    /* 26 */
    /***/ (function(module, exports, __webpack_require__) {
    
    var arrayLikeToArray = __webpack_require__(17);
    
    function _arrayWithoutHoles(arr) {
      if (Array.isArray(arr)) return arrayLikeToArray(arr);
    }
    
    module.exports = _arrayWithoutHoles;
    
    /***/ }),
    /* 27 */
    /***/ (function(module, exports) {
    
    function _iterableToArray(iter) {
      if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
    }
    
    module.exports = _iterableToArray;
    
    /***/ }),
    /* 28 */
    /***/ (function(module, exports, __webpack_require__) {
    
    var arrayLikeToArray = __webpack_require__(17);
    
    function _unsupportedIterableToArray(o, minLen) {
      if (!o) return;
      if (typeof o === "string") return arrayLikeToArray(o, minLen);
      var n = Object.prototype.toString.call(o).slice(8, -1);
      if (n === "Object" && o.constructor) n = o.constructor.name;
      if (n === "Map" || n === "Set") return Array.from(o);
      if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
    }
    
    module.exports = _unsupportedIterableToArray;
    
    /***/ }),
    /* 29 */
    /***/ (function(module, exports) {
    
    function _nonIterableSpread() {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    
    module.exports = _nonIterableSpread;
    
    /***/ }),
    /* 30 */
    /***/ (function(module, exports, __webpack_require__) {
    
    // extracted by mini-css-extract-plugin
    
    /***/ }),
    /* 31 */
    /***/ (function(module, exports, __webpack_require__) {
    
    var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(window, factory) {
        if(!window) {return;}
        var globalInstall = function(initialEvent){
            factory(window.lazySizes, initialEvent);
            window.removeEventListener('lazyunveilread', globalInstall, true);
        };
    
        factory = factory.bind(null, window, window.document);
    
        if( true && module.exports){
            factory(__webpack_require__(3));
        } else if (true) {
            !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
                    __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
                    (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
                    __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else {}
    }(typeof window != 'undefined' ?
        window : 0, function(window, document, lazySizes, initialEvent) {
        'use strict';
        var cloneElementClass;
        var style = document.createElement('a').style;
        var fitSupport = 'objectFit' in style;
        var positionSupport = fitSupport && 'objectPosition' in style;
        var regCssFit = /object-fit["']*\s*:\s*["']*(contain|cover)/;
        var regCssPosition = /object-position["']*\s*:\s*["']*(.+?)(?=($|,|'|"|;))/;
        var blankSrc = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
        var regBgUrlEscape = /\(|\)|'/;
        var positionDefaults = {
            center: 'center',
            '50% 50%': 'center',
        };
    
        function getObject(element){
            var css = (getComputedStyle(element, null) || {});
            var content = css.fontFamily || '';
            var objectFit = content.match(regCssFit) || '';
            var objectPosition = objectFit && content.match(regCssPosition) || '';
    
            if(objectPosition){
                objectPosition = objectPosition[1];
            }
    
            return {
                fit: objectFit && objectFit[1] || '',
                position: positionDefaults[objectPosition] || objectPosition || 'center',
            };
        }
    
        function generateStyleClass() {
            if (cloneElementClass) {
                return;
            }
    
            var styleElement = document.createElement('style');
    
            cloneElementClass = lazySizes.cfg.objectFitClass || 'lazysizes-display-clone';
    
            document.querySelector('head').appendChild(styleElement);
        }
    
        function removePrevClone(element) {
            var prev = element.previousElementSibling;
    
            if (prev && lazySizes.hC(prev, cloneElementClass)) {
                prev.parentNode.removeChild(prev);
                element.style.position = prev.getAttribute('data-position') || '';
                element.style.visibility = prev.getAttribute('data-visibility') || '';
            }
        }
    
        function initFix(element, config){
            var switchClassesAdded, addedSrc, styleElement, styleElementStyle;
            var lazysizesCfg = lazySizes.cfg;
    
            var onChange = function(){
                var src = element.currentSrc || element.src;
    
                if(src && addedSrc !== src){
                    addedSrc = src;
                    styleElementStyle.backgroundImage = 'url(' + (regBgUrlEscape.test(src) ? JSON.stringify(src) : src ) + ')';
    
                    if(!switchClassesAdded){
                        switchClassesAdded = true;
                        lazySizes.rC(styleElement, lazysizesCfg.loadingClass);
                        lazySizes.aC(styleElement, lazysizesCfg.loadedClass);
                    }
                }
            };
            var rafedOnChange = function(){
                lazySizes.rAF(onChange);
            };
    
            element._lazysizesParentFit = config.fit;
    
            element.addEventListener('lazyloaded', rafedOnChange, true);
            element.addEventListener('load', rafedOnChange, true);
    
            lazySizes.rAF(function(){
    
                var hideElement = element;
                var container = element.parentNode;
    
                if(container.nodeName.toUpperCase() == 'PICTURE'){
                    hideElement = container;
                    container = container.parentNode;
                }
    
                removePrevClone(hideElement);
    
                if (!cloneElementClass) {
                    generateStyleClass();
                }
    
                styleElement = element.cloneNode(false);
                styleElementStyle = styleElement.style;
    
                styleElement.addEventListener('load', function(){
                    var curSrc = styleElement.currentSrc || styleElement.src;
    
                    if(curSrc && curSrc != blankSrc){
                        styleElement.src = blankSrc;
                        styleElement.srcset = '';
                    }
                });
    
                lazySizes.rC(styleElement, lazysizesCfg.loadedClass);
                lazySizes.rC(styleElement, lazysizesCfg.lazyClass);
                lazySizes.rC(styleElement, lazysizesCfg.autosizesClass);
                lazySizes.aC(styleElement, lazysizesCfg.loadingClass);
                lazySizes.aC(styleElement, cloneElementClass);
    
                ['data-parent-fit', 'data-parent-container', 'data-object-fit-polyfilled',
                    lazysizesCfg.srcsetAttr, lazysizesCfg.srcAttr].forEach(function(attr) {
                    styleElement.removeAttribute(attr);
                });
    
                styleElement.src = blankSrc;
                styleElement.srcset = '';
    
                styleElementStyle.backgroundRepeat = 'no-repeat';
                styleElementStyle.backgroundPosition = config.position;
                styleElementStyle.backgroundSize = config.fit;
    
                styleElement.setAttribute('data-position', hideElement.style.position);
                styleElement.setAttribute('data-visibility', hideElement.style.visibility);
    
                hideElement.style.visibility = 'hidden';
                hideElement.style.position = 'absolute';
    
                element.setAttribute('data-parent-fit', config.fit);
                element.setAttribute('data-parent-container', 'prev');
                element.setAttribute('data-object-fit-polyfilled', '');
                element._objectFitPolyfilledDisplay = styleElement;
    
                container.insertBefore(styleElement, hideElement);
    
                if(element._lazysizesParentFit){
                    delete element._lazysizesParentFit;
                }
    
                if(element.complete){
                    onChange();
                }
            });
        }
    
        if(!fitSupport || !positionSupport){
            var onRead = function(e){
                if(e.detail.instance != lazySizes){return;}
    
                var element = e.target;
                var obj = getObject(element);
    
                if(obj.fit && (!fitSupport || (obj.position != 'center'))){
                    initFix(element, obj);
                    return true;
                }
    
                return false;
            };
    
            window.addEventListener('lazybeforesizes', function(e) {
                if(e.detail.instance != lazySizes){return;}
                var element = e.target;
    
                if (element.getAttribute('data-object-fit-polyfilled') != null && !element._objectFitPolyfilledDisplay) {
                    if(!onRead(e)){
                        lazySizes.rAF(function () {
                            element.removeAttribute('data-object-fit-polyfilled');
                        });
                    }
                }
            });
            window.addEventListener('lazyunveilread', onRead, true);
    
            if(initialEvent && initialEvent.detail){
                onRead(initialEvent);
            }
        }
    }));
    
    
    /***/ }),
    /* 32 */
    /***/ (function(module, exports, __webpack_require__) {
    
    var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(window, factory) {
        if(!window) {return;}
        var globalInstall = function(){
            factory(window.lazySizes);
            window.removeEventListener('lazyunveilread', globalInstall, true);
        };
    
        factory = factory.bind(null, window, window.document);
    
        if( true && module.exports){
            factory(__webpack_require__(3));
        } else if (true) {
            !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
                    __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
                    (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
                    __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else {}
    }(typeof window != 'undefined' ?
        window : 0, function(window, document, lazySizes) {
        'use strict';
    
        if(!window.addEventListener){return;}
    
        var regDescriptors = /\s+(\d+)(w|h)\s+(\d+)(w|h)/;
        var regCssFit = /parent-fit["']*\s*:\s*["']*(contain|cover|width)/;
        var regCssObject = /parent-container["']*\s*:\s*["']*(.+?)(?=(\s|$|,|'|"|;))/;
        var regPicture = /^picture$/i;
        var cfg = lazySizes.cfg;
    
        var getCSS = function (elem){
            return (getComputedStyle(elem, null) || {});
        };
    
        var parentFit = {
    
            getParent: function(element, parentSel){
                var parent = element;
                var parentNode = element.parentNode;
    
                if((!parentSel || parentSel == 'prev') && parentNode && regPicture.test(parentNode.nodeName || '')){
                    parentNode = parentNode.parentNode;
                }
    
                if(parentSel != 'self'){
                    if(parentSel == 'prev'){
                        parent = element.previousElementSibling;
                    } else if(parentSel && (parentNode.closest || window.jQuery)){
                        parent = (parentNode.closest ?
                                parentNode.closest(parentSel) :
                                jQuery(parentNode).closest(parentSel)[0]) ||
                            parentNode
                        ;
                    } else {
                        parent = parentNode;
                    }
                }
    
                return parent;
            },
    
            getFit: function(element){
                var tmpMatch, parentObj;
                var css = getCSS(element);
                var content = css.content || css.fontFamily;
                var obj = {
                    fit: element._lazysizesParentFit || element.getAttribute('data-parent-fit')
                };
    
                if(!obj.fit && content && (tmpMatch = content.match(regCssFit))){
                    obj.fit = tmpMatch[1];
                }
    
                if(obj.fit){
                    parentObj = element._lazysizesParentContainer || element.getAttribute('data-parent-container');
    
                    if(!parentObj && content && (tmpMatch = content.match(regCssObject))){
                        parentObj = tmpMatch[1];
                    }
    
                    obj.parent = parentFit.getParent(element, parentObj);
    
    
                } else {
                    obj.fit = css.objectFit;
                }
    
                return obj;
            },
    
            getImageRatio: function(element){
                var i, srcset, media, ratio, match, width, height;
                var parent = element.parentNode;
                var elements = parent && regPicture.test(parent.nodeName || '') ?
                        parent.querySelectorAll('source, img') :
                        [element]
                    ;
    
                for(i = 0; i < elements.length; i++){
                    element = elements[i];
                    srcset = element.getAttribute(cfg.srcsetAttr) || element.getAttribute('srcset') || element.getAttribute('data-pfsrcset') || element.getAttribute('data-risrcset') || '';
                    media = element._lsMedia || element.getAttribute('media');
                    media = cfg.customMedia[element.getAttribute('data-media') || media] || media;
    
                    if(srcset && (!media || (window.matchMedia && matchMedia(media) || {}).matches )){
                        ratio = parseFloat(element.getAttribute('data-aspectratio'));
    
                        if (!ratio) {
                            match = srcset.match(regDescriptors);
    
                            if (match) {
                                if(match[2] == 'w'){
                                    width = match[1];
                                    height = match[3];
                                } else {
                                    width = match[3];
                                    height = match[1];
                                }
                            } else {
                                width = element.getAttribute('width');
                                height = element.getAttribute('height');
                            }
    
                            ratio = width / height;
                        }
    
                        break;
                    }
                }
    
                return ratio;
            },
    
            calculateSize: function(element, width){
                var displayRatio, height, imageRatio, retWidth;
                var fitObj = this.getFit(element);
                var fit = fitObj.fit;
                var fitElem = fitObj.parent;
    
                if(fit != 'width' && ((fit != 'contain' && fit != 'cover') || !(imageRatio = this.getImageRatio(element)))){
                    return width;
                }
    
                if(fitElem){
                    width = fitElem.clientWidth;
                } else {
                    fitElem = element;
                }
    
                retWidth = width;
    
                if(fit == 'width'){
                    retWidth = width;
                } else {
                    height = fitElem.clientHeight;
    
                    if((displayRatio =  width / height) && ((fit == 'cover' && displayRatio < imageRatio) || (fit == 'contain' && displayRatio > imageRatio))){
                        retWidth = width * (imageRatio / displayRatio);
                    }
                }
    
                return retWidth;
            }
        };
    
        lazySizes.parentFit = parentFit;
    
        document.addEventListener('lazybeforesizes', function(e){
            if(e.defaultPrevented || e.detail.instance != lazySizes){return;}
    
            var element = e.target;
            e.detail.width = parentFit.calculateSize(element, e.detail.width);
        });
    }));
    
    
    /***/ }),
    /* 33 */
    /***/ (function(module, exports, __webpack_require__) {
    
    var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(window, factory) {
        var globalInstall = function(){
            factory(window.lazySizes);
            window.removeEventListener('lazyunveilread', globalInstall, true);
        };
    
        factory = factory.bind(null, window, window.document);
    
        if( true && module.exports){
            factory(__webpack_require__(3));
        } else if (true) {
            !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
                    __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
                    (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
                    __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else {}
    }(window, function(window, document, lazySizes) {
        /*jshint eqnull:true */
        'use strict';
    
        var config, riasCfg;
        var lazySizesCfg = lazySizes.cfg;
        var replaceTypes = {string: 1, number: 1};
        var regNumber = /^\-*\+*\d+\.*\d*$/;
        var regPicture = /^picture$/i;
        var regWidth = /\s*\{\s*width\s*\}\s*/i;
        var regHeight = /\s*\{\s*height\s*\}\s*/i;
        var regPlaceholder = /\s*\{\s*([a-z0-9]+)\s*\}\s*/ig;
        var regObj = /^\[.*\]|\{.*\}$/;
        var regAllowedSizes = /^(?:auto|\d+(px)?)$/;
        var anchor = document.createElement('a');
        var img = document.createElement('img');
        var buggySizes = ('srcset' in img) && !('sizes' in img);
        var supportPicture = !!window.HTMLPictureElement && !buggySizes;
    
        (function(){
            var prop;
            var noop = function(){};
            var riasDefaults = {
                prefix: '',
                postfix: '',
                srcAttr: 'data-src',
                absUrl: false,
                modifyOptions: noop,
                widthmap: {},
                ratio: false,
                traditionalRatio: false,
                aspectratio: false,
            };
    
            config = lazySizes && lazySizes.cfg;
    
            if(!config.supportsType){
                config.supportsType = function(type/*, elem*/){
                    return !type;
                };
            }
    
            if(!config.rias){
                config.rias = {};
            }
            riasCfg = config.rias;
    
            if(!('widths' in riasCfg)){
                riasCfg.widths = [];
                (function (widths){
                    var width;
                    var i = 0;
                    while(!width || width < 3000){
                        i += 5;
                        if(i > 30){
                            i += 1;
                        }
                        width = (36 * i);
                        widths.push(width);
                    }
                })(riasCfg.widths);
            }
    
            for(prop in riasDefaults){
                if(!(prop in riasCfg)){
                    riasCfg[prop] = riasDefaults[prop];
                }
            }
        })();
    
        function getElementOptions(elem, src){
            var attr, parent, setOption, options;
            var elemStyles = window.getComputedStyle(elem);
    
    
            parent = elem.parentNode;
            options = {
                isPicture: !!(parent && regPicture.test(parent.nodeName || ''))
            };
    
            setOption = function(attr, run){
                var attrVal = elem.getAttribute('data-'+ attr);
    
                if (!attrVal) {
                    // no data- attr, get value from the CSS
                    var styles = elemStyles.getPropertyValue('--ls-' + attr);
                    // at least Safari 9 returns null rather than
                    // an empty string for getPropertyValue causing
                    // .trim() to fail
                    if (styles) {
                        attrVal = styles.trim();
                    }
                }
    
                if (attrVal) {
                    if(attrVal == 'true'){
                        attrVal = true;
                    } else if(attrVal == 'false'){
                        attrVal = false;
                    } else if(regNumber.test(attrVal)){
                        attrVal = parseFloat(attrVal);
                    } else if(typeof riasCfg[attr] == 'function'){
                        attrVal = riasCfg[attr](elem, attrVal);
                    } else if(regObj.test(attrVal)){
                        try {
                            attrVal = JSON.parse(attrVal);
                        } catch(e){}
                    }
                    options[attr] = attrVal;
                } else if((attr in riasCfg) && typeof riasCfg[attr] != 'function'){
                    options[attr] = riasCfg[attr];
                } else if(run && typeof riasCfg[attr] == 'function'){
                    options[attr] = riasCfg[attr](elem, attrVal);
                }
            };
    
            for(attr in riasCfg){
                setOption(attr);
            }
            src.replace(regPlaceholder, function(full, match){
                if(!(match in options)){
                    setOption(match, true);
                }
            });
    
            return options;
        }
    
        function replaceUrlProps(url, options){
            var candidates = [];
            var replaceFn = function(full, match){
                return (replaceTypes[typeof options[match]]) ? options[match] : full;
            };
            candidates.srcset = [];
    
            if(options.absUrl){
                anchor.setAttribute('href', url);
                url = anchor.href;
            }
    
            url = ((options.prefix || '') + url + (options.postfix || '')).replace(regPlaceholder, replaceFn);
    
            options.widths.forEach(function(width){
                var widthAlias = options.widthmap[width] || width;
                var ratio = options.aspectratio || options.ratio;
                var traditionalRatio = !options.aspectratio && riasCfg.traditionalRatio;
                var candidate = {
                    u: url.replace(regWidth, widthAlias)
                            .replace(regHeight, ratio ?
                                traditionalRatio ?
                                    Math.round(width * ratio) :
                                    Math.round(width / ratio)
                                : ''),
                    w: width
                };
    
                candidates.push(candidate);
                candidates.srcset.push( (candidate.c = candidate.u + ' ' + width + 'w') );
            });
            return candidates;
        }
    
        function setSrc(src, opts, elem){
            var elemW = 0;
            var elemH = 0;
            var sizeElement = elem;
    
            if(!src){return;}
    
            if (opts.ratio === 'container') {
                // calculate image or parent ratio
                elemW = sizeElement.scrollWidth;
                elemH = sizeElement.scrollHeight;
    
                while ((!elemW || !elemH) && sizeElement !== document) {
                    sizeElement = sizeElement.parentNode;
                    elemW = sizeElement.scrollWidth;
                    elemH = sizeElement.scrollHeight;
                }
                if (elemW && elemH) {
                    opts.ratio = opts.traditionalRatio ? elemH / elemW : elemW / elemH;
                }
            }
    
            src = replaceUrlProps(src, opts);
    
            src.isPicture = opts.isPicture;
    
            if(buggySizes && elem.nodeName.toUpperCase() == 'IMG'){
                elem.removeAttribute(config.srcsetAttr);
            } else {
                elem.setAttribute(config.srcsetAttr, src.srcset.join(', '));
            }
    
            Object.defineProperty(elem, '_lazyrias', {
                value: src,
                writable: true
            });
        }
    
        function createAttrObject(elem, src){
            var opts = getElementOptions(elem, src);
    
            riasCfg.modifyOptions.call(elem, {target: elem, details: opts, detail: opts});
    
            lazySizes.fire(elem, 'lazyriasmodifyoptions', opts);
            return opts;
        }
    
        function getSrc(elem){
            return elem.getAttribute( elem.getAttribute('data-srcattr') || riasCfg.srcAttr ) || elem.getAttribute(config.srcsetAttr) || elem.getAttribute(config.srcAttr) || elem.getAttribute('data-pfsrcset') || '';
        }
    
        addEventListener('lazybeforesizes', function(e){
            if(e.detail.instance != lazySizes){return;}
    
            var elem, src, elemOpts, parent, sources, i, len, sourceSrc, sizes, detail, hasPlaceholder, modified, emptyList;
            elem = e.target;
    
            if(!e.detail.dataAttr || e.defaultPrevented || riasCfg.disabled || !((sizes = elem.getAttribute(config.sizesAttr) || elem.getAttribute('sizes')) && regAllowedSizes.test(sizes))){return;}
    
            src = getSrc(elem);
    
            elemOpts = createAttrObject(elem, src);
    
            hasPlaceholder = regWidth.test(elemOpts.prefix) || regWidth.test(elemOpts.postfix);
    
            if(elemOpts.isPicture && (parent = elem.parentNode)){
                sources = parent.getElementsByTagName('source');
                for(i = 0, len = sources.length; i < len; i++){
                    if ( hasPlaceholder || regWidth.test(sourceSrc = getSrc(sources[i])) ){
                        setSrc(sourceSrc, elemOpts, sources[i]);
                        modified = true;
                    }
                }
            }
    
            if ( hasPlaceholder || regWidth.test(src) ){
                setSrc(src, elemOpts, elem);
                modified = true;
            } else if (modified) {
                emptyList = [];
                emptyList.srcset = [];
                emptyList.isPicture = true;
                Object.defineProperty(elem, '_lazyrias', {
                    value: emptyList,
                    writable: true
                });
            }
    
            if(modified){
                if(supportPicture){
                    elem.removeAttribute(config.srcAttr);
                } else if(sizes != 'auto') {
                    detail = {
                        width: parseInt(sizes, 10)
                    };
                    polyfill({
                        target: elem,
                        detail: detail
                    });
                }
            }
        }, true);
        // partial polyfill
        var polyfill = (function(){
            var ascendingSort = function( a, b ) {
                return a.w - b.w;
            };
    
            var reduceCandidate = function (srces) {
                var lowerCandidate, bonusFactor;
                var len = srces.length;
                var candidate = srces[len -1];
                var i = 0;
    
                for(i; i < len;i++){
                    candidate = srces[i];
                    candidate.d = candidate.w / srces.w;
                    if(candidate.d >= srces.d){
                        if(!candidate.cached && (lowerCandidate = srces[i - 1]) &&
                            lowerCandidate.d > srces.d - (0.13 * Math.pow(srces.d, 2.2))){
    
                            bonusFactor = Math.pow(lowerCandidate.d - 0.6, 1.6);
    
                            if(lowerCandidate.cached) {
                                lowerCandidate.d += 0.15 * bonusFactor;
                            }
    
                            if(lowerCandidate.d + ((candidate.d - srces.d) * bonusFactor) > srces.d){
                                candidate = lowerCandidate;
                            }
                        }
                        break;
                    }
                }
                return candidate;
            };
    
            var getWSet = function(elem, testPicture){
                var src;
                if(!elem._lazyrias && lazySizes.pWS && (src = lazySizes.pWS(elem.getAttribute(config.srcsetAttr || ''))).length){
                    Object.defineProperty(elem, '_lazyrias', {
                        value: src,
                        writable: true
                    });
                    if(testPicture && elem.parentNode){
                        src.isPicture = elem.parentNode.nodeName.toUpperCase() == 'PICTURE';
                    }
                }
                return elem._lazyrias;
            };
    
            var getX = function(elem){
                var dpr = window.devicePixelRatio || 1;
                var optimum = lazySizes.getX && lazySizes.getX(elem);
                return Math.min(optimum || dpr, 2.4, dpr);
            };
    
            var getCandidate = function(elem, width){
                var sources, i, len, media, srces, src;
    
                srces = elem._lazyrias;
    
                if(srces.isPicture && window.matchMedia){
                    for(i = 0, sources = elem.parentNode.getElementsByTagName('source'), len = sources.length; i < len; i++){
                        if(getWSet(sources[i]) && !sources[i].getAttribute('type') && ( !(media = sources[i].getAttribute('media')) || ((matchMedia(media) || {}).matches))){
                            srces = sources[i]._lazyrias;
                            break;
                        }
                    }
                }
    
                if(!srces.w || srces.w < width){
                    srces.w = width;
                    srces.d = getX(elem);
                    src = reduceCandidate(srces.sort(ascendingSort));
                }
    
                return src;
            };
    
            var polyfill = function(e){
                if(e.detail.instance != lazySizes){return;}
    
                var candidate;
                var elem = e.target;
    
                if(!buggySizes && (window.respimage || window.picturefill || lazySizesCfg.pf)){
                    document.removeEventListener('lazybeforesizes', polyfill);
                    return;
                }
    
                if(!('_lazyrias' in elem) && (!e.detail.dataAttr || !getWSet(elem, true))){
                    return;
                }
    
                candidate = getCandidate(elem, e.detail.width);
    
                if(candidate && candidate.u && elem._lazyrias.cur != candidate.u){
                    elem._lazyrias.cur = candidate.u;
                    candidate.cached = true;
                    lazySizes.rAF(function(){
                        elem.setAttribute(config.srcAttr, candidate.u);
                        elem.setAttribute('src', candidate.u);
                    });
                }
            };
    
            if(!supportPicture){
                addEventListener('lazybeforesizes', polyfill);
            } else {
                polyfill = function(){};
            }
    
            return polyfill;
    
        })();
    
    }));
    
    
    /***/ }),
    /* 34 */
    /***/ (function(module, exports, __webpack_require__) {
    
    var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(window, factory) {
        var globalInstall = function(){
            factory(window.lazySizes);
            window.removeEventListener('lazyunveilread', globalInstall, true);
        };
    
        factory = factory.bind(null, window, window.document);
    
        if( true && module.exports){
            factory(__webpack_require__(3));
        } else if (true) {
            !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
                    __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
                    (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
                    __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else {}
    }(window, function(window, document, lazySizes) {
        'use strict';
        if(!window.addEventListener){return;}
    
        var lazySizesCfg = lazySizes.cfg;
        var regWhite = /\s+/g;
        var regSplitSet = /\s*\|\s+|\s+\|\s*/g;
        var regSource = /^(.+?)(?:\s+\[\s*(.+?)\s*\])(?:\s+\[\s*(.+?)\s*\])?$/;
        var regType = /^\s*\(*\s*type\s*:\s*(.+?)\s*\)*\s*$/;
        var regBgUrlEscape = /\(|\)|'/;
        var allowedBackgroundSize = {contain: 1, cover: 1};
        var proxyWidth = function(elem){
            var width = lazySizes.gW(elem, elem.parentNode);
    
            if(!elem._lazysizesWidth || width > elem._lazysizesWidth){
                elem._lazysizesWidth = width;
            }
            return elem._lazysizesWidth;
        };
        var getBgSize = function(elem){
            var bgSize;
    
            bgSize = (getComputedStyle(elem) || {getPropertyValue: function(){}}).getPropertyValue('background-size');
    
            if(!allowedBackgroundSize[bgSize] && allowedBackgroundSize[elem.style.backgroundSize]){
                bgSize = elem.style.backgroundSize;
            }
    
            return bgSize;
        };
        var setTypeOrMedia = function(source, match){
            if(match){
                var typeMatch = match.match(regType);
                if(typeMatch && typeMatch[1]){
                    source.setAttribute('type', typeMatch[1]);
                } else {
                    source.setAttribute('media', lazySizesCfg.customMedia[match] || match);
                }
            }
        };
        var createPicture = function(sets, elem, img){
            var picture = document.createElement('picture');
            var sizes = elem.getAttribute(lazySizesCfg.sizesAttr);
            var ratio = elem.getAttribute('data-ratio');
            var optimumx = elem.getAttribute('data-optimumx');
    
            if(elem._lazybgset && elem._lazybgset.parentNode == elem){
                elem.removeChild(elem._lazybgset);
            }
    
            Object.defineProperty(img, '_lazybgset', {
                value: elem,
                writable: true
            });
            Object.defineProperty(elem, '_lazybgset', {
                value: picture,
                writable: true
            });
    
            sets = sets.replace(regWhite, ' ').split(regSplitSet);
    
            picture.style.display = 'none';
            img.className = lazySizesCfg.lazyClass;
    
            if(sets.length == 1 && !sizes){
                sizes = 'auto';
            }
    
            sets.forEach(function(set){
                var match;
                var source = document.createElement('source');
    
                if(sizes && sizes != 'auto'){
                    source.setAttribute('sizes', sizes);
                }
    
                if((match = set.match(regSource))){
                    source.setAttribute(lazySizesCfg.srcsetAttr, match[1]);
    
                    setTypeOrMedia(source, match[2]);
                    setTypeOrMedia(source, match[3]);
                } else {
                    source.setAttribute(lazySizesCfg.srcsetAttr, set);
                }
    
                picture.appendChild(source);
            });
    
            if(sizes){
                img.setAttribute(lazySizesCfg.sizesAttr, sizes);
                elem.removeAttribute(lazySizesCfg.sizesAttr);
                elem.removeAttribute('sizes');
            }
            if(optimumx){
                img.setAttribute('data-optimumx', optimumx);
            }
            if(ratio) {
                img.setAttribute('data-ratio', ratio);
            }
    
            picture.appendChild(img);
    
            elem.appendChild(picture);
        };
    
        var proxyLoad = function(e){
            if(!e.target._lazybgset){return;}
    
            var image = e.target;
            var elem = image._lazybgset;
            var bg = image.currentSrc || image.src;
    
    
            if(bg){
                var event = lazySizes.fire(elem, 'bgsetproxy', {
                    src: bg,
                    useSrc: regBgUrlEscape.test(bg) ? JSON.stringify(bg) : bg,
                });
    
                if(!event.defaultPrevented){
                    elem.style.backgroundImage = 'url(' + event.detail.useSrc + ')';
                }
            }
    
            if(image._lazybgsetLoading){
                lazySizes.fire(elem, '_lazyloaded', {}, false, true);
                delete image._lazybgsetLoading;
            }
        };
    
        addEventListener('lazybeforeunveil', function(e){
            var set, image, elem;
    
            if(e.defaultPrevented || !(set = e.target.getAttribute('data-bgset'))){return;}
    
            elem = e.target;
            image = document.createElement('img');
    
            image.alt = '';
    
            image._lazybgsetLoading = true;
            e.detail.firesLoad = true;
    
            createPicture(set, elem, image);
    
            setTimeout(function(){
                lazySizes.loader.unveil(image);
    
                lazySizes.rAF(function(){
                    lazySizes.fire(image, '_lazyloaded', {}, true, true);
                    if(image.complete) {
                        proxyLoad({target: image});
                    }
                });
            });
    
        });
    
        document.addEventListener('load', proxyLoad, true);
    
        window.addEventListener('lazybeforesizes', function(e){
            if(e.detail.instance != lazySizes){return;}
            if(e.target._lazybgset && e.detail.dataAttr){
                var elem = e.target._lazybgset;
                var bgSize = getBgSize(elem);
    
                if(allowedBackgroundSize[bgSize]){
                    e.target._lazysizesParentFit = bgSize;
    
                    lazySizes.rAF(function(){
                        e.target.setAttribute('data-parent-fit', bgSize);
                        if(e.target._lazysizesParentFit){
                            delete e.target._lazysizesParentFit;
                        }
                    });
                }
            }
        }, true);
    
        document.documentElement.addEventListener('lazybeforesizes', function(e){
            if(e.defaultPrevented || !e.target._lazybgset || e.detail.instance != lazySizes){return;}
            e.detail.width = proxyWidth(e.target._lazybgset);
        });
    }));
    
    
    /***/ }),
    /* 35 */
    /***/ (function(module, exports, __webpack_require__) {
    
    var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(window, factory) {
        if(!window) {return;}
        var globalInstall = function(){
            factory(window.lazySizes);
            window.removeEventListener('lazyunveilread', globalInstall, true);
        };
    
        factory = factory.bind(null, window, window.document);
    
        if( true && module.exports){
            factory(__webpack_require__(3));
        } else if (true) {
            !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
                    __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
                    (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
                    __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else {}
    }(typeof window != 'undefined' ?
        window : 0, function(window, document, lazySizes) {
        /*jshint eqnull:true */
        'use strict';
        var polyfill;
        var lazySizesCfg = lazySizes.cfg;
        var img = document.createElement('img');
        var supportSrcset = ('sizes' in img) && ('srcset' in img);
        var regHDesc = /\s+\d+h/g;
        var fixEdgeHDescriptor = (function(){
            var regDescriptors = /\s+(\d+)(w|h)\s+(\d+)(w|h)/;
            var forEach = Array.prototype.forEach;
    
            return function(){
                var img = document.createElement('img');
                var removeHDescriptors = function(source){
                    var ratio, match;
                    var srcset = source.getAttribute(lazySizesCfg.srcsetAttr);
                    if(srcset){
                        if((match = srcset.match(regDescriptors))){
                            if(match[2] == 'w'){
                                ratio = match[1] / match[3];
                            } else {
                                ratio = match[3] / match[1];
                            }
    
                            if(ratio){
                                source.setAttribute('data-aspectratio', ratio);
                            }
                            source.setAttribute(lazySizesCfg.srcsetAttr, srcset.replace(regHDesc, ''));
                        }
                    }
                };
                var handler = function(e){
                    if(e.detail.instance != lazySizes){return;}
                    var picture = e.target.parentNode;
    
                    if(picture && picture.nodeName == 'PICTURE'){
                        forEach.call(picture.getElementsByTagName('source'), removeHDescriptors);
                    }
                    removeHDescriptors(e.target);
                };
    
                var test = function(){
                    if(!!img.currentSrc){
                        document.removeEventListener('lazybeforeunveil', handler);
                    }
                };
    
                document.addEventListener('lazybeforeunveil', handler);
    
                img.onload = test;
                img.onerror = test;
    
                img.srcset = 'data:,a 1w 1h';
    
                if(img.complete){
                    test();
                }
            };
        })();
    
        if(!lazySizesCfg.supportsType){
            lazySizesCfg.supportsType = function(type/*, elem*/){
                return !type;
            };
        }
    
        if (window.HTMLPictureElement && supportSrcset) {
            if(!lazySizes.hasHDescriptorFix && document.msElementsFromPoint){
                lazySizes.hasHDescriptorFix = true;
                fixEdgeHDescriptor();
            }
            return;
        }
    
        if(window.picturefill || lazySizesCfg.pf){return;}
    
        lazySizesCfg.pf = function(options){
            var i, len;
            if(window.picturefill){return;}
            for(i = 0, len = options.elements.length; i < len; i++){
                polyfill(options.elements[i]);
            }
        };
    
        // partial polyfill
        polyfill = (function(){
            var ascendingSort = function( a, b ) {
                return a.w - b.w;
            };
            var regPxLength = /^\s*\d+\.*\d*px\s*$/;
            var reduceCandidate = function (srces) {
                var lowerCandidate, bonusFactor;
                var len = srces.length;
                var candidate = srces[len -1];
                var i = 0;
    
                for(i; i < len;i++){
                    candidate = srces[i];
                    candidate.d = candidate.w / srces.w;
    
                    if(candidate.d >= srces.d){
                        if(!candidate.cached && (lowerCandidate = srces[i - 1]) &&
                            lowerCandidate.d > srces.d - (0.13 * Math.pow(srces.d, 2.2))){
    
                            bonusFactor = Math.pow(lowerCandidate.d - 0.6, 1.6);
    
                            if(lowerCandidate.cached) {
                                lowerCandidate.d += 0.15 * bonusFactor;
                            }
    
                            if(lowerCandidate.d + ((candidate.d - srces.d) * bonusFactor) > srces.d){
                                candidate = lowerCandidate;
                            }
                        }
                        break;
                    }
                }
                return candidate;
            };
    
            var parseWsrcset = (function(){
                var candidates;
                var regWCandidates = /(([^,\s].[^\s]+)\s+(\d+)w)/g;
                var regMultiple = /\s/;
                var addCandidate = function(match, candidate, url, wDescriptor){
                    candidates.push({
                        c: candidate,
                        u: url,
                        w: wDescriptor * 1
                    });
                };
    
                return function(input){
                    candidates = [];
                    input = input.trim();
                    input
                        .replace(regHDesc, '')
                        .replace(regWCandidates, addCandidate)
                    ;
    
                    if(!candidates.length && input && !regMultiple.test(input)){
                        candidates.push({
                            c: input,
                            u: input,
                            w: 99
                        });
                    }
    
                    return candidates;
                };
            })();
    
            var runMatchMedia = function(){
                if(runMatchMedia.init){return;}
    
                runMatchMedia.init = true;
                addEventListener('resize', (function(){
                    var timer;
                    var matchMediaElems = document.getElementsByClassName('lazymatchmedia');
                    var run = function(){
                        var i, len;
                        for(i = 0, len = matchMediaElems.length; i < len; i++){
                            polyfill(matchMediaElems[i]);
                        }
                    };
    
                    return function(){
                        clearTimeout(timer);
                        timer = setTimeout(run, 66);
                    };
                })());
            };
    
            var createSrcset = function(elem, isImage){
                var parsedSet;
                var srcSet = elem.getAttribute('srcset') || elem.getAttribute(lazySizesCfg.srcsetAttr);
    
                if(!srcSet && isImage){
                    srcSet = !elem._lazypolyfill ?
                        (elem.getAttribute(lazySizesCfg.srcAttr) || elem.getAttribute('src')) :
                        elem._lazypolyfill._set
                    ;
                }
    
                if(!elem._lazypolyfill || elem._lazypolyfill._set != srcSet){
    
                    parsedSet = parseWsrcset( srcSet || '' );
                    if(isImage && elem.parentNode){
                        parsedSet.isPicture = elem.parentNode.nodeName.toUpperCase() == 'PICTURE';
    
                        if(parsedSet.isPicture){
                            if(window.matchMedia){
                                lazySizes.aC(elem, 'lazymatchmedia');
                                runMatchMedia();
                            }
                        }
                    }
    
                    parsedSet._set = srcSet;
                    Object.defineProperty(elem, '_lazypolyfill', {
                        value: parsedSet,
                        writable: true
                    });
                }
            };
    
            var getX = function(elem){
                var dpr = window.devicePixelRatio || 1;
                var optimum = lazySizes.getX && lazySizes.getX(elem);
                return Math.min(optimum || dpr, 2.5, dpr);
            };
    
            var matchesMedia = function(media){
                if(window.matchMedia){
                    matchesMedia = function(media){
                        return !media || (matchMedia(media) || {}).matches;
                    };
                } else {
                    return !media;
                }
    
                return matchesMedia(media);
            };
    
            var getCandidate = function(elem){
                var sources, i, len, media, source, srces, src, width;
    
                source = elem;
                createSrcset(source, true);
                srces = source._lazypolyfill;
    
                if(srces.isPicture){
                    for(i = 0, sources = elem.parentNode.getElementsByTagName('source'), len = sources.length; i < len; i++){
                        if( lazySizesCfg.supportsType(sources[i].getAttribute('type'), elem) && matchesMedia( sources[i].getAttribute('media')) ){
                            source = sources[i];
                            createSrcset(source);
                            srces = source._lazypolyfill;
                            break;
                        }
                    }
                }
    
                if(srces.length > 1){
                    width = source.getAttribute('sizes') || '';
                    width = regPxLength.test(width) && parseInt(width, 10) || lazySizes.gW(elem, elem.parentNode);
                    srces.d = getX(elem);
                    if(!srces.src || !srces.w || srces.w < width){
                        srces.w = width;
                        src = reduceCandidate(srces.sort(ascendingSort));
                        srces.src = src;
                    } else {
                        src = srces.src;
                    }
                } else {
                    src = srces[0];
                }
    
                return src;
            };
    
            var p = function(elem){
                if(supportSrcset && elem.parentNode && elem.parentNode.nodeName.toUpperCase() != 'PICTURE'){return;}
                var candidate = getCandidate(elem);
    
                if(candidate && candidate.u && elem._lazypolyfill.cur != candidate.u){
                    elem._lazypolyfill.cur = candidate.u;
                    candidate.cached = true;
                    elem.setAttribute(lazySizesCfg.srcAttr, candidate.u);
                    elem.setAttribute('src', candidate.u);
                }
            };
    
            p.parse = parseWsrcset;
    
            return p;
        })();
    
        if(lazySizesCfg.loadedClass && lazySizesCfg.loadingClass){
            (function(){
                var sels = [];
                ['img[sizes$="px"][srcset].', 'picture > img:not([srcset]).'].forEach(function(sel){
                    sels.push(sel + lazySizesCfg.loadedClass);
                    sels.push(sel + lazySizesCfg.loadingClass);
                });
                lazySizesCfg.pf({
                    elements: document.querySelectorAll(sels.join(', '))
                });
            })();
    
        }
    }));
    
    
    /***/ }),
    /* 36 */
    /***/ (function(module, exports, __webpack_require__) {
    
    var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
     * matchesSelector v2.0.2
     * matchesSelector( element, '.selector' )
     * MIT license
     */
    
    /*jshint browser: true, strict: true, undef: true, unused: true */
    
    ( function( window, factory ) {
      /*global define: false, module: false */
      'use strict';
      // universal module definition
      if ( true ) {
        // AMD
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
                    __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
                    (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
                    __WEBPACK_AMD_DEFINE_FACTORY__),
                    __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
      } else {}
    
    }( window, function factory() {
      'use strict';
    
      var matchesMethod = ( function() {
        var ElemProto = window.Element.prototype;
        // check for the standard method name first
        if ( ElemProto.matches ) {
          return 'matches';
        }
        // check un-prefixed
        if ( ElemProto.matchesSelector ) {
          return 'matchesSelector';
        }
        // check vendor prefixes
        var prefixes = [ 'webkit', 'moz', 'ms', 'o' ];
    
        for ( var i=0; i < prefixes.length; i++ ) {
          var prefix = prefixes[i];
          var method = prefix + 'MatchesSelector';
          if ( ElemProto[ method ] ) {
            return method;
          }
        }
      })();
    
      return function matchesSelector( elem, selector ) {
        return elem[ matchesMethod ]( selector );
      };
    
    }));
    
    
    /***/ }),
    /* 37 */
    /***/ (function(module, exports, __webpack_require__) {
    
    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Flickity.Cell
    ( function( window, factory ) {
      // universal module definition
      if ( true ) {
        // AMD
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
          __webpack_require__(18),
        ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( getSize ) {
          return factory( window, getSize );
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
                    __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
      } else {}
    
    }( window, function factory( window, getSize ) {
    
    'use strict';
    
    function Cell( elem, parent ) {
      this.element = elem;
      this.parent = parent;
    
      this.create();
    }
    
    var proto = Cell.prototype;
    
    proto.create = function() {
      this.element.style.position = 'absolute';
      this.element.setAttribute( 'aria-hidden', 'true' );
      this.x = 0;
      this.shift = 0;
    };
    
    proto.destroy = function() {
      // reset style
      this.unselect();
      this.element.style.position = '';
      var side = this.parent.originSide;
      this.element.style[ side ] = '';
      this.element.removeAttribute('aria-hidden');
    };
    
    proto.getSize = function() {
      this.size = getSize( this.element );
    };
    
    proto.setPosition = function( x ) {
      this.x = x;
      this.updateTarget();
      this.renderPosition( x );
    };
    
    // setDefaultTarget v1 method, backwards compatibility, remove in v3
    proto.updateTarget = proto.setDefaultTarget = function() {
      var marginProperty = this.parent.originSide == 'left' ? 'marginLeft' : 'marginRight';
      this.target = this.x + this.size[ marginProperty ] +
        this.size.width * this.parent.cellAlign;
    };
    
    proto.renderPosition = function( x ) {
      // render position of cell with in slider
      var side = this.parent.originSide;
      this.element.style[ side ] = this.parent.getPositionValue( x );
    };
    
    proto.select = function() {
      this.element.classList.add('is-selected');
      this.element.removeAttribute('aria-hidden');
    };
    
    proto.unselect = function() {
      this.element.classList.remove('is-selected');
      this.element.setAttribute( 'aria-hidden', 'true' );
    };
    
    /**
     * @param {Integer} shift - 0, 1, or -1
     */
    proto.wrapShift = function( shift ) {
      this.shift = shift;
      this.renderPosition( this.x + this.parent.slideableWidth * shift );
    };
    
    proto.remove = function() {
      this.element.parentNode.removeChild( this.element );
    };
    
    return Cell;
    
    } ) );
    
    
    /***/ }),
    /* 38 */
    /***/ (function(module, exports, __webpack_require__) {
    
    var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;// slide
    ( function( window, factory ) {
      // universal module definition
      if ( true ) {
        // AMD
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
                    __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
                    (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
                    __WEBPACK_AMD_DEFINE_FACTORY__),
                    __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
      } else {}
    
    }( window, function factory() {
    'use strict';
    
    function Slide( parent ) {
      this.parent = parent;
      this.isOriginLeft = parent.originSide == 'left';
      this.cells = [];
      this.outerWidth = 0;
      this.height = 0;
    }
    
    var proto = Slide.prototype;
    
    proto.addCell = function( cell ) {
      this.cells.push( cell );
      this.outerWidth += cell.size.outerWidth;
      this.height = Math.max( cell.size.outerHeight, this.height );
      // first cell stuff
      if ( this.cells.length == 1 ) {
        this.x = cell.x; // x comes from first cell
        var beginMargin = this.isOriginLeft ? 'marginLeft' : 'marginRight';
        this.firstMargin = cell.size[ beginMargin ];
      }
    };
    
    proto.updateTarget = function() {
      var endMargin = this.isOriginLeft ? 'marginRight' : 'marginLeft';
      var lastCell = this.getLastCell();
      var lastMargin = lastCell ? lastCell.size[ endMargin ] : 0;
      var slideWidth = this.outerWidth - ( this.firstMargin + lastMargin );
      this.target = this.x + this.firstMargin + slideWidth * this.parent.cellAlign;
    };
    
    proto.getLastCell = function() {
      return this.cells[ this.cells.length - 1 ];
    };
    
    proto.select = function() {
      this.parent.checkVisibility();
      
      this.cells.forEach( function( cell ) {
        cell.select();
      } );
    };
    
    proto.unselect = function() {
      this.cells.forEach( function( cell ) {
        cell.unselect();
      } );
    };
    
    proto.getCellElements = function() {
      return this.cells.map( function( cell ) {
        return cell.element;
      } );
    };
    
    return Slide;
    
    } ) );
    
    
    /***/ }),
    /* 39 */
    /***/ (function(module, exports, __webpack_require__) {
    
    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// animate
    ( function( window, factory ) {
      // universal module definition
      if ( true ) {
        // AMD
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
          __webpack_require__(4),
        ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( utils ) {
          return factory( window, utils );
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
                    __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
      } else {}
    
    }( window, function factory( window, utils ) {
    
    'use strict';
    
    // -------------------------- animate -------------------------- //
    
    var proto = {};
    
    proto.startAnimation = function() {
      if ( this.isAnimating ) {
        return;
      }
    
      this.isAnimating = true;
      this.restingFrames = 0;
      this.animate();
    };
    
    proto.animate = function() {
      this.applyDragForce();
      this.applySelectedAttraction();
    
      var previousX = this.x;
    
      this.integratePhysics();
      this.positionSlider();
      this.settle( previousX );
      // animate next frame
      if ( this.isAnimating ) {
        var _this = this;
        requestAnimationFrame( function animateFrame() {
          _this.animate();
        } );
      }
    };
    
    proto.positionSlider = function() {
      var x = this.x;
      // wrap position around
      if ( this.options.wrapAround && this.cells.length > 1 ) {
        x = utils.modulo( x, this.slideableWidth );
        x -= this.slideableWidth;
        this.shiftWrapCells( x );
      }
    
      this.setTranslateX( x, this.isAnimating );
      this.dispatchScrollEvent();
    };
    
    proto.setTranslateX = function( x, is3d ) {
      x += this.cursorPosition;
      // reverse if right-to-left and using transform
      x = this.options.rightToLeft ? -x : x;
      var translateX = this.getPositionValue( x );
      // use 3D transforms for hardware acceleration on iOS
      // but use 2D when settled, for better font-rendering
      this.slider.style.transform = is3d ?
        'translate3d(' + translateX + ',0,0)' : 'translateX(' + translateX + ')';
    };
    
    proto.dispatchScrollEvent = function() {
      var firstSlide = this.slides[0];
      if ( !firstSlide ) {
        return;
      }
      var positionX = -this.x - firstSlide.target;
      var progress = positionX / this.slidesWidth;
      this.dispatchEvent( 'scroll', null, [ progress, positionX ] );
    };
    
    proto.positionSliderAtSelected = function() {
      if ( !this.cells.length ) {
        return;
      }
      this.x = -this.selectedSlide.target;
      this.velocity = 0; // stop wobble
      this.positionSlider();
    };
    
    proto.getPositionValue = function( position ) {
      if ( this.options.percentPosition ) {
        // percent position, round to 2 digits, like 12.34%
        return ( Math.round( ( position / this.size.innerWidth ) * 10000 ) * 0.01 ) + '%';
      } else {
        // pixel positioning
        return Math.round( position ) + 'px';
      }
    };
    
    proto.settle = function( previousX ) {
      // keep track of frames where x hasn't moved
      var isResting = !this.isPointerDown &&
          Math.round( this.x * 100 ) == Math.round( previousX * 100 );
      if ( isResting ) {
        this.restingFrames++;
      }
      // stop animating if resting for 3 or more frames
      if ( this.restingFrames > 2 ) {
        this.isAnimating = false;
        delete this.isFreeScrolling;
        // render position with translateX when settled
        this.positionSlider();
        this.dispatchEvent( 'settle', null, [ this.selectedIndex ] );
      }
    
      this.checkVisibility();
    };
    
    proto.shiftWrapCells = function( x ) {
      // shift before cells
      var beforeGap = this.cursorPosition + x;
      this._shiftCells( this.beforeShiftCells, beforeGap, -1 );
      // shift after cells
      var afterGap = this.size.innerWidth - ( x + this.slideableWidth + this.cursorPosition );
      this._shiftCells( this.afterShiftCells, afterGap, 1 );
    };
    
    proto._shiftCells = function( cells, gap, shift ) {
      for ( var i = 0; i < cells.length; i++ ) {
        var cell = cells[i];
        var cellShift = gap > 0 ? shift : 0;
        cell.wrapShift( cellShift );
        gap -= cell.size.outerWidth;
      }
    };
    
    proto._unshiftCells = function( cells ) {
      if ( !cells || !cells.length ) {
        return;
      }
      for ( var i = 0; i < cells.length; i++ ) {
        cells[i].wrapShift( 0 );
      }
    };
    
    // -------------------------- physics -------------------------- //
    
    proto.integratePhysics = function() {
      this.x += this.velocity;
      this.velocity *= this.getFrictionFactor();
    };
    
    proto.applyForce = function( force ) {
      this.velocity += force;
    };
    
    proto.getFrictionFactor = function() {
      return 1 - this.options[ this.isFreeScrolling ? 'freeScrollFriction' : 'friction' ];
    };
    
    proto.getRestingPosition = function() {
      // my thanks to Steven Wittens, who simplified this math greatly
      return this.x + this.velocity / ( 1 - this.getFrictionFactor() );
    };
    
    proto.applyDragForce = function() {
      if ( !this.isDraggable || !this.isPointerDown ) {
        return;
      }
      // change the position to drag position by applying force
      var dragVelocity = this.dragX - this.x;
      var dragForce = dragVelocity - this.velocity;
      this.applyForce( dragForce );
    };
    
    proto.applySelectedAttraction = function() {
      // do not attract if pointer down or no slides
      var dragDown = this.isDraggable && this.isPointerDown;
      if ( dragDown || this.isFreeScrolling || !this.slides.length ) {
        return;
      }
      var distance = this.selectedSlide.target * -1 - this.x;
      var force = distance * this.options.selectedAttraction;
      this.applyForce( force );
    };
    
    return proto;
    
    } ) );
    
    
    /***/ }),
    /* 40 */
    /***/ (function(module, exports, __webpack_require__) {
    
    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// drag
    ( function( window, factory ) {
      // universal module definition
      if ( true ) {
        // AMD
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
          __webpack_require__(6),
          __webpack_require__(41),
          __webpack_require__(4),
        ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( Flickity, Unidragger, utils ) {
          return factory( window, Flickity, Unidragger, utils );
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
                    __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
      } else {}
    
    }( window, function factory( window, Flickity, Unidragger, utils ) {
    
    'use strict';
    
    // ----- defaults ----- //
    
    utils.extend( Flickity.defaults, {
      draggable: '>1',
      dragThreshold: 3,
    } );
    
    // ----- create ----- //
    
    Flickity.createMethods.push('_createDrag');
    
    // -------------------------- drag prototype -------------------------- //
    
    var proto = Flickity.prototype;
    utils.extend( proto, Unidragger.prototype );
    proto._touchActionValue = 'pan-y';
    
    // --------------------------  -------------------------- //
    
    var isTouch = 'createTouch' in document;
    var isTouchmoveScrollCanceled = false;
    
    proto._createDrag = function() {
      this.on( 'activate', this.onActivateDrag );
      this.on( 'uiChange', this._uiChangeDrag );
      this.on( 'deactivate', this.onDeactivateDrag );
      this.on( 'cellChange', this.updateDraggable );
      // TODO updateDraggable on resize? if groupCells & slides change
      // HACK - add seemingly innocuous handler to fix iOS 10 scroll behavior
      // #457, RubaXa/Sortable#973
      if ( isTouch && !isTouchmoveScrollCanceled ) {
        window.addEventListener( 'touchmove', function() {} );
        isTouchmoveScrollCanceled = true;
      }
    };
    
    proto.onActivateDrag = function() {
      this.handles = [ this.viewport ];
      this.bindHandles();
      this.updateDraggable();
    };
    
    proto.onDeactivateDrag = function() {
      this.unbindHandles();
      this.element.classList.remove('is-draggable');
    };
    
    proto.updateDraggable = function() {
      // disable dragging if less than 2 slides. #278
      if ( this.options.draggable == '>1' ) {
        this.isDraggable = this.slides.length > 1;
      } else if (this.options.draggable === 'onOverflow') {
        this.isDraggable = this.viewport.scrollWidth > this.viewport.offsetWidth;
      } else {
        this.isDraggable = this.options.draggable;
      }
      if ( this.isDraggable ) {
        this.element.classList.add('is-draggable');
      } else {
        this.element.classList.remove('is-draggable');
      }
    };
    
    // backwards compatibility
    proto.bindDrag = function() {
      this.options.draggable = true;
      this.updateDraggable();
    };
    
    proto.unbindDrag = function() {
      this.options.draggable = false;
      this.updateDraggable();
    };
    
    proto._uiChangeDrag = function() {
      delete this.isFreeScrolling;
    };
    
    // -------------------------- pointer events -------------------------- //
    
    proto.pointerDown = function( event, pointer ) {
      if ( !this.isDraggable ) {
        this._pointerDownDefault( event, pointer );
        return;
      }
      var isOkay = this.okayPointerDown( event );
      if ( !isOkay ) {
        return;
      }
    
      this._pointerDownPreventDefault( event );
      this.pointerDownFocus( event );
      // blur
      if ( document.activeElement != this.element ) {
        // do not blur if already focused
        this.pointerDownBlur();
      }
    
      // stop if it was moving
      this.dragX = this.x;
      this.viewport.classList.add('is-pointer-down');
      // track scrolling
      this.pointerDownScroll = getScrollPosition();
      window.addEventListener( 'scroll', this );
    
      this._pointerDownDefault( event, pointer );
    };
    
    // default pointerDown logic, used for staticClick
    proto._pointerDownDefault = function( event, pointer ) {
      // track start event position
      // Safari 9 overrides pageX and pageY. These values needs to be copied. #779
      this.pointerDownPointer = {
        pageX: pointer.pageX,
        pageY: pointer.pageY,
      };
      // bind move and end events
      this._bindPostStartEvents( event );
      this.dispatchEvent( 'pointerDown', event, [ pointer ] );
    };
    
    var focusNodes = {
      INPUT: true,
      TEXTAREA: true,
      SELECT: true,
    };
    
    proto.pointerDownFocus = function( event ) {
      var isFocusNode = focusNodes[ event.target.nodeName ];
      if ( !isFocusNode ) {
        this.focus();
      }
    };
    
    proto._pointerDownPreventDefault = function( event ) {
      var isTouchStart = event.type == 'touchstart';
      var isTouchPointer = event.pointerType == 'touch';
      var isFocusNode = focusNodes[ event.target.nodeName ];
      if ( !isTouchStart && !isTouchPointer && !isFocusNode ) {
        event.preventDefault();
      }
    };
    
    // ----- move ----- //
    
    proto.hasDragStarted = function( moveVector ) {
      return Math.abs( moveVector.x ) > this.options.dragThreshold;
    };
    
    // ----- up ----- //
    
    proto.pointerUp = function( event, pointer ) {
      delete this.isTouchScrolling;
      this.viewport.classList.remove('is-pointer-down');
      this.dispatchEvent( 'pointerUp', event, [ pointer ] );
      this._dragPointerUp( event, pointer );
    };
    
    proto.pointerDone = function() {
      window.removeEventListener( 'scroll', this );
      delete this.pointerDownScroll;
    };
    
    // -------------------------- dragging -------------------------- //
    
    proto.dragStart = function( event, pointer ) {
      if ( !this.isDraggable ) {
        return;
      }
      this.dragStartPosition = this.x;
      this.startAnimation();
      window.removeEventListener( 'scroll', this );
      this.dispatchEvent( 'dragStart', event, [ pointer ] );
    };
    
    proto.pointerMove = function( event, pointer ) {
      var moveVector = this._dragPointerMove( event, pointer );
      this.dispatchEvent( 'pointerMove', event, [ pointer, moveVector ] );
      this._dragMove( event, pointer, moveVector );
    };
    
    proto.dragMove = function( event, pointer, moveVector ) {
      if ( !this.isDraggable ) {
        return;
      }
      event.preventDefault();
    
      this.previousDragX = this.dragX;
      // reverse if right-to-left
      var direction = this.options.rightToLeft ? -1 : 1;
      if ( this.options.wrapAround ) {
        // wrap around move. #589
        moveVector.x %= this.slideableWidth;
      }
      var dragX = this.dragStartPosition + moveVector.x * direction;
    
      if ( !this.options.wrapAround && this.slides.length ) {
        // slow drag
        var originBound = Math.max( -this.slides[0].target, this.dragStartPosition );
        dragX = dragX > originBound ? ( dragX + originBound ) * 0.5 : dragX;
        var endBound = Math.min( -this.getLastSlide().target, this.dragStartPosition );
        dragX = dragX < endBound ? ( dragX + endBound ) * 0.5 : dragX;
      }
    
      this.dragX = dragX;
    
      this.dragMoveTime = new Date();
      this.dispatchEvent( 'dragMove', event, [ pointer, moveVector ] );
    };
    
    proto.dragEnd = function( event, pointer ) {
      if ( !this.isDraggable ) {
        return;
      }
      if ( this.options.freeScroll ) {
        this.isFreeScrolling = true;
      }
      // set selectedIndex based on where flick will end up
      var index = this.dragEndRestingSelect();
    
      if ( this.options.freeScroll && !this.options.wrapAround ) {
        // if free-scroll & not wrap around
        // do not free-scroll if going outside of bounding slides
        // so bounding slides can attract slider, and keep it in bounds
        var restingX = this.getRestingPosition();
        this.isFreeScrolling = -restingX > this.slides[0].target &&
          -restingX < this.getLastSlide().target;
      } else if ( !this.options.freeScroll && index == this.selectedIndex ) {
        // boost selection if selected index has not changed
        index += this.dragEndBoostSelect();
      }
      delete this.previousDragX;
      // apply selection
      // TODO refactor this, selecting here feels weird
      // HACK, set flag so dragging stays in correct direction
      this.isDragSelect = this.options.wrapAround;
      this.select( index );
      delete this.isDragSelect;
      this.dispatchEvent( 'dragEnd', event, [ pointer ] );
    };
    
    proto.dragEndRestingSelect = function() {
      var restingX = this.getRestingPosition();
      // how far away from selected slide
      var distance = Math.abs( this.getSlideDistance( -restingX, this.selectedIndex ) );
      // get closet resting going up and going down
      var positiveResting = this._getClosestResting( restingX, distance, 1 );
      var negativeResting = this._getClosestResting( restingX, distance, -1 );
      // use closer resting for wrap-around
      var index = positiveResting.distance < negativeResting.distance ?
        positiveResting.index : negativeResting.index;
      return index;
    };
    
    /**
     * given resting X and distance to selected cell
     * get the distance and index of the closest cell
     * @param {Number} restingX - estimated post-flick resting position
     * @param {Number} distance - distance to selected cell
     * @param {Integer} increment - +1 or -1, going up or down
     * @returns {Object} - { distance: {Number}, index: {Integer} }
     */
    proto._getClosestResting = function( restingX, distance, increment ) {
      var index = this.selectedIndex;
      var minDistance = Infinity;
      var condition = this.options.contain && !this.options.wrapAround ?
        // if contain, keep going if distance is equal to minDistance
        function( dist, minDist ) {
          return dist <= minDist;
        } : function( dist, minDist ) {
          return dist < minDist;
        };
      while ( condition( distance, minDistance ) ) {
        // measure distance to next cell
        index += increment;
        minDistance = distance;
        distance = this.getSlideDistance( -restingX, index );
        if ( distance === null ) {
          break;
        }
        distance = Math.abs( distance );
      }
      return {
        distance: minDistance,
        // selected was previous index
        index: index - increment,
      };
    };
    
    /**
     * measure distance between x and a slide target
     * @param {Number} x - horizontal position
     * @param {Integer} index - slide index
     * @returns {Number} - slide distance
     */
    proto.getSlideDistance = function( x, index ) {
      var len = this.slides.length;
      // wrap around if at least 2 slides
      var isWrapAround = this.options.wrapAround && len > 1;
      var slideIndex = isWrapAround ? utils.modulo( index, len ) : index;
      var slide = this.slides[ slideIndex ];
      if ( !slide ) {
        return null;
      }
      // add distance for wrap-around slides
      var wrap = isWrapAround ? this.slideableWidth * Math.floor( index/len ) : 0;
      return x - ( slide.target + wrap );
    };
    
    proto.dragEndBoostSelect = function() {
      // do not boost if no previousDragX or dragMoveTime
      if ( this.previousDragX === undefined || !this.dragMoveTime ||
        // or if drag was held for 100 ms
        new Date() - this.dragMoveTime > 100 ) {
        return 0;
      }
    
      var distance = this.getSlideDistance( -this.dragX, this.selectedIndex );
      var delta = this.previousDragX - this.dragX;
      if ( distance > 0 && delta > 0 ) {
        // boost to next if moving towards the right, and positive velocity
        return 1;
      } else if ( distance < 0 && delta < 0 ) {
        // boost to previous if moving towards the left, and negative velocity
        return -1;
      }
      return 0;
    };
    
    // ----- staticClick ----- //
    
    proto.staticClick = function( event, pointer ) {
      // get clickedCell, if cell was clicked
      var clickedCell = this.getParentCell( event.target );
      var cellElem = clickedCell && clickedCell.element;
      var cellIndex = clickedCell && this.cells.indexOf( clickedCell );
      this.dispatchEvent( 'staticClick', event, [ pointer, cellElem, cellIndex ] );
    };
    
    // ----- scroll ----- //
    
    proto.onscroll = function() {
      var scroll = getScrollPosition();
      var scrollMoveX = this.pointerDownScroll.x - scroll.x;
      var scrollMoveY = this.pointerDownScroll.y - scroll.y;
      // cancel click/tap if scroll is too much
      if ( Math.abs( scrollMoveX ) > 3 || Math.abs( scrollMoveY ) > 3 ) {
        this._pointerDone();
      }
    };
    
    // ----- utils ----- //
    
    function getScrollPosition() {
      return {
        x: window.pageXOffset,
        y: window.pageYOffset,
      };
    }
    
    // -----  ----- //
    
    return Flickity;
    
    } ) );
    
    
    /***/ }),
    /* 41 */
    /***/ (function(module, exports, __webpack_require__) {
    
    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
     * Unidragger v2.3.1
     * Draggable base class
     * MIT license
     */
    
    /*jshint browser: true, unused: true, undef: true, strict: true */
    
    ( function( window, factory ) {
      // universal module definition
      /*jshint strict: false */ /*globals define, module, require */
    
      if ( true ) {
        // AMD
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
          __webpack_require__(13)
        ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( Unipointer ) {
          return factory( window, Unipointer );
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
                    __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
      } else {}
    
    }( window, function factory( window, Unipointer ) {
    
    'use strict';
    
    // -------------------------- Unidragger -------------------------- //
    
    function Unidragger() {}
    
    // inherit Unipointer & EvEmitter
    var proto = Unidragger.prototype = Object.create( Unipointer.prototype );
    
    // ----- bind start ----- //
    
    proto.bindHandles = function() {
      this._bindHandles( true );
    };
    
    proto.unbindHandles = function() {
      this._bindHandles( false );
    };
    
    /**
     * Add or remove start event
     * @param {Boolean} isAdd
     */
    proto._bindHandles = function( isAdd ) {
      // munge isAdd, default to true
      isAdd = isAdd === undefined ? true : isAdd;
      // bind each handle
      var bindMethod = isAdd ? 'addEventListener' : 'removeEventListener';
      var touchAction = isAdd ? this._touchActionValue : '';
      for ( var i=0; i < this.handles.length; i++ ) {
        var handle = this.handles[i];
        this._bindStartEvent( handle, isAdd );
        handle[ bindMethod ]( 'click', this );
        // touch-action: none to override browser touch gestures. metafizzy/flickity#540
        if ( window.PointerEvent ) {
          handle.style.touchAction = touchAction;
        }
      }
    };
    
    // prototype so it can be overwriteable by Flickity
    proto._touchActionValue = 'none';
    
    // ----- start event ----- //
    
    /**
     * pointer start
     * @param {Event} event
     * @param {Event or Touch} pointer
     */
    proto.pointerDown = function( event, pointer ) {
      var isOkay = this.okayPointerDown( event );
      if ( !isOkay ) {
        return;
      }
      // track start event position
      // Safari 9 overrides pageX and pageY. These values needs to be copied. flickity#842
      this.pointerDownPointer = {
        pageX: pointer.pageX,
        pageY: pointer.pageY,
      };
    
      event.preventDefault();
      this.pointerDownBlur();
      // bind move and end events
      this._bindPostStartEvents( event );
      this.emitEvent( 'pointerDown', [ event, pointer ] );
    };
    
    // nodes that have text fields
    var cursorNodes = {
      TEXTAREA: true,
      INPUT: true,
      SELECT: true,
      OPTION: true,
    };
    
    // input types that do not have text fields
    var clickTypes = {
      radio: true,
      checkbox: true,
      button: true,
      submit: true,
      image: true,
      file: true,
    };
    
    // dismiss inputs with text fields. flickity#403, flickity#404
    proto.okayPointerDown = function( event ) {
      var isCursorNode = cursorNodes[ event.target.nodeName ];
      var isClickType = clickTypes[ event.target.type ];
      var isOkay = !isCursorNode || isClickType;
      if ( !isOkay ) {
        this._pointerReset();
      }
      return isOkay;
    };
    
    // kludge to blur previously focused input
    proto.pointerDownBlur = function() {
      var focused = document.activeElement;
      // do not blur body for IE10, metafizzy/flickity#117
      var canBlur = focused && focused.blur && focused != document.body;
      if ( canBlur ) {
        focused.blur();
      }
    };
    
    // ----- move event ----- //
    
    /**
     * drag move
     * @param {Event} event
     * @param {Event or Touch} pointer
     */
    proto.pointerMove = function( event, pointer ) {
      var moveVector = this._dragPointerMove( event, pointer );
      this.emitEvent( 'pointerMove', [ event, pointer, moveVector ] );
      this._dragMove( event, pointer, moveVector );
    };
    
    // base pointer move logic
    proto._dragPointerMove = function( event, pointer ) {
      var moveVector = {
        x: pointer.pageX - this.pointerDownPointer.pageX,
        y: pointer.pageY - this.pointerDownPointer.pageY
      };
      // start drag if pointer has moved far enough to start drag
      if ( !this.isDragging && this.hasDragStarted( moveVector ) ) {
        this._dragStart( event, pointer );
      }
      return moveVector;
    };
    
    // condition if pointer has moved far enough to start drag
    proto.hasDragStarted = function( moveVector ) {
      return Math.abs( moveVector.x ) > 3 || Math.abs( moveVector.y ) > 3;
    };
    
    // ----- end event ----- //
    
    /**
     * pointer up
     * @param {Event} event
     * @param {Event or Touch} pointer
     */
    proto.pointerUp = function( event, pointer ) {
      this.emitEvent( 'pointerUp', [ event, pointer ] );
      this._dragPointerUp( event, pointer );
    };
    
    proto._dragPointerUp = function( event, pointer ) {
      if ( this.isDragging ) {
        this._dragEnd( event, pointer );
      } else {
        // pointer didn't move enough for drag to start
        this._staticClick( event, pointer );
      }
    };
    
    // -------------------------- drag -------------------------- //
    
    // dragStart
    proto._dragStart = function( event, pointer ) {
      this.isDragging = true;
      // prevent clicks
      this.isPreventingClicks = true;
      this.dragStart( event, pointer );
    };
    
    proto.dragStart = function( event, pointer ) {
      this.emitEvent( 'dragStart', [ event, pointer ] );
    };
    
    // dragMove
    proto._dragMove = function( event, pointer, moveVector ) {
      // do not drag if not dragging yet
      if ( !this.isDragging ) {
        return;
      }
    
      this.dragMove( event, pointer, moveVector );
    };
    
    proto.dragMove = function( event, pointer, moveVector ) {
      event.preventDefault();
      this.emitEvent( 'dragMove', [ event, pointer, moveVector ] );
    };
    
    // dragEnd
    proto._dragEnd = function( event, pointer ) {
      // set flags
      this.isDragging = false;
      // re-enable clicking async
      setTimeout( function() {
        delete this.isPreventingClicks;
      }.bind( this ) );
    
      this.dragEnd( event, pointer );
    };
    
    proto.dragEnd = function( event, pointer ) {
      this.emitEvent( 'dragEnd', [ event, pointer ] );
    };
    
    // ----- onclick ----- //
    
    // handle all clicks and prevent clicks when dragging
    proto.onclick = function( event ) {
      if ( this.isPreventingClicks ) {
        event.preventDefault();
      }
    };
    
    // ----- staticClick ----- //
    
    // triggered after pointer down & up with no/tiny movement
    proto._staticClick = function( event, pointer ) {
      // ignore emulated mouse up clicks
      if ( this.isIgnoringMouseUp && event.type == 'mouseup' ) {
        return;
      }
    
      this.staticClick( event, pointer );
    
      // set flag for emulated clicks 300ms after touchend
      if ( event.type != 'mouseup' ) {
        this.isIgnoringMouseUp = true;
        // reset flag after 300ms
        setTimeout( function() {
          delete this.isIgnoringMouseUp;
        }.bind( this ), 400 );
      }
    };
    
    proto.staticClick = function( event, pointer ) {
      this.emitEvent( 'staticClick', [ event, pointer ] );
    };
    
    // ----- utils ----- //
    
    Unidragger.getPointerPoint = Unipointer.getPointerPoint;
    
    // -----  ----- //
    
    return Unidragger;
    
    }));
    
    
    /***/ }),
    /* 42 */
    /***/ (function(module, exports, __webpack_require__) {
    
    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// prev/next buttons
    ( function( window, factory ) {
      // universal module definition
      if ( true ) {
        // AMD
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
          __webpack_require__(6),
          __webpack_require__(13),
          __webpack_require__(4),
        ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( Flickity, Unipointer, utils ) {
          return factory( window, Flickity, Unipointer, utils );
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
                    __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
      } else {}
    
    }( window, function factory( window, Flickity, Unipointer, utils ) {
    'use strict';
    
    var svgURI = 'http://www.w3.org/2000/svg';
    
    // -------------------------- PrevNextButton -------------------------- //
    
    function PrevNextButton( direction, parent ) {
      this.direction = direction;
      this.parent = parent;
      this._create();
    }
    
    PrevNextButton.prototype = Object.create( Unipointer.prototype );
    
    PrevNextButton.prototype._create = function() {
      // properties
      this.isEnabled = true;
      this.isPrevious = this.direction == -1;
      var leftDirection = this.parent.options.rightToLeft ? 1 : -1;
      this.isLeft = this.direction == leftDirection;
    
      var element = this.element = document.createElement('button');
      element.className = 'flickity-button flickity-prev-next-button';
      element.className += this.isPrevious ? ' previous' : ' next';
      // prevent button from submitting form http://stackoverflow.com/a/10836076/182183
      element.setAttribute( 'type', 'button' );
      // init as disabled
      this.disable();
    
      element.setAttribute( 'aria-label', this.isPrevious ? 'Previous' : 'Next' );
    
      // create arrow
      var svg = this.createSVG();
      element.appendChild( svg );
      // events
      this.parent.on( 'select', this.update.bind( this ) );
      this.on( 'pointerDown', this.parent.childUIPointerDown.bind( this.parent ) );
    };
    
    PrevNextButton.prototype.activate = function() {
      this.bindStartEvent( this.element );
      this.element.addEventListener( 'click', this );
      // add to DOM
      this.parent.element.appendChild( this.element );
    };
    
    PrevNextButton.prototype.deactivate = function() {
      // remove from DOM
      this.parent.element.removeChild( this.element );
      // click events
      this.unbindStartEvent( this.element );
      this.element.removeEventListener( 'click', this );
    };
    
    PrevNextButton.prototype.createSVG = function() {
      var svg = document.createElementNS( svgURI, 'svg' );
      svg.setAttribute( 'class', 'flickity-button-icon' );
      svg.setAttribute( 'viewBox', '0 0 100 100' );
      var path = document.createElementNS( svgURI, 'path' );
      var pathMovements = getArrowMovements( this.parent.options.arrowShape );
      path.setAttribute( 'd', pathMovements );
      path.setAttribute( 'class', 'arrow' );
      // rotate arrow
      if ( !this.isLeft ) {
        path.setAttribute( 'transform', 'translate(100, 100) rotate(180) ' );
      }
      svg.appendChild( path );
      return svg;
    };
    
    // get SVG path movmement
    function getArrowMovements( shape ) {
      // use shape as movement if string
      if ( typeof shape == 'string' ) {
        return shape;
      }
      // create movement string
      return 'M ' + shape.x0 + ',50' +
        ' L ' + shape.x1 + ',' + ( shape.y1 + 50 ) +
        ' L ' + shape.x2 + ',' + ( shape.y2 + 50 ) +
        ' L ' + shape.x3 + ',50 ' +
        ' L ' + shape.x2 + ',' + ( 50 - shape.y2 ) +
        ' L ' + shape.x1 + ',' + ( 50 - shape.y1 ) +
        ' Z';
    }
    
    PrevNextButton.prototype.handleEvent = utils.handleEvent;
    
    PrevNextButton.prototype.onclick = function() {
      if ( !this.isEnabled ) {
        return;
      }
      this.parent.uiChange();
      var method = this.isPrevious ? 'previous' : 'next';
      this.parent[ method ]();
    };
    
    // -----  ----- //
    
    PrevNextButton.prototype.enable = function() {
      if ( this.isEnabled ) {
        return;
      }
      this.element.disabled = false;
      this.isEnabled = true;
    };
    
    PrevNextButton.prototype.disable = function() {
      if ( !this.isEnabled ) {
        return;
      }
      this.element.disabled = true;
      this.isEnabled = false;
    };
    
    PrevNextButton.prototype.update = function() {
      // index of first or last slide, if previous or next
      var slides = this.parent.slides;
      // enable is wrapAround and at least 2 slides
      if ( this.parent.options.wrapAround && slides.length > 1 ) {
        this.enable();
        return;
      }
      var lastIndex = slides.length ? slides.length - 1 : 0;
      var boundIndex = this.isPrevious ? 0 : lastIndex;
      var method = this.parent.selectedIndex == boundIndex ? 'disable' : 'enable';
      this[ method ]();
    };
    
    PrevNextButton.prototype.destroy = function() {
      this.deactivate();
      this.allOff();
    };
    
    // -------------------------- Flickity prototype -------------------------- //
    
    utils.extend( Flickity.defaults, {
      prevNextButtons: true,
      arrowShape: {
        x0: 10,
        x1: 60, y1: 50,
        x2: 70, y2: 40,
        x3: 30,
      },
    } );
    
    Flickity.createMethods.push('_createPrevNextButtons');
    var proto = Flickity.prototype;
    
    proto._createPrevNextButtons = function() {
      if ( !this.options.prevNextButtons ) {
        return;
      }
    
      this.prevButton = new PrevNextButton( -1, this );
      this.nextButton = new PrevNextButton( 1, this );
    
      this.on( 'activate', this.activatePrevNextButtons );
    };
    
    proto.activatePrevNextButtons = function() {
      this.prevButton.activate();
      this.nextButton.activate();
      this.on( 'deactivate', this.deactivatePrevNextButtons );
    };
    
    proto.deactivatePrevNextButtons = function() {
      this.prevButton.deactivate();
      this.nextButton.deactivate();
      this.off( 'deactivate', this.deactivatePrevNextButtons );
    };
    
    // --------------------------  -------------------------- //
    
    Flickity.PrevNextButton = PrevNextButton;
    
    return Flickity;
    
    } ) );
    
    
    /***/ }),
    /* 43 */
    /***/ (function(module, exports, __webpack_require__) {
    
    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// page dots
    ( function( window, factory ) {
      // universal module definition
      if ( true ) {
        // AMD
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
          __webpack_require__(6),
          __webpack_require__(13),
          __webpack_require__(4),
        ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( Flickity, Unipointer, utils ) {
          return factory( window, Flickity, Unipointer, utils );
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
                    __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
      } else {}
    
    }( window, function factory( window, Flickity, Unipointer, utils ) {
    
    // -------------------------- PageDots -------------------------- //
    
    'use strict';
    
    function PageDots( parent ) {
      this.parent = parent;
      this._create();
    }
    
    PageDots.prototype = Object.create( Unipointer.prototype );
    
    PageDots.prototype._create = function() {
      // create holder element
      this.holder = document.createElement('ol');
      this.holder.className = 'flickity-page-dots';
      // create dots, array of elements
      this.dots = [];
      // events
      this.handleClick = this.onClick.bind( this );
      this.on( 'pointerDown', this.parent.childUIPointerDown.bind( this.parent ) );
    };
    
    PageDots.prototype.activate = function() {
      this.setDots();
      this.holder.addEventListener( 'click', this.handleClick );
      this.bindStartEvent( this.holder );
      // add to DOM
      this.parent.element.appendChild( this.holder );
    };
    
    PageDots.prototype.deactivate = function() {
      this.holder.removeEventListener( 'click', this.handleClick );
      this.unbindStartEvent( this.holder );
      // remove from DOM
      this.parent.element.removeChild( this.holder );
    };
    
    PageDots.prototype.setDots = function() {
      // get difference between number of slides and number of dots
      var delta = this.parent.slides.length - this.dots.length;
      if ( delta > 0 ) {
        this.addDots( delta );
      } else if ( delta < 0 ) {
        this.removeDots( -delta );
      }
    };
    
    PageDots.prototype.addDots = function( count ) {
      var fragment = document.createDocumentFragment();
      var newDots = [];
      var length = this.dots.length;
      var max = length + count;
    
      for ( var i = length; i < max; i++ ) {
        var dot = document.createElement('li');
        dot.className = 'dot';
        dot.setAttribute( 'aria-label', 'Page dot ' + ( i + 1 ) );
        fragment.appendChild( dot );
        newDots.push( dot );
      }
    
      this.holder.appendChild( fragment );
      this.dots = this.dots.concat( newDots );
    };
    
    PageDots.prototype.removeDots = function( count ) {
      // remove from this.dots collection
      var removeDots = this.dots.splice( this.dots.length - count, count );
      // remove from DOM
      removeDots.forEach( function( dot ) {
        this.holder.removeChild( dot );
      }, this );
    };
    
    PageDots.prototype.updateSelected = function() {
      // remove selected class on previous
      if ( this.selectedDot ) {
        this.selectedDot.className = 'dot';
        this.selectedDot.removeAttribute('aria-current');
      }
      // don't proceed if no dots
      if ( !this.dots.length ) {
        return;
      }
      this.selectedDot = this.dots[ this.parent.selectedIndex ];
      this.selectedDot.className = 'dot is-selected';
      this.selectedDot.setAttribute( 'aria-current', 'step' );
    };
    
    PageDots.prototype.onTap = // old method name, backwards-compatible
    PageDots.prototype.onClick = function( event ) {
      var target = event.target;
      // only care about dot clicks
      if ( target.nodeName != 'LI' ) {
        return;
      }
    
      this.parent.uiChange();
      var index = this.dots.indexOf( target );
      this.parent.select( index );
    };
    
    PageDots.prototype.destroy = function() {
      this.deactivate();
      this.allOff();
    };
    
    Flickity.PageDots = PageDots;
    
    // -------------------------- Flickity -------------------------- //
    
    utils.extend( Flickity.defaults, {
      pageDots: true,
    } );
    
    Flickity.createMethods.push('_createPageDots');
    
    var proto = Flickity.prototype;
    
    proto._createPageDots = function() {
      if ( !this.options.pageDots ) {
        return;
      }
      this.pageDots = new PageDots( this );
      // events
      this.on( 'activate', this.activatePageDots );
      this.on( 'select', this.updateSelectedPageDots );
      this.on( 'cellChange', this.updatePageDots );
      this.on( 'resize', this.updatePageDots );
      this.on( 'deactivate', this.deactivatePageDots );
    };
    
    proto.activatePageDots = function() {
      this.pageDots.activate();
    };
    
    proto.updateSelectedPageDots = function() {
      this.pageDots.updateSelected();
    };
    
    proto.updatePageDots = function() {
      this.pageDots.setDots();
    };
    
    proto.deactivatePageDots = function() {
      this.pageDots.deactivate();
    };
    
    // -----  ----- //
    
    Flickity.PageDots = PageDots;
    
    return Flickity;
    
    } ) );
    
    
    /***/ }),
    /* 44 */
    /***/ (function(module, exports, __webpack_require__) {
    
    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// player & autoPlay
    ( function( window, factory ) {
      // universal module definition
      if ( true ) {
        // AMD
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
          __webpack_require__(12),
          __webpack_require__(4),
          __webpack_require__(6),
        ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( EvEmitter, utils, Flickity ) {
          return factory( EvEmitter, utils, Flickity );
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
                    __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
      } else {}
    
    }( window, function factory( EvEmitter, utils, Flickity ) {
    
    'use strict';
    
    // -------------------------- Player -------------------------- //
    
    function Player( parent ) {
      this.parent = parent;
      this.state = 'stopped';
      // visibility change event handler
      this.onVisibilityChange = this.visibilityChange.bind( this );
      this.onVisibilityPlay = this.visibilityPlay.bind( this );
    }
    
    Player.prototype = Object.create( EvEmitter.prototype );
    
    // start play
    Player.prototype.play = function() {
      if ( this.state == 'playing' ) {
        return;
      }
      // do not play if page is hidden, start playing when page is visible
      var isPageHidden = document.hidden;
      if ( isPageHidden ) {
        document.addEventListener( 'visibilitychange', this.onVisibilityPlay );
        return;
      }
    
      this.state = 'playing';
      // listen to visibility change
      document.addEventListener( 'visibilitychange', this.onVisibilityChange );
      // start ticking
      this.tick();
    };
    
    Player.prototype.tick = function() {
      // do not tick if not playing
      if ( this.state != 'playing' ) {
        return;
      }
    
      var time = this.parent.options.autoPlay;
      // default to 3 seconds
      time = typeof time == 'number' ? time : 3000;
      var _this = this;
      // HACK: reset ticks if stopped and started within interval
      this.clear();
      this.timeout = setTimeout( function() {
        _this.parent.next( true );
        _this.tick();
      }, time );
    };
    
    Player.prototype.stop = function() {
      this.state = 'stopped';
      this.clear();
      // remove visibility change event
      document.removeEventListener( 'visibilitychange', this.onVisibilityChange );
    };
    
    Player.prototype.clear = function() {
      clearTimeout( this.timeout );
    };
    
    Player.prototype.pause = function() {
      if ( this.state == 'playing' ) {
        this.state = 'paused';
        this.clear();
      }
    };
    
    Player.prototype.unpause = function() {
      // re-start play if paused
      if ( this.state == 'paused' ) {
        this.play();
      }
    };
    
    // pause if page visibility is hidden, unpause if visible
    Player.prototype.visibilityChange = function() {
      var isPageHidden = document.hidden;
      this[ isPageHidden ? 'pause' : 'unpause' ]();
    };
    
    Player.prototype.visibilityPlay = function() {
      this.play();
      document.removeEventListener( 'visibilitychange', this.onVisibilityPlay );
    };
    
    // -------------------------- Flickity -------------------------- //
    
    utils.extend( Flickity.defaults, {
      pauseAutoPlayOnHover: true,
    } );
    
    Flickity.createMethods.push('_createPlayer');
    var proto = Flickity.prototype;
    
    proto._createPlayer = function() {
      this.player = new Player( this );
    
      this.on( 'activate', this.activatePlayer );
      this.on( 'uiChange', this.stopPlayer );
      this.on( 'pointerDown', this.stopPlayer );
      this.on( 'deactivate', this.deactivatePlayer );
    };
    
    proto.activatePlayer = function() {
      if ( !this.options.autoPlay ) {
        return;
      }
      this.player.play();
      this.element.addEventListener( 'mouseenter', this );
    };
    
    // Player API, don't hate the ... thanks I know where the door is
    
    proto.playPlayer = function() {
      this.player.play();
    };
    
    proto.stopPlayer = function() {
      this.player.stop();
    };
    
    proto.pausePlayer = function() {
      this.player.pause();
    };
    
    proto.unpausePlayer = function() {
      this.player.unpause();
    };
    
    proto.deactivatePlayer = function() {
      this.player.stop();
      this.element.removeEventListener( 'mouseenter', this );
    };
    
    // ----- mouseenter/leave ----- //
    
    // pause auto-play on hover
    proto.onmouseenter = function() {
      if ( !this.options.pauseAutoPlayOnHover ) {
        return;
      }
      this.player.pause();
      this.element.addEventListener( 'mouseleave', this );
    };
    
    // resume auto-play on hover off
    proto.onmouseleave = function() {
      this.player.unpause();
      this.element.removeEventListener( 'mouseleave', this );
    };
    
    // -----  ----- //
    
    Flickity.Player = Player;
    
    return Flickity;
    
    } ) );
    
    
    /***/ }),
    /* 45 */
    /***/ (function(module, exports, __webpack_require__) {
    
    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// add, remove cell
    ( function( window, factory ) {
      // universal module definition
      if ( true ) {
        // AMD
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
          __webpack_require__(6),
          __webpack_require__(4),
        ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( Flickity, utils ) {
          return factory( window, Flickity, utils );
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
                    __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
      } else {}
    
    }( window, function factory( window, Flickity, utils ) {
    
    'use strict';
    
    // append cells to a document fragment
    function getCellsFragment( cells ) {
      var fragment = document.createDocumentFragment();
      cells.forEach( function( cell ) {
        fragment.appendChild( cell.element );
      } );
      return fragment;
    }
    
    // -------------------------- add/remove cell prototype -------------------------- //
    
    var proto = Flickity.prototype;
    
    /**
     * Insert, prepend, or append cells
     * @param {[Element, Array, NodeList]} elems - Elements to insert
     * @param {Integer} index - Zero-based number to insert
     */
    proto.insert = function( elems, index ) {
      var cells = this._makeCells( elems );
      if ( !cells || !cells.length ) {
        return;
      }
      var len = this.cells.length;
      // default to append
      index = index === undefined ? len : index;
      // add cells with document fragment
      var fragment = getCellsFragment( cells );
      // append to slider
      var isAppend = index == len;
      if ( isAppend ) {
        this.slider.appendChild( fragment );
      } else {
        var insertCellElement = this.cells[ index ].element;
        this.slider.insertBefore( fragment, insertCellElement );
      }
      // add to this.cells
      if ( index === 0 ) {
        // prepend, add to start
        this.cells = cells.concat( this.cells );
      } else if ( isAppend ) {
        // append, add to end
        this.cells = this.cells.concat( cells );
      } else {
        // insert in this.cells
        var endCells = this.cells.splice( index, len - index );
        this.cells = this.cells.concat( cells ).concat( endCells );
      }
    
      this._sizeCells( cells );
      this.cellChange( index, true );
    };
    
    proto.append = function( elems ) {
      this.insert( elems, this.cells.length );
    };
    
    proto.prepend = function( elems ) {
      this.insert( elems, 0 );
    };
    
    /**
     * Remove cells
     * @param {[Element, Array, NodeList]} elems - ELements to remove
     */
    proto.remove = function( elems ) {
      var cells = this.getCells( elems );
      if ( !cells || !cells.length ) {
        return;
      }
    
      var minCellIndex = this.cells.length - 1;
      // remove cells from collection & DOM
      cells.forEach( function( cell ) {
        cell.remove();
        var index = this.cells.indexOf( cell );
        minCellIndex = Math.min( index, minCellIndex );
        utils.removeFrom( this.cells, cell );
      }, this );
    
      this.cellChange( minCellIndex, true );
    };
    
    /**
     * logic to be run after a cell's size changes
     * @param {Element} elem - cell's element
     */
    proto.cellSizeChange = function( elem ) {
      var cell = this.getCell( elem );
      if ( !cell ) {
        return;
      }
      cell.getSize();
    
      var index = this.cells.indexOf( cell );
      this.cellChange( index );
    };
    
    /**
     * logic any time a cell is changed: added, removed, or size changed
     * @param {Integer} changedCellIndex - index of the changed cell, optional
     * @param {Boolean} isPositioningSlider - Positions slider after selection
     */
    proto.cellChange = function( changedCellIndex, isPositioningSlider ) {
      var prevSelectedElem = this.selectedElement;
      this._positionCells( changedCellIndex );
      this._getWrapShiftCells();
      this.setGallerySize();
      // update selectedIndex
      // try to maintain position & select previous selected element
      var cell = this.getCell( prevSelectedElem );
      if ( cell ) {
        this.selectedIndex = this.getCellSlideIndex( cell );
      }
      this.selectedIndex = Math.min( this.slides.length - 1, this.selectedIndex );
    
      this.emitEvent( 'cellChange', [ changedCellIndex ] );
      // position slider
      this.select( this.selectedIndex );
      // do not position slider after lazy load
      if ( isPositioningSlider ) {
        this.positionSliderAtSelected();
      }
    };
    
    // -----  ----- //
    
    return Flickity;
    
    } ) );
    
    
    /***/ }),
    /* 46 */
    /***/ (function(module, exports, __webpack_require__) {
    
    var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// lazyload
    ( function( window, factory ) {
      // universal module definition
      if ( true ) {
        // AMD
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
          __webpack_require__(6),
          __webpack_require__(4),
        ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( Flickity, utils ) {
          return factory( window, Flickity, utils );
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
                    __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
      } else {}
    
    }( window, function factory( window, Flickity, utils ) {
    'use strict';
    
    Flickity.createMethods.push('_createLazyload');
    var proto = Flickity.prototype;
    
    proto._createLazyload = function() {
      this.on( 'select', this.lazyLoad );
    };
    
    proto.lazyLoad = function() {
      var lazyLoad = this.options.lazyLoad;
      if ( !lazyLoad ) {
        return;
      }
      // get adjacent cells, use lazyLoad option for adjacent count
      var adjCount = typeof lazyLoad == 'number' ? lazyLoad : 0;
      var cellElems = this.getAdjacentCellElements( adjCount );
      // get lazy images in those cells
      var lazyImages = [];
      cellElems.forEach( function( cellElem ) {
        var lazyCellImages = getCellLazyImages( cellElem );
        lazyImages = lazyImages.concat( lazyCellImages );
      } );
      // load lazy images
      lazyImages.forEach( function( img ) {
        new LazyLoader( img, this );
      }, this );
    };
    
    function getCellLazyImages( cellElem ) {
      // check if cell element is lazy image
      if ( cellElem.nodeName == 'IMG' ) {
        var lazyloadAttr = cellElem.getAttribute('data-flickity-lazyload');
        var srcAttr = cellElem.getAttribute('data-flickity-lazyload-src');
        var srcsetAttr = cellElem.getAttribute('data-flickity-lazyload-srcset');
        if ( lazyloadAttr || srcAttr || srcsetAttr ) {
          return [ cellElem ];
        }
      }
      // select lazy images in cell
      var lazySelector = 'img[data-flickity-lazyload], ' +
        'img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]';
      var imgs = cellElem.querySelectorAll( lazySelector );
      return utils.makeArray( imgs );
    }
    
    // -------------------------- LazyLoader -------------------------- //
    
    /**
     * class to handle loading images
     * @param {Image} img - Image element
     * @param {Flickity} flickity - Flickity instance
     */
    function LazyLoader( img, flickity ) {
      this.img = img;
      this.flickity = flickity;
      this.load();
    }
    
    LazyLoader.prototype.handleEvent = utils.handleEvent;
    
    LazyLoader.prototype.load = function() {
      this.img.addEventListener( 'load', this );
      this.img.addEventListener( 'error', this );
      // get src & srcset
      var src = this.img.getAttribute('data-flickity-lazyload') ||
        this.img.getAttribute('data-flickity-lazyload-src');
      var srcset = this.img.getAttribute('data-flickity-lazyload-srcset');
      // set src & serset
      this.img.src = src;
      if ( srcset ) {
        this.img.setAttribute( 'srcset', srcset );
      }
      // remove attr
      this.img.removeAttribute('data-flickity-lazyload');
      this.img.removeAttribute('data-flickity-lazyload-src');
      this.img.removeAttribute('data-flickity-lazyload-srcset');
    };
    
    LazyLoader.prototype.onload = function( event ) {
      this.complete( event, 'flickity-lazyloaded' );
    };
    
    LazyLoader.prototype.onerror = function( event ) {
      this.complete( event, 'flickity-lazyerror' );
    };
    
    LazyLoader.prototype.complete = function( event, className ) {
      // unbind events
      this.img.removeEventListener( 'load', this );
      this.img.removeEventListener( 'error', this );
    
      var cell = this.flickity.getParentCell( this.img );
      var cellElem = cell && cell.element;
      this.flickity.cellSizeChange( cellElem );
    
      this.img.classList.add( className );
      this.flickity.dispatchEvent( 'lazyLoad', event, cellElem );
    };
    
    // -----  ----- //
    
    Flickity.LazyLoader = LazyLoader;
    
    return Flickity;
    
    } ) );
    
    
    /***/ }),
    /* 47 */
    /***/ (function(module, exports, __webpack_require__) {
    
    "use strict";
    
    
    var Sister;
    
    /**
    * @link https://github.com/gajus/sister for the canonical source repository
    * @license https://github.com/gajus/sister/blob/master/LICENSE BSD 3-Clause
    */
    Sister = function () {
        var sister = {},
            events = {};
    
        /**
         * @name handler
         * @function
         * @param {Object} data Event data.
         */
    
        /**
         * @param {String} name Event name.
         * @param {handler} handler
         * @return {listener}
         */
        sister.on = function (name, handler) {
            var listener = {name: name, handler: handler};
            events[name] = events[name] || [];
            events[name].unshift(listener);
            return listener;
        };
    
        /**
         * @param {listener}
         */
        sister.off = function (listener) {
            var index = events[listener.name].indexOf(listener);
    
            if (index !== -1) {
                events[listener.name].splice(index, 1);
            }
        };
    
        /**
         * @param {String} name Event name.
         * @param {Object} data Event data.
         */
        sister.trigger = function (name, data) {
            var listeners = events[name],
                i;
    
            if (listeners) {
                i = listeners.length;
                while (i--) {
                    listeners[i].handler(data);
                }
            }
        };
    
        return sister;
    };
    
    module.exports = Sister;
    
    
    /***/ }),
    /* 48 */
    /***/ (function(module, exports, __webpack_require__) {
    
    "use strict";
    
    
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    
    var _loadScript = __webpack_require__(49);
    
    var _loadScript2 = _interopRequireDefault(_loadScript);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    exports.default = function (emitter) {
      /**
       * A promise that is resolved when window.onYouTubeIframeAPIReady is called.
       * The promise is resolved with a reference to window.YT object.
       */
      var iframeAPIReady = new Promise(function (resolve) {
        if (window.YT && window.YT.Player && window.YT.Player instanceof Function) {
          resolve(window.YT);
    
          return;
        } else {
          var protocol = window.location.protocol === 'http:' ? 'http:' : 'https:';
    
          (0, _loadScript2.default)(protocol + '//www.youtube.com/iframe_api', function (error) {
            if (error) {
              emitter.trigger('error', error);
            }
          });
        }
    
        var previous = window.onYouTubeIframeAPIReady;
    
        // The API will call this function when page has finished downloading
        // the JavaScript for the player API.
        window.onYouTubeIframeAPIReady = function () {
          if (previous) {
            previous();
          }
    
          resolve(window.YT);
        };
      });
    
      return iframeAPIReady;
    };
    
    module.exports = exports['default'];
    
    /***/ }),
    /* 49 */
    /***/ (function(module, exports) {
    
    
    module.exports = function load (src, opts, cb) {
      var head = document.head || document.getElementsByTagName('head')[0]
      var script = document.createElement('script')
    
      if (typeof opts === 'function') {
        cb = opts
        opts = {}
      }
    
      opts = opts || {}
      cb = cb || function() {}
    
      script.type = opts.type || 'text/javascript'
      script.charset = opts.charset || 'utf8';
      script.async = 'async' in opts ? !!opts.async : true
      script.src = src
    
      if (opts.attrs) {
        setAttributes(script, opts.attrs)
      }
    
      if (opts.text) {
        script.text = '' + opts.text
      }
    
      var onend = 'onload' in script ? stdOnEnd : ieOnEnd
      onend(script, cb)
    
      // some good legacy browsers (firefox) fail the 'in' detection above
      // so as a fallback we always set onload
      // old IE will ignore this and new IE will set onload
      if (!script.onload) {
        stdOnEnd(script, cb);
      }
    
      head.appendChild(script)
    }
    
    function setAttributes(script, attrs) {
      for (var attr in attrs) {
        script.setAttribute(attr, attrs[attr]);
      }
    }
    
    function stdOnEnd (script, cb) {
      script.onload = function () {
        this.onerror = this.onload = null
        cb(null, script)
      }
      script.onerror = function () {
        // this.onload = null here is necessary
        // because even IE9 works not like others
        this.onerror = this.onload = null
        cb(new Error('Failed to load ' + this.src), script)
      }
    }
    
    function ieOnEnd (script, cb) {
      script.onreadystatechange = function () {
        if (this.readyState != 'complete' && this.readyState != 'loaded') return
        this.onreadystatechange = null
        cb(null, script) // there is no way to catch loading errors in IE8
      }
    }
    
    
    /***/ }),
    /* 50 */
    /***/ (function(module, exports, __webpack_require__) {
    
    "use strict";
    
    
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    
    var _debug = __webpack_require__(51);
    
    var _debug2 = _interopRequireDefault(_debug);
    
    var _functionNames = __webpack_require__(54);
    
    var _functionNames2 = _interopRequireDefault(_functionNames);
    
    var _eventNames = __webpack_require__(55);
    
    var _eventNames2 = _interopRequireDefault(_eventNames);
    
    var _FunctionStateMap = __webpack_require__(56);
    
    var _FunctionStateMap2 = _interopRequireDefault(_FunctionStateMap);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    /* eslint-disable promise/prefer-await-to-then */
    
    var debug = (0, _debug2.default)('youtube-player');
    
    var YouTubePlayer = {};
    
    /**
     * Construct an object that defines an event handler for all of the YouTube
     * player events. Proxy captured events through an event emitter.
     *
     * @todo Capture event parameters.
     * @see https://developers.google.com/youtube/iframe_api_reference#Events
     */
    YouTubePlayer.proxyEvents = function (emitter) {
      var events = {};
    
      var _loop = function _loop(eventName) {
        var onEventName = 'on' + eventName.slice(0, 1).toUpperCase() + eventName.slice(1);
    
        events[onEventName] = function (event) {
          debug('event "%s"', onEventName, event);
    
          emitter.trigger(eventName, event);
        };
      };
    
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;
    
      try {
        for (var _iterator = _eventNames2.default[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var eventName = _step.value;
    
          _loop(eventName);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    
      return events;
    };
    
    /**
     * Delays player API method execution until player state is ready.
     *
     * @todo Proxy all of the methods using Object.keys.
     * @todo See TRICKY below.
     * @param playerAPIReady Promise that resolves when player is ready.
     * @param strictState A flag designating whether or not to wait for
     * an acceptable state when calling supported functions.
     * @returns {Object}
     */
    YouTubePlayer.promisifyPlayer = function (playerAPIReady) {
      var strictState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    
      var functions = {};
    
      var _loop2 = function _loop2(functionName) {
        if (strictState && _FunctionStateMap2.default[functionName]) {
          functions[functionName] = function () {
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
    
            return playerAPIReady.then(function (player) {
              var stateInfo = _FunctionStateMap2.default[functionName];
              var playerState = player.getPlayerState();
    
              // eslint-disable-next-line no-warning-comments
              // TODO: Just spread the args into the function once Babel is fixed:
              // https://github.com/babel/babel/issues/4270
              //
              // eslint-disable-next-line prefer-spread
              var value = player[functionName].apply(player, args);
    
              // TRICKY: For functions like `seekTo`, a change in state must be
              // triggered given that the resulting state could match the initial
              // state.
              if (stateInfo.stateChangeRequired ||
    
              // eslint-disable-next-line no-extra-parens
              Array.isArray(stateInfo.acceptableStates) && stateInfo.acceptableStates.indexOf(playerState) === -1) {
                return new Promise(function (resolve) {
                  var onPlayerStateChange = function onPlayerStateChange() {
                    var playerStateAfterChange = player.getPlayerState();
    
                    var timeout = void 0;
    
                    if (typeof stateInfo.timeout === 'number') {
                      timeout = setTimeout(function () {
                        player.removeEventListener('onStateChange', onPlayerStateChange);
    
                        resolve();
                      }, stateInfo.timeout);
                    }
    
                    if (Array.isArray(stateInfo.acceptableStates) && stateInfo.acceptableStates.indexOf(playerStateAfterChange) !== -1) {
                      player.removeEventListener('onStateChange', onPlayerStateChange);
    
                      clearTimeout(timeout);
    
                      resolve();
                    }
                  };
    
                  player.addEventListener('onStateChange', onPlayerStateChange);
                }).then(function () {
                  return value;
                });
              }
    
              return value;
            });
          };
        } else {
          functions[functionName] = function () {
            for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
              args[_key2] = arguments[_key2];
            }
    
            return playerAPIReady.then(function (player) {
              // eslint-disable-next-line no-warning-comments
              // TODO: Just spread the args into the function once Babel is fixed:
              // https://github.com/babel/babel/issues/4270
              //
              // eslint-disable-next-line prefer-spread
              return player[functionName].apply(player, args);
            });
          };
        }
      };
    
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;
    
      try {
        for (var _iterator2 = _functionNames2.default[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var functionName = _step2.value;
    
          _loop2(functionName);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    
      return functions;
    };
    
    exports.default = YouTubePlayer;
    module.exports = exports['default'];
    
    /***/ }),
    /* 51 */
    /***/ (function(module, exports, __webpack_require__) {
    
    /* WEBPACK VAR INJECTION */(function(process) {/**
     * This is the web browser implementation of `debug()`.
     *
     * Expose `debug()` as the module.
     */
    
    exports = module.exports = __webpack_require__(52);
    exports.log = log;
    exports.formatArgs = formatArgs;
    exports.save = save;
    exports.load = load;
    exports.useColors = useColors;
    exports.storage = 'undefined' != typeof chrome
                   && 'undefined' != typeof chrome.storage
                      ? chrome.storage.local
                      : localstorage();
    
    /**
     * Colors.
     */
    
    exports.colors = [
      'lightseagreen',
      'forestgreen',
      'goldenrod',
      'dodgerblue',
      'darkorchid',
      'crimson'
    ];
    
    /**
     * Currently only WebKit-based Web Inspectors, Firefox >= v31,
     * and the Firebug extension (any Firefox version) are known
     * to support "%c" CSS customizations.
     *
     * TODO: add a `localStorage` variable to explicitly enable/disable colors
     */
    
    function useColors() {
      // NB: In an Electron preload script, document will be defined but not fully
      // initialized. Since we know we're in Chrome, we'll just detect this case
      // explicitly
      if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
        return true;
      }
    
      // is webkit? http://stackoverflow.com/a/16459606/376773
      // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
      return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
        // is firebug? http://stackoverflow.com/a/398120/376773
        (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
        // is firefox >= v31?
        // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
        (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
        // double check webkit in userAgent just in case we are in a worker
        (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
    }
    
    /**
     * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
     */
    
    exports.formatters.j = function(v) {
      try {
        return JSON.stringify(v);
      } catch (err) {
        return '[UnexpectedJSONParseError]: ' + err.message;
      }
    };
    
    
    /**
     * Colorize log arguments if enabled.
     *
     * @api public
     */
    
    function formatArgs(args) {
      var useColors = this.useColors;
    
      args[0] = (useColors ? '%c' : '')
        + this.namespace
        + (useColors ? ' %c' : ' ')
        + args[0]
        + (useColors ? '%c ' : ' ')
        + '+' + exports.humanize(this.diff);
    
      if (!useColors) return;
    
      var c = 'color: ' + this.color;
      args.splice(1, 0, c, 'color: inherit')
    
      // the final "%c" is somewhat tricky, because there could be other
      // arguments passed either before or after the %c, so we need to
      // figure out the correct index to insert the CSS into
      var index = 0;
      var lastC = 0;
      args[0].replace(/%[a-zA-Z%]/g, function(match) {
        if ('%%' === match) return;
        index++;
        if ('%c' === match) {
          // we only are interested in the *last* %c
          // (the user may have provided their own)
          lastC = index;
        }
      });
    
      args.splice(lastC, 0, c);
    }
    
    /**
     * Invokes `console.log()` when available.
     * No-op when `console.log` is not a "function".
     *
     * @api public
     */
    
    function log() {
      // this hackery is required for IE8/9, where
      // the `console.log` function doesn't have 'apply'
      return 'object' === typeof console
        && console.log
        && Function.prototype.apply.call(console.log, console, arguments);
    }
    
    /**
     * Save `namespaces`.
     *
     * @param {String} namespaces
     * @api private
     */
    
    function save(namespaces) {
      try {
        if (null == namespaces) {
          exports.storage.removeItem('debug');
        } else {
          exports.storage.debug = namespaces;
        }
      } catch(e) {}
    }
    
    /**
     * Load `namespaces`.
     *
     * @return {String} returns the previously persisted debug modes
     * @api private
     */
    
    function load() {
      var r;
      try {
        r = exports.storage.debug;
      } catch(e) {}
    
      // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
      if (!r && typeof process !== 'undefined' && 'env' in process) {
        r = process.env.DEBUG;
      }
    
      return r;
    }
    
    /**
     * Enable namespaces listed in `localStorage.debug` initially.
     */
    
    exports.enable(load());
    
    /**
     * Localstorage attempts to return the localstorage.
     *
     * This is necessary because safari throws
     * when a user disables cookies/localstorage
     * and you attempt to access it.
     *
     * @return {LocalStorage}
     * @api private
     */
    
    function localstorage() {
      try {
        return window.localStorage;
      } catch (e) {}
    }
    
    /* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(14)))
    
    /***/ }),
    /* 52 */
    /***/ (function(module, exports, __webpack_require__) {
    
    
    /**
     * This is the common logic for both the Node.js and web browser
     * implementations of `debug()`.
     *
     * Expose `debug()` as the module.
     */
    
    exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
    exports.coerce = coerce;
    exports.disable = disable;
    exports.enable = enable;
    exports.enabled = enabled;
    exports.humanize = __webpack_require__(53);
    
    /**
     * The currently active debug mode names, and names to skip.
     */
    
    exports.names = [];
    exports.skips = [];
    
    /**
     * Map of special "%n" handling functions, for the debug "format" argument.
     *
     * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
     */
    
    exports.formatters = {};
    
    /**
     * Previous log timestamp.
     */
    
    var prevTime;
    
    /**
     * Select a color.
     * @param {String} namespace
     * @return {Number}
     * @api private
     */
    
    function selectColor(namespace) {
      var hash = 0, i;
    
      for (i in namespace) {
        hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
        hash |= 0; // Convert to 32bit integer
      }
    
      return exports.colors[Math.abs(hash) % exports.colors.length];
    }
    
    /**
     * Create a debugger with the given `namespace`.
     *
     * @param {String} namespace
     * @return {Function}
     * @api public
     */
    
    function createDebug(namespace) {
    
      function debug() {
        // disabled?
        if (!debug.enabled) return;
    
        var self = debug;
    
        // set `diff` timestamp
        var curr = +new Date();
        var ms = curr - (prevTime || curr);
        self.diff = ms;
        self.prev = prevTime;
        self.curr = curr;
        prevTime = curr;
    
        // turn the `arguments` into a proper Array
        var args = new Array(arguments.length);
        for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i];
        }
    
        args[0] = exports.coerce(args[0]);
    
        if ('string' !== typeof args[0]) {
          // anything else let's inspect with %O
          args.unshift('%O');
        }
    
        // apply any `formatters` transformations
        var index = 0;
        args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
          // if we encounter an escaped % then don't increase the array index
          if (match === '%%') return match;
          index++;
          var formatter = exports.formatters[format];
          if ('function' === typeof formatter) {
            var val = args[index];
            match = formatter.call(self, val);
    
            // now we need to remove `args[index]` since it's inlined in the `format`
            args.splice(index, 1);
            index--;
          }
          return match;
        });
    
        // apply env-specific formatting (colors, etc.)
        exports.formatArgs.call(self, args);
    
        var logFn = debug.log || exports.log || console.log.bind(console);
        logFn.apply(self, args);
      }
    
      debug.namespace = namespace;
      debug.enabled = exports.enabled(namespace);
      debug.useColors = exports.useColors();
      debug.color = selectColor(namespace);
    
      // env-specific initialization logic for debug instances
      if ('function' === typeof exports.init) {
        exports.init(debug);
      }
    
      return debug;
    }
    
    /**
     * Enables a debug mode by namespaces. This can include modes
     * separated by a colon and wildcards.
     *
     * @param {String} namespaces
     * @api public
     */
    
    function enable(namespaces) {
      exports.save(namespaces);
    
      exports.names = [];
      exports.skips = [];
    
      var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
      var len = split.length;
    
      for (var i = 0; i < len; i++) {
        if (!split[i]) continue; // ignore empty strings
        namespaces = split[i].replace(/\*/g, '.*?');
        if (namespaces[0] === '-') {
          exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
        } else {
          exports.names.push(new RegExp('^' + namespaces + '$'));
        }
      }
    }
    
    /**
     * Disable debug output.
     *
     * @api public
     */
    
    function disable() {
      exports.enable('');
    }
    
    /**
     * Returns true if the given mode name is enabled, false otherwise.
     *
     * @param {String} name
     * @return {Boolean}
     * @api public
     */
    
    function enabled(name) {
      var i, len;
      for (i = 0, len = exports.skips.length; i < len; i++) {
        if (exports.skips[i].test(name)) {
          return false;
        }
      }
      for (i = 0, len = exports.names.length; i < len; i++) {
        if (exports.names[i].test(name)) {
          return true;
        }
      }
      return false;
    }
    
    /**
     * Coerce `val`.
     *
     * @param {Mixed} val
     * @return {Mixed}
     * @api private
     */
    
    function coerce(val) {
      if (val instanceof Error) return val.stack || val.message;
      return val;
    }
    
    
    /***/ }),
    /* 53 */
    /***/ (function(module, exports) {
    
    /**
     * Helpers.
     */
    
    var s = 1000;
    var m = s * 60;
    var h = m * 60;
    var d = h * 24;
    var y = d * 365.25;
    
    /**
     * Parse or format the given `val`.
     *
     * Options:
     *
     *  - `long` verbose formatting [false]
     *
     * @param {String|Number} val
     * @param {Object} [options]
     * @throws {Error} throw an error if val is not a non-empty string or a number
     * @return {String|Number}
     * @api public
     */
    
    module.exports = function(val, options) {
      options = options || {};
      var type = typeof val;
      if (type === 'string' && val.length > 0) {
        return parse(val);
      } else if (type === 'number' && isNaN(val) === false) {
        return options.long ? fmtLong(val) : fmtShort(val);
      }
      throw new Error(
        'val is not a non-empty string or a valid number. val=' +
          JSON.stringify(val)
      );
    };
    
    /**
     * Parse the given `str` and return milliseconds.
     *
     * @param {String} str
     * @return {Number}
     * @api private
     */
    
    function parse(str) {
      str = String(str);
      if (str.length > 100) {
        return;
      }
      var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
        str
      );
      if (!match) {
        return;
      }
      var n = parseFloat(match[1]);
      var type = (match[2] || 'ms').toLowerCase();
      switch (type) {
        case 'years':
        case 'year':
        case 'yrs':
        case 'yr':
        case 'y':
          return n * y;
        case 'days':
        case 'day':
        case 'd':
          return n * d;
        case 'hours':
        case 'hour':
        case 'hrs':
        case 'hr':
        case 'h':
          return n * h;
        case 'minutes':
        case 'minute':
        case 'mins':
        case 'min':
        case 'm':
          return n * m;
        case 'seconds':
        case 'second':
        case 'secs':
        case 'sec':
        case 's':
          return n * s;
        case 'milliseconds':
        case 'millisecond':
        case 'msecs':
        case 'msec':
        case 'ms':
          return n;
        default:
          return undefined;
      }
    }
    
    /**
     * Short format for `ms`.
     *
     * @param {Number} ms
     * @return {String}
     * @api private
     */
    
    function fmtShort(ms) {
      if (ms >= d) {
        return Math.round(ms / d) + 'd';
      }
      if (ms >= h) {
        return Math.round(ms / h) + 'h';
      }
      if (ms >= m) {
        return Math.round(ms / m) + 'm';
      }
      if (ms >= s) {
        return Math.round(ms / s) + 's';
      }
      return ms + 'ms';
    }
    
    /**
     * Long format for `ms`.
     *
     * @param {Number} ms
     * @return {String}
     * @api private
     */
    
    function fmtLong(ms) {
      return plural(ms, d, 'day') ||
        plural(ms, h, 'hour') ||
        plural(ms, m, 'minute') ||
        plural(ms, s, 'second') ||
        ms + ' ms';
    }
    
    /**
     * Pluralization helper.
     */
    
    function plural(ms, n, name) {
      if (ms < n) {
        return;
      }
      if (ms < n * 1.5) {
        return Math.floor(ms / n) + ' ' + name;
      }
      return Math.ceil(ms / n) + ' ' + name + 's';
    }
    
    
    /***/ }),
    /* 54 */
    /***/ (function(module, exports, __webpack_require__) {
    
    "use strict";
    
    
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    
    
    /**
     * @see https://developers.google.com/youtube/iframe_api_reference#Functions
     */
    exports.default = ['cueVideoById', 'loadVideoById', 'cueVideoByUrl', 'loadVideoByUrl', 'playVideo', 'pauseVideo', 'stopVideo', 'getVideoLoadedFraction', 'cuePlaylist', 'loadPlaylist', 'nextVideo', 'previousVideo', 'playVideoAt', 'setShuffle', 'setLoop', 'getPlaylist', 'getPlaylistIndex', 'setOption', 'mute', 'unMute', 'isMuted', 'setVolume', 'getVolume', 'seekTo', 'getPlayerState', 'getPlaybackRate', 'setPlaybackRate', 'getAvailablePlaybackRates', 'getPlaybackQuality', 'setPlaybackQuality', 'getAvailableQualityLevels', 'getCurrentTime', 'getDuration', 'removeEventListener', 'getVideoUrl', 'getVideoEmbedCode', 'getOptions', 'getOption', 'addEventListener', 'destroy', 'setSize', 'getIframe'];
    module.exports = exports['default'];
    
    /***/ }),
    /* 55 */
    /***/ (function(module, exports, __webpack_require__) {
    
    "use strict";
    
    
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    
    
    /**
     * @see https://developers.google.com/youtube/iframe_api_reference#Events
     * `volumeChange` is not officially supported but seems to work
     * it emits an object: `{volume: 82.6923076923077, muted: false}`
     */
    exports.default = ['ready', 'stateChange', 'playbackQualityChange', 'playbackRateChange', 'error', 'apiChange', 'volumeChange'];
    module.exports = exports['default'];
    
    /***/ }),
    /* 56 */
    /***/ (function(module, exports, __webpack_require__) {
    
    "use strict";
    
    
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    
    var _PlayerStates = __webpack_require__(57);
    
    var _PlayerStates2 = _interopRequireDefault(_PlayerStates);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    exports.default = {
      pauseVideo: {
        acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PAUSED],
        stateChangeRequired: false
      },
      playVideo: {
        acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PLAYING],
        stateChangeRequired: false
      },
      seekTo: {
        acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PLAYING, _PlayerStates2.default.PAUSED],
        stateChangeRequired: true,
    
        // TRICKY: `seekTo` may not cause a state change if no buffering is
        // required.
        timeout: 3000
      }
    };
    module.exports = exports['default'];
    
    /***/ }),
    /* 57 */
    /***/ (function(module, exports, __webpack_require__) {
    
    "use strict";
    
    
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = {
      BUFFERING: 3,
      ENDED: 0,
      PAUSED: 2,
      PLAYING: 1,
      UNSTARTED: -1,
      VIDEO_CUED: 5
    };
    module.exports = exports["default"];
    
    /***/ }),
    /* 58 */
    /***/ (function(module, exports, __webpack_require__) {
    
    /* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
                (typeof self !== "undefined" && self) ||
                window;
    var apply = Function.prototype.apply;
    
    // DOM APIs, for completeness
    
    exports.setTimeout = function() {
      return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
    };
    exports.setInterval = function() {
      return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
    };
    exports.clearTimeout =
    exports.clearInterval = function(timeout) {
      if (timeout) {
        timeout.close();
      }
    };
    
    function Timeout(id, clearFn) {
      this._id = id;
      this._clearFn = clearFn;
    }
    Timeout.prototype.unref = Timeout.prototype.ref = function() {};
    Timeout.prototype.close = function() {
      this._clearFn.call(scope, this._id);
    };
    
    // Does not start the time, just sets up the members needed.
    exports.enroll = function(item, msecs) {
      clearTimeout(item._idleTimeoutId);
      item._idleTimeout = msecs;
    };
    
    exports.unenroll = function(item) {
      clearTimeout(item._idleTimeoutId);
      item._idleTimeout = -1;
    };
    
    exports._unrefActive = exports.active = function(item) {
      clearTimeout(item._idleTimeoutId);
    
      var msecs = item._idleTimeout;
      if (msecs >= 0) {
        item._idleTimeoutId = setTimeout(function onTimeout() {
          if (item._onTimeout)
            item._onTimeout();
        }, msecs);
      }
    };
    
    // setimmediate attaches itself to the global object
    __webpack_require__(59);
    // On some exotic environments, it's not clear which object `setimmediate` was
    // able to install onto.  Search each possibility in the same order as the
    // `setimmediate` library.
    exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                           (typeof global !== "undefined" && global.setImmediate) ||
                           (this && this.setImmediate);
    exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                             (typeof global !== "undefined" && global.clearImmediate) ||
                             (this && this.clearImmediate);
    
    /* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(10)))
    
    /***/ }),
    /* 59 */
    /***/ (function(module, exports, __webpack_require__) {
    
    /* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
        "use strict";
    
        if (global.setImmediate) {
            return;
        }
    
        var nextHandle = 1; // Spec says greater than zero
        var tasksByHandle = {};
        var currentlyRunningATask = false;
        var doc = global.document;
        var registerImmediate;
    
        function setImmediate(callback) {
          // Callback can either be a function or a string
          if (typeof callback !== "function") {
            callback = new Function("" + callback);
          }
          // Copy function arguments
          var args = new Array(arguments.length - 1);
          for (var i = 0; i < args.length; i++) {
              args[i] = arguments[i + 1];
          }
          // Store and register the task
          var task = { callback: callback, args: args };
          tasksByHandle[nextHandle] = task;
          registerImmediate(nextHandle);
          return nextHandle++;
        }
    
        function clearImmediate(handle) {
            delete tasksByHandle[handle];
        }
    
        function run(task) {
            var callback = task.callback;
            var args = task.args;
            switch (args.length) {
            case 0:
                callback();
                break;
            case 1:
                callback(args[0]);
                break;
            case 2:
                callback(args[0], args[1]);
                break;
            case 3:
                callback(args[0], args[1], args[2]);
                break;
            default:
                callback.apply(undefined, args);
                break;
            }
        }
    
        function runIfPresent(handle) {
            // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
            // So if we're currently running a task, we'll need to delay this invocation.
            if (currentlyRunningATask) {
                // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
                // "too much recursion" error.
                setTimeout(runIfPresent, 0, handle);
            } else {
                var task = tasksByHandle[handle];
                if (task) {
                    currentlyRunningATask = true;
                    try {
                        run(task);
                    } finally {
                        clearImmediate(handle);
                        currentlyRunningATask = false;
                    }
                }
            }
        }
    
        function installNextTickImplementation() {
            registerImmediate = function(handle) {
                process.nextTick(function () { runIfPresent(handle); });
            };
        }
    
        function canUsePostMessage() {
            // The test against `importScripts` prevents this implementation from being installed inside a web worker,
            // where `global.postMessage` means something completely different and can't be used for this purpose.
            if (global.postMessage && !global.importScripts) {
                var postMessageIsAsynchronous = true;
                var oldOnMessage = global.onmessage;
                global.onmessage = function() {
                    postMessageIsAsynchronous = false;
                };
                global.postMessage("", "*");
                global.onmessage = oldOnMessage;
                return postMessageIsAsynchronous;
            }
        }
    
        function installPostMessageImplementation() {
            // Installs an event handler on `global` for the `message` event: see
            // * https://developer.mozilla.org/en/DOM/window.postMessage
            // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
    
            var messagePrefix = "setImmediate$" + Math.random() + "$";
            var onGlobalMessage = function(event) {
                if (event.source === global &&
                    typeof event.data === "string" &&
                    event.data.indexOf(messagePrefix) === 0) {
                    runIfPresent(+event.data.slice(messagePrefix.length));
                }
            };
    
            if (global.addEventListener) {
                global.addEventListener("message", onGlobalMessage, false);
            } else {
                global.attachEvent("onmessage", onGlobalMessage);
            }
    
            registerImmediate = function(handle) {
                global.postMessage(messagePrefix + handle, "*");
            };
        }
    
        function installMessageChannelImplementation() {
            var channel = new MessageChannel();
            channel.port1.onmessage = function(event) {
                var handle = event.data;
                runIfPresent(handle);
            };
    
            registerImmediate = function(handle) {
                channel.port2.postMessage(handle);
            };
        }
    
        function installReadyStateChangeImplementation() {
            var html = doc.documentElement;
            registerImmediate = function(handle) {
                // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
                // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
                var script = doc.createElement("script");
                script.onreadystatechange = function () {
                    runIfPresent(handle);
                    script.onreadystatechange = null;
                    html.removeChild(script);
                    script = null;
                };
                html.appendChild(script);
            };
        }
    
        function installSetTimeoutImplementation() {
            registerImmediate = function(handle) {
                setTimeout(runIfPresent, 0, handle);
            };
        }
    
        // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
        var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
        attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
    
        // Don't get fooled by e.g. browserify environments.
        if ({}.toString.call(global.process) === "[object process]") {
            // For Node.js before 0.9
            installNextTickImplementation();
    
        } else if (canUsePostMessage()) {
            // For non-IE10 modern browsers
            installPostMessageImplementation();
    
        } else if (global.MessageChannel) {
            // For web workers, where supported
            installMessageChannelImplementation();
    
        } else if (doc && "onreadystatechange" in doc.createElement("script")) {
            // For IE 6–8
            installReadyStateChangeImplementation();
    
        } else {
            // For older browsers
            installSetTimeoutImplementation();
        }
    
        attachTo.setImmediate = setImmediate;
        attachTo.clearImmediate = clearImmediate;
    }(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
    
    /* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(10), __webpack_require__(14)))
    
    /***/ }),
    /* 60 */
    /***/ (function(module, exports) {
    
    module.exports = function(module) {
        if (!module.webpackPolyfill) {
            module.deprecate = function() {};
            module.paths = [];
            // module.parent = undefined by default
            if (!module.children) module.children = [];
            Object.defineProperty(module, "loaded", {
                enumerable: true,
                get: function() {
                    return module.l;
                }
            });
            Object.defineProperty(module, "id", {
                enumerable: true,
                get: function() {
                    return module.i;
                }
            });
            module.webpackPolyfill = 1;
        }
        return module;
    };
    
    
    /***/ }),
    /* 61 */
    /***/ (function(module, __webpack_exports__, __webpack_require__) {
    
    "use strict";
    // ESM COMPAT FLAG
    __webpack_require__.r(__webpack_exports__);
    
    // CONCATENATED MODULE: ./node_modules/@shopify/theme-sections/section.js
    var SECTION_ID_ATTR = 'data-section-id';
    
    function Section(container, properties) {
      this.container = validateContainerElement(container);
      this.id = container.getAttribute(SECTION_ID_ATTR);
      this.extensions = [];
    
      // eslint-disable-next-line es5/no-es6-static-methods
      Object.assign(this, validatePropertiesObject(properties));
    
      this.onLoad();
    }
    
    Section.prototype = {
      onLoad: Function.prototype,
      onUnload: Function.prototype,
      onSelect: Function.prototype,
      onDeselect: Function.prototype,
      onBlockSelect: Function.prototype,
      onBlockDeselect: Function.prototype,
    
      extend: function extend(extension) {
        this.extensions.push(extension); // Save original extension
    
        // eslint-disable-next-line es5/no-es6-static-methods
        var extensionClone = Object.assign({}, extension);
        delete extensionClone.init; // Remove init function before assigning extension properties
    
        // eslint-disable-next-line es5/no-es6-static-methods
        Object.assign(this, extensionClone);
    
        if (typeof extension.init === 'function') {
          extension.init.apply(this);
        }
      }
    };
    
    function validateContainerElement(container) {
      if (!(container instanceof Element)) {
        throw new TypeError(
          'Theme Sections: Attempted to load section. The section container provided is not a DOM element.'
        );
      }
      if (container.getAttribute(SECTION_ID_ATTR) === null) {
        throw new Error(
          'Theme Sections: The section container provided does not have an id assigned to the ' +
            SECTION_ID_ATTR +
            ' attribute.'
        );
      }
    
      return container;
    }
    
    function validatePropertiesObject(value) {
      if (
        (typeof value !== 'undefined' && typeof value !== 'object') ||
        value === null
      ) {
        throw new TypeError(
          'Theme Sections: The properties object provided is not a valid'
        );
      }
    
      return value;
    }
    
    // Object.assign() polyfill from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign#Polyfill
    if (typeof Object.assign != 'function') {
      // Must be writable: true, enumerable: false, configurable: true
      Object.defineProperty(Object, 'assign', {
        value: function assign(target) {
          // .length of function is 2
          'use strict';
          if (target == null) {
            // TypeError if undefined or null
            throw new TypeError('Cannot convert undefined or null to object');
          }
    
          var to = Object(target);
    
          for (var index = 1; index < arguments.length; index++) {
            var nextSource = arguments[index];
    
            if (nextSource != null) {
              // Skip over if undefined or null
              for (var nextKey in nextSource) {
                // Avoid bugs when hasOwnProperty is shadowed
                if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                  to[nextKey] = nextSource[nextKey];
                }
              }
            }
          }
          return to;
        },
        writable: true,
        configurable: true
      });
    }
    
    // CONCATENATED MODULE: ./node_modules/@shopify/theme-sections/theme-sections.js
    /*
     * @shopify/theme-sections
     * -----------------------------------------------------------------------------
     *
     * A framework to provide structure to your Shopify sections and a load and unload
     * lifecycle. The lifecycle is automatically connected to theme editor events so
     * that your sections load and unload as the editor changes the content and
     * settings of your sections.
     */
    
    
    
    var SECTION_TYPE_ATTR = 'data-section-type';
    var theme_sections_SECTION_ID_ATTR = 'data-section-id';
    
    window.Shopify = window.Shopify || {};
    window.Shopify.theme = window.Shopify.theme || {};
    window.Shopify.theme.sections = window.Shopify.theme.sections || {};
    
    var registered = (window.Shopify.theme.sections.registered =
      window.Shopify.theme.sections.registered || {});
    var theme_sections_instances = (window.Shopify.theme.sections.instances =
      window.Shopify.theme.sections.instances || []);
    
    function register(type, properties) {
      if (typeof type !== 'string') {
        throw new TypeError(
          'Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered'
        );
      }
    
      if (typeof registered[type] !== 'undefined') {
        throw new Error(
          'Theme Sections: A section of type "' +
            type +
            '" has already been registered. You cannot register the same section type twice'
        );
      }
    
      function TypedSection(container) {
        Section.call(this, container, properties);
      }
    
      TypedSection.constructor = Section;
      TypedSection.prototype = Object.create(Section.prototype);
      TypedSection.prototype.type = type;
    
      return (registered[type] = TypedSection);
    }
    
    function unregister(types) {
      types = normalizeType(types);
    
      types.forEach(function(type) {
        delete registered[type];
      });
    }
    
    function load(types, containers) {
      types = normalizeType(types);
    
      if (typeof containers === 'undefined') {
        containers = document.querySelectorAll('[' + SECTION_TYPE_ATTR + ']');
      }
    
      containers = normalizeContainers(containers);
    
      types.forEach(function(type) {
        var TypedSection = registered[type];
    
        if (typeof TypedSection === 'undefined') {
          return;
        }
    
        containers = containers.filter(function(container) {
          // Filter from list of containers because container already has an instance loaded
          if (isInstance(container)) {
            return false;
          }
    
          // Filter from list of containers because container doesn't have data-section-type attribute
          if (container.getAttribute(SECTION_TYPE_ATTR) === null) {
            return false;
          }
    
          // Keep in list of containers because current type doesn't match
          if (container.getAttribute(SECTION_TYPE_ATTR) !== type) {
            return true;
          }
    
          theme_sections_instances.push(new TypedSection(container));
    
          // Filter from list of containers because container now has an instance loaded
          return false;
        });
      });
    }
    
    function theme_sections_unload(selector) {
      var instancesToUnload = getInstances(selector);
    
      instancesToUnload.forEach(function(instance) {
        var index = theme_sections_instances
          .map(function(e) {
            return e.id;
          })
          .indexOf(instance.id);
        theme_sections_instances.splice(index, 1);
        instance.onUnload();
      });
    }
    
    function extend(selector, extension) {
      var instancesToExtend = getInstances(selector);
    
      instancesToExtend.forEach(function(instance) {
        instance.extend(extension);
      });
    }
    
    function getInstances(selector) {
      var filteredInstances = [];
    
      // Fetch first element if its an array
      if (NodeList.prototype.isPrototypeOf(selector) || Array.isArray(selector)) {
        var firstElement = selector[0];
      }
    
      // If selector element is DOM element
      if (selector instanceof Element || firstElement instanceof Element) {
        var containers = normalizeContainers(selector);
    
        containers.forEach(function(container) {
          filteredInstances = filteredInstances.concat(
            theme_sections_instances.filter(function(instance) {
              return instance.container === container;
            })
          );
        });
    
        // If select is type string
      } else if (typeof selector === 'string' || typeof firstElement === 'string') {
        var types = normalizeType(selector);
    
        types.forEach(function(type) {
          filteredInstances = filteredInstances.concat(
            theme_sections_instances.filter(function(instance) {
              return instance.type === type;
            })
          );
        });
      }
    
      return filteredInstances;
    }
    
    function getInstanceById(id) {
      var instance;
    
      for (var i = 0; i < theme_sections_instances.length; i++) {
        if (theme_sections_instances[i].id === id) {
          instance = theme_sections_instances[i];
          break;
        }
      }
      return instance;
    }
    
    function isInstance(selector) {
      return getInstances(selector).length > 0;
    }
    
    function normalizeType(types) {
      // If '*' then fetch all registered section types
      if (types === '*') {
        types = Object.keys(registered);
    
        // If a single section type string is passed, put it in an array
      } else if (typeof types === 'string') {
        types = [types];
    
        // If single section constructor is passed, transform to array with section
        // type string
      } else if (types.constructor === Section) {
        types = [types.prototype.type];
    
        // If array of typed section constructors is passed, transform the array to
        // type strings
      } else if (Array.isArray(types) && types[0].constructor === Section) {
        types = types.map(function(TypedSection) {
          return TypedSection.prototype.type;
        });
      }
    
      types = types.map(function(type) {
        return type.toLowerCase();
      });
    
      return types;
    }
    
    function normalizeContainers(containers) {
      // Nodelist with entries
      if (NodeList.prototype.isPrototypeOf(containers) && containers.length > 0) {
        containers = Array.prototype.slice.call(containers);
    
        // Empty Nodelist
      } else if (
        NodeList.prototype.isPrototypeOf(containers) &&
        containers.length === 0
      ) {
        containers = [];
    
        // Handle null (document.querySelector() returns null with no match)
      } else if (containers === null) {
        containers = [];
    
        // Single DOM element
      } else if (!Array.isArray(containers) && containers instanceof Element) {
        containers = [containers];
      }
    
      return containers;
    }
    
    if (window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', function(event) {
        var id = event.detail.sectionId;
        var container = event.target.querySelector(
          '[' + theme_sections_SECTION_ID_ATTR + '="' + id + '"]'
        );
    
        if (container !== null) {
          load(container.getAttribute(SECTION_TYPE_ATTR), container);
        }
      });
    
      document.addEventListener('shopify:section:unload', function(event) {
        var id = event.detail.sectionId;
        var container = event.target.querySelector(
          '[' + theme_sections_SECTION_ID_ATTR + '="' + id + '"]'
        );
        var instance = getInstances(container)[0];
    
        if (typeof instance === 'object') {
          theme_sections_unload(container);
        }
      });
    
      document.addEventListener('shopify:section:select', function(event) {
        var instance = getInstanceById(event.detail.sectionId);
    
        if (typeof instance === 'object') {
          instance.onSelect(event);
        }
      });
    
      document.addEventListener('shopify:section:deselect', function(event) {
        var instance = getInstanceById(event.detail.sectionId);
    
        if (typeof instance === 'object') {
          instance.onDeselect(event);
        }
      });
    
      document.addEventListener('shopify:block:select', function(event) {
        var instance = getInstanceById(event.detail.sectionId);
    
        if (typeof instance === 'object') {
          instance.onBlockSelect(event);
        }
      });
    
      document.addEventListener('shopify:block:deselect', function(event) {
        var instance = getInstanceById(event.detail.sectionId);
    
        if (typeof instance === 'object') {
          instance.onBlockDeselect(event);
        }
      });
    }
    
    // CONCATENATED MODULE: ./node_modules/slide-anim/dist/slide-anim.module.js
    /*!
     * slide-anim
     * https://github.com/yomotsu/slide-anim
     * (c) 2017 @yomotsu
     * Released under the MIT License.
     */
    var global = window;
    var isPromiseSuppoted = typeof global.Promise === 'function';
    var PromiseLike = isPromiseSuppoted ? global.Promise : (function () {
        function PromiseLike(executor) {
            var callback = function () { };
            var resolve = function () {
                callback();
            };
            executor(resolve);
            return {
                then: function (_callback) {
                    callback = _callback;
                }
            };
        }
        return PromiseLike;
    }());
    
    var pool = [];
    var inAnimItems = {
        add: function (el, defaultStyle, timeoutId, onCancelled) {
            var inAnimItem = { el: el, defaultStyle: defaultStyle, timeoutId: timeoutId, onCancelled: onCancelled };
            this.remove(el);
            pool.push(inAnimItem);
        },
        remove: function (el) {
            var index = inAnimItems.findIndex(el);
            if (index === -1)
                return;
            var inAnimItem = pool[index];
            clearTimeout(inAnimItem.timeoutId);
            inAnimItem.onCancelled();
            pool.splice(index, 1);
        },
        find: function (el) {
            return pool[inAnimItems.findIndex(el)];
        },
        findIndex: function (el) {
            var index = -1;
            pool.some(function (item, i) {
                if (item.el === el) {
                    index = i;
                    return true;
                }
                return false;
            });
            return index;
        }
    };
    
    var CSS_EASEOUT_EXPO = 'cubic-bezier( 0.19, 1, 0.22, 1 )';
    function slideDown(el, options) {
        if (options === void 0) { options = {}; }
        return new PromiseLike(function (resolve) {
            if (inAnimItems.findIndex(el) !== -1)
                return;
            var _isVisible = isVisible(el);
            var hasEndHeight = typeof options.endHeight === 'number';
            var display = options.display || 'block';
            var duration = options.duration || 400;
            var onCancelled = options.onCancelled || function () { };
            var defaultStyle = el.getAttribute('style') || '';
            var style = window.getComputedStyle(el);
            var defaultStyles = getDefaultStyles(el, display);
            var isBorderBox = /border-box/.test(style.getPropertyValue('box-sizing'));
            var contentHeight = defaultStyles.height;
            var minHeight = defaultStyles.minHeight;
            var paddingTop = defaultStyles.paddingTop;
            var paddingBottom = defaultStyles.paddingBottom;
            var borderTop = defaultStyles.borderTop;
            var borderBottom = defaultStyles.borderBottom;
            var cssDuration = duration + "ms";
            var cssEasing = CSS_EASEOUT_EXPO;
            var cssTransition = [
                "height " + cssDuration + " " + cssEasing,
                "min-height " + cssDuration + " " + cssEasing,
                "padding " + cssDuration + " " + cssEasing,
                "border-width " + cssDuration + " " + cssEasing
            ].join();
            var startHeight = _isVisible ? style.height : '0px';
            var startMinHeight = _isVisible ? style.minHeight : '0px';
            var startPaddingTop = _isVisible ? style.paddingTop : '0px';
            var startPaddingBottom = _isVisible ? style.paddingBottom : '0px';
            var startBorderTopWidth = _isVisible ? style.borderTopWidth : '0px';
            var startBorderBottomWidth = _isVisible ? style.borderBottomWidth : '0px';
            var endHeight = (function () {
                if (hasEndHeight)
                    return options.endHeight + "px";
                return !isBorderBox ?
                    contentHeight - paddingTop - paddingBottom + "px" :
                    contentHeight + borderTop + borderBottom + "px";
            })();
            var endMinHeight = minHeight + "px";
            var endPaddingTop = paddingTop + "px";
            var endPaddingBottom = paddingBottom + "px";
            var endBorderTopWidth = borderTop + "px";
            var endBorderBottomWidth = borderBottom + "px";
            if (startHeight === endHeight &&
                startPaddingTop === endPaddingTop &&
                startPaddingBottom === endPaddingBottom &&
                startBorderTopWidth === endBorderTopWidth &&
                startBorderBottomWidth === endBorderBottomWidth) {
                resolve();
                return;
            }
            requestAnimationFrame(function () {
                el.style.height = startHeight;
                el.style.minHeight = startMinHeight;
                el.style.paddingTop = startPaddingTop;
                el.style.paddingBottom = startPaddingBottom;
                el.style.borderTopWidth = startBorderTopWidth;
                el.style.borderBottomWidth = startBorderBottomWidth;
                el.style.display = display;
                el.style.overflow = 'hidden';
                el.style.visibility = 'visible';
                el.style.transition = cssTransition;
                el.style.webkitTransition = cssTransition;
                requestAnimationFrame(function () {
                    el.style.height = endHeight;
                    el.style.minHeight = endMinHeight;
                    el.style.paddingTop = endPaddingTop;
                    el.style.paddingBottom = endPaddingBottom;
                    el.style.borderTopWidth = endBorderTopWidth;
                    el.style.borderBottomWidth = endBorderBottomWidth;
                });
            });
            var timeoutId = setTimeout(function () {
                resetStyle(el);
                el.style.display = display;
                if (hasEndHeight) {
                    el.style.height = options.endHeight + "px";
                    el.style.overflow = "hidden";
                }
                inAnimItems.remove(el);
                resolve();
            }, duration);
            inAnimItems.add(el, defaultStyle, timeoutId, onCancelled);
        });
    }
    function slideUp(el, options) {
        if (options === void 0) { options = {}; }
        return new PromiseLike(function (resolve) {
            if (inAnimItems.findIndex(el) !== -1)
                return;
            var _isVisible = isVisible(el);
            var display = options.display || 'block';
            var duration = options.duration || 400;
            var onCancelled = options.onCancelled || function () { };
            if (!_isVisible) {
                resolve();
                return;
            }
            var defaultStyle = el.getAttribute('style') || '';
            var style = window.getComputedStyle(el);
            var isBorderBox = /border-box/.test(style.getPropertyValue('box-sizing'));
            var minHeight = pxToNumber(style.getPropertyValue('min-height'));
            var paddingTop = pxToNumber(style.getPropertyValue('padding-top'));
            var paddingBottom = pxToNumber(style.getPropertyValue('padding-bottom'));
            var borderTop = pxToNumber(style.getPropertyValue('border-top-width'));
            var borderBottom = pxToNumber(style.getPropertyValue('border-bottom-width'));
            var contentHeight = el.scrollHeight;
            var cssDuration = duration + 'ms';
            var cssEasing = CSS_EASEOUT_EXPO;
            var cssTransition = [
                "height " + cssDuration + " " + cssEasing,
                "padding " + cssDuration + " " + cssEasing,
                "border-width " + cssDuration + " " + cssEasing
            ].join();
            var startHeight = !isBorderBox ?
                contentHeight - paddingTop - paddingBottom + "px" :
                contentHeight + borderTop + borderBottom + "px";
            var startMinHeight = minHeight + "px";
            var startPaddingTop = paddingTop + "px";
            var startPaddingBottom = paddingBottom + "px";
            var startBorderTopWidth = borderTop + "px";
            var startBorderBottomWidth = borderBottom + "px";
            requestAnimationFrame(function () {
                el.style.height = startHeight;
                el.style.minHeight = startMinHeight;
                el.style.paddingTop = startPaddingTop;
                el.style.paddingBottom = startPaddingBottom;
                el.style.borderTopWidth = startBorderTopWidth;
                el.style.borderBottomWidth = startBorderBottomWidth;
                el.style.display = display;
                el.style.overflow = 'hidden';
                el.style.transition = cssTransition;
                el.style.webkitTransition = cssTransition;
                requestAnimationFrame(function () {
                    el.style.height = '0';
                    el.style.minHeight = '0';
                    el.style.paddingTop = '0';
                    el.style.paddingBottom = '0';
                    el.style.borderTopWidth = '0';
                    el.style.borderBottomWidth = '0';
                });
            });
            var timeoutId = setTimeout(function () {
                resetStyle(el);
                el.style.display = 'none';
                inAnimItems.remove(el);
                resolve();
            }, duration);
            inAnimItems.add(el, defaultStyle, timeoutId, onCancelled);
        });
    }
    function slideStop(el) {
        var elementObject = inAnimItems.find(el);
        if (!elementObject)
            return;
        var style = window.getComputedStyle(el);
        var height = style.height;
        var paddingTop = style.paddingTop;
        var paddingBottom = style.paddingBottom;
        var borderTopWidth = style.borderTopWidth;
        var borderBottomWidth = style.borderBottomWidth;
        resetStyle(el);
        el.style.height = height;
        el.style.paddingTop = paddingTop;
        el.style.paddingBottom = paddingBottom;
        el.style.borderTopWidth = borderTopWidth;
        el.style.borderBottomWidth = borderBottomWidth;
        el.style.overflow = 'hidden';
        inAnimItems.remove(el);
    }
    function isVisible(el) {
        return el.offsetHeight !== 0;
    }
    function resetStyle(el) {
        el.style.visibility = '';
        el.style.height = '';
        el.style.minHeight = '';
        el.style.paddingTop = '';
        el.style.paddingBottom = '';
        el.style.borderTopWidth = '';
        el.style.borderBottomWidth = '';
        el.style.overflow = '';
        el.style.transition = '';
        el.style.webkitTransition = '';
    }
    function getDefaultStyles(el, defaultDisplay) {
        if (defaultDisplay === void 0) { defaultDisplay = 'block'; }
        var defaultStyle = el.getAttribute('style') || '';
        var style = window.getComputedStyle(el);
        el.style.visibility = 'hidden';
        el.style.display = defaultDisplay;
        var width = pxToNumber(style.getPropertyValue('width'));
        el.style.position = 'absolute';
        el.style.width = width + "px";
        el.style.height = '';
        el.style.minHeight = '';
        el.style.paddingTop = '';
        el.style.paddingBottom = '';
        el.style.borderTopWidth = '';
        el.style.borderBottomWidth = '';
        var minHeight = pxToNumber(style.getPropertyValue('min-height'));
        var paddingTop = pxToNumber(style.getPropertyValue('padding-top'));
        var paddingBottom = pxToNumber(style.getPropertyValue('padding-bottom'));
        var borderTop = pxToNumber(style.getPropertyValue('border-top-width'));
        var borderBottom = pxToNumber(style.getPropertyValue('border-bottom-width'));
        var height = el.scrollHeight;
        el.setAttribute('style', defaultStyle);
        return {
            height: height,
            minHeight: minHeight,
            paddingTop: paddingTop,
            paddingBottom: paddingBottom,
            borderTop: borderTop,
            borderBottom: borderBottom
        };
    }
    function pxToNumber(px) {
        return +px.replace(/px/, '');
    }
    
    
    
    // CONCATENATED MODULE: ./node_modules/@fluorescent/dom/dist/fluorescent-dom.es.js
    function fluorescent_dom_es_n(n,t){return void 0===t&&(t=document),t.querySelector(n)}function fluorescent_dom_es_t(n,t){return void 0===t&&(t=document),[].slice.call(t.querySelectorAll(n))}function fluorescent_dom_es_c(n,t){return Array.isArray(n)?n.forEach(t):t(n)}function fluorescent_dom_es_r(n){return function(t,r,e){return fluorescent_dom_es_c(t,function(t){return t[n+"EventListener"](r,e)})}}function fluorescent_dom_es_e(n,t,c){return fluorescent_dom_es_r("add")(n,t,c),function(){return fluorescent_dom_es_r("remove")(n,t,c)}}function fluorescent_dom_es_o(n){return function(t){var r=arguments;return fluorescent_dom_es_c(t,function(t){var c;return(c=t.classList)[n].apply(c,[].slice.call(r,1))})}}function fluorescent_dom_es_u(n){fluorescent_dom_es_o("add").apply(void 0,[n].concat([].slice.call(arguments,1)))}function fluorescent_dom_es_i(n){fluorescent_dom_es_o("remove").apply(void 0,[n].concat([].slice.call(arguments,1)))}function fluorescent_dom_es_l(n){fluorescent_dom_es_o("toggle").apply(void 0,[n].concat([].slice.call(arguments,1)))}function fluorescent_dom_es_a(n,t){return n.classList.contains(t)}
    
    // CONCATENATED MODULE: ./src/scripts/components/accordion.js
    
    
    var selectors = {
      labels: '.accordion__label'
    };
    
    var accordion_accordion = function accordion(node) {
      var labels = fluorescent_dom_es_t(selectors.labels, node);
      var events = [];
    
      var _handleAnimation = function _handleAnimation(e) {
        var _e$currentTarget = e.currentTarget,
            group = _e$currentTarget.parentNode,
            content = _e$currentTarget.nextElementSibling;
        e.preventDefault();
        slideStop(content);
    
        if (isVisible(content)) {
          slideUp(content);
          group.setAttribute('data-open', false);
          content.setAttribute('aria-hidden', true);
        } else {
          slideDown(content);
          group.setAttribute('data-open', true);
          content.setAttribute('aria-hidden', false);
        }
      };
    
      labels.forEach(function (label) {
        label.href = '#';
        events.push(fluorescent_dom_es_e(label, 'click', function (e) {
          return _handleAnimation(e);
        }));
      });
    
      var unload = function unload() {
        events.forEach(function (event) {
          event.element.removeEventListener(event.action, event["function"]);
        });
      };
    
      return {
        unload: unload
      };
    };
    
    /* harmony default export */ var components_accordion = (accordion_accordion);
    // CONCATENATED MODULE: ./node_modules/srraf/dist/srraf.es.js
    var srraf_es_n,srraf_es_e,srraf_es_i,srraf_es_o,srraf_es_t,srraf_es_r,srraf_es_f,srraf_es_d,srraf_es_p,srraf_es_u=[];function w(n,a){return srraf_es_e=window.pageXOffset,srraf_es_o=window.pageYOffset,srraf_es_r=window.innerHeight,srraf_es_d=window.innerWidth,void 0===srraf_es_i&&(srraf_es_i=srraf_es_e),void 0===srraf_es_t&&(srraf_es_t=srraf_es_o),void 0===srraf_es_p&&(srraf_es_p=srraf_es_d),void 0===srraf_es_f&&(srraf_es_f=srraf_es_r),(a||srraf_es_o!==srraf_es_t||srraf_es_e!==srraf_es_i||srraf_es_r!==srraf_es_f||srraf_es_d!==srraf_es_p)&&(!function(n){for(var w=0;w<srraf_es_u.length;w++)srraf_es_u[w]({x:srraf_es_e,y:srraf_es_o,px:srraf_es_i,py:srraf_es_t,vh:srraf_es_r,pvh:srraf_es_f,vw:srraf_es_d,pvw:srraf_es_p},n)}(n),srraf_es_i=srraf_es_e,srraf_es_t=srraf_es_o,srraf_es_f=srraf_es_r,srraf_es_p=srraf_es_d),requestAnimationFrame(w)}/* harmony default export */ var srraf_es = (function(e){return srraf_es_u.indexOf(e)<0&&srraf_es_u.push(e),srraf_es_n=srraf_es_n||w(performance.now()),{update:function(){return w(performance.now(),!0),this},destroy:function(){srraf_es_u.splice(srraf_es_u.indexOf(e),1)}}});
    //# sourceMappingURL=srraf.es.js.map
    
    // CONCATENATED MODULE: ./node_modules/evx/dist/evx.es.js
    var evx_es_n=function(n){if("object"!=typeof(t=n)||Array.isArray(t))throw"state should be an object";var t},evx_es_t=function(n,t,e,c){return(r=n,r.reduce(function(n,t,e){return n.indexOf(t)>-1?n:n.concat(t)},[])).reduce(function(n,e){return n.concat(t[e]||[])},[]).map(function(n){return n(e,c)});var r},evx_es_e=evx_es_a(),evx_es_c=evx_es_e.on,evx_es_r=evx_es_e.emit,evx_es_o=evx_es_e.hydrate,evx_es_u=evx_es_e.getState;function evx_es_a(e){void 0===e&&(e={});var c={};return{getState:function(){return Object.assign({},e)},hydrate:function(r){return evx_es_n(r),Object.assign(e,r),function(){var n=["*"].concat(Object.keys(r));evx_es_t(n,c,e)}},on:function(n,t){return(n=[].concat(n)).map(function(n){return c[n]=(c[n]||[]).concat(t)}),function(){return n.map(function(n){return c[n].splice(c[n].indexOf(t),1)})}},emit:function(r,o,u){var a=("*"===r?[]:["*"]).concat(r);(o="function"==typeof o?o(e):o)&&(evx_es_n(o),Object.assign(e,o),a=a.concat(Object.keys(o))),evx_es_t(a,c,e,u)}}}
    //# sourceMappingURL=evx.es.js.map
    
    // CONCATENATED MODULE: ./src/scripts/neon/events.js
    
    // CONCATENATED MODULE: ./src/scripts/components/stickyHeader.js
    
    
    var stickyHeader_selectors = {
      headerContainer: '.header-container',
      headerWrapper: '#header',
      announcementBar: '.announcement-bar-section',
      logoWrapper: '.header__logo-wrapper'
    };
    
    var stickyHeader_stickyHeader = function stickyHeader(node) {
      var root = document.documentElement; // Elements can change when resizing or altering header
    
      var headerParent = null;
      var headerHeight = null;
      var headerWrapper = null;
      var announcementBar = null;
      var announcementBarHeight = null;
      var logo = null;
      var headerHasCustomLogoImage = null;
      var initialHeightSet = false;
      var transparentEnabled = null;
      var scroller = null;
      var stickyScroller = null; // Breakpoint is equal to 60em
    
      var mediumBP = 960;
      var offsetRootVar = '--header-offset-height';
      var initialHeight = '--header-initial-height'; // get elements & element heights
    
      var _defineElements = function _defineElements() {
        headerParent = document.querySelector(stickyHeader_selectors.headerContainer);
        headerWrapper = node.querySelector(stickyHeader_selectors.headerWrapper);
        announcementBar = node.querySelector(stickyHeader_selectors.announcementBar);
        announcementBarHeight = announcementBar ? announcementBar.offsetHeight : 0;
        headerHeight = announcementBarHeight + headerWrapper.offsetHeight;
        logo = node.querySelector(stickyHeader_selectors.logoWrapper);
        headerHasCustomLogoImage = node.querySelector('.header__logo-image img'); // True if the transparent header is enabled in the theme editor
    
        transparentEnabled = JSON.parse(headerWrapper.dataset.transparentHeader);
      };
    
      _defineElements();
    
      var _screenUnderMediumBP = function _screenUnderMediumBP() {
        var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
        return viewportWidth <= mediumBP;
      };
    
      var screenUnderMediumBP = _screenUnderMediumBP();
    
      scroller = srraf_es(function (_ref) {
        var vw = _ref.vw;
    
        _setRootVar('--header-height', announcementBarHeight + headerWrapper.offsetHeight);
    
        var currentScreenWidthUnderMediumBP = vw <= mediumBP;
    
        if (currentScreenWidthUnderMediumBP !== screenUnderMediumBP) {
          screenUnderMediumBP = currentScreenWidthUnderMediumBP;
    
          _setupStickyHeader();
        }
      });
    
      var _setRootVar = function _setRootVar(name, value) {
        root.style.setProperty(name, "".concat(value, "px"));
      };
    
      var _setHeaderType = function _setHeaderType() {
        // Remove header types incase of customizer changes
        root.classList.remove('header-transparent', 'header-sticky');
        root.classList.add(transparentEnabled ? 'header-transparent' : 'header-sticky');
      };
    
      var _setupStickyHeader = function _setupStickyHeader() {
        //redifine elements & heights
        _defineElements(); // If the header has a logo image we calculate values after image has loaded
    
    
        if (!headerHasCustomLogoImage || headerHasCustomLogoImage && headerHasCustomLogoImage.complete) {
          _processStickyHeader();
        } else {
          headerHasCustomLogoImage.addEventListener('load', _processStickyHeader, {
            once: true
          });
        }
      };
    
      var _processStickyHeader = function _processStickyHeader() {
        if (!initialHeightSet) {
          _setRootVar(initialHeight, headerHeight);
    
          initialHeightSet = true;
        }
    
        _setRootVar(offsetRootVar, headerHeight);
    
        _setHeaderType();
    
        _initStickyHeader(_getStickyOffsets());
      }; // Returns object of offset values
    
    
      var _getStickyOffsets = function _getStickyOffsets() {
        var offsets = {};
        offsets.stickyHeaderResetPosition = announcementBarHeight ? 0 : 1; // Set offSets based on size and content of header
    
        offsets.offsetHeight = announcementBarHeight;
        offsets.scrollYToSticky = announcementBarHeight ? announcementBarHeight : 1;
        return offsets;
      };
    
      var _initStickyHeader = function _initStickyHeader(offsets) {
        var scrollYToSticky = offsets.scrollYToSticky,
            offsetHeight = offsets.offsetHeight,
            stickyHeaderResetPosition = offsets.stickyHeaderResetPosition; // Destroy stickyScroller if one already exists
    
        if (stickyScroller) {
          stickyScroller.destroy();
        } // Init the scroller to monitor for y position to stick/unstick header
    
    
        stickyScroller = srraf_es(function (_ref2) {
          var y = _ref2.y;
    
          if (y < scrollYToSticky) {
            _toggleStickyHeader(false, headerParent);
    
            _setElementTopPosition(headerParent, stickyHeaderResetPosition);
    
            _setRootVar(offsetRootVar, headerHeight - y);
          } else if (y >= scrollYToSticky) {
            _toggleStickyHeader(true, headerParent);
    
            _setElementTopPosition(headerParent, -offsetHeight);
    
            _setRootVar(offsetRootVar, headerHeight);
          }
        });
        stickyScroller.update();
      };
    
      var _setElementTopPosition = function _setElementTopPosition(element, value) {
        element.style.top = "".concat(value, "px");
      };
    
      var _toggleStickyHeader = function _toggleStickyHeader(isSticky, element) {
        if (isSticky) {
          root.classList.add('header-stuck');
          element.classList.add('is-sticky');
          headerWrapper.classList.remove('header--transparent');
        } else {
          element.classList.remove('is-sticky');
          root.classList.remove('header-stuck');
    
          if (transparentEnabled) {
            headerWrapper.classList.add('header--transparent');
          }
        }
      };
    
      var _reload = function _reload() {
        scroller.update();
    
        _setupStickyHeader(); // Let pages know the header changed
    
    
        evx_es_r('headerChange', function () {});
      };
    
      evx_es_c('sticky-header:reload', function () {
        _reload();
      });
    
      _setupStickyHeader();
    
      var unload = function unload() {
        if (scroller) {
          scroller.destroy();
        }
    
        if (stickyScroller) {
          stickyScroller.destroy();
        }
      };
    
      return {
        unload: unload
      };
    };
    
    /* harmony default export */ var components_stickyHeader = (stickyHeader_stickyHeader);
    // CONCATENATED MODULE: ./src/scripts/constants/events.js
    /* harmony default export */ var constants_events = ({
      filters: {
        updated: 'filters:updated'
      },
      sort: {
        updated: 'sort:updated'
      },
      reviews: {
        added: 'reviews:added'
      },
      headerOverlay: {
        show: 'headerOverlay:show',
        hide: 'headerOverlay:hide',
        hiding: 'headerOverlay:hiding'
      },
      drawerOverlay: {
        show: 'drawerOverlay:show',
        hide: 'drawerOverlay:hide',
        hiding: 'drawerOverlay:hiding'
      }
    });
    // CONCATENATED MODULE: ./src/scripts/constants/index.js
    
    // CONCATENATED MODULE: ./src/scripts/components/headerOverlay.js
    
    
    var headerOverlay_selectors = {
      innerOverlay: '.header-overlay__inner'
    };
    var headerOverlay_classes = {
      isVisible: 'is-visible',
      isActive: 'is-active'
    };
    
    var headerOverlay_headerOverlay = function headerOverlay(node) {
      var overlay = node;
      var overlayInner = node.querySelector(headerOverlay_selectors.innerOverlay);
      var overlayShowListener = evx_es_c(constants_events.headerOverlay.show, function () {
        return _showOverlay();
      });
      var overlayHideListener = evx_es_c(constants_events.headerOverlay.hide, function () {
        return _hideOverlay();
      });
    
      var _showOverlay = function _showOverlay() {
        evx_es_o({
          headerOverlayOpen: true
        });
        overlay.classList.add(headerOverlay_classes.isActive);
        setTimeout(function () {
          overlayInner.classList.add(headerOverlay_classes.isVisible);
        }, 10);
      };
    
      var _hideOverlay = function _hideOverlay() {
        evx_es_o({
          headerOverlayOpen: false
        });
        evx_es_r(constants_events.headerOverlay.hiding);
        overlayInner.classList.remove(headerOverlay_classes.isVisible);
        setTimeout(function () {
          overlay.classList.remove(headerOverlay_classes.isActive);
        }, 300);
      };
    
      var unload = function unload() {
        overlayShowListener();
        overlayHideListener();
      };
    
      return {
        unload: unload
      };
    };
    
    /* harmony default export */ var components_headerOverlay = (headerOverlay_headerOverlay);
    // CONCATENATED MODULE: ./src/scripts/components/drawerOverlay.js
    
    
    var drawerOverlay_selectors = {
      innerOverlay: '.drawer-overlay__inner'
    };
    var drawerOverlay_classes = {
      isVisible: 'is-visible',
      isActive: 'is-active'
    };
    
    var drawerOverlay_drawerOverlay = function drawerOverlay(node) {
      var overlay = node;
      var overlayInner = node.querySelector(drawerOverlay_selectors.innerOverlay);
      var overlayShowListener = evx_es_c(constants_events.drawerOverlay.show, function () {
        return _showOverlay();
      });
      var overlayHideListener = evx_es_c(constants_events.drawerOverlay.hide, function () {
        return _hideOverlay();
      });
    
      var _showOverlay = function _showOverlay() {
        overlay.classList.add(drawerOverlay_classes.isActive);
        setTimeout(function () {
          overlayInner.classList.add(drawerOverlay_classes.isVisible);
        }, 10);
      };
    
      var _hideOverlay = function _hideOverlay() {
        evx_es_r(constants_events.drawerOverlay.hiding);
        overlayInner.classList.remove(drawerOverlay_classes.isVisible);
        setTimeout(function () {
          overlay.classList.remove(drawerOverlay_classes.isActive);
        }, 300);
      };
    
      overlay.addEventListener('click', _hideOverlay);
    
      var unload = function unload() {
        overlayShowListener();
        overlayHideListener();
        overlay.removeEventListener('click', _hideOverlay);
      };
    
      return {
        unload: unload
      };
    };
    
    /* harmony default export */ var components_drawerOverlay = (drawerOverlay_drawerOverlay);
    // CONCATENATED MODULE: ./node_modules/focus-trap/node_modules/tabbable/dist/index.esm.js
    /*!
    * tabbable 5.1.0
    * @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
    */
    let candidateSelectors = [
      'input',
      'select',
      'textarea',
      'a[href]',
      'button',
      '[tabindex]',
      'audio[controls]',
      'video[controls]',
      '[contenteditable]:not([contenteditable="false"])',
      'details>summary',
    ];
    let candidateSelector = /* #__PURE__ */ candidateSelectors.join(',');
    
    let matches =
      typeof Element === 'undefined'
        ? function () {}
        : Element.prototype.matches ||
          Element.prototype.msMatchesSelector ||
          Element.prototype.webkitMatchesSelector;
    
    function tabbable(el, options) {
      options = options || {};
    
      let regularTabbables = [];
      let orderedTabbables = [];
    
      let candidates = getCandidates(
        el,
        options.includeContainer,
        isNodeMatchingSelectorTabbable
      );
    
      candidates.forEach(function (candidate, i) {
        let candidateTabindex = getTabindex(candidate);
        if (candidateTabindex === 0) {
          regularTabbables.push(candidate);
        } else {
          orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            node: candidate,
          });
        }
      });
    
      let tabbableNodes = orderedTabbables
        .sort(sortOrderedTabbables)
        .map((a) => a.node)
        .concat(regularTabbables);
    
      return tabbableNodes;
    }
    
    function focusable(el, options) {
      options = options || {};
    
      let candidates = getCandidates(
        el,
        options.includeContainer,
        isNodeMatchingSelectorFocusable
      );
    
      return candidates;
    }
    
    function getCandidates(el, includeContainer, filter) {
      if(!el)
        return;
      let candidates = Array.prototype.slice.apply(
        el.querySelectorAll(candidateSelector)
      );
      if (includeContainer && matches.call(el, candidateSelector)) {
        candidates.unshift(el);
      }
      candidates = candidates.filter(filter);
      return candidates;
    }
    
    function isNodeMatchingSelectorTabbable(node) {
      if (
        !isNodeMatchingSelectorFocusable(node) ||
        isNonTabbableRadio(node) ||
        getTabindex(node) < 0
      ) {
        return false;
      }
      return true;
    }
    
    function isTabbable(node) {
      if (!node) {
        throw new Error('No node provided');
      }
      if (matches.call(node, candidateSelector) === false) {
        return false;
      }
      return isNodeMatchingSelectorTabbable(node);
    }
    
    function isNodeMatchingSelectorFocusable(node) {
      if (node.disabled || isHiddenInput(node) || isHidden(node)) {
        return false;
      }
      return true;
    }
    
    let focusableCandidateSelector = /* #__PURE__ */ candidateSelectors
      .concat('iframe')
      .join(',');
    function isFocusable(node) {
      if (!node) {
        throw new Error('No node provided');
      }
      if (matches.call(node, focusableCandidateSelector) === false) {
        return false;
      }
      return isNodeMatchingSelectorFocusable(node);
    }
    
    function getTabindex(node) {
      let tabindexAttr = parseInt(node.getAttribute('tabindex'), 10);
    
      if (!isNaN(tabindexAttr)) {
        return tabindexAttr;
      }
    
      // Browsers do not return `tabIndex` correctly for contentEditable nodes;
      // so if they don't have a tabindex attribute specifically set, assume it's 0.
      if (isContentEditable(node)) {
        return 0;
      }
    
      // in Chrome, <audio controls/> and <video controls/> elements get a default
      //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
      //  yet they are still part of the regular tab order; in FF, they get a default
      //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
      //  order, consider their tab index to be 0
      if (
        (node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO') &&
        node.getAttribute('tabindex') === null
      ) {
        return 0;
      }
    
      return node.tabIndex;
    }
    
    function sortOrderedTabbables(a, b) {
      return a.tabIndex === b.tabIndex
        ? a.documentOrder - b.documentOrder
        : a.tabIndex - b.tabIndex;
    }
    
    function isContentEditable(node) {
      return node.contentEditable === 'true';
    }
    
    function isInput(node) {
      return node.tagName === 'INPUT';
    }
    
    function isHiddenInput(node) {
      return isInput(node) && node.type === 'hidden';
    }
    
    function isRadio(node) {
      return isInput(node) && node.type === 'radio';
    }
    
    function isNonTabbableRadio(node) {
      return isRadio(node) && !isTabbableRadio(node);
    }
    
    function getCheckedRadio(nodes, form) {
      for (let i = 0; i < nodes.length; i++) {
        if (nodes[i].checked && nodes[i].form === form) {
          return nodes[i];
        }
      }
    }
    
    function isTabbableRadio(node) {
      if (!node.name) {
        return true;
      }
      const radioScope = node.form || node.ownerDocument;
      let radioSet = radioScope.querySelectorAll(
        'input[type="radio"][name="' + node.name + '"]'
      );
      let checked = getCheckedRadio(radioSet, node.form);
      return !checked || checked === node;
    }
    
    function isHidden(node) {
      if (getComputedStyle(node).visibility === 'hidden') return true;
    
      while (node) {
        if (getComputedStyle(node).display === 'none') return true;
        node = node.parentElement;
      }
    
      return false;
    }
    
    
    //# sourceMappingURL=index.esm.js.map
    
    // CONCATENATED MODULE: ./node_modules/focus-trap/dist/focus-trap.esm.js
    /*!
    * focus-trap 6.1.0
    * @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
    */
    
    
    var activeFocusDelay;
    
    var activeFocusTraps = (function () {
      var trapQueue = [];
      return {
        activateTrap: function (trap) {
          if (trapQueue.length > 0) {
            var activeTrap = trapQueue[trapQueue.length - 1];
            if (activeTrap !== trap) {
              activeTrap.pause();
            }
          }
    
          var trapIndex = trapQueue.indexOf(trap);
          if (trapIndex === -1) {
            trapQueue.push(trap);
          } else {
            // move this existing trap to the front of the queue
            trapQueue.splice(trapIndex, 1);
            trapQueue.push(trap);
          }
        },
    
        deactivateTrap: function (trap) {
          var trapIndex = trapQueue.indexOf(trap);
          if (trapIndex !== -1) {
            trapQueue.splice(trapIndex, 1);
          }
    
          if (trapQueue.length > 0) {
            trapQueue[trapQueue.length - 1].unpause();
          }
        },
      };
    })();
    
    function createFocusTrap(element, userOptions) {
      var doc = document;
      var container =
        typeof element === 'string' ? doc.querySelector(element) : element;
    
      var config = {
        returnFocusOnDeactivate: true,
        escapeDeactivates: true,
        delayInitialFocus: true,
        ...userOptions,
      };
    
      var state = {
        firstTabbableNode: null,
        lastTabbableNode: null,
        nodeFocusedBeforeActivation: null,
        mostRecentlyFocusedNode: null,
        active: false,
        paused: false,
      };
    
      var trap = {
        activate: activate,
        deactivate: deactivate,
        pause: pause,
        unpause: unpause,
      };
    
      return trap;
    
      function activate(activateOptions) {
        if (state.active) return;
    
        updateTabbableNodes();
    
        state.active = true;
        state.paused = false;
        state.nodeFocusedBeforeActivation = doc.activeElement;
    
        var onActivate =
          activateOptions && activateOptions.onActivate
            ? activateOptions.onActivate
            : config.onActivate;
        if (onActivate) {
          onActivate();
        }
    
        addListeners();
        return trap;
      }
    
      function deactivate(deactivateOptions) {
        if (!state.active) return;
    
        clearTimeout(activeFocusDelay);
    
        removeListeners();
        state.active = false;
        state.paused = false;
    
        activeFocusTraps.deactivateTrap(trap);
    
        var onDeactivate =
          deactivateOptions && deactivateOptions.onDeactivate !== undefined
            ? deactivateOptions.onDeactivate
            : config.onDeactivate;
        if (onDeactivate) {
          onDeactivate();
        }
    
        var returnFocus =
          deactivateOptions && deactivateOptions.returnFocus !== undefined
            ? deactivateOptions.returnFocus
            : config.returnFocusOnDeactivate;
        if (returnFocus) {
          delay(function () {
            tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
          });
        }
    
        return trap;
      }
    
      function pause() {
        if (state.paused || !state.active) return;
        state.paused = true;
        removeListeners();
      }
    
      function unpause() {
        if (!state.paused || !state.active) return;
        state.paused = false;
        updateTabbableNodes();
        addListeners();
      }
    
      function addListeners() {
        if (!state.active) return;
    
        // There can be only one listening focus trap at a time
        activeFocusTraps.activateTrap(trap);
    
        // Delay ensures that the focused element doesn't capture the event
        // that caused the focus trap activation.
        activeFocusDelay = config.delayInitialFocus
          ? delay(function () {
              tryFocus(getInitialFocusNode());
            })
          : tryFocus(getInitialFocusNode());
    
        doc.addEventListener('focusin', checkFocusIn, true);
        doc.addEventListener('mousedown', checkPointerDown, {
          capture: true,
          passive: false,
        });
        doc.addEventListener('touchstart', checkPointerDown, {
          capture: true,
          passive: false,
        });
        doc.addEventListener('click', checkClick, {
          capture: true,
          passive: false,
        });
        doc.addEventListener('keydown', checkKey, {
          capture: true,
          passive: false,
        });
    
        return trap;
      }
    
      function removeListeners() {
        if (!state.active) return;
    
        doc.removeEventListener('focusin', checkFocusIn, true);
        doc.removeEventListener('mousedown', checkPointerDown, true);
        doc.removeEventListener('touchstart', checkPointerDown, true);
        doc.removeEventListener('click', checkClick, true);
        doc.removeEventListener('keydown', checkKey, true);
    
        return trap;
      }
    
      function getNodeForOption(optionName) {
        var optionValue = config[optionName];
        var node = optionValue;
        if (!optionValue) {
          return null;
        }
        if (typeof optionValue === 'string') {
          node = doc.querySelector(optionValue);
          if (!node) {
            throw new Error('`' + optionName + '` refers to no known node');
          }
        }
        if (typeof optionValue === 'function') {
          node = optionValue();
          if (!node) {
            throw new Error('`' + optionName + '` did not return a node');
          }
        }
        return node;
      }
    
      function getInitialFocusNode() {
        var node;
        if (getNodeForOption('initialFocus') !== null) {
          node = getNodeForOption('initialFocus');
        } else if (container.contains(doc.activeElement)) {
          node = doc.activeElement;
        } else {
          node = state.firstTabbableNode || getNodeForOption('fallbackFocus');
        }
    
        if (!node) {
          throw new Error(
            'Your focus-trap needs to have at least one focusable element'
          );
        }
    
        return node;
      }
    
      function getReturnFocusNode(previousActiveElement) {
        var node = getNodeForOption('setReturnFocus');
        return node ? node : previousActiveElement;
      }
    
      // This needs to be done on mousedown and touchstart instead of click
      // so that it precedes the focus event.
      function checkPointerDown(e) {
        if (container.contains(e.target)) return;
        if (config.clickOutsideDeactivates) {
          deactivate({
            returnFocus: !isFocusable(e.target),
          });
          return;
        }
        // This is needed for mobile devices.
        // (If we'll only let `click` events through,
        // then on mobile they will be blocked anyways if `touchstart` is blocked.)
        if (
          config.allowOutsideClick &&
          (typeof config.allowOutsideClick === 'boolean'
            ? config.allowOutsideClick
            : config.allowOutsideClick(e))
        ) {
          return;
        }
        e.preventDefault();
      }
    
      // In case focus escapes the trap for some strange reason, pull it back in.
      function checkFocusIn(e) {
        // In Firefox when you Tab out of an iframe the Document is briefly focused.
        if (container.contains(e.target) || e.target instanceof Document) {
          return;
        }
        e.stopImmediatePropagation();
        tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
      }
    
      function checkKey(e) {
        if (config.escapeDeactivates !== false && isEscapeEvent(e)) {
          e.preventDefault();
          deactivate();
          return;
        }
        if (isTabEvent(e)) {
          checkTab(e);
          return;
        }
      }
    
      // Hijack Tab events on the first and last focusable nodes of the trap,
      // in order to prevent focus from escaping. If it escapes for even a
      // moment it can end up scrolling the page and causing confusion so we
      // kind of need to capture the action at the keydown phase.
      function checkTab(e) {
        updateTabbableNodes();
        if (e.shiftKey && e.target === state.firstTabbableNode) {
          e.preventDefault();
          tryFocus(state.lastTabbableNode);
          return;
        }
        if (!e.shiftKey && e.target === state.lastTabbableNode) {
          e.preventDefault();
          tryFocus(state.firstTabbableNode);
          return;
        }
      }
    
      function checkClick(e) {
        if (config.clickOutsideDeactivates) return;
        if (container.contains(e.target)) return;
        if (
          config.allowOutsideClick &&
          (typeof config.allowOutsideClick === 'boolean'
            ? config.allowOutsideClick
            : config.allowOutsideClick(e))
        ) {
          return;
        }
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    
      function updateTabbableNodes() {
        var tabbableNodes = tabbable(container);
        state.firstTabbableNode = tabbableNodes[0] || getInitialFocusNode();
        state.lastTabbableNode =
          tabbableNodes[tabbableNodes.length - 1] || getInitialFocusNode();
      }
    
      function tryFocus(node) {
        if (node === doc.activeElement) return;
        if (!node || !node.focus) {
          tryFocus(getInitialFocusNode());
          return;
        }
        node.focus({ preventScroll: !!config.preventScroll });
        state.mostRecentlyFocusedNode = node;
        if (isSelectableInput(node)) {
          node.select();
        }
      }
    }
    
    function isSelectableInput(node) {
      return (
        node.tagName &&
        node.tagName.toLowerCase() === 'input' &&
        typeof node.select === 'function'
      );
    }
    
    function isEscapeEvent(e) {
      return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
    }
    
    function isTabEvent(e) {
      return e.key === 'Tab' || e.keyCode === 9;
    }
    
    function delay(fn) {
      return setTimeout(fn, 0);
    }
    
    
    //# sourceMappingURL=focus-trap.esm.js.map
    
    // EXTERNAL MODULE: ./node_modules/@shopify/theme-currency/dist/currency.cjs.js
    var currency_cjs = __webpack_require__(7);
    
    // CONCATENATED MODULE: ./node_modules/shopify-currency/dist/shopify-currency.es.js
    var shopify_currency_es_m={USD:{money_format:"${{amount}}",money_with_currency_format:"${{amount}} USD"},EUR:{money_format:"&euro;{{amount}}",money_with_currency_format:"&euro;{{amount}} EUR"},GBP:{money_format:"&pound;{{amount}}",money_with_currency_format:"&pound;{{amount}} GBP"},CAD:{money_format:"${{amount}}",money_with_currency_format:"${{amount}} CAD"},ALL:{money_format:"Lek {{amount}}",money_with_currency_format:"Lek {{amount}} ALL"},DZD:{money_format:"DA {{amount}}",money_with_currency_format:"DA {{amount}} DZD"},AOA:{money_format:"Kz{{amount}}",money_with_currency_format:"Kz{{amount}} AOA"},ARS:{money_format:"${{amount_with_comma_separator}}",money_with_currency_format:"${{amount_with_comma_separator}} ARS"},AMD:{money_format:"{{amount}} AMD",money_with_currency_format:"{{amount}} AMD"},AWG:{money_format:"Afl{{amount}}",money_with_currency_format:"Afl{{amount}} AWG"},AUD:{money_format:"${{amount}}",money_with_currency_format:"${{amount}} AUD"},BBD:{money_format:"${{amount}}",money_with_currency_format:"${{amount}} Bds"},AZN:{money_format:"m.{{amount}}",money_with_currency_format:"m.{{amount}} AZN"},BDT:{money_format:"Tk {{amount}}",money_with_currency_format:"Tk {{amount}} BDT"},BSD:{money_format:"BS${{amount}}",money_with_currency_format:"BS${{amount}} BSD"},BHD:{money_format:"{{amount}}0 BD",money_with_currency_format:"{{amount}}0 BHD"},BYR:{money_format:"Br {{amount}}",money_with_currency_format:"Br {{amount}} BYR"},BZD:{money_format:"BZ${{amount}}",money_with_currency_format:"BZ${{amount}} BZD"},BTN:{money_format:"Nu {{amount}}",money_with_currency_format:"Nu {{amount}} BTN"},BAM:{money_format:"KM {{amount_with_comma_separator}}",money_with_currency_format:"KM {{amount_with_comma_separator}} BAM"},BRL:{money_format:"R$ {{amount_with_comma_separator}}",money_with_currency_format:"R$ {{amount_with_comma_separator}} BRL"},BOB:{money_format:"Bs{{amount_with_comma_separator}}",money_with_currency_format:"Bs{{amount_with_comma_separator}} BOB"},BWP:{money_format:"P{{amount}}",money_with_currency_format:"P{{amount}} BWP"},BND:{money_format:"${{amount}}",money_with_currency_format:"${{amount}} BND"},BGN:{money_format:"{{amount}} лв",money_with_currency_format:"{{amount}} лв BGN"},MMK:{money_format:"K{{amount}}",money_with_currency_format:"K{{amount}} MMK"},KHR:{money_format:"KHR{{amount}}",money_with_currency_format:"KHR{{amount}}"},KYD:{money_format:"${{amount}}",money_with_currency_format:"${{amount}} KYD"},XAF:{money_format:"FCFA{{amount}}",money_with_currency_format:"FCFA{{amount}} XAF"},CLP:{money_format:"${{amount_no_decimals}}",money_with_currency_format:"${{amount_no_decimals}} CLP"},CNY:{money_format:"&#165;{{amount}}",money_with_currency_format:"&#165;{{amount}} CNY"},COP:{money_format:"${{amount_with_comma_separator}}",money_with_currency_format:"${{amount_with_comma_separator}} COP"},CRC:{money_format:"&#8353; {{amount_with_comma_separator}}",money_with_currency_format:"&#8353; {{amount_with_comma_separator}} CRC"},HRK:{money_format:"{{amount_with_comma_separator}} kn",money_with_currency_format:"{{amount_with_comma_separator}} kn HRK"},CZK:{money_format:"{{amount_with_comma_separator}} K&#269;",money_with_currency_format:"{{amount_with_comma_separator}} K&#269;"},DKK:{money_format:"{{amount_with_comma_separator}}",money_with_currency_format:"kr.{{amount_with_comma_separator}}"},DOP:{money_format:"RD$ {{amount}}",money_with_currency_format:"RD$ {{amount}}"},XCD:{money_format:"${{amount}}",money_with_currency_format:"EC${{amount}}"},EGP:{money_format:"LE {{amount}}",money_with_currency_format:"LE {{amount}} EGP"},ETB:{money_format:"Br{{amount}}",money_with_currency_format:"Br{{amount}} ETB"},XPF:{money_format:"{{amount_no_decimals_with_comma_separator}} XPF",money_with_currency_format:"{{amount_no_decimals_with_comma_separator}} XPF"},FJD:{money_format:"${{amount}}",money_with_currency_format:"FJ${{amount}}"},GMD:{money_format:"D {{amount}}",money_with_currency_format:"D {{amount}} GMD"},GHS:{money_format:"GH&#8373;{{amount}}",money_with_currency_format:"GH&#8373;{{amount}}"},GTQ:{money_format:"Q{{amount}}",money_with_currency_format:"{{amount}} GTQ"},GYD:{money_format:"G${{amount}}",money_with_currency_format:"${{amount}} GYD"},GEL:{money_format:"{{amount}} GEL",money_with_currency_format:"{{amount}} GEL"},HNL:{money_format:"L {{amount}}",money_with_currency_format:"L {{amount}} HNL"},HKD:{money_format:"${{amount}}",money_with_currency_format:"HK${{amount}}"},HUF:{money_format:"{{amount_no_decimals_with_comma_separator}}",money_with_currency_format:"{{amount_no_decimals_with_comma_separator}} Ft"},ISK:{money_format:"{{amount_no_decimals}} kr",money_with_currency_format:"{{amount_no_decimals}} kr ISK"},INR:{money_format:"Rs. {{amount}}",money_with_currency_format:"Rs. {{amount}}"},IDR:{money_format:"{{amount_with_comma_separator}}",money_with_currency_format:"Rp {{amount_with_comma_separator}}"},ILS:{money_format:"{{amount}} NIS",money_with_currency_format:"{{amount}} NIS"},JMD:{money_format:"${{amount}}",money_with_currency_format:"${{amount}} JMD"},JPY:{money_format:"&#165;{{amount_no_decimals}}",money_with_currency_format:"&#165;{{amount_no_decimals}} JPY"},JEP:{money_format:"&pound;{{amount}}",money_with_currency_format:"&pound;{{amount}} JEP"},JOD:{money_format:"{{amount}}0 JD",money_with_currency_format:"{{amount}}0 JOD"},KZT:{money_format:"{{amount}} KZT",money_with_currency_format:"{{amount}} KZT"},KES:{money_format:"KSh{{amount}}",money_with_currency_format:"KSh{{amount}}"},KWD:{money_format:"{{amount}}0 KD",money_with_currency_format:"{{amount}}0 KWD"},KGS:{money_format:"лв{{amount}}",money_with_currency_format:"лв{{amount}}"},LVL:{money_format:"Ls {{amount}}",money_with_currency_format:"Ls {{amount}} LVL"},LBP:{money_format:"L&pound;{{amount}}",money_with_currency_format:"L&pound;{{amount}} LBP"},LTL:{money_format:"{{amount}} Lt",money_with_currency_format:"{{amount}} Lt"},MGA:{money_format:"Ar {{amount}}",money_with_currency_format:"Ar {{amount}} MGA"},MKD:{money_format:"ден {{amount}}",money_with_currency_format:"ден {{amount}} MKD"},MOP:{money_format:"MOP${{amount}}",money_with_currency_format:"MOP${{amount}}"},MVR:{money_format:"Rf{{amount}}",money_with_currency_format:"Rf{{amount}} MRf"},MXN:{money_format:"$ {{amount}}",money_with_currency_format:"$ {{amount}} MXN"},MYR:{money_format:"RM{{amount}} MYR",money_with_currency_format:"RM{{amount}} MYR"},MUR:{money_format:"Rs {{amount}}",money_with_currency_format:"Rs {{amount}} MUR"},MDL:{money_format:"{{amount}} MDL",money_with_currency_format:"{{amount}} MDL"},MAD:{money_format:"{{amount}} dh",money_with_currency_format:"Dh {{amount}} MAD"},MNT:{money_format:"{{amount_no_decimals}} &#8366",money_with_currency_format:"{{amount_no_decimals}} MNT"},MZN:{money_format:"{{amount}} Mt",money_with_currency_format:"Mt {{amount}} MZN"},NAD:{money_format:"N${{amount}}",money_with_currency_format:"N${{amount}} NAD"},NPR:{money_format:"Rs{{amount}}",money_with_currency_format:"Rs{{amount}} NPR"},ANG:{money_format:"&fnof;{{amount}}",money_with_currency_format:"{{amount}} NA&fnof;"},NZD:{money_format:"${{amount}}",money_with_currency_format:"${{amount}} NZD"},NIO:{money_format:"C${{amount}}",money_with_currency_format:"C${{amount}} NIO"},NGN:{money_format:"&#8358;{{amount}}",money_with_currency_format:"&#8358;{{amount}} NGN"},NOK:{money_format:"kr {{amount_with_comma_separator}}",money_with_currency_format:"kr {{amount_with_comma_separator}} NOK"},OMR:{money_format:"{{amount_with_comma_separator}} OMR",money_with_currency_format:"{{amount_with_comma_separator}} OMR"},PKR:{money_format:"Rs.{{amount}}",money_with_currency_format:"Rs.{{amount}} PKR"},PGK:{money_format:"K {{amount}}",money_with_currency_format:"K {{amount}} PGK"},PYG:{money_format:"Gs. {{amount_no_decimals_with_comma_separator}}",money_with_currency_format:"Gs. {{amount_no_decimals_with_comma_separator}} PYG"},PEN:{money_format:"S/. {{amount}}",money_with_currency_format:"S/. {{amount}} PEN"},PHP:{money_format:"&#8369;{{amount}}",money_with_currency_format:"&#8369;{{amount}} PHP"},PLN:{money_format:"{{amount_with_comma_separator}} zl",money_with_currency_format:"{{amount_with_comma_separator}} zl PLN"},QAR:{money_format:"QAR {{amount_with_comma_separator}}",money_with_currency_format:"QAR {{amount_with_comma_separator}}"},RON:{money_format:"{{amount_with_comma_separator}} lei",money_with_currency_format:"{{amount_with_comma_separator}} lei RON"},RUB:{money_format:"&#1088;&#1091;&#1073;{{amount_with_comma_separator}}",money_with_currency_format:"&#1088;&#1091;&#1073;{{amount_with_comma_separator}} RUB"},RWF:{money_format:"{{amount_no_decimals}} RF",money_with_currency_format:"{{amount_no_decimals}} RWF"},WST:{money_format:"WS$ {{amount}}",money_with_currency_format:"WS$ {{amount}} WST"},SAR:{money_format:"{{amount}} SR",money_with_currency_format:"{{amount}} SAR"},STD:{money_format:"Db {{amount}}",money_with_currency_format:"Db {{amount}} STD"},RSD:{money_format:"{{amount}} RSD",money_with_currency_format:"{{amount}} RSD"},SCR:{money_format:"Rs {{amount}}",money_with_currency_format:"Rs {{amount}} SCR"},SGD:{money_format:"${{amount}}",money_with_currency_format:"${{amount}} SGD"},SYP:{money_format:"S&pound;{{amount}}",money_with_currency_format:"S&pound;{{amount}} SYP"},ZAR:{money_format:"R {{amount}}",money_with_currency_format:"R {{amount}} ZAR"},KRW:{money_format:"&#8361;{{amount_no_decimals}}",money_with_currency_format:"&#8361;{{amount_no_decimals}} KRW"},LKR:{money_format:"Rs {{amount}}",money_with_currency_format:"Rs {{amount}} LKR"},SEK:{money_format:"{{amount_no_decimals}} kr",money_with_currency_format:"{{amount_no_decimals}} kr SEK"},CHF:{money_format:"SFr. {{amount}}",money_with_currency_format:"SFr. {{amount}} CHF"},TWD:{money_format:"${{amount}}",money_with_currency_format:"${{amount}} TWD"},THB:{money_format:"{{amount}} &#xe3f;",money_with_currency_format:"{{amount}} &#xe3f; THB"},TZS:{money_format:"{{amount}} TZS",money_with_currency_format:"{{amount}} TZS"},TTD:{money_format:"${{amount}}",money_with_currency_format:"${{amount}} TTD"},TND:{money_format:"{{amount}}",money_with_currency_format:"{{amount}} DT"},TRY:{money_format:"{{amount}}TL",money_with_currency_format:"{{amount}}TL"},UGX:{money_format:"Ush {{amount_no_decimals}}",money_with_currency_format:"Ush {{amount_no_decimals}} UGX"},UAH:{money_format:"₴{{amount}}",money_with_currency_format:"₴{{amount}} UAH"},AED:{money_format:"Dhs. {{amount}}",money_with_currency_format:"Dhs. {{amount}} AED"},UYU:{money_format:"${{amount_with_comma_separator}}",money_with_currency_format:"${{amount_with_comma_separator}} UYU"},VUV:{money_format:"${{amount}}",money_with_currency_format:"${{amount}}VT"},VEF:{money_format:"Bs. {{amount_with_comma_separator}}",money_with_currency_format:"Bs. {{amount_with_comma_separator}} VEF"},VND:{money_format:"{{amount_no_decimals_with_comma_separator}}&#8363;",money_with_currency_format:"{{amount_no_decimals_with_comma_separator}} VND"},XBT:{money_format:"{{amount_no_decimals}} BTC",money_with_currency_format:"{{amount_no_decimals}} BTC"},XOF:{money_format:"CFA{{amount}}",money_with_currency_format:"CFA{{amount}} XOF"},ZMW:{money_format:"K{{amount_no_decimals_with_comma_separator}}",money_with_currency_format:"ZMW{{amount_no_decimals_with_comma_separator}}"}},shopify_currency_es_t=function(o){return o.toLowerCase().split("").map(function(o,m){return 0===m?o.toUpperCase():o}).join("")};/* harmony default export */ var shopify_currency_es = (function(n){void 0===n&&(n={});var a=Object.assign({},{format:"money_with_currency_format",formats:{},storageKey:"shopify-currency"},n);a.formats=Object.assign({},shopify_currency_es_m,a.formats);var r,_=(void 0===(r=a.storageKey)&&(r="currency"),{key:r,read:function(){return localStorage.getItem(r)},write:function(o){localStorage.setItem(r,o)},remove:function(){localStorage.removeItem(r)}});function e(o){_.write(o)}return{getCurrent:function(){return _.read()},setCurrent:e,convertAll:function(m,n,r,_){if(void 0===_&&(_=a.format),"undefined"==typeof Currency)throw new Error("Can't access Shopify Currency library. Make sure it's properly loaded.");n&&((r||document.querySelectorAll("span.money")).forEach(function(r){if(r.dataset.current!==n){if(Boolean(r.dataset["currency"+shopify_currency_es_t(n)]))return r.innerHTML=r.dataset["currency"+shopify_currency_es_t(n)],void(r.dataset.currency=n);var e,u=a.formats[m][_]||"{{amount}}",y=a.formats[n][_]||"{{amount}}",c=function(o){return Currency.convert(o,m,n)},f=parseInt(r.innerHTML.replace(/[^0-9]/g,""),10);e=-1!==u.indexOf("amount_no_decimals")?c(100*f):["JOD","KWD","BHD"].includes(m)?c(f/10):c(f);var i=Object(currency_cjs["formatMoney"])(e,y);r.innerHTML=i,r.dataset.currency=n,r.setAttribute("data-currency-"+n,i)}}),e(n))}}});
    //# sourceMappingURL=shopify-currency.es.js.map
    
    // CONCATENATED MODULE: ./src/scripts/neon/currency.js
    
    
    var currency = shopify_currency_es(typeof currencyOpts !== 'undefined' ? currencyOpts : {});
    var currency_formatMoney = function formatMoney(val) {
      return Object(currency_cjs["formatMoney"])(val, theme.moneyFormat || '${{amount}}');
    };
    /* harmony default export */ var neon_currency = (currency);
    // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/objectWithoutProperties.js
    var objectWithoutProperties = __webpack_require__(15);
    var objectWithoutProperties_default = /*#__PURE__*/__webpack_require__.n(objectWithoutProperties);
    
    // CONCATENATED MODULE: ./src/scripts/lib/images.js
    /**
     * Image Helper Functions
     * -----------------------------------------------------------------------------
     * A collection of functions that help with basic image operations.
     *
     */
    
    /**
     * Preloads an image in memory and uses the browsers cache to store it until needed.
     *
     * @param {Array} images - A list of image urls
     * @param {String} size - A shopify image size attribute
     */
    function preload(images, size) {
      if (typeof images === 'string') {
        images = [images];
      }
    
      for (var i = 0; i < images.length; i++) {
        var image = images[i];
        loadImage(getSizedImageUrl(image, size));
      }
    }
    /**
     * Loads and caches an image in the browsers cache.
     * @param {string} path - An image url
     */
    
    function loadImage(path) {
      /* eslint-disable */
      new Image().src = path;
      /* eslint-enable */
    }
    /**
     * Find the Shopify image attribute size
     *
     * @param {string} src
     * @returns {null}
     */
    
    function imageSize(src) {
      /* eslint-disable */
      var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
      /* esling-enable */
    
      if (match) {
        return match[1];
      } else {
        return null;
      }
    }
    /**
     * Adds a Shopify size attribute to a URL
     *
     * @param src
     * @param size
     * @returns {*}
     */
    
    function getSizedImageUrl(src, size) {
      if (size === null) {
        return src;
      }
    
      if (size === 'master') {
        return removeProtocol(src);
      }
    
      var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
    
      if (match) {
        var prefix = src.split(match[0]);
        var suffix = match[0];
        return removeProtocol(prefix[0] + '_' + size + suffix);
      } else {
        return null;
      }
    }
    function removeProtocol(path) {
      return path.replace(/http(s)?:/, '');
    }
    function onImagesLoaded(container, event) {
      var images = container.getElementsByTagName('img');
      var imageCount = images.length;
      var imagesLoaded = 0;
    
      for (var i = 0; i < imageCount; i++) {
        images[i].onload = function () {
          imagesLoaded++;
    
          if (imagesLoaded === imageCount) {
            event();
          }
        };
      }
    }
    // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/toConsumableArray.js
    var toConsumableArray = __webpack_require__(0);
    var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);
    
    // CONCATENATED MODULE: ./node_modules/dcx/dist/dcx.es.js
    /* harmony default export */ var dcx_es = (function(t){return function(){for(var n=[],e=arguments.length;e--;)n[e]=arguments[e];n.reduce(function(t,n){return t.concat("object"==typeof n?Object.keys(n).map(function(t){return[t,n[t]]}):[[n,!0]])},[]).map(function(n){t.classList[n[1]?"add":"remove"](n[0])})}});
    //# sourceMappingURL=dcx.es.js.map
    
    // CONCATENATED MODULE: ./src/scripts/lib/product/createSwatchGroups.js
    
    
    
    var createSwatchGroups_createSwatchGroup = function createSwatchGroup(group) {
      var _this = this;
    
      var productOption = group.dataset.productOption;
      var swatches = group.querySelectorAll('[data-product-swatch]');
      var sel = this.container.querySelector("select#".concat(productOption));
      sel.classList.add('hidden');
    
      var handleClick = function handleClick(evt) {
        evt.preventDefault();
        var swatch = evt.target;
    
        var classes = toConsumableArray_default()(swatch.classList);
    
        if (!classes.includes('product-form__color-swatch') || classes.includes('selected')) return;
        var selected = swatch.dataset.productSwatchOption;
        swatches.forEach(function (s) {
          return dcx_es(s)({
            selected: s.dataset.productSwatchOption === selected
          });
        });
    
        var selectedLabel = _this.container.querySelector('.product-form__color-swatches-selected');
    
        selectedLabel.innerText = selected;
    
        var opt = _this.container.querySelector("select#".concat(productOption, " [value=\"").concat(selected, "\"]"));
    
        opt.selected = true;
        sel.dispatchEvent(new Event('change'));
      };
    
      group.addEventListener('click', handleClick);
      return function () {
        return group.removeEventListener('click', handleClick);
      };
    };
    
    /* harmony default export */ var createSwatchGroups = (function (groupSelector) {
      var _this2 = this;
    
      var swatchGroups = this.container.querySelectorAll(groupSelector);
      if (swatchGroups.length < 1) return;
      var groups = [];
    
      toConsumableArray_default()(swatchGroups).forEach(function (group) {
        return groups.push(createSwatchGroups_createSwatchGroup.call(_this2, group));
      });
    
      return function () {
        return groups.forEach(function (g) {
          return g();
        });
      };
    });
    // CONCATENATED MODULE: ./src/scripts/lib/product/createChipGroups.js
    
    
    var createChipGroups_createChipGroup = function createChipGroup(group) {
      var handleClick = function handleClick(evt) {
        var chip = evt.target;
        var classes = toConsumableArray_default()(chip.classList);
    
        if (!classes.includes('product-form__chip-input')) return;
        var selectedLabel = group.querySelector('.product-form__chip-selected');
        selectedLabel.innerText = chip.value;
        chip.checked = true;
      };
    
      group.addEventListener('click', handleClick);
      return function () {
        return group.removeEventListener('click', handleClick);
      };
    };
    
    /* harmony default export */ var createChipGroups = (function (groupSelector) {
      var _this = this;
    
      var chipGroups = this.container.querySelectorAll(groupSelector);
      if (chipGroups.length < 1) return;
      var groups = [];
    
      toConsumableArray_default()(chipGroups).forEach(function (group) {
        return groups.push(createChipGroups_createChipGroup.call(_this, group));
      });
    
      return function () {
        return groups.forEach(function (g) {
          return g();
        });
      };
    });
    // CONCATENATED MODULE: ./src/scripts/lib/product/quantityInput.js
    /* harmony default export */ var quantityInput = (function (quantitySelector) {
      var quantityWrapper = this.container.querySelector(quantitySelector);
      var quantityInput = quantityWrapper.querySelector('[data-quantity-input]');
      var addQuantity = quantityWrapper.querySelector('.product-form__quantity-add-item');
      var subtractQuanity = quantityWrapper.querySelector('.product-form__quantity-subtract-item');
    
      var handleAddQuantity = function handleAddQuantity() {
        var currentValue = parseInt(quantityInput.value);
        var newValue = currentValue + 1;
        quantityInput.value = addLeadingZero(newValue);
      };
    
      var handleSubtractQuantity = function handleSubtractQuantity() {
        var currentValue = parseInt(quantityInput.value);
        if (currentValue === 1) return;
        var newValue = currentValue - 1;
        quantityInput.value = addLeadingZero(newValue);
      };
    
      var addLeadingZero = function addLeadingZero(number) {
        var s = number + '';
    
        if (s.length < 2) {
          s = '0' + s;
        }
    
        return s;
      };
    
      addQuantity.addEventListener('click', handleAddQuantity);
      subtractQuanity.addEventListener('click', handleSubtractQuantity);
      return function () {// removeEventListener
      };
    });
    // CONCATENATED MODULE: ./src/scripts/lib/product/getProduct.js
    /* harmony default export */ var getProduct = (function (handle) {
      return function (cb) {
        return fetch("/products/".concat(handle, ".js")).then(function (res) {
          return res.json();
        }).then(function (data) {
          return cb(data);
        })["catch"](function (err) {
          return console.log(err.message);
        });
      };
    });
    // CONCATENATED MODULE: ./src/scripts/lib/selectors.js
    /* harmony default export */ var lib_selectors = ({
      product: {
        addButton: '[data-add-to-cart]',
        addButtonQuickShop: '[data-add-button]',
        addButtonText: '[data-add-to-cart-text]',
        comparePrice: '[data-compare-price]',
        comparePriceText: '[data-compare-text]',
        form: '[data-product-form]',
        imageById: function imageById(id) {
          return "[data-image-id='".concat(id, "']");
        },
        imageWrapper: '[data-product-image-wrapper]',
        optionById: function optionById(id) {
          return "[value='".concat(id, "']");
        },
        price: '[data-product-price]',
        thumb: '[data-product-single-thumbnail]',
        thumbById: function thumbById(id) {
          return "[data-thumbnail-id='".concat(id, "']");
        },
        thumbs: '[data-product-thumbnails]',
        variantSelect: '[data-variant-select]',
        zoom: '[data-product-zoom]',
        storeAvailability: '[data-store-availability-container]'
      },
      a11y: {
        formStatus: '.form-status'
      }
    });
    // CONCATENATED MODULE: ./src/scripts/lib/product/updateBuyButton.js
    
    /* harmony default export */ var updateBuyButton = (function (node, variant) {
      var btn = node.querySelector(lib_selectors.product.addButton);
      var text = btn.querySelector(lib_selectors.product.addButtonText);
      var _btn$dataset = btn.dataset,
          langAvailable = _btn$dataset.langAvailable,
          langSoldOut = _btn$dataset.langSoldOut,
          langUnavailable = _btn$dataset.langUnavailable;
    
      if (!variant) {
        btn.setAttribute('disabled', 'disabled');
        text.textContent = langUnavailable;
      } else if (variant.available) {
        btn.removeAttribute('disabled');
        text.textContent = langAvailable;
      } else {
        btn.setAttribute('disabled', 'disabled');
        text.textContent = langSoldOut;
      }
    });
    // CONCATENATED MODULE: ./src/scripts/lib/product/updatePrices.js
    
    
    
    var _theme = theme,
        strings = _theme.strings.products;
    var updatePrices_selector = lib_selectors.product;
    var updatePrices_classes = {
      activeThumb: 'active-thumbnail',
      hide: 'hide'
    };
    /* harmony default export */ var product_updatePrices = (function (node, variant) {
      var comparePrice = node.querySelector(updatePrices_selector.comparePrice);
      var compareEls = node.querySelectorAll("".concat(updatePrices_selector.comparePrice, ", ").concat(updatePrices_selector.comparePriceText));
    
      var productPrices = toConsumableArray_default()(node.querySelectorAll(updatePrices_selector.price));
    
      var unavailableString = strings.product.unavailable;
    
      if (!variant) {
        productPrices.forEach(function (el) {
          return el.innerHTML = unavailableString;
        });
        compareEls.forEach(function (el) {
          return el.innerHTML = '';
        });
        compareEls.forEach(function (el) {
          return el.classList.add(updatePrices_classes.hide);
        });
        return;
      }
    
      productPrices.forEach(function (el) {
        return el.innerHTML = currency_formatMoney(variant.price);
      });
    
      if (variant.compare_at_price > variant.price) {
        compareEls.forEach(function (el) {
          return el.innerHTML = currency_formatMoney(variant.compare_at_price);
        });
        compareEls.forEach(function (el) {
          return el.classList.remove(updatePrices_classes.hide);
        });
      } else {
        compareEls.forEach(function (el) {
          return el.innerHTML = '';
        });
        compareEls.forEach(function (el) {
          return el.classList.add(updatePrices_classes.hide);
        });
      }
    });
    // CONCATENATED MODULE: ./src/scripts/lib/product/updateQuickShopMedia.js
    
    var updateKlarnaPlacements = function(node, variant) {
      node.setAttribute('data-purchase-amount', variant.price);
      if(typeof window.KlarnaOnsiteService !== undefined) {
          window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
      }
    };
    var updateQuickShopMedia_selector = lib_selectors.product;
    
    var changeImage = function changeImage(node, image) {
      var container = node;
      var currentImage = container.querySelector("".concat(updateQuickShopMedia_selector.imageWrapper, " img"));
      currentImage.srcset = '';
      currentImage.src = image;
    };
    
    /* harmony default export */ var updateQuickShopMedia = (changeImage);
    // CONCATENATED MODULE: ./node_modules/unfetch/dist/unfetch.mjs
    /* harmony default export */ var unfetch = (function(e,n){return n=n||{},new Promise(function(t,r){var s=new XMLHttpRequest,o=[],u=[],i={},a=function(){return{ok:2==(s.status/100|0),statusText:s.statusText,status:s.status,url:s.responseURL,text:function(){return Promise.resolve(s.responseText)},json:function(){return Promise.resolve(JSON.parse(s.responseText))},blob:function(){return Promise.resolve(new Blob([s.response]))},clone:a,headers:{keys:function(){return o},entries:function(){return u},get:function(e){return i[e.toLowerCase()]},has:function(e){return e.toLowerCase()in i}}}};for(var l in s.open(n.method||"get",e,!0),s.onload=function(){s.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm,function(e,n,t){o.push(n=n.toLowerCase()),u.push([n,t]),i[n]=i[n]?i[n]+","+t:t}),t(a())},s.onerror=r,s.withCredentials="include"==n.credentials,n.headers)s.setRequestHeader(l,n.headers[l]);s.send(n.body||null)})});
    //# sourceMappingURL=unfetch.mjs.map
    
    // CONCATENATED MODULE: ./src/scripts/neon/cart.js
    
    
    var ls = {
      get: function get() {
        return JSON.parse(localStorage.getItem('cartItemOrder'));
      },
      set: function set(val) {
        return localStorage.setItem('cartItemOrder', val);
      }
    };
    function addVariant(variant, quantity) {
      var numAvailable = variant.inventory_policy === 'deny' && variant.inventory_management === 'shopify' ? variant.inventory_quantity : null; // null means they can add as many as they want
    
      return fetchCart().then(function (_ref) {
        var items = _ref.items;
        var existing = items.filter(function (item) {
          return item.id === variant.id;
        })[0] || {};
        var numRequested = (existing.quantity || 0) + quantity;
    
        if (numAvailable !== null && numRequested > numAvailable) {
          var err = "There are only ".concat(numAvailable, " of that product available, requested ").concat(numRequested, ".");
          evx_es_r('error', err);
          throw new Error(err);
        } else {
          return addItemById(variant.id, quantity);
        }
      });
    }
    function updateAddon(id, quantity) {
      return fetchCart().then(function (_ref2) {
        var items = _ref2.items;
    
        for (var i = 0; i < items.length; i++) {
          if (items[i].variant_id === parseInt(id)) {
            return changeAddon(i + 1, quantity); // shopify cart is a 1-based index
          }
        }
      });
    }
    function removeAddon(id) {
      if (localStorageAvailable() && ls.get()) {
        removeItemFromLocalOrder(id);
      }
    
      return updateAddon(id, 0);
    }
    
    function changeAddon(line, quantity) {
      evx_es_r('cart:updating');
      return unfetch("".concat(theme.routes.cart.change, ".js"), {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          line: line,
          quantity: quantity
        })
      }).then(function (res) {
        return res.json();
      }).then(function (cart) {
        if (localStorageAvailable() && ls.get()) {
          cart.items = reorderCartItems(cart.items, ls.get());
        }
    
        evx_es_o({
          cart: cart
        });
        evx_es_r('cart:updated', {
          cart: cart
        });
        return cart;
      });
    }
    /**
     * Warning: this does not check available products first
     */
    
    
    function addItemById(id, quantity) {
      var properties = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      evx_es_r('cart:updating');
      return unfetch("".concat(theme.routes.cart.add, ".js"), {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: id,
          quantity: quantity,
          properties: properties
        })
      }).then(function (r) {
        return r.json();
      }).then(function (item) {
        return fetchCart(id).then(function (cart) {
          evx_es_o({
            cart: cart
          });
          evx_es_r('cart:updated');
          return {
            item: item,
            cart: cart
          };
        });
      });
    }
    function addItem(form) {
      evx_es_r('cart:updating');
      return unfetch("".concat(theme.routes.cart.add, ".js"), {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: serialize(form)
      }).then(function (r) {
        return r.json();
      }).then(function (item) {
        return fetchCart(item.id).then(function (cart) {
          evx_es_o({
            cart: cart
          });
          evx_es_r('cart:updated');
          return {
            item: item,
            cart: cart
          };
        });
      });
    }
    function fetchCart(newestProductId) {
      return unfetch("".concat(theme.routes.cart.base, ".js"), {
        method: 'GET',
        credentials: 'include'
      }).then(function (res) {
        return res.json();
      }).then(function (cart) {
        if (localStorageAvailable()) {
          var cartOrder = cart.items.map(function (e) {
            return e.id;
          }); // Set the initial cart order if one does not exist in storage
    
          if (!ls.get()) {
            ls.set(JSON.stringify(cartOrder));
          }
    
          if (newestProductId) {
            var indexOfNewProduct = cartOrder.indexOf(newestProductId); // Place newest product at the front of the cart order
    
            cartOrder.unshift(cartOrder.splice(indexOfNewProduct, 1)[0]);
            ls.set(JSON.stringify(cartOrder)); // Let the cart know there is a new product at the front of the order
    
            evx_es_o({
              newItemInCart: true
            });
          }
    
          cart.items = reorderCartItems(cart.items, cartOrder);
        }
    
        return cart;
      });
    } // Match the cart order with the order determined in local storage
    
    function reorderCartItems(items, sortOrder) {
      return items.sort(function (a, b) {
        return sortOrder.indexOf(a.id) - sortOrder.indexOf(b.id);
      });
    }
    
    function removeItemFromLocalOrder(id) {
      var cartOrder = ls.get();
      var indexOfProduct = cartOrder.indexOf(id);
      cartOrder.splice(indexOfProduct, 1);
      ls.set(JSON.stringify(cartOrder));
    } // See if user has local storage enabled
    
    
    function localStorageAvailable() {
      var test = 'test';
    
      try {
        localStorage.setItem(test, test);
        localStorage.removeItem(test);
        return true;
      } catch (e) {
        return false;
      }
    }
    /*!
     * Serialize all form data into a SearchParams string
     * (c) 2020 Chris Ferdinandi, MIT License, https://gomakethings.com
     * @param  {Node}   form The form to serialize
     * @return {String}      The serialized form data
     */
    
    
    function serialize(form) {
      var arr = [];
      Array.prototype.slice.call(form.elements).forEach(function (field) {
        if (!field.name || field.disabled || ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1) return;
    
        if (field.type === 'select-multiple') {
          Array.prototype.slice.call(field.options).forEach(function (option) {
            if (!option.selected) return;
            arr.push(encodeURIComponent(field.name) + '=' + encodeURIComponent(option.value));
          });
          return;
        }
    
        if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked) return;
        arr.push(encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value));
      });
      return arr.join('&');
    }
    // CONCATENATED MODULE: ./src/scripts/neon/formatMoney.js
    
    /* harmony default export */ var neon_formatMoney = (function (val) {
      return Object(currency_cjs["formatMoney"])(val, window.theme.moneyFormat || '${{amount}}');
    });
    // CONCATENATED MODULE: ./src/scripts/neon/getProduct.js
    // Fetch the product data from the .js endpoint because it includes
    // more data than the .json endpoint.
    /* harmony default export */ var neon_getProduct = (function (handle) {
      return function (cb) {
        return fetch("".concat(window.theme.routes.products, "/").concat(handle, ".js")).then(function (res) {
          return res.json();
        }).then(function (data) {
          return cb(data);
        })["catch"](function (err) {
          return console.log(err.message);
        });
      };
    });
    // CONCATENATED MODULE: ./src/scripts/neon/section.js
    
    /* harmony default export */ var section = (register);
    // CONCATENATED MODULE: ./src/scripts/neon/index.js
    
    
    
    
    // CONCATENATED MODULE: ./src/scripts/lib/product/unitPricing.js
    
    
    var unitPricing_theme = theme,
        unitPricing_strings = unitPricing_theme.strings.products;
    var unitPricing_selectors = {
      unitPriceContainer: '[data-unit-price-container]',
      unitPrice: '[data-unit-price]',
      unitPriceBase: '[data-unit-base]'
    };
    var unitPricing_classes = {
      available: 'unit-price--available'
    };
    
    var unitPricing_updateUnitPrices = function updateUnitPrices(container, variant) {
      var unitPriceContainers = fluorescent_dom_es_t(unitPricing_selectors.unitPriceContainer, container);
      var unitPrices = fluorescent_dom_es_t(unitPricing_selectors.unitPrice, container);
      var unitPriceBases = fluorescent_dom_es_t(unitPricing_selectors.unitPriceBase, container);
      fluorescent_dom_es_l(unitPriceContainers, unitPricing_classes.available, variant.unit_price !== undefined);
      if (!variant.unit_price) return;
    
      _replaceText(unitPrices, neon_formatMoney(variant.unit_price));
    
      _replaceText(unitPriceBases, _getBaseUnit(variant.unit_price_measurement));
    };
    
    var unitPricing_renderUnitPrice = function renderUnitPrice(unitPrice, unitPriceMeasurement) {
      if (unitPrice && unitPriceMeasurement) {
        var label = unitPricing_strings.product.unitPrice;
        return "\n      <div class=\"unit-price ".concat(unitPricing_classes.available, "\">\n        <dt>\n          <span class=\"visually-hidden visually-hidden--inline\">").concat(label, "</span>\n        </dt>\n        <dd class=\"unit-price__price\">\n          <span data-unit-price>").concat(neon_formatMoney(unitPrice), "</span><span aria-hidden=\"true\">/</span><span class=\"visually-hidden\">").concat(unitPricing_strings.product.unitPriceSeparator, "&nbsp;</span><span data-unit-base>").concat(_getBaseUnit(unitPriceMeasurement), "</span>\n        </dd>\n      </div>\n    ");
      } else {
        return '';
      }
    };
    
    var _getBaseUnit = function _getBaseUnit(unitPriceMeasurement) {
      return unitPriceMeasurement.reference_value === 1 ? unitPriceMeasurement.reference_unit : unitPriceMeasurement.reference_value + unitPriceMeasurement.reference_unit;
    };
    
    var _replaceText = function _replaceText(nodeList, replacementText) {
      nodeList.forEach(function (node) {
        return node.innerText = replacementText;
      });
    };
    
    
    // CONCATENATED MODULE: ./src/scripts/lib/product/index.js
    
    
    
    
    
    
    
    
    // CONCATENATED MODULE: ./src/scripts/lib/quick-cart.js
    
    
    
    
    var plus = "<svg width=\"11\" height=\"11\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M5.5 0v11M0 5.5h11\" stroke=\"currentColor\"/></svg>";
    var minus = "<svg width=\"10\" height=\"2\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M1 1h8\" stroke=\"currentColor\" stroke-linecap=\"square\"/></svg>";
    
    var quick_cart_renderLineDiscounts = function renderLineDiscounts(discounts) {
      if (Boolean(discounts.length)) {
        var formatted_discounts = discounts.map(function (_ref) {
          var amount = _ref.amount,
              title = _ref.discount_application.title;
          return "<li>".concat(title, " (-").concat(currency_formatMoney(amount), ")</li>");
        });
        return "\n      <ul class=\"quick-cart__item-discounts\">\n        ".concat(formatted_discounts, "\n      </ul>\n    ");
      } else {
        return '';
      }
    };
    
    function createItem(_ref2, highlightProduct) {
      var id = _ref2.variant_id,
          title = _ref2.product_title,
          original_price = _ref2.original_line_price,
          price = _ref2.price,
          color = _ref2.variant_title,
          line_discounts = _ref2.line_level_discount_allocations,
          options_with_values = _ref2.options_with_values,
          product_has_only_default_variant = _ref2.product_has_only_default_variant,
          image = _ref2.image,
          url = _ref2.url,
          quantity = _ref2.quantity,
          unit_price = _ref2.unit_price,
          unit_price_measurement = _ref2.unit_price_measurement,
          selling_plan_allocation = _ref2.selling_plan_allocation,
          item = objectWithoutProperties_default()(_ref2, ["variant_id", "product_title", "original_line_price", "price", "variant_title", "line_level_discount_allocations", "options_with_values", "product_has_only_default_variant", "image", "url", "quantity", "unit_price", "unit_price_measurement", "selling_plan_allocation"]),
          gwp_product = _ref2.properties && _ref2.properties['FREE'] && _ref2.properties['FREE'] === 'GWP' || _ref2.handle && _ref2.handle.includes('freegift');
    
      var img = image && getSizedImageUrl(image.replace('.' + imageSize(image), ''), '200x');
      var priceQuanity = '';
    
      if (quantity > 1) {
        priceQuanity = "x ".concat(quantity);
      }
    
      var productOptions = "";
      var quantityZeroLeading = quantity > 9 ? quantity : "0".concat(quantity);
    
      if (!product_has_only_default_variant) {
        options_with_values.forEach(function (option) {
          var optionItem = "\n        <div>\n          ".concat(option.name, ": ").concat(option.value, "\n        </div>\n      ");
          productOptions += optionItem;
        });
      }
    
      var sellingPlanName = selling_plan_allocation ? "<p class=\"type-body-regular mt0 mb0\">".concat(selling_plan_allocation.selling_plan.name, "</p>") : "";
      return (
        /*html*/
        "\n    <div class='cart__item".concat(highlightProduct ? ' cart__item--highlight' : '', gwp_product ? ' cart__item--gwp': '', "' data-component='quickCartItem' data-id=").concat(id, ">\n      <div class=\"cart__item-content\">\n        <div class='quick-cart__image'>\n        ").concat(img ? "\n              <a href='".concat(url, "'>\n                <img src='").concat(img, "' loading='lazy' />\n              </a>\n            ") : "<div class=\"placeholder\"></div>", "\n        </div>\n        <div class='quick-cart__product-details justify-between'>\n          <div>\n            <h4 class=\"ma0\">\n              <a href='").concat(url, "'>").concat(title, "</a>\n            </h4>\n            <span class=\"quick-cart__product-price\">\n              <span class=\"quick-cart__product-price-value\">\n                ").concat(currency_formatMoney(price), " <span>").concat(priceQuanity, "</span>\n              </span>\n              ").concat(unitPricing_renderUnitPrice(unit_price, unit_price_measurement), "\n              ").concat(quick_cart_renderLineDiscounts(line_discounts), "\n              ").concat(sellingPlanName, "\n            </span>\n            ").concat(productOptions, "\n          </div>\n        </div>\n      </div>\n\n      <div class='quick-cart__item-bottom'>\n        <div class='quick-cart__quantity'>\n          <button type=\"button\" class='quick-cart__quantity-button js-remove-single px05'>").concat(minus, "</button>\n          <div class='quick-cart__item-total js-single-quantity'>").concat(quantityZeroLeading, "</div>\n          <button type=\"button\" class='quick-cart__quantity-button js-add-single px05'>").concat(plus, "</button>\n        </div>\n      </div>\n    </div>\n  ")
      );
    }
    function createRecent(_ref3) {
      var handle = _ref3.handle,
          title = _ref3.title,
          url = _ref3.url,
          image = _ref3.featured_image,
          product = objectWithoutProperties_default()(_ref3, ["handle", "title", "url", "featured_image"]);
    
      var img = image && getSizedImageUrl(image.replace('.' + imageSize(image), ''), '200x');
      return (
        /*html*/
        "\n    <div class=\"cart__item justify-around\">\n      <div class=\"cart__item-content\">\n        <div class=\"quick-cart__image\">\n          ".concat(img ? "\n              <a href='".concat(url, "'>\n                <img src='").concat(img, "' loading='lazy' />\n              </a>\n            ") : "<div class=\"placeholder\"></div>", "\n        </div>\n        <div class=\"quick-cart__product-details\">\n          <a href=\"").concat(url, "\">\n            <h3 class=\"ma0\">").concat(title, "</h3>\n          </a>\n          <span class=\"quick-cart__product-price\">").concat(currency_formatMoney(product.price), "</span>\n        </div>\n      </div>\n    </div>\n  ")
      );
    }
    // CONCATENATED MODULE: ./src/scripts/lib/recentlyViewed.js
    var recentlyViewed_ls = {
      get: function get() {
        return JSON.parse(localStorage.getItem('recentlyViewed'));
      },
      set: function set(val) {
        return localStorage.setItem('recentlyViewed', val);
      }
    };
    var updateRecentProducts = function updateRecentProducts(product) {
      var recentlyViewed = [];
    
      if (recentlyViewed_ls.get() !== null) {
        recentlyViewed = recentlyViewed_ls.get().filter(function (item) {
          return item.id !== product.id;
        });
        recentlyViewed.unshift(product);
        recentlyViewed_ls.set(JSON.stringify(recentlyViewed.slice(0, 20)));
      } else if (recentlyViewed_ls.get() === null) {
        recentlyViewed.push(product);
        recentlyViewed_ls.set(JSON.stringify(recentlyViewed));
      }
    };
    var resetRecentProducts = function resetRecentProducts() {
      return localStorage.removeItem('recentlyViewed');
    };
    var getRecentProducts = function getRecentProducts() {
      return recentlyViewed_ls.get();
    };
    // CONCATENATED MODULE: ./src/scripts/lib/quick-cart-item.js
    
    
    var quick_cart_item_quickCartItem = function quickCartItem(item) {
      var decrease = item.querySelector('.js-remove-single');
      var increase = item.querySelector('.js-add-single');
      var currentQty = item.querySelector('.js-single-quantity').innerHTML;
      var id = item.getAttribute('data-id');
      decrease.addEventListener('click', function (e) {
        e.preventDefault();
    
        if (currentQty === 1) {
          removeAddon(id);
        } else {
          updateAddon(id, parseInt(currentQty) - 1);
        }
        updateCart();
      });
      increase.addEventListener('click', function (e) {
        e.preventDefault();
        updateAddon(id, parseInt(currentQty) + 1);
        updateCart();
      });
    };

    function updateCart() {
      setTimeout(function () {
          fetchCart().then(function (cart) {
              evx_es_o({cart: cart});
              evx_es_r('cart:updated');
          });
      },2500)
  }
    
    /* harmony default export */ var quick_cart_item = (quick_cart_item_quickCartItem);
    // CONCATENATED MODULE: ./src/scripts/components/cartDrawer.js
    
    
    
    
    
    
    
    function renderItems(items) {
      return items.length > 0 ? items.reduce(function (markup, item) {
        var hightlightProduct = evx_es_u().newItemInCart; // Only the first product should be highlighted. If a product
        // is highlighted set the flag to false after the first
    
        if (hightlightProduct) {
          evx_es_o({
            newItemInCart: false
          });
        }
    
        markup += createItem(item, hightlightProduct);
        return markup;
      }, '') : "<p class=\"quick-cart__empty-state\">".concat(theme.strings.cart.general.empty, "</p>");
    }
    
    function renderDiscounts(discounts) {
      return discounts.length > 0 ? "\n    <div>\n      ".concat(discounts.map(function (_ref) {
        var title = _ref.title,
            value = _ref.total_allocated_amount;
        return "<div>".concat(title, " (-").concat(currency_formatMoney(value), ")</div>");
      }), "\n    </div>\n  ") : "";
    }
    
    function renderRecent(products) {
      return products.length > 0 ? products.reduce(function (markup, product) {
        markup += createRecent(product);
        return markup;
      }, '') : "<p class=\"quick-cart__empty-state\">".concat(general.products.no_recently_viewed, "</p>");
    }
    
    var cartDrawer_selectors = {
      cartItems: '.cart__item'
    };
    
    var cartDrawer_cartDrawer = function cartDrawer(node) {
      var focusTrap = createFocusTrap(node, {
        allowOutsideClick: true
      });
      var cartDOM = node.parentNode.querySelector('[data-cart-page]');
      var discounts = node.querySelector('.js-discounts');
      var subtotal = node.querySelectorAll('.js-subtotal');
      var itemsRoot = node.querySelector('.js-items');
      var footer = node.querySelector('.js-footer');
      var closeIcon = node.querySelectorAll('.js-close');
	    var cartNote = node.querySelector('.js-cartnote');
      var loading = itemsRoot.innerHTML;
      var tabLinkCart = node.querySelector('.js-tab-link-cart');
      var tabLinkRecent = node.querySelector('.js-tab-link-recent');
      var tabLinkQuickShop = node.querySelector('.js-tab-link-quick-shop');
      var freeShippingDOM = node.querySelector('.js-free-shipping');
      var freeShippingPriceDOM = node.querySelector('.js-free-shipping-price');
      var upsellDOM = document.querySelector('.js-upsell');
      var gwpDOM = node.querySelector('.js-gwp');
    
      var render = function render(cart) {
        var cart_discounts = cart.cart_level_discount_applications;
        tabLinkCart.classList.add('active');
        tabLinkQuickShop.classList.remove('active');
        tabLinkRecent.classList.remove('active');
        itemsRoot.innerHTML = renderItems(cart.items);
        var cartItems = itemsRoot.querySelectorAll(cartDrawer_selectors.cartItems);
    
        if (cartItems.length) {
          cartItems.forEach(function (item) {
            quick_cart_item(item);
          });
        }
    
        if (getRecentProducts()) {
          tabLinkRecent.classList.remove('hide');
        }
    
        discounts.innerHTML = renderDiscounts(cart_discounts);
        cart.items.length > 0 ? footer.classList.add('active') : footer.classList.remove('active');
        Boolean(cart_discounts.length > 0) ? discounts.classList.add('active') : discounts.classList.remove('active');
    
        if (subtotal.length > 0) {
          subtotal.forEach((subtotalDOM) => {
            subtotalDOM.innerHTML = currency_formatMoney(cart.total_price);
          });
        }

        // FREE SHIPPING
        if (freeShippingDOM) {
          freeShipping(cart, freeShippingDOM, freeShippingPriceDOM);
        }

        //GWP

        if (gwpDOM) {
          gwpEvents(cart, gwpDOM);
        }

        // UPSELL
        if (upsellDOM) {
          upsell(cart, upsellDOM);
        }
      };
    
      var open = function open(cart, hasquickShopProduct) {
        node.classList.add('is-visible');
        evx_es_r('drawerOverlay:show');
        node.classList.add('is-active');
        itemsRoot.innerHTML = loading;
    
        if (evx_es_u().quickShopProduct) {
          node.classList.add('has-quick-shop-product');
        }
    
        setTimeout(function () {
          focusTrap.activate();
    
          if (hasquickShopProduct) {
            tabLinkQuickShop.classList.add('active');
            setTimeout(viewQuickAdd(), 10);
          } else {
            tabLinkCart.classList.add('active');
            setTimeout(render(cart), 10);
          }
        }, 50);
      };
    
      var close = function close() {
        var hideOverlay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        hideOverlay && evx_es_r('drawerOverlay:hide');
        node.classList.remove('is-visible');
        tabLinkQuickShop.classList.remove('active');
        tabLinkRecent.classList.remove('active');
        tabLinkCart.classList.remove('active');
        node.classList.remove('has-quick-shop-product');
        setTimeout(function () {
          focusTrap.deactivate();
          evx_es_o({
            cartOpen: false,
            quickShopProduct: null
          });
        }, 50);
      };
    
      var overlayHideListener = evx_es_c('drawerOverlay:hiding', function () {
        return close(false);
      });
    
      var viewCart = function viewCart() {
        tabLinkCart.classList.add('active');
        tabLinkRecent.classList.remove('active');
        tabLinkQuickShop.classList.remove('active');
        var cart = evx_es_u().cart;
        render(cart);
      };
    
      var viewRecent = function viewRecent(products) {
        if (!products) return;
        tabLinkCart.classList.remove('active');
        tabLinkQuickShop.classList.remove('active');
        tabLinkRecent.classList.add('active');
        footer.classList.remove('active');
        itemsRoot.innerHTML = renderRecent(products);
      };
    
      var viewQuickAdd = function viewQuickAdd() {
        tabLinkQuickShop.classList.add('active');
        tabLinkCart.classList.remove('active');
        tabLinkRecent.classList.remove('active');
        footer.classList.remove('active');
        itemsRoot.innerHTML = '';
        itemsRoot.appendChild(evx_es_u().quickShopProduct);
      };
    
      var handleKeyboard = function handleKeyboard(e) {
        var cartOpen = evx_es_u().cartOpen;
    
        if (!cartOpen) {
          return;
        }
    
        if (e.key == 'Escape' || e.keyCode === 27 && drawerOpen) {
          close();
        }
      };

      cartNote.addEventListener('input', function() {
        updateCartNote(cartNote.value);
        if (freeShippingDOM && cartNote.value) {
          var cartNoteLength = cartNote.value.length,
              cartNoteLabel = cartNote.parentElement.querySelector('.cart-note__label');
          cartNoteLength <= 1
            ? cartNoteLabel ? cartNoteLabel.style.opacity = 1 : ''
            : cartNoteLabel ? cartNoteLabel.style.opacity = 0 : '';
        }
      });

      var updateCartNote = function(cartNote) {
        var data = JSON.stringify({
          note: cartNote
        });
        var req = new XMLHttpRequest();
        req.open('POST', '/cart/update.js', true);
        req.setRequestHeader('Content-Type', 'application/json');
        req.onerror = function() {
          console.error(this);
        };
        req.send(data);
      };
    
      render(evx_es_u().cart);
      tabLinkCart.addEventListener('click', function (e) {
        return e.preventDefault() || viewCart();
      });
      tabLinkRecent.addEventListener('click', function (e) {
        return e.preventDefault() || viewRecent(getRecentProducts());
      });
      tabLinkQuickShop.addEventListener('click', function (e) {
        return e.preventDefault() || viewQuickAdd();
      });
      closeIcon.forEach((icon) => {
        icon.addEventListener('click', close);
        evx_es_c('cart:toggle', function (_ref2) {
          var cart = _ref2.cart,
              cartOpen = _ref2.cartOpen,
              quickShopProduct = _ref2.quickShopProduct;
          cartOpen ? open(cart, quickShopProduct) : close();
        });
      });
      evx_es_c('cart:updated', function (_ref3) {
        var cartOpen = _ref3.cartOpen,
            cart = _ref3.cart;
        node.classList.remove('has-quick-shop-product'); // Rerender the cart list only if cart is open
    
        if (cartOpen) {
          render(cart);
        } else {
          evx_es_o({
            cartOpen: true
          });
          open(cart);
        }
      });
      window.addEventListener('keydown', handleKeyboard);
    
      var unload = function unload() {
        window.removeEventListener('keydown', handleKeyboard);
        overlayHideListener();
      };

      /**
       * FREE SHIPPING
       */
      function freeShipping(cart, freeShippingDOM, freeShippingPriceDOM) {
        var fs$datas = freeShippingDOM.dataset,
            fs$label = freeShippingDOM.querySelector('.js-free-shipping__label'),
            fs$progressBar = freeShippingDOM.querySelector('.js-free-shipping__progress-bar'),
            fs$datas$threshold = fs$datas.freeShippingThreshold * 100,
            // drawer-cart -> fs footer pricing
            fsPrice$datas = freeShippingPriceDOM.dataset,
            // Validations
            cart_price = cart.total_price,
            fs_shop_currency = fs$datas.shopCurrencySymbol,
            fs_label = fs$datas.freeShippingLabel,
            fs_goal_reached = fs$datas.freeShippingGoalReached,
            fs_icon_check=fs$datas.iconCheck,
            fs_price_to_goal = (fs$datas$threshold - cart_price) / 100,
            fs_progress = (cart_price * 100) / fs$datas$threshold;
        if (cartDOM) {
          var fs$cartLabel = cartDOM.querySelector('.js-free-shipping__label');
        };
        fs$progressBar.setAttribute('value', fs_progress);
        
        if (fs$datas$threshold <= cart_price) {
          fs$label.innerHTML = fs_icon_check.concat(fs_goal_reached);
          freeShippingPriceDOM.innerHTML = fsPrice$datas.freeShippingUnlocked;
          fs$label.classList.add('goal');
          fs$label.classList.remove('goaless');

          if (fs$cartLabel) {
            fs$cartLabel.innerHTML = fs_icon_check.concat(fs_goal_reached);
            fs$cartLabel.classList.add('goal');
            fs$cartLabel.classList.remove('goaless');  
          };
        } else {
          fs$label.innerHTML = fs_label.replace('{{ amount }}', fs_shop_currency.concat(fs_price_to_goal));
          freeShippingPriceDOM.innerHTML = fsPrice$datas.freeShippingLocked;
          fs$label.classList.remove('goal');
          fs$label.classList.add('goaless');

          if (fs$cartLabel) {
            fs$cartLabel.innerHTML = fs_label.replace('{{ amount }}', fs_shop_currency.concat(fs_price_to_goal));
            fs$cartLabel.classList.remove('goal');
            fs$cartLabel.classList.add('goaless');
          };
        }
      }
      /**
       * END FREE SHIPPING
       */
      
      /**
       * GWP
       */
      function gwpEvents(cart, gwpDOM) {
        var hasFS = gwpDOM.parentElement.querySelector('.js-free-shipping'),
            gwp$datas = gwpDOM.dataset,
            cart_price = cart.total_price;

        var gwp$threshold = gwp$datas.gwpThreshold * 100,
            gwp$gwpProdID = parseInt(gwp$datas.gwpProductId),
            gwp$gwpProdAvailable = gwp$datas.gwpProductAvailable === 'true',
            gwp$gwpProdRuleIDs = gwp$datas.gwpProductRuleId && gwp$datas.gwpProductRuleId.split(',');

        /*=====> RULES VALIDATIONS <=====*/
        if (!gwp$gwpProdAvailable) return; // only enable GWP if GWP product is available

        if (gwp$gwpProdRuleIDs && gwp$gwpProdRuleIDs.length > 0) { // only add GWP if product-rule exist
          var gwp$prod_rule_in_cart = false;
          cart.items.forEach((cartItem) => {
            for (var i=0; i < gwp$gwpProdRuleIDs.length; i++) {
              var currProdRuleID = parseInt(gwp$gwpProdRuleIDs[i]);
              if (cartItem.id === currProdRuleID) {
                gwp$prod_rule_in_cart = true;
                break;
              }
            }
          });
          if (!gwp$prod_rule_in_cart) {
            gwpHandle(gwp$gwpProdID, 'remove');
            return;
          }

          if (gwp$threshold <= cart_price) { // Handle GWP - when GWP-product-rule exist
            gwpHandle(gwp$gwpProdID, 'add');
          } else if (cart_price <= gwp$threshold) {
            gwpHandle(gwp$gwpProdID, 'remove');
          }
        }

        if (gwp$threshold <= cart_price) { // Handle GWP - when GWP-product-rule don't exist
          gwpHandle(gwp$gwpProdID, 'add');
        } else if (cart_price <= gwp$threshold) {
          gwpHandle(gwp$gwpProdID, 'remove');
        }

        async function gwpHandle(product_id, req_type = null) {
          if (req_type === null) return; // Cancel actions if no req_type declared
          var gwp_in_cart = false,
              gwp_key = null;
          cart.items.forEach((item) => {
            if (item.properties && item.properties['FREE'] && item.properties['FREE'] === 'GWP') {
              gwp_in_cart = true;
              gwp_key = item.key;
            }
          });
          // if (!gwp_in_cart) return; // Cancel actions if GWP product is in cart and req_type equals to "remove"

          if (gwp_in_cart && gwp_key !== null && req_type === 'remove') { // Remove GWP product, it needs to be into cart
            var update_data = {};
            update_data[`${gwp_key}`] = 0;

            evx_es_r('cart:updating');
            return unfetch("".concat(theme.routes.cart.update, ".js"), {
              method: "POST",
              credentials: "include",
              headers: {
                "Content-Type": "application/json"
              },
              body: JSON.stringify({
                updates: update_data
              })
            }).then(function (r) {
              return r.json();
            }).then(function (item) {
              return fetchCart(product_id).then(function (cart) {
                evx_es_o({
                  cart: cart
                });
                evx_es_r('cart:updated');
                return {
                  item: item,
                  cart: cart,
                }
              });
            });
          }

          if (!gwp_in_cart && req_type === 'add') { // Add GWP product
            evx_es_r('cart:updating');
            return unfetch("".concat(theme.routes.cart.add, ".js"), {
              method: "POST",
              credentials: "include",
              headers: {
                "Content-Type": "application/json"
              },
              body: JSON.stringify({
                id: product_id,
                quantity: 1,
                properties: {
                  "FREE": "GWP"
                }
              })
            }).then(function (r) {
              return r.json();
            }).then(function (item) {
              return fetchCart(product_id).then(function (cart) {
                evx_es_o({
                  cart: cart
                });
                evx_es_r('cart:updated');
                return {
                  item: item,
                  cart: cart,
                }
              });
            });
          }
        }

      }
      /**
       * END GWP
       */
    
      /**
       * UPSELL
       */
      var handleUpsellFieldsetChange = function handleUpsellFieldsetChange(event) {
        var fieldset = event.target.closest('fieldset'),
            form = fieldset.closest('form'),
            currInput = fieldset.querySelector('input:checked'),
            currInputVal = currInput && currInput.value;

        form.querySelector('[name="id"]').value = currInputVal;
        form.querySelector('[name="id"]').setAttribute('value', currInputVal);
      }

      var handleUpsellFormSubmit = function handleUpsellFormSubmit(event) {
        event.preventDefault();

        var form = event.target,
            formItemId = form.querySelector('[name="id"]').value;

        evx_es_r('cart:updating');
        return unfetch("".concat(theme.routes.cart.add, ".js"), {
          method: 'POST',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: formItemId,
            quantity: 1,
          })
        }).then(function (r) {
          return r.json();
        }).then(function (item) {
          return fetchCart(formItemId).then(function (cart) {
            evx_es_o({
              cart: cart
            });
            evx_es_r('cart:updated');
            return {
              item: item,
              cart: cart,
            };
          });
        });
      }

      function upsell(cart, upsellDOM) {
        var upsell$list = upsellDOM.querySelector('#UpsellList'),
            upsell$items = upsellDOM.querySelectorAll('.js-upsell-item');

        if (upsell$items.length > 0) {
          upsell$items.forEach((item, index) => {
            var upsell$item = item,
                upsell$item$id = parseInt(item.dataset.itemId),
                upsell$item$form = item.querySelector('form.actions__form');
            cart.items.forEach((cartItem, index) => {
              if (cartItem.id === upsell$item$id) {
                upsell$list.removeChild(upsell$item);
                if (upsell$list.children.length === 0) {
                  upsellDOM.style.display = 'none';
                }
              }
            });

            if (upsell$list.classList.contains('upsell-list__type-product')) {
              var upsell$item$fieldset = upsell$item.querySelector('.info-content__text--variants');

              upsell$item$fieldset && upsell$item$fieldset.addEventListener('input', handleUpsellFieldsetChange);
            }

            upsell$item$form && upsell$item$form.addEventListener('submit', handleUpsellFormSubmit);
          });
        }
      }
      /**
       * END UPSELL
       */

      return {
        unload: unload,
        open: open
      };
    };
    
    /* harmony default export */ var components_cartDrawer = (cartDrawer_cartDrawer);
    // CONCATENATED MODULE: ./src/scripts/components/modal.js
    
    
    
    
    var modal_classes = {
      visible: 'is-visible'
    };
    var modal_selectors = {
      closeBtn: '[data-modal-close]',
      modalContent: '.modal__content',
      accordion: '.accordion'
    };
    
    var modal_modal = function modal(node) {
      var focusTrap = createFocusTrap(node, {
        allowOutsideClick: true
      });
      var modalContent = fluorescent_dom_es_n(modal_selectors.modalContent, node);
      var accordionElement = null;
      var events = [fluorescent_dom_es_e(fluorescent_dom_es_n(modal_selectors.closeBtn, node), 'click', function (e) {
        e.preventDefault();
    
        _close();
      }), fluorescent_dom_es_e(node, 'keydown', function (_ref) {
        var keyCode = _ref.keyCode;
        if (keyCode === 27) _close();
      }), evx_es_c('drawerOverlay:hiding', function () {
        return _close(false);
      }), evx_es_c('modal:open', function (state, _ref2) {
        var modalContent = _ref2.modalContent;
    
        _renderModalContent(modalContent);
    
        _open();
      })];
    
      var _renderModalContent = function _renderModalContent(content) {
        var clonedContent = content.cloneNode(true);
        modalContent.innerHTML = '';
        modalContent.appendChild(clonedContent);
    
        _initAccordion();
      };
    
      var _initAccordion = function _initAccordion() {
        var accordionItem = modalContent.querySelector(modal_selectors.accordion);
        if (!accordionItem) return;
        accordionElement = components_accordion(accordionItem);
      };
    
      var _open = function _open() {
        fluorescent_dom_es_u(node, modal_classes.visible);
        focusTrap.activate();
        evx_es_r('drawerOverlay:show');
      };
    
      var _close = function _close() {
        var hideOverlay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        modalContent.innerHTML = '';
        focusTrap.deactivate();
        hideOverlay && evx_es_r('drawerOverlay:hide');
        fluorescent_dom_es_i(node, modal_classes.visible);
      };
    
      var unload = function unload() {
        events.forEach(function (unsubscribe) {
          return unsubscribe();
        });
        accordionElement && accordionElement.unload();
      };
    
      return {
        unload: unload
      };
    };
    
    /* harmony default export */ var components_modal = (modal_modal);
    // CONCATENATED MODULE: ./src/scripts/components/storeAvailabilityDrawer.js
    
    
    
    
    
    
    var storeAvailabilityDrawer_classes = {
      visible: 'is-visible'
    };
    var storeAvailabilityDrawer_selectors = {
      closeBtn: '[data-store-availability-close]',
      productTitle: '[data-store-availability-product-title]',
      variantTitle: '[data-store-availability-variant-title]',
      productCard: '[data-store-availability-product]',
      storeListcontainer: '[data-store-list-container]'
    };
    
    var storeAvailabilityDrawer_storeAvailabilityDrawer = function storeAvailabilityDrawer(node) {
      var focusTrap = createFocusTrap(node, {
        allowOutsideClick: true
      });
      var productCard = fluorescent_dom_es_n(storeAvailabilityDrawer_selectors.productCard, node);
      var storeListContainer = fluorescent_dom_es_n(storeAvailabilityDrawer_selectors.storeListcontainer, node);
      var events = [fluorescent_dom_es_e(fluorescent_dom_es_n(storeAvailabilityDrawer_selectors.closeBtn, node), 'click', function (e) {
        e.preventDefault();
    
        _close();
      }), fluorescent_dom_es_e(node, 'keydown', function (_ref) {
        var keyCode = _ref.keyCode;
        if (keyCode === 27) _close();
      }), evx_es_c('drawerOverlay:hiding', function () {
        return _close(false);
      }), evx_es_c('availability:showMore', function (_ref2) {
        var product = _ref2.product,
            variant = _ref2.variant,
            storeList = _ref2.storeList;
        productCard.innerHTML = _renderProductCard(product, variant);
    
        _renderAvailabilityList(storeList);
    
        _open();
      })];
    
      var _renderAvailabilityList = function _renderAvailabilityList(storeList) {
        storeListContainer.innerHTML = '';
        storeListContainer.appendChild(storeList);
      };
    
      var _renderProductCard = function _renderProductCard(_ref3, _ref4) {
        var image = _ref3.featured_image,
            title = _ref3.title;
        var variant_title = _ref4.title,
            featured_image = _ref4.featured_image,
            price = _ref4.price,
            unit_price = _ref4.unit_price,
            unit_price_measurement = _ref4.unit_price_measurement;
    
        var productImage = _getVariantImage(image, featured_image);
    
        return "\n      <div class=\"store-availbility-flyout__product-card type-body-regular\">\n        ".concat(productImage ? "\n            <div class='store-availbility-flyout__product-card-image'>\n              <img src='".concat(productImage, "' alt='").concat(title, "' loading='lazy'/>\n            </div>\n          ") : '', "\n        <div class='store-availbility-flyout__product-card-details'>\n          <div>\n            <h4 class=\"ma0\">\n              <span>").concat(title, "</span>\n            </h4>\n            <div class=\"store-availbility-flyout__product-price-wrapper\">\n              <span class=\"store-availbility-flyout__product-price\">").concat(currency_formatMoney(price), "</span>\n              ").concat(unitPricing_renderUnitPrice(unit_price, unit_price_measurement), "\n            </div>\n            <div class=\"store-availbility-flyout__product-card-options\">\n              ").concat(variant_title, "\n            </div>\n          </div>\n        </div>\n      </div>\n    ");
      };
    
      var _getVariantImage = function _getVariantImage(productImage, variantImage) {
        if (!productImage && !variantImage) return '';
    
        if (variantImage) {
          return _updateImageSize(variantImage.src);
        }
    
        return _updateImageSize(productImage);
      };
    
      var _updateImageSize = function _updateImageSize(imageUrl) {
        return getSizedImageUrl(imageUrl.replace('.' + imageSize(imageUrl), ''), '200x');
      };
    
      var _open = function _open() {
        fluorescent_dom_es_u(node, storeAvailabilityDrawer_classes.visible);
        node.setAttribute('aria-hidden', 'false');
        focusTrap.activate();
        evx_es_r('drawerOverlay:show');
      };
    
      var _close = function _close() {
        var hideOverlay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        focusTrap.deactivate();
        hideOverlay && evx_es_r('drawerOverlay:hide');
        fluorescent_dom_es_i(node, storeAvailabilityDrawer_classes.visible);
        node.setAttribute('aria-hidden', 'true');
      };
    
      var unload = function unload() {
        events.forEach(function (unsubscribe) {
          return unsubscribe();
        });
      };
    
      return {
        unload: unload
      };
    };
    
    /* harmony default export */ var components_storeAvailabilityDrawer = (storeAvailabilityDrawer_storeAvailabilityDrawer);
    // EXTERNAL MODULE: ./src/styles/index.css
    var styles = __webpack_require__(30);
    
    // EXTERNAL MODULE: ./node_modules/lazysizes/plugins/object-fit/ls.object-fit.js
    var ls_object_fit = __webpack_require__(31);
    
    // EXTERNAL MODULE: ./node_modules/lazysizes/plugins/parent-fit/ls.parent-fit.js
    var ls_parent_fit = __webpack_require__(32);
    
    // EXTERNAL MODULE: ./node_modules/lazysizes/plugins/rias/ls.rias.js
    var ls_rias = __webpack_require__(33);
    
    // EXTERNAL MODULE: ./node_modules/lazysizes/plugins/bgset/ls.bgset.js
    var ls_bgset = __webpack_require__(34);
    
    // EXTERNAL MODULE: ./node_modules/lazysizes/lazysizes.js
    var lazysizes = __webpack_require__(3);
    
    // EXTERNAL MODULE: ./node_modules/lazysizes/plugins/respimg/ls.respimg.js
    var ls_respimg = __webpack_require__(35);
    
    // CONCATENATED MODULE: ./src/scripts/components/disclosure.js
    
    var disclosure_selectors = {
      form: '.selectors-form',
      disclosureList: '[data-disclosure-list]',
      disclosureToggle: '[data-disclosure-toggle]',
      disclosureInput: '[data-disclosure-input]',
      disclosureOptions: '[data-disclosure-option]'
    };
    var disclosure_classes = {
      listVisible: 'disclosure-list--visible'
    };
    
    function has(list, selector) {
      return list.map(function (l) {
        return l.contains(selector);
      }).filter(Boolean);
    }
    
    var disclosure_disclosure = function disclosure(node, container) {
      var form = container.querySelector(disclosure_selectors.form);
      var disclosureList = node.querySelector(disclosure_selectors.disclosureList);
      var disclosureToggle = node.querySelector(disclosure_selectors.disclosureToggle);
      var disclosureInput = node.querySelector(disclosure_selectors.disclosureInput);
      var disclosureOptions = node.querySelectorAll(disclosure_selectors.disclosureOptions);
      disclosureOptions.forEach(function (option) {
        return option.addEventListener('click', submitForm);
      });
      disclosureToggle.addEventListener('click', handleToggle);
      disclosureToggle.addEventListener('focusout', handleToggleFocusOut);
      disclosureList.addEventListener('focusout', handleListFocusOut);
      node.addEventListener('keyup', handleKeyup);
      document.addEventListener('click', handleBodyClick);
    
      function submitForm(evt) {
        evt.preventDefault();
        var value = evt.currentTarget.dataset.value;
        disclosureInput.value = value;
        form.submit();
      }
    
      function handleToggleFocusOut(evt) {
        var disclosureLostFocus = has([node], evt.relatedTarget).length === 0;
    
        if (disclosureLostFocus) {
          hideList();
        }
      }
    
      function handleListFocusOut(evt) {
        var childInFocus = has([node], evt.relatedTarget).length > 0;
        var isVisible = disclosureList.classList.contains(disclosure_classes.listVisible);
    
        if (isVisible && !childInFocus) {
          hideList();
        }
      }
    
      function handleKeyup(evt) {
        if (evt.which !== 27) return;
        hideList();
        disclosureToggle.focus();
      }
    
      function handleToggle(evt) {
        disclosureList.classList.toggle(disclosure_classes.listVisible);
        var ariaExpanded = disclosureList.classList.contains(disclosure_classes.listVisible);
        evt.currentTarget.setAttribute('aria-expanded', ariaExpanded);
    
        if (ariaExpanded) {
          evx_es_r('navitem:closeOthers');
        }
      }
    
      function handleBodyClick(evt) {
        var isOption = has([node], evt.target).length > 0;
        var isVisible = disclosureList.classList.contains(disclosure_classes.listVisible);
    
        if (isVisible && !isOption) {
          hideList();
        }
      }
    
      function hideList() {
        disclosureToggle.setAttribute('aria-expanded', false);
        disclosureList.classList.remove(disclosure_classes.listVisible);
      }
    
      var unload = function unload() {
        disclosureOptions.forEach(function (o) {
          return o.removeEventListener('click', submitForm);
        });
        disclosureToggle.removeEventListener('click', handleToggle);
        disclosureToggle.removeEventListener('focusout', handleToggleFocusOut);
        disclosureList.removeEventListener('focusout', handleListFocusOut);
        node.removeEventListener('keyup', handleKeyup);
        document.removeEventListener('click', handleBodyClick);
      };
    
      return {
        unload: unload
      };
    };
    
    /* harmony default export */ var components_disclosure = (disclosure_disclosure);
    // CONCATENATED MODULE: ./src/scripts/frame/footer.js
    
    
    var footer_selectors = {
      disclosure: '[data-disclosure]'
    };
    section('footer', {
      crossBorder: {},
      onLoad: function onLoad() {
        var _this = this;
    
        // Wire up Cross Border disclosures
        var cbSelectors = this.container.querySelectorAll(footer_selectors.disclosure);
    
        if (cbSelectors) {
          cbSelectors.forEach(function (selector) {
            var d = selector.dataset.disclosure;
            _this.crossBorder[d] = components_disclosure(selector, _this.container);
          });
        }
      },
      onUnload: function onUnload() {
        var _this2 = this;
    
        Object.keys(this.crossBorder).forEach(function (t) {
          _this2.crossBorder[t].unload();
        });
      }
    });
    // CONCATENATED MODULE: ./src/scripts/components/navigation.js
    
    
    var navigation_selectors = {
      activeItem: 'nav__item--active',
      activeMenu: 'nav__menu--active',
      navTrigger: '[data-navmenu-trigger]',
      subMenu: '[data-nav-submenu]',
      headerNav: '.header__nav',
      navLink: '.nav__link',
      linkParent: '.nav__link-parent',
      itemParent: '.nav__item-parent',
      navDepthOne: '.nav--depth-1',
      quickSearchTrigger: '.quick-search__trigger',
      headerAcccountIcon: '.header__icon--account',
      logoTrigger: '.header__logo-image'
    };
    
    var navigation_navigation = function navigation(node) {
      var header = node.querySelector('.header');
      var detectMenuLength = header.classList.contains('header--detect-menu-length');
      var resizeWatcher = null;
      var headerNav = node.querySelector(navigation_selectors.headerNav);
      var navDepthOne = headerNav.querySelector(navigation_selectors.navDepthOne);
      var headerLinks = navDepthOne.querySelectorAll("".concat(navigation_selectors.navDepthOne, " > li:not(").concat(navigation_selectors.itemParent, ") > ").concat(navigation_selectors.navLink));
      var logoTrigger = node.querySelector(navigation_selectors.logoTrigger);
      var quickSearchTrigger = node.querySelector(navigation_selectors.quickSearchTrigger);
      var accountTrigger = node.querySelector("".concat(navigation_selectors.headerAcccountIcon, " > a"));
      var navMenuTrigger = node.querySelectorAll("".concat(navigation_selectors.navTrigger, " > ").concat(navigation_selectors.linkParent));
      var events = [];
    
      var _addEvent = function _addEvent(element, action, func) {
        element.addEventListener(action, func, true);
        events.push({
          element: element,
          action: action,
          func: func
        });
      };
    
      var _bindEvents = function _bindEvents() {
        _addEvent(document, 'click', _handleBodyClick);
    
        navMenuTrigger.forEach(function (trigger) {
          _addEvent(trigger, 'focusin', _toggleMenu);
    
          _addEvent(trigger, 'mousedown', _toggleMenu);
    
          _addEvent(trigger, 'click', _preventHandler);
        });
        headerLinks.forEach(function (link) {
          _addEvent(link, 'focus', _hideOverlay);
    
          _addEvent(link, 'focus', closeAll);
        });
    
        if (logoTrigger) {
          _addEvent(logoTrigger, 'focus', closeAll);
    
          _addEvent(logoTrigger, 'focus', _hideOverlay);
        }
    
        if (quickSearchTrigger) {
          _addEvent(quickSearchTrigger, 'focus', closeAll);
    
          _addEvent(quickSearchTrigger, 'focus', _hideOverlay);
        }
    
        if (accountTrigger) {
          _addEvent(accountTrigger, 'focus', closeAll);
    
          _addEvent(accountTrigger, 'focus', _hideOverlay);
        } // Init scroll watcher
    
    
        _addEvent(navDepthOne, 'scroll', _handleScroll);
      }; // Close all nav drop downs if anything is clicked outside of menu
    
    
      var _handleBodyClick = function _handleBodyClick(event) {
        if (!evx_es_u().headerOverlayOpen) return;
    
        if (event.target.matches('[data-navigation-dropdown-trigger], [data-navigation-dropdown-trigger] *')) {
          return;
        }
    
        if (!event.target.matches('[data-navigation-dropdown], [data-navigation-dropdown] *')) {
          _hideOverlay();
    
          closeAll();
        }
      };
    
      var _toggleMenu = function _toggleMenu(event) {
        event.preventDefault();
        var element = event.currentTarget.parentNode;
        var menu = element.querySelector(navigation_selectors.subMenu);
    
        if (_isVisible(menu)) {
          _closeMenu(element);
        } else {
          evx_es_r('headerOverlay:show');
    
          _openMenu(element);
        }
      };
    
      var _preventHandler = function _preventHandler(e) {
        e.preventDefault();
      };
    
      var _hideOverlay = function _hideOverlay() {
        evx_es_r('headerOverlay:hide');
      };
    
      var _isVisible = function _isVisible(node) {
        return !!(node.offsetWidth || node.offsetHeight || node.getClientRects().length);
      };
    
      var _openMenu = function _openMenu(target) {
        if (!target.parentNode.classList.contains('nav--depth-2')) {
          closeAll();
        } else {
          // Close all submenus
          target.parentNode.querySelectorAll(navigation_selectors.navTrigger).forEach(function (submenu) {
            return _closeMenu(submenu);
          });
        }
    
        var menu = target.querySelector(navigation_selectors.subMenu);
        var menuLink = target.querySelector(navigation_selectors.navLink);
        menu.classList.add('visible');
        menuLink.classList.add(navigation_selectors.activeMenu);
        menuLink.setAttribute('aria-expanded', true);
        header.setAttribute('data-transparent-header', false);
      };
    
      var _closeMenu = function _closeMenu(target) {
        var menu = target.querySelector(navigation_selectors.subMenu);
        var menuLink = target.querySelector(navigation_selectors.navLink);
    
        if (!target.parentNode.classList.contains('nav--depth-2')) {
          _hideOverlay();
        }
    
        menu.classList.remove('visible');
        menuLink.classList.remove(navigation_selectors.activeMenu);
        menuLink.setAttribute('aria-expanded', false);
        header.setAttribute('data-transparent-header', true);
      };
    
      var closeAll = function closeAll() {
        node.classList.remove();
        var menuTriggers = node.querySelectorAll(navigation_selectors.navTrigger);
        menuTriggers.forEach(function (trigger) {
          var menu = trigger.querySelector(navigation_selectors.subMenu);
          var menuLink = trigger.querySelector(navigation_selectors.navLink);
          menu.classList.remove('visible');
          menuLink.classList.remove(navigation_selectors.activeMenu);
          menuLink.setAttribute('aria-expanded', false);
        });
        header.setAttribute('data-transparent-header', true);
      };
    
      var _handleScroll = function _handleScroll() {
        var scroll = navDepthOne.scrollLeft;
        var root = document.documentElement;
        root.style.setProperty('--navigation-scroll-offset', "".concat(scroll, "px"));
      };
    
      var _checkMenuWidth = function _checkMenuWidth() {
        if (navDepthOne.scrollWidth > navDepthOne.clientWidth) {
          if (header.classList.contains('header--always-mobile')) {
            return;
          }
    
          header.classList.add('header--always-mobile');
          header.classList.remove('header--default');
        }
      };
    
      if (detectMenuLength) {
        resizeWatcher = srraf_es(function (_ref) {
          var vw = _ref.vw;
    
          // 960 is large breakpoint 60em;
          if (vw > 960) {
            _checkMenuWidth();
          }
        });
    
        _checkMenuWidth();
      }
    
      _bindEvents();
    
      var unload = function unload() {
        events.forEach(function (event) {
          event.element.removeEventListener(event.action, event["function"]);
        });
    
        if (resizeWatcher) {
          resizeWatcher.destroy();
        }
      };
    
      return {
        unload: unload,
        closeAll: closeAll
      };
    };
    
    /* harmony default export */ var components_navigation = (navigation_navigation);
    // CONCATENATED MODULE: ./node_modules/@shopify/theme-predictive-search/src/validate.js
    function validateQuery(query) {
      var error;
    
      if (query === null || query === undefined) {
        error = new TypeError("'query' is missing");
        error.type = "argument";
        throw error;
      }
    
      if (typeof query !== "string") {
        error = new TypeError("'query' is not a string");
        error.type = "argument";
        throw error;
      }
    }
    
    // CONCATENATED MODULE: ./node_modules/@shopify/theme-predictive-search/src/utilities/CustomError.js
    function GenericError() {
      var error = Error.call(this);
    
      error.name = "Server error";
      error.message = "Something went wrong on the server";
      error.status = 500;
    
      return error;
    }
    
    function NotFoundError(status) {
      var error = Error.call(this);
    
      error.name = "Not found";
      error.message = "Not found";
      error.status = status;
    
      return error;
    }
    
    function ServerError() {
      var error = Error.call(this);
    
      error.name = "Server error";
      error.message = "Something went wrong on the server";
      error.status = 500;
    
      return error;
    }
    
    function ContentTypeError(status) {
      var error = Error.call(this);
    
      error.name = "Content-Type error";
      error.message = "Content-Type was not provided or is of wrong type";
      error.status = status;
    
      return error;
    }
    
    function JsonParseError(status) {
      var error = Error.call(this);
    
      error.name = "JSON parse error";
      error.message = "JSON syntax error";
      error.status = status;
    
      return error;
    }
    
    function ThrottledError(status, name, message, retryAfter) {
      var error = Error.call(this);
    
      error.name = name;
      error.message = message;
      error.status = status;
      error.retryAfter = retryAfter;
    
      return error;
    }
    
    function InvalidParameterError(status, name, message) {
      var error = Error.call(this);
    
      error.name = name;
      error.message = message;
      error.status = status;
    
      return error;
    }
    
    function ExpectationFailedError(status, name, message) {
      var error = Error.call(this);
    
      error.name = name;
      error.message = message;
      error.status = status;
    
      return error;
    }
    
    // CONCATENATED MODULE: ./node_modules/@shopify/theme-predictive-search/src/request.js
    
    
    function request(configParams, query, onSuccess, onError) {
      var xhr = new XMLHttpRequest();
    
      xhr.onreadystatechange = function () {
        if (xhr.readyState === XMLHttpRequest.DONE) {
          var contentType = xhr.getResponseHeader("Content-Type");
    
          if (xhr.status >= 500) {
            onError(new ServerError());
    
            return;
          }
    
          if (xhr.status === 404) {
            onError(new NotFoundError(xhr.status));
    
            return;
          }
    
          if (
            typeof contentType !== "string" ||
            contentType.toLowerCase().match("application/json") === null
          ) {
            onError(new ContentTypeError(xhr.status));
    
            return;
          }
    
          if (xhr.status === 417) {
            try {
              var invalidParameterJson = JSON.parse(xhr.responseText);
    
              onError(
                new InvalidParameterError(
                  xhr.status,
                  invalidParameterJson.message,
                  invalidParameterJson.description
                )
              );
            } catch (error) {
              onError(new JsonParseError(xhr.status));
            }
    
            return;
          }
    
          if (xhr.status === 422) {
            try {
              var expectationFailedJson = JSON.parse(xhr.responseText);
    
              onError(
                new ExpectationFailedError(
                  xhr.status,
                  expectationFailedJson.message,
                  expectationFailedJson.description
                )
              );
            } catch (error) {
              onError(new JsonParseError(xhr.status));
            }
    
            return;
          }
    
          if (xhr.status === 429) {
            try {
              var throttledJson = JSON.parse(xhr.responseText);
    
              onError(
                new ThrottledError(
                  xhr.status,
                  throttledJson.message,
                  throttledJson.description,
                  xhr.getResponseHeader("Retry-After")
                )
              );
            } catch (error) {
              onError(new JsonParseError(xhr.status));
            }
    
            return;
          }
    
          if (xhr.status === 200) {
            try {
              var res = JSON.parse(xhr.responseText);
              res.query = query;
              onSuccess(res);
            } catch (error) {
              onError(new JsonParseError(xhr.status));
            }
    
            return;
          }
    
          try {
            var genericErrorJson = JSON.parse(xhr.responseText);
            onError(
              new GenericError(
                xhr.status,
                genericErrorJson.message,
                genericErrorJson.description
              )
            );
          } catch (error) {
            onError(new JsonParseError(xhr.status));
          }
    
          return;
        }
      };
    
      xhr.open(
        "get",
        "/search/suggest.json?q=" + encodeURIComponent(query) + "&" + configParams
      );
    
      xhr.setRequestHeader("Content-Type", "application/json");
    
      xhr.send();
    }
    // CONCATENATED MODULE: ./node_modules/@shopify/theme-predictive-search/src/utilities/debounce.js
    function debounce(func, wait) {
      var timeout = null;
      return function() {
        var context = this;
        var args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(function() {
          timeout = null;
          func.apply(context, args);
        }, wait || 0);
      };
    }
    
    // CONCATENATED MODULE: ./node_modules/@shopify/theme-predictive-search/src/utilities/Dispatcher.js
    function Dispatcher() {
      this.events = {};
    }
    
    Dispatcher.prototype.on = function(eventName, callback) {
      var event = this.events[eventName];
      if (!event) {
        event = new DispatcherEvent(eventName);
        this.events[eventName] = event;
      }
      event.registerCallback(callback);
    };
    
    Dispatcher.prototype.off = function(eventName, callback) {
      var event = this.events[eventName];
      if (event && event.callbacks.indexOf(callback) > -1) {
        event.unregisterCallback(callback);
        if (event.callbacks.length === 0) {
          delete this.events[eventName];
        }
      }
    };
    
    Dispatcher.prototype.dispatch = function(eventName, payload) {
      var event = this.events[eventName];
      if (event) {
        event.fire(payload);
      }
    };
    
    function DispatcherEvent(eventName) {
      this.eventName = eventName;
      this.callbacks = [];
    }
    
    DispatcherEvent.prototype.registerCallback = function(callback) {
      this.callbacks.push(callback);
    };
    
    DispatcherEvent.prototype.unregisterCallback = function(callback) {
      var index = this.callbacks.indexOf(callback);
      if (index > -1) {
        this.callbacks.splice(index, 1);
      }
    };
    
    DispatcherEvent.prototype.fire = function(payload) {
      var callbacks = this.callbacks.slice(0);
      callbacks.forEach(function(callback) {
        callback(payload);
      });
    };
    
    // CONCATENATED MODULE: ./node_modules/@shopify/theme-predictive-search/src/utilities/Cache.js
    function Cache(config) {
      this._store = {};
      this._keys = [];
      if (config && config.bucketSize) {
        this.bucketSize = config.bucketSize;
      } else {
        this.bucketSize = 20;
      }
    }
    
    Cache.prototype.set = function(key, value) {
      if (this.count() >= this.bucketSize) {
        var deleteKey = this._keys.splice(0, 1);
        this.delete(deleteKey);
      }
    
      this._keys.push(key);
      this._store[key] = value;
    
      return this._store;
    };
    
    Cache.prototype.get = function(key) {
      return this._store[key];
    };
    
    Cache.prototype.has = function(key) {
      return Boolean(this._store[key]);
    };
    
    Cache.prototype.count = function() {
      return Object.keys(this._store).length;
    };
    
    Cache.prototype.delete = function(key) {
      var exists = Boolean(this._store[key]);
      delete this._store[key];
      return exists && !this._store[key];
    };
    
    // CONCATENATED MODULE: ./node_modules/@shopify/theme-predictive-search/src/utilities/objectToQueryParams.js
    function objectToQueryParams(obj, parentKey) {
      var output = "";
      parentKey = parentKey || null;
    
      Object.keys(obj).forEach(function (key) {
        var outputKey = key + "=";
        if (parentKey) {
          outputKey = parentKey + "[" + key + "]";
        }
    
        switch (trueTypeOf(obj[key])) {
          case "object":
            output += objectToQueryParams(obj[key], parentKey ? outputKey : key);
            break;
          case "array":
            output += outputKey + "=" + obj[key].join(",") + "&";
            break;
          default:
            if (parentKey) {
              outputKey += "=";
            }
            output += outputKey + encodeURIComponent(obj[key]) + "&";
            break;
        }
      });
    
      return output;
    }
    
    function trueTypeOf(obj) {
      return Object.prototype.toString
        .call(obj)
        .slice(8, -1)
        .toLowerCase();
    }
    // CONCATENATED MODULE: ./node_modules/@shopify/theme-predictive-search/src/theme-predictive-search.js
    
    
    
    
    var DEBOUNCE_RATE = 10;
    var requestDebounced = debounce(request, DEBOUNCE_RATE);
    
    function PredictiveSearch(config) {
      if (!config) {
        throw new TypeError("No config object was specified");
      }
    
      this._retryAfter = null;
      this._currentQuery = null;
    
      this.dispatcher = new Dispatcher();
      this.cache = new Cache({ bucketSize: 40 });
      this.configParams = objectToQueryParams(config);
    }
    
    PredictiveSearch.TYPES = {
      PRODUCT: "product",
      PAGE: "page",
      ARTICLE: "article"
    };
    
    PredictiveSearch.FIELDS = {
      AUTHOR: "author",
      BODY: "body",
      PRODUCT_TYPE: "product_type",
      TAG: "tag",
      TITLE: "title",
      VARIANTS_BARCODE: "variants.barcode",
      VARIANTS_SKU: "variants.sku",
      VARIANTS_TITLE: "variants.title",
      VENDOR: "vendor"
    };
    
    PredictiveSearch.UNAVAILABLE_PRODUCTS = {
      SHOW: "show",
      HIDE: "hide",
      LAST: "last"
    };
    
    PredictiveSearch.prototype.query = function query(query) {
      try {
        validateQuery(query);
      } catch (error) {
        this.dispatcher.dispatch("error", error);
        return;
      }
    
      if (query === "") {
        return this;
      }
    
      this._currentQuery = normalizeQuery(query);
      var cacheResult = this.cache.get(this._currentQuery);
      if (cacheResult) {
        this.dispatcher.dispatch("success", cacheResult);
        return this;
      }
    
      requestDebounced(
        this.configParams,
        query,
        function(result) {
          this.cache.set(normalizeQuery(result.query), result);
          if (normalizeQuery(result.query) === this._currentQuery) {
            this._retryAfter = null;
            this.dispatcher.dispatch("success", result);
          }
        }.bind(this),
        function(error) {
          if (error.retryAfter) {
            this._retryAfter = error.retryAfter;
          }
          this.dispatcher.dispatch("error", error);
        }.bind(this)
      );
    
      return this;
    };
    
    PredictiveSearch.prototype.on = function on(eventName, callback) {
      this.dispatcher.on(eventName, callback);
    
      return this;
    };
    
    PredictiveSearch.prototype.off = function on(eventName, callback) {
      this.dispatcher.off(eventName, callback);
    
      return this;
    };
    
    function normalizeQuery(query) {
      if (typeof query !== "string") {
        return null;
      }
    
      return query
        .trim()
        .replace(" ", "-")
        .toLowerCase();
    }
    
    // EXTERNAL MODULE: ./node_modules/@shopify/theme-images/dist/images.cjs.js
    var images_cjs = __webpack_require__(19);
    
    // EXTERNAL MODULE: ./node_modules/string-strip-html/dist/string-strip-html.umd.js
    var string_strip_html_umd = __webpack_require__(11);
    var string_strip_html_umd_default = /*#__PURE__*/__webpack_require__.n(string_strip_html_umd);
    
    // CONCATENATED MODULE: ./src/scripts/lib/predictive-search.js
    
    
    
    
    
    var predictive_search_strings = window.theme.strings;
    var placeholderSVG = "\n  <svg xmlns=\"http://www.w3.org/2000/svg\">\n    <rect width=\"100%\" height=\"100%\" fill=\"transparent\"/>\n    <svg\n      fill=\"none\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      preserveAspectRatio=\"none\"\n    >\n      <text id=\"ok_text\"\n        x=\"50%\"\n        y=\"50%\"\n        text-anchor=\"middle\"\n        alignment-baseline=\"middle\"\n        fill=\"currentColor\"\n      >\n        Abc\n      </text>\n    </svg>\n  </svg>\n";
    var defaultOptions = {
      limit: 4,
      show_articles: true,
      show_pages: true,
      show_products: true,
      show_price: true,
      show_vendor: false
    };
    /* harmony default export */ var predictive_search = (function (_ref) {
      var opts = _ref.opts;
    
      var _Object$assign = Object.assign(defaultOptions, opts),
          limit = _Object$assign.limit,
          show_articles = _Object$assign.show_articles,
          show_pages = _Object$assign.show_pages,
          show_products = _Object$assign.show_products,
          show_price = _Object$assign.show_price,
          show_vendor = _Object$assign.show_vendor; // Create a new event bus
    
    
      var _create = evx_es_a({
        count: 0
      }),
          emit = _create.emit,
          getState = _create.getState,
          hydrate = _create.hydrate,
          on = _create.on;
    
      var types = [show_articles && PredictiveSearch.TYPES.ARTICLE, show_pages && PredictiveSearch.TYPES.PAGE, show_products && PredictiveSearch.TYPES.PRODUCT].filter(Boolean);
      var instance = new PredictiveSearch({
        resources: {
          type: types,
          limit: limit,
          options: {
            unavailable_products: 'last',
            fields: [PredictiveSearch.FIELDS.TITLE, PredictiveSearch.FIELDS.PRODUCT_TYPE, PredictiveSearch.FIELDS.VARIANTS_TITLE]
          }
        }
      });
      on('search', function (data, _ref2) {
        var query = _ref2.query;
        return instance.query(query);
      });
      instance.on('success', function (_ref3) {
        var query = _ref3.query,
            results = _ref3.resources.results;
        hydrate({
          query: query
        });
        var markup = renderResults(results, query);
        emit('success', {
          markup: markup,
          query: query
        });
      });
      instance.on('error', function (err) {});
    
      function renderResults(results, query) {

        var articles = results.articles !== undefined ? results.articles : {},
            pages = results.pages !== undefined ? results.pages : {},
            products = results.products !== undefined ? results.products : {};
    
        if (!articles.length && !pages.length && !products.length) {
          return "\n        <div class=\"quick-search__no-results\">\n          ".concat(predictive_search_strings.search.no_results, " &ldquo;").concat(query, "&rdquo;\n        </div>\n      ");
        }
    
        var resultsMarkup = '';
    
        if (products) {
          // Render product results
          resultsMarkup += renderGroup(products, predictive_search_strings.search.headings.products, function (_ref4) {
            var url = _ref4.url,
                image = _ref4.image,
                title = _ref4.title,
                price = _ref4.price,
                vendor = _ref4.vendor;
            var formattedPrice = currency_formatMoney(price * Shopify.currency.rate * 100.0);
            var subheading = [show_vendor && vendor, show_price && string_strip_html_umd_default()(formattedPrice)].filter(Boolean).join(' • ');
            return renderResult({
              url: url,
              image: image,
              heading: title,
              subheading: subheading
            });
          });
        }
    
        if (pages) {
          // Render page results
          resultsMarkup += renderGroup(pages, predictive_search_strings.search.headings.pages, function (_ref5) {
            var url = _ref5.url,
                image = _ref5.image,
                title = _ref5.title,
                body = _ref5.body;
            return renderResult({
              url: url,
              image: image,
              heading: title,
              subheading: string_strip_html_umd_default()(body)
            });
          });
        }
    
        if (articles) {
          // Render article results
          resultsMarkup += renderGroup(articles, predictive_search_strings.search.headings.articles, function (_ref6) {
            var url = _ref6.url,
                image = _ref6.image,
                title = _ref6.title,
                body = _ref6.body;
            return renderResult({
              url: url,
              image: image,
              heading: title,
              subheading: string_strip_html_umd_default()(body)
            });
          });
        }
    
        var viewAll = "\n      <div class=\"quick-search__view-all accent\">\n        <button type=\"submit\">".concat(predictive_search_strings.search.view_all, " &rarr;</button>\n      </div>\n    ");
        return resultsMarkup + viewAll;
      }
    
      function renderGroup(items, heading, cb) {
        var headingMarkup = "<div class=\"quick-search__header type-heading-meta overline\">".concat(heading, "</div>");
        return items.length >= 1 ? headingMarkup + items.map(cb).join('') : '';
      }
    
      function renderResult(_ref7) {
        var url = _ref7.url,
            image = _ref7.image,
            heading = _ref7.heading,
            subheading = _ref7.subheading;
    
        var _getState = getState(),
            query = _getState.query;
    
        var regex = new RegExp('(' + query + ')', 'gi');
        var hlHeading = heading.replace(regex, '<span class="hl">$1</span>');
        var hlSubheading = subheading.replace(regex, '<span class="hl">$1</span>');
        var img = image ? "<img class=\"image__img lazyload\" data-src=\"".concat(Object(images_cjs["getSizedImageUrl"])(image, '120x'), "\" loading=\"lazy\" />") : placeholderSVG;
        return "\n      <a class=\"quick-search__result\" href=\"".concat(url, "\">\n        <div class=\"quick-search__result-image\">").concat(img, "</div>\n        <div class=\"quick-search__result-details\">\n          <div class=\"quick-search__result-heading type-body-regular\">").concat(hlHeading, "</div>\n          <div class=\"quick-search__result-subheading type-body-small\">").concat(hlSubheading, "</div>\n        </div>\n      </a>\n    ");
      }
    
      function query(q) {
        emit('search', null, {
          query: q
        });
      }
    
      return {
        on: on,
        query: query
      };
    });
    // CONCATENATED MODULE: ./src/scripts/components/quickSearch.js
    
    var quickSearch_selectors = {
      trigger: '.quick-search__trigger',
      searchOverlay: '.search__overlay',
      searchInput: '.search__input',
      inputClear: '.search__input-clear',
      inputClose: '.search__input-close',
      results: '.search__results',
      settings: '[data-settings]'
    };
    var classNames = {
      active: 'is-active',
      activeQuery: 'has-active-query',
      activeSuggestions: 'has-suggestions'
    };
    
    var quickSearch_quickSearch = function quickSearch(opts) {
      var container = opts.container;
      var settings = container.querySelector(quickSearch_selectors.settings);
      var trigger = container.querySelector(quickSearch_selectors.trigger);
      var overlay = container.querySelector(quickSearch_selectors.searchOverlay);
      var searchInput = container.querySelector(quickSearch_selectors.searchInput);
      var searchInputClear = container.querySelector(quickSearch_selectors.inputClear);
      var searchInputClose = container.querySelector(quickSearch_selectors.inputClose);
      var resultsContainer = container.querySelector(quickSearch_selectors.results);
      var events = [];
      var options = JSON.parse(settings.innerHTML);
      var search = predictive_search({
        opts: options
      });
      search.on('success', function (_ref) {
        var markup = _ref.markup;
        container.classList.add(classNames.activeSuggestions);
        resultsContainer.innerHTML = markup;
      });
    
      var _bindEvents = function _bindEvents() {
        _addEvent(trigger, 'click', _showSearchBar);
    
        _addEvent(overlay, 'click', _hideSearchBar);
    
        _addEvent(document, 'keydown', _handleEsq);
    
        _addEvent(searchInput, 'input', _searchInputHandler);
    
        _addEvent(searchInputClose, 'click', _hideSearchBar);
    
        _addEvent(searchInputClear, 'click', _clearSearchInput);
      };
    
      var _addEvent = function _addEvent(element, action, func) {
        element.addEventListener(action, func, true);
        events.push({
          element: element,
          action: action,
          func: func
        });
      };
    
      var _showSearchBar = function _showSearchBar(e) {
        e.preventDefault();
        container.classList.add(classNames.active);
        searchInput.focus();
      };
    
      var _hideSearchBar = function _hideSearchBar(e) {
        e.preventDefault();
        container.classList.remove(classNames.active);
      };
    
      var _handleEsq = function _handleEsq(e) {
        if (container.classList.contains(classNames.active) && e.keyCode === 27) {
          _hideSearchBar(e);
        }
      };
    
      var _clearSearchInput = function _clearSearchInput(e) {
        e.preventDefault();
        searchInput.value = '';
    
        _searchInputHandler(e);
    
        searchInput.focus();
      };
    
      var _searchInputHandler = function _searchInputHandler(event) {
        var query = event.target.value;
    
        if (!query) {
          container.classList.remove(classNames.activeQuery);
          container.classList.remove(classNames.activeSuggestions);
          return;
        }
    
        container.classList.add(classNames.activeQuery);
    
        if (options.show_products || options.show_pages || options.show_articles) {
          search.query(query);
        }
      };
    
      var unload = function unload() {
        events.forEach(function (event) {
          event.element.removeEventListener(event.action, event["function"]);
        });
      };
    
      _bindEvents();
    
      return {
        unload: unload
      };
    };
    
    /* harmony default export */ var components_quickSearch = (quickSearch_quickSearch);
    // CONCATENATED MODULE: ./node_modules/animejs/lib/anime.es.js
    /*
     * anime.js v3.2.0
     * (c) 2020 Julian Garnier
     * Released under the MIT license
     * animejs.com
     */
    
    // Defaults
    
    var defaultInstanceSettings = {
      update: null,
      begin: null,
      loopBegin: null,
      changeBegin: null,
      change: null,
      changeComplete: null,
      loopComplete: null,
      complete: null,
      loop: 1,
      direction: 'normal',
      autoplay: true,
      timelineOffset: 0
    };
    
    var defaultTweenSettings = {
      duration: 1000,
      delay: 0,
      endDelay: 0,
      easing: 'easeOutElastic(1, .5)',
      round: 0
    };
    
    var validTransforms = ['translateX', 'translateY', 'translateZ', 'rotate', 'rotateX', 'rotateY', 'rotateZ', 'scale', 'scaleX', 'scaleY', 'scaleZ', 'skew', 'skewX', 'skewY', 'perspective', 'matrix', 'matrix3d'];
    
    // Caching
    
    var cache = {
      CSS: {},
      springs: {}
    };
    
    // Utils
    
    function minMax(val, min, max) {
      return Math.min(Math.max(val, min), max);
    }
    
    function stringContains(str, text) {
      return str.indexOf(text) > -1;
    }
    
    function applyArguments(func, args) {
      return func.apply(null, args);
    }
    
    var is = {
      arr: function (a) { return Array.isArray(a); },
      obj: function (a) { return stringContains(Object.prototype.toString.call(a), 'Object'); },
      pth: function (a) { return is.obj(a) && a.hasOwnProperty('totalLength'); },
      svg: function (a) { return a instanceof SVGElement; },
      inp: function (a) { return a instanceof HTMLInputElement; },
      dom: function (a) { return a.nodeType || is.svg(a); },
      str: function (a) { return typeof a === 'string'; },
      fnc: function (a) { return typeof a === 'function'; },
      und: function (a) { return typeof a === 'undefined'; },
      hex: function (a) { return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(a); },
      rgb: function (a) { return /^rgb/.test(a); },
      hsl: function (a) { return /^hsl/.test(a); },
      col: function (a) { return (is.hex(a) || is.rgb(a) || is.hsl(a)); },
      key: function (a) { return !defaultInstanceSettings.hasOwnProperty(a) && !defaultTweenSettings.hasOwnProperty(a) && a !== 'targets' && a !== 'keyframes'; }
    };
    
    // Easings
    
    function parseEasingParameters(string) {
      var match = /\(([^)]+)\)/.exec(string);
      return match ? match[1].split(',').map(function (p) { return parseFloat(p); }) : [];
    }
    
    // Spring solver inspired by Webkit Copyright © 2016 Apple Inc. All rights reserved. https://webkit.org/demos/spring/spring.js
    
    function spring(string, duration) {
    
      var params = parseEasingParameters(string);
      var mass = minMax(is.und(params[0]) ? 1 : params[0], .1, 100);
      var stiffness = minMax(is.und(params[1]) ? 100 : params[1], .1, 100);
      var damping = minMax(is.und(params[2]) ? 10 : params[2], .1, 100);
      var velocity =  minMax(is.und(params[3]) ? 0 : params[3], .1, 100);
      var w0 = Math.sqrt(stiffness / mass);
      var zeta = damping / (2 * Math.sqrt(stiffness * mass));
      var wd = zeta < 1 ? w0 * Math.sqrt(1 - zeta * zeta) : 0;
      var a = 1;
      var b = zeta < 1 ? (zeta * w0 + -velocity) / wd : -velocity + w0;
    
      function solver(t) {
        var progress = duration ? (duration * t) / 1000 : t;
        if (zeta < 1) {
          progress = Math.exp(-progress * zeta * w0) * (a * Math.cos(wd * progress) + b * Math.sin(wd * progress));
        } else {
          progress = (a + b * progress) * Math.exp(-progress * w0);
        }
        if (t === 0 || t === 1) { return t; }
        return 1 - progress;
      }
    
      function getDuration() {
        var cached = cache.springs[string];
        if (cached) { return cached; }
        var frame = 1/6;
        var elapsed = 0;
        var rest = 0;
        while(true) {
          elapsed += frame;
          if (solver(elapsed) === 1) {
            rest++;
            if (rest >= 16) { break; }
          } else {
            rest = 0;
          }
        }
        var duration = elapsed * frame * 1000;
        cache.springs[string] = duration;
        return duration;
      }
    
      return duration ? solver : getDuration;
    
    }
    
    // Basic steps easing implementation https://developer.mozilla.org/fr/docs/Web/CSS/transition-timing-function
    
    function steps(steps) {
      if ( steps === void 0 ) steps = 10;
    
      return function (t) { return Math.ceil((minMax(t, 0.000001, 1)) * steps) * (1 / steps); };
    }
    
    // BezierEasing https://github.com/gre/bezier-easing
    
    var bezier = (function () {
    
      var kSplineTableSize = 11;
      var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
    
      function A(aA1, aA2) { return 1.0 - 3.0 * aA2 + 3.0 * aA1 }
      function B(aA1, aA2) { return 3.0 * aA2 - 6.0 * aA1 }
      function C(aA1)      { return 3.0 * aA1 }
    
      function calcBezier(aT, aA1, aA2) { return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT }
      function getSlope(aT, aA1, aA2) { return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1) }
    
      function binarySubdivide(aX, aA, aB, mX1, mX2) {
        var currentX, currentT, i = 0;
        do {
          currentT = aA + (aB - aA) / 2.0;
          currentX = calcBezier(currentT, mX1, mX2) - aX;
          if (currentX > 0.0) { aB = currentT; } else { aA = currentT; }
        } while (Math.abs(currentX) > 0.0000001 && ++i < 10);
        return currentT;
      }
    
      function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
        for (var i = 0; i < 4; ++i) {
          var currentSlope = getSlope(aGuessT, mX1, mX2);
          if (currentSlope === 0.0) { return aGuessT; }
          var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
          aGuessT -= currentX / currentSlope;
        }
        return aGuessT;
      }
    
      function bezier(mX1, mY1, mX2, mY2) {
    
        if (!(0 <= mX1 && mX1 <= 1 && 0 <= mX2 && mX2 <= 1)) { return; }
        var sampleValues = new Float32Array(kSplineTableSize);
    
        if (mX1 !== mY1 || mX2 !== mY2) {
          for (var i = 0; i < kSplineTableSize; ++i) {
            sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
          }
        }
    
        function getTForX(aX) {
    
          var intervalStart = 0;
          var currentSample = 1;
          var lastSample = kSplineTableSize - 1;
    
          for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
            intervalStart += kSampleStepSize;
          }
    
          --currentSample;
    
          var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
          var guessForT = intervalStart + dist * kSampleStepSize;
          var initialSlope = getSlope(guessForT, mX1, mX2);
    
          if (initialSlope >= 0.001) {
            return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
          } else if (initialSlope === 0.0) {
            return guessForT;
          } else {
            return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
          }
    
        }
    
        return function (x) {
          if (mX1 === mY1 && mX2 === mY2) { return x; }
          if (x === 0 || x === 1) { return x; }
          return calcBezier(getTForX(x), mY1, mY2);
        }
    
      }
    
      return bezier;
    
    })();
    
    var penner = (function () {
    
      // Based on jQuery UI's implemenation of easing equations from Robert Penner (http://www.robertpenner.com/easing)
    
      var eases = { linear: function () { return function (t) { return t; }; } };
    
      var functionEasings = {
        Sine: function () { return function (t) { return 1 - Math.cos(t * Math.PI / 2); }; },
        Circ: function () { return function (t) { return 1 - Math.sqrt(1 - t * t); }; },
        Back: function () { return function (t) { return t * t * (3 * t - 2); }; },
        Bounce: function () { return function (t) {
          var pow2, b = 4;
          while (t < (( pow2 = Math.pow(2, --b)) - 1) / 11) {}
          return 1 / Math.pow(4, 3 - b) - 7.5625 * Math.pow(( pow2 * 3 - 2 ) / 22 - t, 2)
        }; },
        Elastic: function (amplitude, period) {
          if ( amplitude === void 0 ) amplitude = 1;
          if ( period === void 0 ) period = .5;
    
          var a = minMax(amplitude, 1, 10);
          var p = minMax(period, .1, 2);
          return function (t) {
            return (t === 0 || t === 1) ? t : 
              -a * Math.pow(2, 10 * (t - 1)) * Math.sin((((t - 1) - (p / (Math.PI * 2) * Math.asin(1 / a))) * (Math.PI * 2)) / p);
          }
        }
      };
    
      var baseEasings = ['Quad', 'Cubic', 'Quart', 'Quint', 'Expo'];
    
      baseEasings.forEach(function (name, i) {
        functionEasings[name] = function () { return function (t) { return Math.pow(t, i + 2); }; };
      });
    
      Object.keys(functionEasings).forEach(function (name) {
        var easeIn = functionEasings[name];
        eases['easeIn' + name] = easeIn;
        eases['easeOut' + name] = function (a, b) { return function (t) { return 1 - easeIn(a, b)(1 - t); }; };
        eases['easeInOut' + name] = function (a, b) { return function (t) { return t < 0.5 ? easeIn(a, b)(t * 2) / 2 : 
          1 - easeIn(a, b)(t * -2 + 2) / 2; }; };
      });
    
      return eases;
    
    })();
    
    function parseEasings(easing, duration) {
      if (is.fnc(easing)) { return easing; }
      var name = easing.split('(')[0];
      var ease = penner[name];
      var args = parseEasingParameters(easing);
      switch (name) {
        case 'spring' : return spring(easing, duration);
        case 'cubicBezier' : return applyArguments(bezier, args);
        case 'steps' : return applyArguments(steps, args);
        default : return applyArguments(ease, args);
      }
    }
    
    // Strings
    
    function selectString(str) {
      try {
        var nodes = document.querySelectorAll(str);
        return nodes;
      } catch(e) {
        return;
      }
    }
    
    // Arrays
    
    function filterArray(arr, callback) {
      var len = arr.length;
      var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
      var result = [];
      for (var i = 0; i < len; i++) {
        if (i in arr) {
          var val = arr[i];
          if (callback.call(thisArg, val, i, arr)) {
            result.push(val);
          }
        }
      }
      return result;
    }
    
    function flattenArray(arr) {
      return arr.reduce(function (a, b) { return a.concat(is.arr(b) ? flattenArray(b) : b); }, []);
    }
    
    function toArray(o) {
      if (is.arr(o)) { return o; }
      if (is.str(o)) { o = selectString(o) || o; }
      if (o instanceof NodeList || o instanceof HTMLCollection) { return [].slice.call(o); }
      return [o];
    }
    
    function arrayContains(arr, val) {
      return arr.some(function (a) { return a === val; });
    }
    
    // Objects
    
    function cloneObject(o) {
      var clone = {};
      for (var p in o) { clone[p] = o[p]; }
      return clone;
    }
    
    function replaceObjectProps(o1, o2) {
      var o = cloneObject(o1);
      for (var p in o1) { o[p] = o2.hasOwnProperty(p) ? o2[p] : o1[p]; }
      return o;
    }
    
    function mergeObjects(o1, o2) {
      var o = cloneObject(o1);
      for (var p in o2) { o[p] = is.und(o1[p]) ? o2[p] : o1[p]; }
      return o;
    }
    
    // Colors
    
    function rgbToRgba(rgbValue) {
      var rgb = /rgb\((\d+,\s*[\d]+,\s*[\d]+)\)/g.exec(rgbValue);
      return rgb ? ("rgba(" + (rgb[1]) + ",1)") : rgbValue;
    }
    
    function hexToRgba(hexValue) {
      var rgx = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
      var hex = hexValue.replace(rgx, function (m, r, g, b) { return r + r + g + g + b + b; } );
      var rgb = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      var r = parseInt(rgb[1], 16);
      var g = parseInt(rgb[2], 16);
      var b = parseInt(rgb[3], 16);
      return ("rgba(" + r + "," + g + "," + b + ",1)");
    }
    
    function hslToRgba(hslValue) {
      var hsl = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(hslValue) || /hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*([\d.]+)\)/g.exec(hslValue);
      var h = parseInt(hsl[1], 10) / 360;
      var s = parseInt(hsl[2], 10) / 100;
      var l = parseInt(hsl[3], 10) / 100;
      var a = hsl[4] || 1;
      function hue2rgb(p, q, t) {
        if (t < 0) { t += 1; }
        if (t > 1) { t -= 1; }
        if (t < 1/6) { return p + (q - p) * 6 * t; }
        if (t < 1/2) { return q; }
        if (t < 2/3) { return p + (q - p) * (2/3 - t) * 6; }
        return p;
      }
      var r, g, b;
      if (s == 0) {
        r = g = b = l;
      } else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1/3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1/3);
      }
      return ("rgba(" + (r * 255) + "," + (g * 255) + "," + (b * 255) + "," + a + ")");
    }
    
    function colorToRgb(val) {
      if (is.rgb(val)) { return rgbToRgba(val); }
      if (is.hex(val)) { return hexToRgba(val); }
      if (is.hsl(val)) { return hslToRgba(val); }
    }
    
    // Units
    
    function getUnit(val) {
      var split = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?(%|px|pt|em|rem|in|cm|mm|ex|ch|pc|vw|vh|vmin|vmax|deg|rad|turn)?$/.exec(val);
      if (split) { return split[1]; }
    }
    
    function getTransformUnit(propName) {
      if (stringContains(propName, 'translate') || propName === 'perspective') { return 'px'; }
      if (stringContains(propName, 'rotate') || stringContains(propName, 'skew')) { return 'deg'; }
    }
    
    // Values
    
    function getFunctionValue(val, animatable) {
      if (!is.fnc(val)) { return val; }
      return val(animatable.target, animatable.id, animatable.total);
    }
    
    function getAttribute(el, prop) {
      return el.getAttribute(prop);
    }
    
    function convertPxToUnit(el, value, unit) {
      var valueUnit = getUnit(value);
      if (arrayContains([unit, 'deg', 'rad', 'turn'], valueUnit)) { return value; }
      var cached = cache.CSS[value + unit];
      if (!is.und(cached)) { return cached; }
      var baseline = 100;
      var tempEl = document.createElement(el.tagName);
      var parentEl = (el.parentNode && (el.parentNode !== document)) ? el.parentNode : document.body;
      parentEl.appendChild(tempEl);
      tempEl.style.position = 'absolute';
      tempEl.style.width = baseline + unit;
      var factor = baseline / tempEl.offsetWidth;
      parentEl.removeChild(tempEl);
      var convertedUnit = factor * parseFloat(value);
      cache.CSS[value + unit] = convertedUnit;
      return convertedUnit;
    }
    
    function getCSSValue(el, prop, unit) {
      if (prop in el.style) {
        var uppercasePropName = prop.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
        var value = el.style[prop] || getComputedStyle(el).getPropertyValue(uppercasePropName) || '0';
        return unit ? convertPxToUnit(el, value, unit) : value;
      }
    }
    
    function getAnimationType(el, prop) {
      if (is.dom(el) && !is.inp(el) && (getAttribute(el, prop) || (is.svg(el) && el[prop]))) { return 'attribute'; }
      if (is.dom(el) && arrayContains(validTransforms, prop)) { return 'transform'; }
      if (is.dom(el) && (prop !== 'transform' && getCSSValue(el, prop))) { return 'css'; }
      if (el[prop] != null) { return 'object'; }
    }
    
    function getElementTransforms(el) {
      if (!is.dom(el)) { return; }
      var str = el.style.transform || '';
      var reg  = /(\w+)\(([^)]*)\)/g;
      var transforms = new Map();
      var m; while (m = reg.exec(str)) { transforms.set(m[1], m[2]); }
      return transforms;
    }
    
    function getTransformValue(el, propName, animatable, unit) {
      var defaultVal = stringContains(propName, 'scale') ? 1 : 0 + getTransformUnit(propName);
      var value = getElementTransforms(el).get(propName) || defaultVal;
      if (animatable) {
        animatable.transforms.list.set(propName, value);
        animatable.transforms['last'] = propName;
      }
      return unit ? convertPxToUnit(el, value, unit) : value;
    }
    
    function getOriginalTargetValue(target, propName, unit, animatable) {
      switch (getAnimationType(target, propName)) {
        case 'transform': return getTransformValue(target, propName, animatable, unit);
        case 'css': return getCSSValue(target, propName, unit);
        case 'attribute': return getAttribute(target, propName);
        default: return target[propName] || 0;
      }
    }
    
    function getRelativeValue(to, from) {
      var operator = /^(\*=|\+=|-=)/.exec(to);
      if (!operator) { return to; }
      var u = getUnit(to) || 0;
      var x = parseFloat(from);
      var y = parseFloat(to.replace(operator[0], ''));
      switch (operator[0][0]) {
        case '+': return x + y + u;
        case '-': return x - y + u;
        case '*': return x * y + u;
      }
    }
    
    function validateValue(val, unit) {
      if (is.col(val)) { return colorToRgb(val); }
      if (/\s/g.test(val)) { return val; }
      var originalUnit = getUnit(val);
      var unitLess = originalUnit ? val.substr(0, val.length - originalUnit.length) : val;
      if (unit) { return unitLess + unit; }
      return unitLess;
    }
    
    // getTotalLength() equivalent for circle, rect, polyline, polygon and line shapes
    // adapted from https://gist.github.com/SebLambla/3e0550c496c236709744
    
    function getDistance(p1, p2) {
      return Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2));
    }
    
    function getCircleLength(el) {
      return Math.PI * 2 * getAttribute(el, 'r');
    }
    
    function getRectLength(el) {
      return (getAttribute(el, 'width') * 2) + (getAttribute(el, 'height') * 2);
    }
    
    function getLineLength(el) {
      return getDistance(
        {x: getAttribute(el, 'x1'), y: getAttribute(el, 'y1')}, 
        {x: getAttribute(el, 'x2'), y: getAttribute(el, 'y2')}
      );
    }
    
    function getPolylineLength(el) {
      var points = el.points;
      var totalLength = 0;
      var previousPos;
      for (var i = 0 ; i < points.numberOfItems; i++) {
        var currentPos = points.getItem(i);
        if (i > 0) { totalLength += getDistance(previousPos, currentPos); }
        previousPos = currentPos;
      }
      return totalLength;
    }
    
    function getPolygonLength(el) {
      var points = el.points;
      return getPolylineLength(el) + getDistance(points.getItem(points.numberOfItems - 1), points.getItem(0));
    }
    
    // Path animation
    
    function getTotalLength(el) {
      if (el.getTotalLength) { return el.getTotalLength(); }
      switch(el.tagName.toLowerCase()) {
        case 'circle': return getCircleLength(el);
        case 'rect': return getRectLength(el);
        case 'line': return getLineLength(el);
        case 'polyline': return getPolylineLength(el);
        case 'polygon': return getPolygonLength(el);
      }
    }
    
    function setDashoffset(el) {
      var pathLength = getTotalLength(el);
      el.setAttribute('stroke-dasharray', pathLength);
      return pathLength;
    }
    
    // Motion path
    
    function getParentSvgEl(el) {
      var parentEl = el.parentNode;
      while (is.svg(parentEl)) {
        if (!is.svg(parentEl.parentNode)) { break; }
        parentEl = parentEl.parentNode;
      }
      return parentEl;
    }
    
    function getParentSvg(pathEl, svgData) {
      var svg = svgData || {};
      var parentSvgEl = svg.el || getParentSvgEl(pathEl);
      var rect = parentSvgEl.getBoundingClientRect();
      var viewBoxAttr = getAttribute(parentSvgEl, 'viewBox');
      var width = rect.width;
      var height = rect.height;
      var viewBox = svg.viewBox || (viewBoxAttr ? viewBoxAttr.split(' ') : [0, 0, width, height]);
      return {
        el: parentSvgEl,
        viewBox: viewBox,
        x: viewBox[0] / 1,
        y: viewBox[1] / 1,
        w: width / viewBox[2],
        h: height / viewBox[3]
      }
    }
    
    function getPath(path, percent) {
      var pathEl = is.str(path) ? selectString(path)[0] : path;
      var p = percent || 100;
      return function(property) {
        return {
          property: property,
          el: pathEl,
          svg: getParentSvg(pathEl),
          totalLength: getTotalLength(pathEl) * (p / 100)
        }
      }
    }
    
    function getPathProgress(path, progress) {
      function point(offset) {
        if ( offset === void 0 ) offset = 0;
    
        var l = progress + offset >= 1 ? progress + offset : 0;
        return path.el.getPointAtLength(l);
      }
      var svg = getParentSvg(path.el, path.svg);
      var p = point();
      var p0 = point(-1);
      var p1 = point(+1);
      switch (path.property) {
        case 'x': return (p.x - svg.x) * svg.w;
        case 'y': return (p.y - svg.y) * svg.h;
        case 'angle': return Math.atan2(p1.y - p0.y, p1.x - p0.x) * 180 / Math.PI;
      }
    }
    
    // Decompose value
    
    function decomposeValue(val, unit) {
      // const rgx = /-?\d*\.?\d+/g; // handles basic numbers
      // const rgx = /[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?/g; // handles exponents notation
      var rgx = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?/g; // handles exponents notation
      var value = validateValue((is.pth(val) ? val.totalLength : val), unit) + '';
      return {
        original: value,
        numbers: value.match(rgx) ? value.match(rgx).map(Number) : [0],
        strings: (is.str(val) || unit) ? value.split(rgx) : []
      }
    }
    
    // Animatables
    
    function parseTargets(targets) {
      var targetsArray = targets ? (flattenArray(is.arr(targets) ? targets.map(toArray) : toArray(targets))) : [];
      return filterArray(targetsArray, function (item, pos, self) { return self.indexOf(item) === pos; });
    }
    
    function getAnimatables(targets) {
      var parsed = parseTargets(targets);
      return parsed.map(function (t, i) {
        return {target: t, id: i, total: parsed.length, transforms: { list: getElementTransforms(t) } };
      });
    }
    
    // Properties
    
    function normalizePropertyTweens(prop, tweenSettings) {
      var settings = cloneObject(tweenSettings);
      // Override duration if easing is a spring
      if (/^spring/.test(settings.easing)) { settings.duration = spring(settings.easing); }
      if (is.arr(prop)) {
        var l = prop.length;
        var isFromTo = (l === 2 && !is.obj(prop[0]));
        if (!isFromTo) {
          // Duration divided by the number of tweens
          if (!is.fnc(tweenSettings.duration)) { settings.duration = tweenSettings.duration / l; }
        } else {
          // Transform [from, to] values shorthand to a valid tween value
          prop = {value: prop};
        }
      }
      var propArray = is.arr(prop) ? prop : [prop];
      return propArray.map(function (v, i) {
        var obj = (is.obj(v) && !is.pth(v)) ? v : {value: v};
        // Default delay value should only be applied to the first tween
        if (is.und(obj.delay)) { obj.delay = !i ? tweenSettings.delay : 0; }
        // Default endDelay value should only be applied to the last tween
        if (is.und(obj.endDelay)) { obj.endDelay = i === propArray.length - 1 ? tweenSettings.endDelay : 0; }
        return obj;
      }).map(function (k) { return mergeObjects(k, settings); });
    }
    
    
    function flattenKeyframes(keyframes) {
      var propertyNames = filterArray(flattenArray(keyframes.map(function (key) { return Object.keys(key); })), function (p) { return is.key(p); })
      .reduce(function (a,b) { if (a.indexOf(b) < 0) { a.push(b); } return a; }, []);
      var properties = {};
      var loop = function ( i ) {
        var propName = propertyNames[i];
        properties[propName] = keyframes.map(function (key) {
          var newKey = {};
          for (var p in key) {
            if (is.key(p)) {
              if (p == propName) { newKey.value = key[p]; }
            } else {
              newKey[p] = key[p];
            }
          }
          return newKey;
        });
      };
    
      for (var i = 0; i < propertyNames.length; i++) loop( i );
      return properties;
    }
    
    function anime_es_getProperties(tweenSettings, params) {
      var properties = [];
      var keyframes = params.keyframes;
      if (keyframes) { params = mergeObjects(flattenKeyframes(keyframes), params); }
      for (var p in params) {
        if (is.key(p)) {
          properties.push({
            name: p,
            tweens: normalizePropertyTweens(params[p], tweenSettings)
          });
        }
      }
      return properties;
    }
    
    // Tweens
    
    function normalizeTweenValues(tween, animatable) {
      var t = {};
      for (var p in tween) {
        var value = getFunctionValue(tween[p], animatable);
        if (is.arr(value)) {
          value = value.map(function (v) { return getFunctionValue(v, animatable); });
          if (value.length === 1) { value = value[0]; }
        }
        t[p] = value;
      }
      t.duration = parseFloat(t.duration);
      t.delay = parseFloat(t.delay);
      return t;
    }
    
    function normalizeTweens(prop, animatable) {
      var previousTween;
      return prop.tweens.map(function (t) {
        var tween = normalizeTweenValues(t, animatable);
        var tweenValue = tween.value;
        var to = is.arr(tweenValue) ? tweenValue[1] : tweenValue;
        var toUnit = getUnit(to);
        var originalValue = getOriginalTargetValue(animatable.target, prop.name, toUnit, animatable);
        var previousValue = previousTween ? previousTween.to.original : originalValue;
        var from = is.arr(tweenValue) ? tweenValue[0] : previousValue;
        var fromUnit = getUnit(from) || getUnit(originalValue);
        var unit = toUnit || fromUnit;
        if (is.und(to)) { to = previousValue; }
        tween.from = decomposeValue(from, unit);
        tween.to = decomposeValue(getRelativeValue(to, from), unit);
        tween.start = previousTween ? previousTween.end : 0;
        tween.end = tween.start + tween.delay + tween.duration + tween.endDelay;
        tween.easing = parseEasings(tween.easing, tween.duration);
        tween.isPath = is.pth(tweenValue);
        tween.isColor = is.col(tween.from.original);
        if (tween.isColor) { tween.round = 1; }
        previousTween = tween;
        return tween;
      });
    }
    
    // Tween progress
    
    var setProgressValue = {
      css: function (t, p, v) { return t.style[p] = v; },
      attribute: function (t, p, v) { return t.setAttribute(p, v); },
      object: function (t, p, v) { return t[p] = v; },
      transform: function (t, p, v, transforms, manual) {
        transforms.list.set(p, v);
        if (p === transforms.last || manual) {
          var str = '';
          transforms.list.forEach(function (value, prop) { str += prop + "(" + value + ") "; });
          t.style.transform = str;
        }
      }
    };
    
    // Set Value helper
    
    function setTargetsValue(targets, properties) {
      var animatables = getAnimatables(targets);
      animatables.forEach(function (animatable) {
        for (var property in properties) {
          var value = getFunctionValue(properties[property], animatable);
          var target = animatable.target;
          var valueUnit = getUnit(value);
          var originalValue = getOriginalTargetValue(target, property, valueUnit, animatable);
          var unit = valueUnit || getUnit(originalValue);
          var to = getRelativeValue(validateValue(value, unit), originalValue);
          var animType = getAnimationType(target, property);
          setProgressValue[animType](target, property, to, animatable.transforms, true);
        }
      });
    }
    
    // Animations
    
    function createAnimation(animatable, prop) {
      var animType = getAnimationType(animatable.target, prop.name);
      if (animType) {
        var tweens = normalizeTweens(prop, animatable);
        var lastTween = tweens[tweens.length - 1];
        return {
          type: animType,
          property: prop.name,
          animatable: animatable,
          tweens: tweens,
          duration: lastTween.end,
          delay: tweens[0].delay,
          endDelay: lastTween.endDelay
        }
      }
    }
    
    function getAnimations(animatables, properties) {
      return filterArray(flattenArray(animatables.map(function (animatable) {
        return properties.map(function (prop) {
          return createAnimation(animatable, prop);
        });
      })), function (a) { return !is.und(a); });
    }
    
    // Create Instance
    
    function getInstanceTimings(animations, tweenSettings) {
      var animLength = animations.length;
      var getTlOffset = function (anim) { return anim.timelineOffset ? anim.timelineOffset : 0; };
      var timings = {};
      timings.duration = animLength ? Math.max.apply(Math, animations.map(function (anim) { return getTlOffset(anim) + anim.duration; })) : tweenSettings.duration;
      timings.delay = animLength ? Math.min.apply(Math, animations.map(function (anim) { return getTlOffset(anim) + anim.delay; })) : tweenSettings.delay;
      timings.endDelay = animLength ? timings.duration - Math.max.apply(Math, animations.map(function (anim) { return getTlOffset(anim) + anim.duration - anim.endDelay; })) : tweenSettings.endDelay;
      return timings;
    }
    
    var instanceID = 0;
    
    function createNewInstance(params) {
      var instanceSettings = replaceObjectProps(defaultInstanceSettings, params);
      var tweenSettings = replaceObjectProps(defaultTweenSettings, params);
      var properties = anime_es_getProperties(tweenSettings, params);
      var animatables = getAnimatables(params.targets);
      var animations = getAnimations(animatables, properties);
      var timings = getInstanceTimings(animations, tweenSettings);
      var id = instanceID;
      instanceID++;
      return mergeObjects(instanceSettings, {
        id: id,
        children: [],
        animatables: animatables,
        animations: animations,
        duration: timings.duration,
        delay: timings.delay,
        endDelay: timings.endDelay
      });
    }
    
    // Core
    
    var activeInstances = [];
    var pausedInstances = [];
    var raf;
    
    var engine = (function () {
      function play() { 
        raf = requestAnimationFrame(step);
      }
      function step(t) {
        var activeInstancesLength = activeInstances.length;
        if (activeInstancesLength) {
          var i = 0;
          while (i < activeInstancesLength) {
            var activeInstance = activeInstances[i];
            if (!activeInstance.paused) {
              activeInstance.tick(t);
            } else {
              var instanceIndex = activeInstances.indexOf(activeInstance);
              if (instanceIndex > -1) {
                activeInstances.splice(instanceIndex, 1);
                activeInstancesLength = activeInstances.length;
              }
            }
            i++;
          }
          play();
        } else {
          raf = cancelAnimationFrame(raf);
        }
      }
      return play;
    })();
    
    function handleVisibilityChange() {
      if (document.hidden) {
        activeInstances.forEach(function (ins) { return ins.pause(); });
        pausedInstances = activeInstances.slice(0);
        anime.running = activeInstances = [];
      } else {
        pausedInstances.forEach(function (ins) { return ins.play(); });
      }
    }
    
    if (typeof document !== 'undefined') {
      document.addEventListener('visibilitychange', handleVisibilityChange);
    }
    
    // Public Instance
    
    function anime(params) {
      if ( params === void 0 ) params = {};
    
    
      var startTime = 0, lastTime = 0, now = 0;
      var children, childrenLength = 0;
      var resolve = null;
    
      function makePromise(instance) {
        var promise = window.Promise && new Promise(function (_resolve) { return resolve = _resolve; });
        instance.finished = promise;
        return promise;
      }
    
      var instance = createNewInstance(params);
      var promise = makePromise(instance);
    
      function toggleInstanceDirection() {
        var direction = instance.direction;
        if (direction !== 'alternate') {
          instance.direction = direction !== 'normal' ? 'normal' : 'reverse';
        }
        instance.reversed = !instance.reversed;
        children.forEach(function (child) { return child.reversed = instance.reversed; });
      }
    
      function adjustTime(time) {
        return instance.reversed ? instance.duration - time : time;
      }
    
      function resetTime() {
        startTime = 0;
        lastTime = adjustTime(instance.currentTime) * (1 / anime.speed);
      }
    
      function seekChild(time, child) {
        if (child) { child.seek(time - child.timelineOffset); }
      }
    
      function syncInstanceChildren(time) {
        if (!instance.reversePlayback) {
          for (var i = 0; i < childrenLength; i++) { seekChild(time, children[i]); }
        } else {
          for (var i$1 = childrenLength; i$1--;) { seekChild(time, children[i$1]); }
        }
      }
    
      function setAnimationsProgress(insTime) {
        var i = 0;
        var animations = instance.animations;
        var animationsLength = animations.length;
        while (i < animationsLength) {
          var anim = animations[i];
          var animatable = anim.animatable;
          var tweens = anim.tweens;
          var tweenLength = tweens.length - 1;
          var tween = tweens[tweenLength];
          // Only check for keyframes if there is more than one tween
          if (tweenLength) { tween = filterArray(tweens, function (t) { return (insTime < t.end); })[0] || tween; }
          var elapsed = minMax(insTime - tween.start - tween.delay, 0, tween.duration) / tween.duration;
          var eased = isNaN(elapsed) ? 1 : tween.easing(elapsed);
          var strings = tween.to.strings;
          var round = tween.round;
          var numbers = [];
          var toNumbersLength = tween.to.numbers.length;
          var progress = (void 0);
          for (var n = 0; n < toNumbersLength; n++) {
            var value = (void 0);
            var toNumber = tween.to.numbers[n];
            var fromNumber = tween.from.numbers[n] || 0;
            if (!tween.isPath) {
              value = fromNumber + (eased * (toNumber - fromNumber));
            } else {
              value = getPathProgress(tween.value, eased * toNumber);
            }
            if (round) {
              if (!(tween.isColor && n > 2)) {
                value = Math.round(value * round) / round;
              }
            }
            numbers.push(value);
          }
          // Manual Array.reduce for better performances
          var stringsLength = strings.length;
          if (!stringsLength) {
            progress = numbers[0];
          } else {
            progress = strings[0];
            for (var s = 0; s < stringsLength; s++) {
              var a = strings[s];
              var b = strings[s + 1];
              var n$1 = numbers[s];
              if (!isNaN(n$1)) {
                if (!b) {
                  progress += n$1 + ' ';
                } else {
                  progress += n$1 + b;
                }
              }
            }
          }
          setProgressValue[anim.type](animatable.target, anim.property, progress, animatable.transforms);
          anim.currentValue = progress;
          i++;
        }
      }
    
      function setCallback(cb) {
        if (instance[cb] && !instance.passThrough) { instance[cb](instance); }
      }
    
      function countIteration() {
        if (instance.remaining && instance.remaining !== true) {
          instance.remaining--;
        }
      }
    
      function setInstanceProgress(engineTime) {
        var insDuration = instance.duration;
        var insDelay = instance.delay;
        var insEndDelay = insDuration - instance.endDelay;
        var insTime = adjustTime(engineTime);
        instance.progress = minMax((insTime / insDuration) * 100, 0, 100);
        instance.reversePlayback = insTime < instance.currentTime;
        if (children) { syncInstanceChildren(insTime); }
        if (!instance.began && instance.currentTime > 0) {
          instance.began = true;
          setCallback('begin');
        }
        if (!instance.loopBegan && instance.currentTime > 0) {
          instance.loopBegan = true;
          setCallback('loopBegin');
        }
        if (insTime <= insDelay && instance.currentTime !== 0) {
          setAnimationsProgress(0);
        }
        if ((insTime >= insEndDelay && instance.currentTime !== insDuration) || !insDuration) {
          setAnimationsProgress(insDuration);
        }
        if (insTime > insDelay && insTime < insEndDelay) {
          if (!instance.changeBegan) {
            instance.changeBegan = true;
            instance.changeCompleted = false;
            setCallback('changeBegin');
          }
          setCallback('change');
          setAnimationsProgress(insTime);
        } else {
          if (instance.changeBegan) {
            instance.changeCompleted = true;
            instance.changeBegan = false;
            setCallback('changeComplete');
          }
        }
        instance.currentTime = minMax(insTime, 0, insDuration);
        if (instance.began) { setCallback('update'); }
        if (engineTime >= insDuration) {
          lastTime = 0;
          countIteration();
          if (!instance.remaining) {
            instance.paused = true;
            if (!instance.completed) {
              instance.completed = true;
              setCallback('loopComplete');
              setCallback('complete');
              if (!instance.passThrough && 'Promise' in window) {
                resolve();
                promise = makePromise(instance);
              }
            }
          } else {
            startTime = now;
            setCallback('loopComplete');
            instance.loopBegan = false;
            if (instance.direction === 'alternate') {
              toggleInstanceDirection();
            }
          }
        }
      }
    
      instance.reset = function() {
        var direction = instance.direction;
        instance.passThrough = false;
        instance.currentTime = 0;
        instance.progress = 0;
        instance.paused = true;
        instance.began = false;
        instance.loopBegan = false;
        instance.changeBegan = false;
        instance.completed = false;
        instance.changeCompleted = false;
        instance.reversePlayback = false;
        instance.reversed = direction === 'reverse';
        instance.remaining = instance.loop;
        children = instance.children;
        childrenLength = children.length;
        for (var i = childrenLength; i--;) { instance.children[i].reset(); }
        if (instance.reversed && instance.loop !== true || (direction === 'alternate' && instance.loop === 1)) { instance.remaining++; }
        setAnimationsProgress(instance.reversed ? instance.duration : 0);
      };
    
      // Set Value helper
    
      instance.set = function(targets, properties) {
        setTargetsValue(targets, properties);
        return instance;
      };
    
      instance.tick = function(t) {
        now = t;
        if (!startTime) { startTime = now; }
        setInstanceProgress((now + (lastTime - startTime)) * anime.speed);
      };
    
      instance.seek = function(time) {
        setInstanceProgress(adjustTime(time));
      };
    
      instance.pause = function() {
        instance.paused = true;
        resetTime();
      };
    
      instance.play = function() {
        if (!instance.paused) { return; }
        if (instance.completed) { instance.reset(); }
        instance.paused = false;
        activeInstances.push(instance);
        resetTime();
        if (!raf) { engine(); }
      };
    
      instance.reverse = function() {
        toggleInstanceDirection();
        instance.completed = instance.reversed ? false : true;
        resetTime();
      };
    
      instance.restart = function() {
        instance.reset();
        instance.play();
      };
    
      instance.reset();
    
      if (instance.autoplay) { instance.play(); }
    
      return instance;
    
    }
    
    // Remove targets from animation
    
    function removeTargetsFromAnimations(targetsArray, animations) {
      for (var a = animations.length; a--;) {
        if (arrayContains(targetsArray, animations[a].animatable.target)) {
          animations.splice(a, 1);
        }
      }
    }
    
    function removeTargets(targets) {
      var targetsArray = parseTargets(targets);
      for (var i = activeInstances.length; i--;) {
        var instance = activeInstances[i];
        var animations = instance.animations;
        var children = instance.children;
        removeTargetsFromAnimations(targetsArray, animations);
        for (var c = children.length; c--;) {
          var child = children[c];
          var childAnimations = child.animations;
          removeTargetsFromAnimations(targetsArray, childAnimations);
          if (!childAnimations.length && !child.children.length) { children.splice(c, 1); }
        }
        if (!animations.length && !children.length) { instance.pause(); }
      }
    }
    
    // Stagger helpers
    
    function stagger(val, params) {
      if ( params === void 0 ) params = {};
    
      var direction = params.direction || 'normal';
      var easing = params.easing ? parseEasings(params.easing) : null;
      var grid = params.grid;
      var axis = params.axis;
      var fromIndex = params.from || 0;
      var fromFirst = fromIndex === 'first';
      var fromCenter = fromIndex === 'center';
      var fromLast = fromIndex === 'last';
      var isRange = is.arr(val);
      var val1 = isRange ? parseFloat(val[0]) : parseFloat(val);
      var val2 = isRange ? parseFloat(val[1]) : 0;
      var unit = getUnit(isRange ? val[1] : val) || 0;
      var start = params.start || 0 + (isRange ? val1 : 0);
      var values = [];
      var maxValue = 0;
      return function (el, i, t) {
        if (fromFirst) { fromIndex = 0; }
        if (fromCenter) { fromIndex = (t - 1) / 2; }
        if (fromLast) { fromIndex = t - 1; }
        if (!values.length) {
          for (var index = 0; index < t; index++) {
            if (!grid) {
              values.push(Math.abs(fromIndex - index));
            } else {
              var fromX = !fromCenter ? fromIndex%grid[0] : (grid[0]-1)/2;
              var fromY = !fromCenter ? Math.floor(fromIndex/grid[0]) : (grid[1]-1)/2;
              var toX = index%grid[0];
              var toY = Math.floor(index/grid[0]);
              var distanceX = fromX - toX;
              var distanceY = fromY - toY;
              var value = Math.sqrt(distanceX * distanceX + distanceY * distanceY);
              if (axis === 'x') { value = -distanceX; }
              if (axis === 'y') { value = -distanceY; }
              values.push(value);
            }
            maxValue = Math.max.apply(Math, values);
          }
          if (easing) { values = values.map(function (val) { return easing(val / maxValue) * maxValue; }); }
          if (direction === 'reverse') { values = values.map(function (val) { return axis ? (val < 0) ? val * -1 : -val : Math.abs(maxValue - val); }); }
        }
        var spacing = isRange ? (val2 - val1) / maxValue : val1;
        return start + (spacing * (Math.round(values[i] * 100) / 100)) + unit;
      }
    }
    
    // Timeline
    
    function timeline(params) {
      if ( params === void 0 ) params = {};
    
      var tl = anime(params);
      tl.duration = 0;
      tl.add = function(instanceParams, timelineOffset) {
        var tlIndex = activeInstances.indexOf(tl);
        var children = tl.children;
        if (tlIndex > -1) { activeInstances.splice(tlIndex, 1); }
        function passThrough(ins) { ins.passThrough = true; }
        for (var i = 0; i < children.length; i++) { passThrough(children[i]); }
        var insParams = mergeObjects(instanceParams, replaceObjectProps(defaultTweenSettings, params));
        insParams.targets = insParams.targets || params.targets;
        var tlDuration = tl.duration;
        insParams.autoplay = false;
        insParams.direction = tl.direction;
        insParams.timelineOffset = is.und(timelineOffset) ? tlDuration : getRelativeValue(timelineOffset, tlDuration);
        passThrough(tl);
        tl.seek(insParams.timelineOffset);
        var ins = anime(insParams);
        passThrough(ins);
        children.push(ins);
        var timings = getInstanceTimings(children, params);
        tl.delay = timings.delay;
        tl.endDelay = timings.endDelay;
        tl.duration = timings.duration;
        tl.seek(0);
        tl.reset();
        if (tl.autoplay) { tl.play(); }
        return tl;
      };
      return tl;
    }
    
    anime.version = '3.2.0';
    anime.speed = 1;
    anime.running = activeInstances;
    anime.remove = removeTargets;
    anime.get = getOriginalTargetValue;
    anime.set = setTargetsValue;
    anime.convertPx = convertPxToUnit;
    anime.path = getPath;
    anime.setDashoffset = setDashoffset;
    anime.stagger = stagger;
    anime.timeline = timeline;
    anime.easing = parseEasings;
    anime.penner = penner;
    anime.random = function (min, max) { return Math.floor(Math.random() * (max - min + 1)) + min; };
    
    /* harmony default export */ var anime_es = (anime);
    
    // CONCATENATED MODULE: ./node_modules/body-scroll-lock/lib/bodyScrollLock.esm.js
    function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
    
    // Older browsers don't support event options, feature detect it.
    
    // Adopted and modified solution from Bohdan Didukh (2017)
    // https://stackoverflow.com/questions/41594997/ios-10-safari-prevent-scrolling-behind-a-fixed-overlay-and-maintain-scroll-posi
    
    var hasPassiveEvents = false;
    if (typeof window !== 'undefined') {
      var passiveTestOptions = {
        get passive() {
          hasPassiveEvents = true;
          return undefined;
        }
      };
      window.addEventListener('testPassive', null, passiveTestOptions);
      window.removeEventListener('testPassive', null, passiveTestOptions);
    }
    
    var isIosDevice = typeof window !== 'undefined' && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1);
    
    
    var locks = [];
    var documentListenerAdded = false;
    var initialClientY = -1;
    var previousBodyOverflowSetting = void 0;
    var previousBodyPaddingRight = void 0;
    
    // returns true if `el` should be allowed to receive touchmove events.
    var allowTouchMove = function allowTouchMove(el) {
      return locks.some(function (lock) {
        if (lock.options.allowTouchMove && lock.options.allowTouchMove(el)) {
          return true;
        }
    
        return false;
      });
    };
    
    var preventDefault = function preventDefault(rawEvent) {
      var e = rawEvent || window.event;
    
      // For the case whereby consumers adds a touchmove event listener to document.
      // Recall that we do document.addEventListener('touchmove', preventDefault, { passive: false })
      // in disableBodyScroll - so if we provide this opportunity to allowTouchMove, then
      // the touchmove event on document will break.
      if (allowTouchMove(e.target)) {
        return true;
      }
    
      // Do not prevent if the event has more than one touch (usually meaning this is a multi touch gesture like pinch to zoom).
      if (e.touches.length > 1) return true;
    
      if (e.preventDefault) e.preventDefault();
    
      return false;
    };
    
    var setOverflowHidden = function setOverflowHidden(options) {
      // Setting overflow on body/documentElement synchronously in Desktop Safari slows down
      // the responsiveness for some reason. Setting within a setTimeout fixes this.
      setTimeout(function () {
        // If previousBodyPaddingRight is already set, don't set it again.
        if (previousBodyPaddingRight === undefined) {
          var _reserveScrollBarGap = !!options && options.reserveScrollBarGap === true;
          var scrollBarGap = window.innerWidth - document.documentElement.clientWidth;
    
          if (_reserveScrollBarGap && scrollBarGap > 0) {
            previousBodyPaddingRight = document.body.style.paddingRight;
            document.body.style.paddingRight = scrollBarGap + 'px';
          }
        }
    
        // If previousBodyOverflowSetting is already set, don't set it again.
        if (previousBodyOverflowSetting === undefined) {
          previousBodyOverflowSetting = document.body.style.overflow;
          document.body.style.overflow = 'hidden';
        }
      });
    };
    
    var restoreOverflowSetting = function restoreOverflowSetting() {
      // Setting overflow on body/documentElement synchronously in Desktop Safari slows down
      // the responsiveness for some reason. Setting within a setTimeout fixes this.
      setTimeout(function () {
        if (previousBodyPaddingRight !== undefined) {
          document.body.style.paddingRight = previousBodyPaddingRight;
    
          // Restore previousBodyPaddingRight to undefined so setOverflowHidden knows it
          // can be set again.
          previousBodyPaddingRight = undefined;
        }
    
        if (previousBodyOverflowSetting !== undefined) {
          document.body.style.overflow = previousBodyOverflowSetting;
    
          // Restore previousBodyOverflowSetting to undefined
          // so setOverflowHidden knows it can be set again.
          previousBodyOverflowSetting = undefined;
        }
      });
    };
    
    // https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
    var isTargetElementTotallyScrolled = function isTargetElementTotallyScrolled(targetElement) {
      return targetElement ? targetElement.scrollHeight - targetElement.scrollTop <= targetElement.clientHeight : false;
    };
    
    var handleScroll = function handleScroll(event, targetElement) {
      var clientY = event.targetTouches[0].clientY - initialClientY;
    
      if (allowTouchMove(event.target)) {
        return false;
      }
    
      if (targetElement && targetElement.scrollTop === 0 && clientY > 0) {
        // element is at the top of its scroll.
        return preventDefault(event);
      }
    
      if (isTargetElementTotallyScrolled(targetElement) && clientY < 0) {
        // element is at the bottom of its scroll.
        return preventDefault(event);
      }
    
      event.stopPropagation();
      return true;
    };
    
    var disableBodyScroll = function disableBodyScroll(targetElement, options) {
      if (isIosDevice) {
        // targetElement must be provided, and disableBodyScroll must not have been
        // called on this targetElement before.
        if (!targetElement) {
          // eslint-disable-next-line no-console
          console.error('disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.');
          return;
        }
    
        if (targetElement && !locks.some(function (lock) {
          return lock.targetElement === targetElement;
        })) {
          var lock = {
            targetElement: targetElement,
            options: options || {}
          };
    
          locks = [].concat(_toConsumableArray(locks), [lock]);
    
          targetElement.ontouchstart = function (event) {
            if (event.targetTouches.length === 1) {
              // detect single touch.
              initialClientY = event.targetTouches[0].clientY;
            }
          };
          targetElement.ontouchmove = function (event) {
            if (event.targetTouches.length === 1) {
              // detect single touch.
              handleScroll(event, targetElement);
            }
          };
    
          if (!documentListenerAdded) {
            document.addEventListener('touchmove', preventDefault, hasPassiveEvents ? { passive: false } : undefined);
            documentListenerAdded = true;
          }
        }
      } else {
        setOverflowHidden(options);
        var _lock = {
          targetElement: targetElement,
          options: options || {}
        };
    
        locks = [].concat(_toConsumableArray(locks), [_lock]);
      }
    };
    
    var clearAllBodyScrollLocks = function clearAllBodyScrollLocks() {
      if (isIosDevice) {
        // Clear all locks ontouchstart/ontouchmove handlers, and the references.
        locks.forEach(function (lock) {
          lock.targetElement.ontouchstart = null;
          lock.targetElement.ontouchmove = null;
        });
    
        if (documentListenerAdded) {
          document.removeEventListener('touchmove', preventDefault, hasPassiveEvents ? { passive: false } : undefined);
          documentListenerAdded = false;
        }
    
        locks = [];
    
        // Reset initial clientY.
        initialClientY = -1;
      } else {
        restoreOverflowSetting();
        locks = [];
      }
    };
    
    var enableBodyScroll = function enableBodyScroll(targetElement) {
      if (isIosDevice) {
        if (!targetElement) {
          // eslint-disable-next-line no-console
          console.error('enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.');
          return;
        }
    
        targetElement.ontouchstart = null;
        targetElement.ontouchmove = null;
    
        locks = locks.filter(function (lock) {
          return lock.targetElement !== targetElement;
        });
    
        if (documentListenerAdded && locks.length === 0) {
          document.removeEventListener('touchmove', preventDefault, hasPassiveEvents ? { passive: false } : undefined);
    
          documentListenerAdded = false;
        }
      } else {
        locks = locks.filter(function (lock) {
          return lock.targetElement !== targetElement;
        });
        if (!locks.length) {
          restoreOverflowSetting();
        }
      }
    };
    
    
    // EXTERNAL MODULE: ./node_modules/tabbable/index.js
    var node_modules_tabbable = __webpack_require__(20);
    var tabbable_default = /*#__PURE__*/__webpack_require__.n(node_modules_tabbable);
    
    // CONCATENATED MODULE: ./node_modules/lbx/dist/lbx.es.js
    function lbx_es_t(e){var t=e.onfocus,n=document.createElement("div");return n.style.cssText="\n    width: 1px;\n    height: 0px;\n    padding: 0px;\n    overflow: hidden;\n    position: fixed;\n    top: 1px;\n    left: 1px;\n  ",n.onfocus=t,n.setAttribute("tabindex","0"),n.setAttribute("aria-hidden","true"),n.setAttribute("data-lockbox",""),n}function lbx_es_n(n){if(n){var o,i,r=document.activeElement,c=tabbable_default()(n);if(!n.querySelector("[data-lockbox]")){o=lbx_es_t({onfocus:function(){var e=c[c.length-1];e&&e.focus()}}),i=lbx_es_t({onfocus:function(){var e=c[0];e&&e.focus()}}),n.insertBefore(o,n.children[0]),n.appendChild(i);var u=c[0];u&&u.focus()}return function(){n.removeChild(o),n.removeChild(i),r.focus()}}}
    //# sourceMappingURL=lbx.es.js.map
    
    // CONCATENATED MODULE: ./src/scripts/lib/mobile-quick-search.js
    
    
    
    var mobile_quick_search_classes = {
      active: 'active',
      visible: 'visible'
    };
    /* harmony default export */ var mobile_quick_search = (function (node) {
      var form = node.querySelector('form');
      var input = node.querySelector('[data-input]');
      var closeBtn = node.querySelector('[data-close]');
      var resultsContainer = node.querySelector('[data-results]');
      var settings = node.querySelector('[data-settings]'); // This gets replaced with a focus trapping util on `open` however
      // this should prevent any errors if the quick search is destroyed
      // when it wasn't open
    
      var lockbox = function lockbox() {};
    
      closeBtn.addEventListener('click', close);
      node.addEventListener('keydown', checkEscape);
      input.addEventListener('input', handleInput);
      var options = JSON.parse(settings.innerHTML);
      var search = predictive_search({
        opts: options
      });
      search.on('success', function (_ref) {
        var markup = _ref.markup;
        resultsContainer.classList.add(mobile_quick_search_classes.visible);
        resultsContainer.innerHTML = markup;
      });
    
      function handleInput(e) {
        if (e.target.value === '') resultsContainer.classList.remove(mobile_quick_search_classes.visible);
    
        if (options.show_products || options.show_pages || options.show_articles) {
          search.query(e.target.value);
        }
      }
    
      function checkEscape(_ref2) {
        var keyCode = _ref2.keyCode;
        if (keyCode === 27) close();
      } // Clear contents of the search input and hide results container
    
    
      function reset(e) {
        e.preventDefault();
        input.value = '';
        resultsContainer.classList.remove(mobile_quick_search_classes.visible);
        input.focus();
      }
    
      function open() {
        node.classList.add(mobile_quick_search_classes.active);
        setTimeout(function () {
          lockbox = lbx_es_n(form);
          disableBodyScroll(node);
          node.classList.add(mobile_quick_search_classes.visible);
          input.focus();
        }, 50);
      }
    
      function close(e) {
        e && e.preventDefault();
        node.classList.remove(mobile_quick_search_classes.visible);
        setTimeout(function () {
          node.classList.remove(mobile_quick_search_classes.active);
          enableBodyScroll(node);
          lockbox();
        }, 350);
      }
    
      function destroy() {
        close();
        closeBtn.addEventListener('click', close);
        node.removeEventListener('keydown', checkEscape);
        input.removeEventListener('input', handleInput);
      }
    
      return {
        open: open,
        close: close,
        destroy: destroy
      };
    });
    // CONCATENATED MODULE: ./src/scripts/lib/drawer-menu.js
    
    
    
    
    var drawer_menu_sel = {
      overlay: '[data-overlay]',
      listItem: '[data-list-item]',
      item: '[data-item]',
      allLinks: '[data-all-links]',
      main: '[data-main]',
      primary: '[data-primary-container]',
      footer: '[data-footer]',
      close: '[data-close-drawer]',
      logo: '.drawer-menu__logo',
      // Cross border
      form: '.drawer-menu__form',
      localeInput: '[data-locale-input]',
      currencyInput: '[data-currency-input]',
      // Quick search
      quickSearch: '[data-quick-search]'
    };
    var drawer_menu_classes = {
      active: 'active',
      visible: 'visible'
    };
    
    var drawer_menu_transitionIn = function transitionIn(targets) {
      return anime_es({
        targets: targets,
        translateX: [40, 0],
        opacity: [0, 1],
        easing: 'cubicBezier(.5, .05, .1, .3)',
        duration: 180,
        delay: anime_es.stagger(80, {
          start: 250
        }),
        complete: function complete() {
          targets.forEach(function (el) {
            return el.style.removeProperty('transform');
          });
        }
      });
    }; // Extra space we add to the height of the inner container
    
    
    var formatHeight = function formatHeight(h) {
      return h + 8 + 'px';
    };
    
    var drawer_menu_menu = function menu(node) {
      // Entire links container
      var primaryDepth = 0; // The individual link list the merchant selected
    
      var linksDepth = 0;
      var focusTrap = createFocusTrap(node, {
        allowOutsideClick: true
      });
      var overlay = node.querySelector(drawer_menu_sel.overlay);
      overlay.addEventListener('click', close);
      var quickSearchEl = node.querySelector(drawer_menu_sel.quickSearch);
      var quickSearch = mobile_quick_search(quickSearchEl);
      var searchLink = node.querySelector('[data-search]');
      searchLink.addEventListener('click', openSearch); // Element that holds all links, primary and secondary
    
      var everything = node.querySelector(drawer_menu_sel.allLinks); // This is the element that holds the one we move left and right (primary)
      // We also need to assign its height initially so we get smooth transitions
    
      var main = node.querySelector(drawer_menu_sel.main); // Element that holds all the primary links and moves left and right
    
      var primary = node.querySelector(drawer_menu_sel.primary); // Cross border
    
      var form = node.querySelector(drawer_menu_sel.form);
      var localeInput = node.querySelector(drawer_menu_sel.localeInput);
      var currencyInput = node.querySelector(drawer_menu_sel.currencyInput);
      var closeBtn = node.querySelector(drawer_menu_sel.close);
      closeBtn.addEventListener('click', close); // Every individual menu item
    
      var items = node.querySelectorAll(drawer_menu_sel.item);
      items.forEach(function (item) {
        return item.addEventListener('click', handleItem);
      });
    
      function openSearch(e) {
        e.preventDefault();
        quickSearch.open();
      }
    
      function handleItem(e) {
        e.preventDefault();
        var item = e.currentTarget.dataset.item;
    
        switch (item) {
          // Standard link that goes to a different url
          case 'link':
            close();
            window.location = e.currentTarget.href;
            break;
          // Element that will navigate to child navigation list
    
          case 'parent':
            clickParent(e);
            break;
          // Element that will navigate back up the tree
    
          case 'back':
            clickBack(e);
            break;
          // Account, currency, and language link at the bottom
    
          case 'secondary':
            handleSecondaryLink(e);
            break;
          // Back link within 'Currency' or 'Language'
    
          case 'secondaryHeading':
            handleSecondaryHeading(e);
            break;
          // Individual language
    
          case 'locale':
            handleLanguage(e);
            break;
          // Individual currency
    
          case 'currency':
            handleCurrency(e);
            break;
        }
      }
    
      function open() {
        node.classList.add(drawer_menu_classes.active);
        setTimeout(function () {
          focusTrap.activate();
          node.classList.add(drawer_menu_classes.visible);
          disableBodyScroll(node, {
            allowTouchMove: function allowTouchMove(el) {
              while (el && el !== document.body) {
                if (el.getAttribute('scroll-lock-ignore') !== null) {
                  return true;
                }
    
                el = el.parentNode;
              }
            }
          });
          var elements = node.querySelectorAll("".concat(drawer_menu_sel.primary, " > ").concat(drawer_menu_sel.listItem, ", ").concat(drawer_menu_sel.footer, " > li, ").concat(drawer_menu_sel.footer, " > form > li"));
    
          if (primaryDepth === 0 && linksDepth === 0) {
            main.style.height = formatHeight(primary.offsetHeight);
            drawer_menu_transitionIn(elements);
          }
        }, 50);
      }
    
      function close(e) {
        e && e.preventDefault();
        focusTrap.deactivate();
        node.classList.remove(drawer_menu_classes.visible);
        setTimeout(function () {
          node.classList.remove(drawer_menu_classes.active);
          enableBodyScroll(node);
        }, 350);
      }
    
      function clickParent(e) {
        e.preventDefault();
        var childMenu = e.currentTarget.nextElementSibling;
        childMenu.classList.add(drawer_menu_classes.visible);
        main.style.height = formatHeight(childMenu.offsetHeight);
        var elements = childMenu.querySelectorAll(":scope > ".concat(drawer_menu_sel.listItem));
        drawer_menu_transitionIn(elements);
        navigate(linksDepth += 1);
      }
    
      function navigate(depth) {
        linksDepth = depth;
        primary.setAttribute('data-depth', depth);
      }
    
      function navigatePrimary(depth) {
        primaryDepth = depth;
        everything.setAttribute('data-depth', depth);
      }
    
      function clickBack(e) {
        e.preventDefault();
        var menuBefore = e.currentTarget.closest(drawer_menu_sel.listItem).closest('ul');
        main.style.height = formatHeight(menuBefore.offsetHeight);
        var parent = e.currentTarget.closest('ul');
        parent.classList.remove(drawer_menu_classes.visible);
        navigate(linksDepth -= 1);
      }
    
      function handleSecondaryLink(e) {
        e.preventDefault();
        navigatePrimary(1);
        var childMenu = e.currentTarget.nextElementSibling;
        childMenu.classList.add(drawer_menu_classes.visible);
        var elements = childMenu.querySelectorAll(":scope > ".concat(drawer_menu_sel.listItem));
        drawer_menu_transitionIn(elements);
      }
    
      function handleSecondaryHeading(e) {
        e.preventDefault();
        navigatePrimary(0);
        var parent = e.currentTarget.closest('ul');
        parent.classList.remove(drawer_menu_classes.visible);
      }
    
      function handleCrossBorder(e, input) {
        var value = e.currentTarget.dataset.value;
        input.value = value;
        close();
        form.submit();
      }
    
      function handleKeyboard(e) {
        if (!node.classList.contains(drawer_menu_classes.visible)) return;
    
        if (e.key == 'Escape' || e.keyCode === 27 && drawerOpen) {
          close();
        }
      }
    
      var handleLanguage = function handleLanguage(e) {
        return handleCrossBorder(e, localeInput);
      };
    
      var handleCurrency = function handleCurrency(e) {
        return handleCrossBorder(e, currencyInput);
      };
    
      window.addEventListener('keydown', handleKeyboard);
    
      function destroy() {
        overlay.removeEventListener('click', close);
        closeBtn.removeEventListener('click', close);
        searchLink.removeEventListener('click', openSearch);
        items.forEach(function (item) {
          return item.removeEventListener('click', handleItem);
        });
        enableBodyScroll(node);
        window.removeEventListener('keydown', handleKeyboard);
      }
    
      return {
        close: close,
        destroy: destroy,
        open: open
      };
    };
    
    /* harmony default export */ var drawer_menu = (drawer_menu_menu);
    // CONCATENATED MODULE: ./src/scripts/frame/header.js
    
    
    
    
    
    
    var header_selectors = {
      jsCartCount: '.js-cart-count',
      jsCartToggle: '.js-cart-drawer-toggle',
      cartCountInner: '.quick-cart__indicator-inner',
      currencySelector: '.header__icon--currency',
      languageSelector: '.header__icon--language',
      disclosure: '[data-disclosure]',
      drawerMenu: '[data-drawer-menu]'
    };
    section('header', {
      crossBorder: {},
      onLoad: function onLoad() {
        var _this = this;
    
        var drawerMenu = document.querySelector(header_selectors.drawerMenu);
        this.menu = drawer_menu(drawerMenu);
        this.menuButton = this.container.querySelector('#mobile-nav');
        var cartCount = this.container.querySelector(header_selectors.jsCartCount);
        var cartToggles = this.container.querySelectorAll(header_selectors.jsCartToggle);
        this.navigation = components_navigation(this.container);
        this.navigationCloseHandler = evx_es_c('navitem:closeOthers', function () {
          _this.navigation.closeAll();
        });
        this.menuButton.addEventListener('click', this._openMenu.bind(this));
        evx_es_c('cart:updated', function (state) {
          var cartCountInner = cartCount.querySelector(header_selectors.cartCountInner);
          if(cartCountInner) {
            cartCountInner.innerHTML = state.cart.item_count;
            cartCountInner.classList.toggle('quick-cart--cart-has-item', state.cart.item_count);
          }
        });
    
        for (var i = 0; i < cartToggles.length; i++) {
          cartToggles[i].addEventListener('click', function (e) {
            e.preventDefault();
            if (window.location.pathname == '/cart') {
              return false;
            };
            fetchCart().then(function (cart) {
                evx_es_o({ cart: cart })
                evx_es_r('cart:updated');
            });            
          });
        }
    
        this.quickSearch = this.container.querySelector('.quick-search');
        this.predictiveSearch = components_quickSearch({
          container: this.quickSearch
        });
    
        this._initDisclosure();
      },
      _openMenu: function _openMenu(e) {
        e.preventDefault();
        this.menu.open();
      },
      _showHeaderOverlay: function _showHeaderOverlay(event) {
        if (event.target.ariaExpanded === 'true') {
          evx_es_r('headerOverlay:show');
        } else {
          evx_es_r('headerOverlay:hide');
        }
      },
      _initDisclosure: function _initDisclosure() {
        var languageSelectorContainer = this.container.querySelector(header_selectors.languageSelector);
        var currencySelectorContainer = this.container.querySelector(header_selectors.currencySelector);
    
        if (languageSelectorContainer) {
          this.languageTrigger = languageSelectorContainer.querySelector(header_selectors.disclosure);
          var d = this.languageTrigger.dataset.disclosure;
          this.crossBorder[d] = components_disclosure(this.languageTrigger, languageSelectorContainer);
          this.languageTrigger.addEventListener('click', this._showHeaderOverlay);
        }
    
        if (currencySelectorContainer) {
          this.currencyTrigger = currencySelectorContainer.querySelector(header_selectors.disclosure);
          var _d = this.currencyTrigger.dataset.disclosure;
          this.crossBorder[_d] = components_disclosure(this.currencyTrigger, currencySelectorContainer);
          this.currencyTrigger.addEventListener('click', this._showHeaderOverlay);
        }
      },
      onSelect: function onSelect() {
        evx_es_r('sticky-header:reload', function () {});
      },
      onBlockSelect: function onBlockSelect(_ref) {
        var navigation = _ref.target;
      },
      onUnload: function onUnload() {
        var _this2 = this;
    
        this.menu.destroy();
        this.predictiveSearch.unload();
        this.navigation.unload();
        this.navigationCloseHandler();
        this.currencyTrigger && this.currencyTrigger.removeEventListener('click', this._showHeaderOverlay);
        this.languageTrigger && this.languageTrigger.removeEventListener('click', this._showHeaderOverlay);
        Object.keys(this.crossBorder).forEach(function (t) {
          _this2.crossBorder[t].unload();
        });
      }
    });
    // EXTERNAL MODULE: ./node_modules/is-mobile/index.js
    var is_mobile = __webpack_require__(5);
    var is_mobile_default = /*#__PURE__*/__webpack_require__.n(is_mobile);
    
    // CONCATENATED MODULE: ./src/scripts/frame/exit-intent.js
    
    
    var ei = {
      get: function get() {
        return JSON.parse(localStorage.getItem('exitIntent'));
      },
      set: function set(val) {
        return localStorage.setItem('exitIntent', val);
      }
    };
    section('exit-intent', {
      onLoad: function onLoad() {
        var _this = this;
    
        this.closeBtn = this.container.querySelector('[data-close-icon]');
        var mobileTimeout = parseInt(this.container.dataset.mobileLandingTimeout);
    
        var mouseLeave = function mouseLeave(e) {
          if (!e.relatedTarget && !e.toElement) {
            _this.showPopup();
    
            document.body.removeEventListener('mouseout', mouseLeave);
          }
        };
    
        var close = function close(e) {
          e.preventDefault();
    
          _this.hidePopup();
    
          ei.set(true);
        };
    
        if (!ei.get()) {
          if (is_mobile_default()()) {
            setTimeout(function () {
              _this.showPopup();
            }, mobileTimeout);
          } else {
            document.body.addEventListener('mouseout', mouseLeave);
          }
    
          this.closeBtn.addEventListener('click', close);
        }
      },
      showPopup: function showPopup() {
        var _this2 = this;
    
        this.container.classList.add('animating');
        setTimeout(function () {
          _this2.container.classList.add('visible');
        }, 250);
      },
      hidePopup: function hidePopup() {
        var _this3 = this;
    
        this.container.classList.remove('visible');
        this.container.classList.add('hidden');
        setTimeout(function () {
          _this3.container.classList.remove('animating');
        }, 250);
      },
      onSelect: function onSelect() {
        this.showPopup();
      },
      onDeselect: function onDeselect() {
        this.hidePopup();
      },
      onUnload: function onUnload() {
        this.closeBtn.removeEventListener('click', close);
      }
    });
    // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/defineProperty.js
    var defineProperty = __webpack_require__(2);
    var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);
    
    // EXTERNAL MODULE: ./node_modules/flickity/js/index.js
    var js = __webpack_require__(1);
    var js_default = /*#__PURE__*/__webpack_require__.n(js);
    
    // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/readOnlyError.js
    var readOnlyError = __webpack_require__(16);
    var readOnlyError_default = /*#__PURE__*/__webpack_require__.n(readOnlyError);
    
    // CONCATENATED MODULE: ./src/scripts/lib/heightObserver.js
    
    
    var heightObserver_heightObserver = function heightObserver(callback) {
      var observables = []; // Array of observed elements that looks like const :
      // [{
      //   el: domNode,
      //   size: {height: x}
      // }]
    
      var observe = function observe(el) {
        if (observables.some(function (observable) {
          return observable.el === el;
        })) {
          return;
        }
    
        var newObservable = {
          el: el,
          size: {
            height: el.clientHeight
          }
        };
        observables.push(newObservable);
      };
    
      var unobserve = function unobserve(el) {
        observables = (readOnlyError_default()("observables"), observables.filter(function (obj) {
          return obj.el !== el;
        }));
      };
    
      var check = function check() {
        var changedEntries = observables.filter(function (obj) {
          var currentHeight = obj.el.clientHeight;
    
          if (obj.size.height !== currentHeight) {
            obj.size.height = currentHeight;
            return true;
          }
        }).map(function (obj) {
          return obj.el;
        });
    
        if (changedEntries.length > 0) {
          callback(changedEntries);
        }
    
        window.requestAnimationFrame(check);
      };
    
      check();
    
      var unload = function unload() {
        observables = (readOnlyError_default()("observables"), []);
      };
    
      return {
        unload: unload,
        observe: observe,
        unobserve: unobserve
      };
    };
    
    /* harmony default export */ var lib_heightObserver = (heightObserver_heightObserver);
    // CONCATENATED MODULE: ./src/scripts/frame/announcement-bar.js
    
    
    function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
    
    function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
    
    
    
    
    
    var announcement_bar_slideshowOpts = {
      adaptiveHeight: false,
      pageDots: false,
      prevNextButtons: false,
      wrapAround: true,
      draggable: false
    };
    var announcement_bar_selectors = {
      announcements: '.announcement-bar'
    };
    var modifiers = {
      active: 'is-active'
    };
    var rootVars = {
      announcementBar: '--announcement-height'
    };
    section('announcement-bar', {
      onLoad: function onLoad() {
        this.announcements = this.container.querySelectorAll(announcement_bar_selectors.announcements);
        var timing = this.container.dataset.timing;
        announcement_bar_slideshowOpts.autoPlay = parseInt(timing);
    
        this._init();
    
        this._setAnnouncementVars();
      },
      _init: function _init() {
        var _this = this;
    
        // Adding announcement status class
        document.body.classList.add('announcement-active');

        this.slideshow = new js_default.a(this.container, _objectSpread(_objectSpread({}, announcement_bar_slideshowOpts), {}, {
          on: {
            ready: function ready() {
              _this._setAnnouncementVars();
            },
            // Need to add a modifier to animate after the first slide has changed
            change: function change(index) {
              _this.announcements.forEach(function (element, i) {
                element.classList.toggle(modifiers.active, i === index);
              });
            }
          }
        }));
        this.resizeObserver = lib_heightObserver(function () {
          evx_es_r('sticky-header:reload', function () {});
    
          _this._setRootVar(rootVars.announcementBar, _this.container.offsetHeight);
        });
        this.resizeObserver.observe(this.container);
      },
      _setRootVar: function _setRootVar(name, value) {
        document.documentElement.style.setProperty(name, "".concat(value, "px"));
      },
      _setAnnouncementVars: function _setAnnouncementVars() {
        this._setRootVar(rootVars.announcementBar, this.announcements.length ? this.container.offsetHeight : 0);
      },
      onSelect: function onSelect() {
        evx_es_r('sticky-header:reload', function () {});
    
        this._setAnnouncementVars();
      },
      onBlockSelect: function onBlockSelect(_ref) {
        var target = _ref.target;
        this.slideshow.pausePlayer();
        this.slideshow.select(target.dataset.index);
      },
      onBlockDeselect: function onBlockDeselect() {
        this.slideshow.unpausePlayer();
      },
      onUnload: function onUnload() {
        this.slideshow.destroy();
        this.resizeObserver.disconnect();
      }
    });
    // CONCATENATED MODULE: ./src/scripts/lib/breakpoints.js
    /* harmony default export */ var breakpoints = ({
      isSmall: function isSmall() {
        return window.matchMedia('(max-width: 38em)').matches;
      },
      isLarge: function isLarge() {
        return window.matchMedia('(min-width: 60em)').matches;
      }
    });
    // CONCATENATED MODULE: ./src/scripts/components/carousel.js
    
    
    function carousel_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
    
    function carousel_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { carousel_ownKeys(Object(source), true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { carousel_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
    
    
    
    
    var carousel_selectors = defineProperty_default()({
      carousel: '[data-carousel]',
      slides: '.carousel__slide',
      carouselWraps: 'carousel--columns-wrap-around',
      textBlock: '.text-block',
      nextButton: '.carousel__next-button',
      previousButton: '.carousel__previous-button'
    }, "textBlock", '.text-block'); // carouslePosition denotes where the carousel lies within the container
    // depending on if there is text content above or below. Carousel navigation
    // paddles will be adjusted to the carousel.
    
    
    var carousel_carousel = function carousel(node) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref$carouselPosition = _ref.carouselPosition,
          carouselPosition = _ref$carouselPosition === void 0 ? 'bottom' : _ref$carouselPosition;
    
      var carousel = null;
      var _node$dataset = node.dataset,
          textPosition = _node$dataset.textPosition,
          textAlignment = _node$dataset.textAlignment;
      var carouselIsInline = textPosition === 'middle';
      var carouselWraps = node.classList.contains(carousel_selectors.carouselWraps);
      var navPrevButton = node.querySelector(carousel_selectors.previousButton);
      var navNextButton = node.querySelector(carousel_selectors.nextButton);
      var carouselContainer = node.querySelector(carousel_selectors.carousel);
      var slides = node.querySelectorAll(carousel_selectors.slides);
      var textBlock = node.querySelector(carousel_selectors.textBlock);
    
      var _init = function _init() {
        var carouselOpts = {
          adaptiveHeight: false,
          wrapAround: false,
          contain: true,
          cellAlign: 'left',
          prevNextButtons: false,
          pageDots: false,
          initialIndex: 0
        }; // Only wrap around if there is enough content to wrap
    
        if (carouselWraps) {
          carouselOpts.wrapAround = true;
        } else if (!carouselWraps && textAlignment == 'right') {
          carouselOpts.initialIndex = slides.length - 1;
          carouselOpts.cellAlign = 'right';
        }
    
        carousel = new js_default.a(carouselContainer, carousel_objectSpread(carousel_objectSpread({}, carouselOpts), {}, {
          on: {
            ready: function ready() {
              _initNavigation();
            },
            scroll: function scroll(progress) {
              if (carouselIsInline) {
                _updateTextBlock(progress);
              }
    
              if (!carouselWraps) {
                _updateNavigation(progress);
              }
            }
          }
        }));
        carousel.resize();
        setTimeout(function () {
          _updateNavigationPosition(carousel.size.height);
        }, 1000);
      };
    
      var _updateTextBlock = function _updateTextBlock(progress) {
        if (!textBlock) return;
        var progressScale = progress * 100;
    
        if (textAlignment == 'left') {
          textBlock.classList.toggle('out-of-view', progressScale > 1);
        } else if (textAlignment == 'right') {
          textBlock.classList.toggle('out-of-view', progressScale < 99);
        }
      };
    
      var _updateNavigation = function _updateNavigation(progress) {
        var progressScale = progress * 100; // Need to hide the prev/next navigation if progress meets thresholds
        // https://github.com/metafizzy/flickity/issues/289
    
        navPrevButton.disabled = progressScale < 1;
        navNextButton.disabled = progressScale > 99;
      };
    
      var _initNavigation = function _initNavigation() {
        navPrevButton.addEventListener('click', _previousSlide);
        navNextButton.addEventListener('click', _nextSlide);
    
        if (!carouselWraps && textAlignment == 'right') {
          navNextButton.disabled = true;
        } else if (!carouselWraps) {
          navPrevButton.disabled = true;
        }
      };
    
      var _updateNavigationPosition = function _updateNavigationPosition(carouselHeight) {
        var buttonHeight = navNextButton.clientHeight;
        var containerPadding = parseFloat(window.getComputedStyle(node).getPropertyValue('padding-top'));
        var offset = carouselHeight / 2 - buttonHeight / 2 + containerPadding;
        navNextButton.style[carouselPosition] = "".concat(offset, "px");
        navPrevButton.style[carouselPosition] = "".concat(offset, "px");
        navNextButton.classList.remove('hidden');
        navPrevButton.classList.remove('hidden');
      };
    
      var _nextSlide = function _nextSlide() {
        carousel.next();
      };
    
      var _previousSlide = function _previousSlide() {
        carousel.previous();
      };
    
      _init();
    
      var unload = function unload() {
        carousel.destroy();
        navPrevButton.removeEventListener('click', _previousSlide);
        navNextButton.removeEventListener('click', _nextSlide);
      };
    
      var goToSlide = function goToSlide(index) {
        carousel.select(index);
      };
    
      return {
        unload: unload,
        goToSlide: goToSlide
      };
    };
    
    /* harmony default export */ var components_carousel = (carousel_carousel);
    // CONCATENATED MODULE: ./src/scripts/lib/scrollIntoView.js
    
    
    
    var scrollIntoView_scrollIntoView = function scrollIntoView(container, animatableItems) {
      var animationDelay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var animationPlayedOnLoad = false;
      var previousY = 0;
      var previousRatio = 0;
      var animation = null;
    
      if (animatableItems) {
        animation = anime_es({
          targets: animatableItems,
          opacity: defineProperty_default()({
            value: 1,
            duration: 1000,
            delay: anime_es.stagger(200),
            easing: 'easeInOutSine'
          }, "delay", animationDelay),
          autoplay: false
        });
      }
    
      var observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0
      };
      var observer = new IntersectionObserver(_onIntersection, observerOptions);
      observer.observe(container);
    
      function _onIntersection(entries) {
        entries.forEach(function (entry) {
          var currentY = entry.boundingClientRect.y;
          var currentRatio = entry.intersectionRatio;
          var isIntersecting = entry.isIntersecting;
    
          if (isIntersecting && !animationPlayedOnLoad) {
            animationPlayedOnLoad = true;
    
            _handleContainerInView();
          }
    
          if (currentY < previousY) {
            if (currentRatio > previousRatio && isIntersecting) {
              // Scrolling down and entering view
              _handleContainerInView();
            }
          } else if (currentY > previousY && !isIntersecting) {
            if (currentRatio < previousRatio) {
              // Scrolling up and leaving view
              container.classList.remove('in-view');
            }
          }
    
          previousY = currentY;
          previousRatio = currentRatio;
        });
      }
    
      function _handleContainerInView() {
        if (animation) {
          animation.play();
        }
    
        container.classList.add('in-view');
        observer.disconnect();
      }
    
      var unload = function unload() {
        observer.disconnect();
      };
    
      return {
        unload: unload
      };
    };
    
    /* harmony default export */ var lib_scrollIntoView = (scrollIntoView_scrollIntoView);
    // CONCATENATED MODULE: ./src/scripts/content/blog-posts.js
    
    
    
    var blog_posts_selectors = {
      carousel: '[data-carousel]',
      animatedSlides: '.animates'
    };
    section('blog-posts', {
      onLoad: function onLoad() {
        this.animatedSlides = this.container.querySelectorAll(blog_posts_selectors.animatedSlides);
        this.carouselContainer = this.container.querySelector(blog_posts_selectors.carouselContainer);
    
        if (this.animatedSlides.length > 1) {
          this.carousel = components_carousel(this.container);
        }
    
        if (this.animatedSlides.length) {
          this.scrollAnimation = lib_scrollIntoView(this.container, this.animatedSlides);
        }
      },
      onUnload: function onUnload() {
        this.carousel && this.carousel.unload();
    
        if (this.animatedSlides.length) {
          this.scrollAnimation.unload();
        }
      }
    });
    // CONCATENATED MODULE: ./node_modules/@shopify/theme-product-form/listeners.js
    function Listeners() {
      this.entries = [];
    }
    
    Listeners.prototype.add = function(element, event, fn) {
      this.entries.push({ element: element, event: event, fn: fn });
      element.addEventListener(event, fn);
    };
    
    Listeners.prototype.removeAll = function() {
      this.entries = this.entries.filter(function(listener) {
        listener.element.removeEventListener(listener.event, listener.fn);
        return false;
      });
    };
    
    // CONCATENATED MODULE: ./node_modules/@shopify/theme-product/theme-product.js
    /**
     * Returns a product JSON object when passed a product URL
     * @param {*} url
     */
    function getProductJson(handle) {
      return fetch('/products/' + handle + '.js').then(function(response) {
        return response.json();
      });
    }
    
    /**
     * Find a match in the project JSON (using a ID number) and return the variant (as an Object)
     * @param {Object} product Product JSON object
     * @param {Number} value Accepts Number (e.g. 6908023078973)
     * @returns {Object} The variant object once a match has been successful. Otherwise null will be return
     */
    function getVariantFromId(product, value) {
      _validateProductStructure(product);
    
      if (typeof value !== 'number') {
        throw new TypeError(value + ' is not a Number.');
      }
    
      var result = product.variants.filter(function(variant) {
        return variant.id === value;
      });
    
      return result[0] || null;
    }
    
    /**
     * Convert the Object (with 'name' and 'value' keys) into an Array of values, then find a match & return the variant (as an Object)
     * @param {Object} product Product JSON object
     * @param {Object} collection Object with 'name' and 'value' keys (e.g. [{ name: "Size", value: "36" }, { name: "Color", value: "Black" }])
     * @returns {Object || null} The variant object once a match has been successful. Otherwise null will be returned
     */
    function getVariantFromSerializedArray(product, collection) {
      _validateProductStructure(product);
    
      // If value is an array of options
      var optionArray = _createOptionArrayFromOptionCollection(product, collection);
      return getVariantFromOptionArray(product, optionArray);
    }
    
    /**
     * Find a match in the project JSON (using Array with option values) and return the variant (as an Object)
     * @param {Object} product Product JSON object
     * @param {Array} options List of submitted values (e.g. ['36', 'Black'])
     * @returns {Object || null} The variant object once a match has been successful. Otherwise null will be returned
     */
    function getVariantFromOptionArray(product, options) {
      _validateProductStructure(product);
      _validateOptionsArray(options);
    
      var result = product.variants.filter(function(variant) {
        return options.every(function(option, index) {
          return variant.options[index] === option;
        });
      });
    
      return result[0] || null;
    }
    
    /**
     * Creates an array of selected options from the object
     * Loops through the project.options and check if the "option name" exist (product.options.name) and matches the target
     * @param {Object} product Product JSON object
     * @param {Array} collection Array of object (e.g. [{ name: "Size", value: "36" }, { name: "Color", value: "Black" }])
     * @returns {Array} The result of the matched values. (e.g. ['36', 'Black'])
     */
    function _createOptionArrayFromOptionCollection(product, collection) {
      _validateProductStructure(product);
      _validateSerializedArray(collection);
    
      var optionArray = [];
    
      collection.forEach(function(option) {
        for (var i = 0; i < product.options.length; i++) {
          if (product.options[i].name.toLowerCase() === option.name.toLowerCase()) {
            optionArray[i] = option.value;
            break;
          }
        }
      });
    
      return optionArray;
    }
    
    /**
     * Check if the product data is a valid JS object
     * Error will be thrown if type is invalid
     * @param {object} product Product JSON object
     */
    function _validateProductStructure(product) {
      if (typeof product !== 'object') {
        throw new TypeError(product + ' is not an object.');
      }
    
      if (Object.keys(product).length === 0 && product.constructor === Object) {
        throw new Error(product + ' is empty.');
      }
    }
    
    /**
     * Validate the structure of the array
     * It must be formatted like jQuery's serializeArray()
     * @param {Array} collection Array of object [{ name: "Size", value: "36" }, { name: "Color", value: "Black" }]
     */
    function _validateSerializedArray(collection) {
      if (!Array.isArray(collection)) {
        throw new TypeError(collection + ' is not an array.');
      }
    
      if (collection.length === 0) {
        return [];
      }
    
      if (collection[0].hasOwnProperty('name')) {
        if (typeof collection[0].name !== 'string') {
          throw new TypeError(
            'Invalid value type passed for name of option ' +
              collection[0].name +
              '. Value should be string.'
          );
        }
      } else {
        throw new Error(collection[0] + 'does not contain name key.');
      }
    }
    
    /**
     * Validate the structure of the array
     * It must be formatted as list of values
     * @param {Array} collection Array of object (e.g. ['36', 'Black'])
     */
    function _validateOptionsArray(options) {
      if (Array.isArray(options) && typeof options[0] === 'object') {
        throw new Error(options + 'is not a valid array of options.');
      }
    }
    
    // CONCATENATED MODULE: ./node_modules/@shopify/theme-product-form/theme-product-form.js
    
    
    
    var theme_product_form_selectors = {
      idInput: '[name="id"]',
      optionInput: '[name^="options"]',
      quantityInput: '[name="quantity"]',
      propertyInput: '[name^="properties"]'
    };
    
    // Public Methods
    // -----------------------------------------------------------------------------
    
    /**
     * Returns a URL with a variant ID query parameter. Useful for updating window.history
     * with a new URL based on the currently select product variant.
     * @param {string} url - The URL you wish to append the variant ID to
     * @param {number} id  - The variant ID you wish to append to the URL
     * @returns {string} - The new url which includes the variant ID query parameter
     */
    
    function getUrlWithVariant(url, id) {
      if (/variant=/.test(url)) {
        return url.replace(/(variant=)[^&]+/, '$1' + id);
      } else if (/\?/.test(url)) {
        return url.concat('&variant=').concat(id);
      }
    
      return url.concat('?variant=').concat(id);
    }
    
    /**
     * Constructor class that creates a new instance of a product form controller.
     *
     * @param {Element} element - DOM element which is equal to the <form> node wrapping product form inputs
     * @param {Object} product - A product object
     * @param {Object} options - Optional options object
     * @param {Function} options.onOptionChange - Callback for whenever an option input changes
     * @param {Function} options.onQuantityChange - Callback for whenever an quantity input changes
     * @param {Function} options.onPropertyChange - Callback for whenever a property input changes
     * @param {Function} options.onFormSubmit - Callback for whenever the product form is submitted
     */
    function ProductForm(element, product, options) {
      this.element = element;
      this.product = _validateProductObject(product);
    
      options = options || {};
    
      this._listeners = new Listeners();
      this._listeners.add(
        this.element,
        'submit',
        this._onSubmit.bind(this, options)
      );
    
      this.optionInputs = this._initInputs(
        theme_product_form_selectors.optionInput,
        options.onOptionChange
      );
    
      this.quantityInputs = this._initInputs(
        theme_product_form_selectors.quantityInput,
        options.onQuantityChange
      );
    
      this.propertyInputs = this._initInputs(
        theme_product_form_selectors.propertyInput,
        options.onPropertyChange
      );
    }
    
    /**
     * Cleans up all event handlers that were assigned when the Product Form was constructed.
     * Useful for use when a section needs to be reloaded in the theme editor.
     */
    ProductForm.prototype.destroy = function() {
      this._listeners.removeAll();
    };
    
    /**
     * Getter method which returns the array of currently selected option values
     *
     * @returns {Array} An array of option values
     */
    ProductForm.prototype.options = function() {
      return _serializeOptionValues(this.optionInputs, function(item) {
        var regex = /(?:^(options\[))(.*?)(?:\])/;
        item.name = regex.exec(item.name)[2]; // Use just the value between 'options[' and ']'
        return item;
      });
    };
    
    /**
     * Getter method which returns the currently selected variant, or `null` if variant
     * doesn't exist.
     *
     * @returns {Object|null} Variant object
     */
    ProductForm.prototype.variant = function() {
      return getVariantFromSerializedArray(this.product, this.options());
    };
    
    /**
     * Getter method which returns a collection of objects containing name and values
     * of property inputs
     *
     * @returns {Array} Collection of objects with name and value keys
     */
    ProductForm.prototype.properties = function() {
      var properties = _serializePropertyValues(this.propertyInputs, function(
        propertyName
      ) {
        var regex = /(?:^(properties\[))(.*?)(?:\])/;
        var name = regex.exec(propertyName)[2]; // Use just the value between 'properties[' and ']'
        return name;
      });
    
      return Object.entries(properties).length === 0 ? null : properties;
    };
    
    /**
     * Getter method which returns the current quantity or 1 if no quantity input is
     * included in the form
     *
     * @returns {Array} Collection of objects with name and value keys
     */
    ProductForm.prototype.quantity = function() {
      return this.quantityInputs[0]
        ? Number.parseInt(this.quantityInputs[0].value, 10)
        : 1;
    };
    
    // Private Methods
    // -----------------------------------------------------------------------------
    ProductForm.prototype._setIdInputValue = function(value) {
      var idInputElement = this.element.querySelector(theme_product_form_selectors.idInput);
    
      if (!idInputElement) {
        idInputElement = document.createElement('input');
        idInputElement.type = 'hidden';
        idInputElement.name = 'id';
        this.element.appendChild(idInputElement);
      }
    
      idInputElement.value = value.toString();
    };
    
    ProductForm.prototype._onSubmit = function(options, event) {
      event.dataset = this._getProductFormEventData();
    
      this._setIdInputValue(event.dataset.variant.id);
    
      if (options.onFormSubmit) {
        options.onFormSubmit(event);
      }
    };
    
    ProductForm.prototype._onFormEvent = function(cb) {
      if (typeof cb === 'undefined') {
        return Function.prototype;
      }
    
      return function(event) {
        event.dataset = this._getProductFormEventData();
        cb(event);
      }.bind(this);
    };
    
    ProductForm.prototype._initInputs = function(selector, cb) {
      var elements = Array.prototype.slice.call(
        this.element.querySelectorAll(selector)
      );
    
      return elements.map(
        function(element) {
          this._listeners.add(element, 'change', this._onFormEvent(cb));
          return element;
        }.bind(this)
      );
    };
    
    ProductForm.prototype._getProductFormEventData = function() {
      return {
        options: this.options(),
        variant: this.variant(),
        properties: this.properties(),
        quantity: this.quantity()
      };
    };
    
    function _serializeOptionValues(inputs, transform) {
      return inputs.reduce(function(options, input) {
        if (
          input.checked || // If input is a checked (means type radio or checkbox)
          (input.type !== 'radio' && input.type !== 'checkbox') // Or if its any other type of input
        ) {
          options.push(transform({ name: input.name, value: input.value }));
        }
    
        return options;
      }, []);
    }
    
    function _serializePropertyValues(inputs, transform) {
      return inputs.reduce(function(properties, input) {
        if (
          input.checked || // If input is a checked (means type radio or checkbox)
          (input.type !== 'radio' && input.type !== 'checkbox') // Or if its any other type of input
        ) {
          properties[transform(input.name)] = input.value;
        }
    
        return properties;
      }, {});
    }
    
    function _validateProductObject(product) {
      if (typeof product !== 'object') {
        throw new TypeError(product + ' is not an object.');
      }
    
      if (typeof product.variants[0].options === 'undefined') {
        throw new TypeError(
          'Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route'
        );
      }
    
      return product;
    }
    
    // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/typeof.js
    var helpers_typeof = __webpack_require__(21);
    var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);
    
    // CONCATENATED MODULE: ./src/scripts/lib/product/productForm.js
    
    
    
    var productForm_selectors = {
      idInput: '[name="id"]',
      optionInput: '[name^="options"]',
      quantityInput: '[name="quantity"]',
      propertyInput: '[name^="properties"]'
    };
    var productForm_defaultOptions = {
      variantSelector: productForm_selectors.idInput
    };
    function productForm_ProductForm(form, prod) {
      var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var config = Object.assign({}, productForm_defaultOptions, opts);
      var product = validateProductObject(prod);
      var events = [];
    
      var _addEvent = function _addEvent(element, action, func) {
        element.addEventListener(action, func, true);
        events.push({
          element: element,
          action: action,
          func: func
        });
      };
    
      var getOptions = function getOptions() {
        return productForm_serializeOptionValues(optionInputs, function (item) {
          var regex = /(?:^(options\[))(.*?)(?:\])/;
          item.name = regex.exec(item.name)[2]; // Use just the value between 'options[' and ']'
    
          return item;
        });
      };
    
      var getVariant = function getVariant() {
        return getVariantFromSerializedArray(product, getOptions());
      };
    
      var getProperties = function getProperties() {
        var properties = productForm_serializePropertyValues(propertyInputs, function (propertyName) {
          var regex = /(?:^(properties\[))(.*?)(?:\])/;
          var name = regex.exec(propertyName)[2]; // Use just the value between 'properties[' and ']'
    
          return name;
        });
    
        return Object.entries(properties).length === 0 ? null : properties;
      };
    
      var getQuantity = function getQuantity() {
        return quantityInputs[0] ? Number.parseInt(quantityInputs[0].value, 10) : 1;
      };
    
      var getProductFormEventData = function getProductFormEventData() {
        return {
          options: getOptions(),
          variant: getVariant(),
          properties: getProperties(),
          quantity: getQuantity()
        };
      };
    
      var onFormEvent = function onFormEvent(cb) {
        if (typeof cb === 'undefined') return;
        return function (event) {
          event.dataset = getProductFormEventData();
          cb(event);
        };
      };
    
      var setIdInputValue = function setIdInputValue(value) {
        var idInputElement = form.querySelector(config.variantSelector);
    
        if (!idInputElement) {
          idInputElement = document.createElement('input');
          idInputElement.type = 'hidden';
          idInputElement.name = 'id';
          form.appendChild(idInputElement);
        }
    
        idInputElement.value = value.toString();
      };
    
      var onSubmit = function onSubmit(event) {
        event.dataset = getProductFormEventData();
        setIdInputValue(event.dataset.variant.id);
    
        if (config.onFormSubmit) {
          config.onFormSubmit(event);
        }
      };
    
      var initInputs = function initInputs(selector, cb) {
        var elements = toConsumableArray_default()(form.querySelectorAll(selector));
    
        return elements.map(function (element) {
          _addEvent(element, 'change', onFormEvent(cb));
    
          return element;
        });
      };
    
      _addEvent(form, 'submit', onSubmit);
    
      var optionInputs = initInputs(productForm_selectors.optionInput, config.onOptionChange);
      var quantityInputs = initInputs(productForm_selectors.quantityInput, config.onQuantityChange);
      var propertyInputs = initInputs(productForm_selectors.propertyInput, config.onPropertyChange);
    
      var destroy = function destroy() {
        events.forEach(function (event) {
          event.element.removeEventListener(event.action, event["function"]);
        });
      };
    
      return {
        getVariant: getVariant,
        destroy: destroy
      };
    }
    
    function validateProductObject(product) {
      if (typeof_default()(product) !== 'object') {
        throw new TypeError(product + ' is not an object.');
      }
    
      if (typeof product.variants[0].options === 'undefined') {
        throw new TypeError('Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route');
      }
    
      return product;
    }
    
    function productForm_serializeOptionValues(inputs, transform) {
      return inputs.reduce(function (options, input) {
        if (input.checked || // If input is a checked (means type radio or checkbox)
        input.type !== 'radio' && input.type !== 'checkbox' // Or if its any other type of input
        ) {
            options.push(transform({
              name: input.name,
              value: input.value
            }));
          }
    
        return options;
      }, []);
    }
    
    function productForm_serializePropertyValues(inputs, transform) {
      return inputs.reduce(function (properties, input) {
        if (input.checked || // If input is a checked (means type radio or checkbox)
        input.type !== 'radio' && input.type !== 'checkbox' // Or if its any other type of input
        ) {
            properties[transform(input.name)] = input.value;
          }
    
        return properties;
      }, {});
    }
    // EXTERNAL MODULE: ./node_modules/ftdomdelegate/browser.js
    var browser = __webpack_require__(8);
    var browser_default = /*#__PURE__*/__webpack_require__.n(browser);
    
    // CONCATENATED MODULE: ./src/scripts/lib/storeAvailability.js
    
    
    
    var storeAvailability_selectors = {
      drawerTrigger: '[data-store-availability-drawer-trigger]',
      drawer: '[data-store-availability-drawer]',
      productTitle: '[data-store-availability-product-title]',
      storeList: '[data-store-availability-list-content]'
    };
    
    var storeAvailability_storeAvailability = function storeAvailability(container, product, variant) {
      var storeList = null;
      var currentVariant = variant;
      var delegate = new browser_default.a(container);
    
      var _clickHandler = function _clickHandler(e) {
        e.preventDefault();
        evx_es_r('availability:showMore', function () {
          return {
            product: product,
            variant: currentVariant,
            storeList: storeList
          };
        });
      };
    
      var update = function update(variant) {
        currentVariant = variant;
        var variantSectionUrl = "".concat(container.dataset.baseUrl, "/variants/").concat(variant.id, "/?section_id=store-availability");
        container.innerHTML = '';
        fetch(variantSectionUrl).then(function (response) {
          return response.text();
        }).then(function (storeAvailabilityHTML) {
          if (storeAvailabilityHTML.trim() === '') return; // Remove section wrapper that throws nested sections error
    
          container.innerHTML = storeAvailabilityHTML;
          container.innerHTML = container.firstElementChild.innerHTML;
          storeList = fluorescent_dom_es_n(storeAvailability_selectors.storeList, container);
        });
      }; // Intialize
    
    
      update(variant);
      delegate.on('click', storeAvailability_selectors.drawerTrigger, _clickHandler);
    
      var unload = function unload() {
        container.innerHTML = '';
      };
    
      return {
        unload: unload,
        update: update
      };
    };
    
    /* harmony default export */ var lib_storeAvailability = (storeAvailability_storeAvailability);
    // CONCATENATED MODULE: ./src/scripts/components/productForm.js
    
    
    
    
    
    
    
    
    
    var productForm_theme = theme,
        productForm_strings = productForm_theme.strings.products;
    var productForm_classes = {
      hide: 'hide'
    };
    
    var productForm_productForm = function productForm(formElement) {
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _formElement$dataset = formElement.dataset,
          productHandle = _formElement$dataset.productHandle,
          ajaxEnabled = _formElement$dataset.ajaxEnabled;
      var selector = lib_selectors.product;
      var storeAvailabilityContainer = formElement.querySelector(selector.storeAvailability);
    
      var formSubmit = function formSubmit(evt) {
        if (ajaxEnabled !== 'true') return;
        evt.preventDefault();
        var _evt$dataset = evt.dataset,
            variant = _evt$dataset.variant,
            properties = _evt$dataset.properties,
            quantity = _evt$dataset.quantity;
        var button = formElement.querySelector(selector.addButton);
        button.classList.add('bttn--loading');
        addItem(formElement).then(function () {
          button.classList.remove('bttn--loading');
        });
      };
    
      var defaultConfig = {
        isProductPage: false,
        isFeaturedProduct: false,
        onOptionChange: function onOptionChange(e) {
          return optionChange(e);
        },
        onFormSubmit: formSubmit,
        container: formElement
      };
    
      var _Object$assign = Object.assign(defaultConfig, config),
          isProductPage = _Object$assign.isProductPage,
          isFeaturedProduct = _Object$assign.isFeaturedProduct,
          onOptionChange = _Object$assign.onOptionChange,
          onFormSubmit = _Object$assign.onFormSubmit,
          container = _Object$assign.container;
    
      var form = null;
      var availability = null;
      var product = neon_getProduct(productHandle);
      product(function (data) {
        form = productForm_ProductForm(formElement, data, {
          variantSelector: '#variant-selector',
          onOptionChange: onOptionChange,
          onFormSubmit: onFormSubmit
        });
    
        if (isProductPage) {
          updateRecentProducts(data);
        } // Surface pickup
    
    
        var variant = form.getVariant();
    
        if (storeAvailabilityContainer && variant) {
          availability = lib_storeAvailability(storeAvailabilityContainer, data, variant);
        }
      }); // When the user changes a product option
    
      var optionChange = function optionChange(_ref) {
        var variant = _ref.dataset.variant;
    
        if (!variant) {
          updateBuyButton(formElement);
          updatePrices(variant);
    
          if (availability && storeAvailabilityContainer) {
            availability.unload();
          }
    
          return;
        } // Update URL with selected variant
    
    
        var url = getUrlWithVariant(window.location.href, variant.id);
        window.history.replaceState({
          path: url
        }, '', url); // Update prices to reflect selected variant
    
        updatePrices(variant); // We need to set the id input manually so the Dynamic Checkout Button works
    
        var selectedVariantOpt = formElement.querySelector("".concat(selector.variantSelect, " ").concat(selector.optionById(variant.id)));
        selectedVariantOpt.selected = true; // Update buy button to reflect selected variant
    
        updateBuyButton(formElement, variant); // Update unit pricing
    
        unitPricing_updateUnitPrices(container, variant); // Scroll to variant media
    
        if (isProductPage && variant.featured_media) {
          if (window.matchMedia('(min-width: 60em)').matches) {
            var image = document.querySelector("[data-media-id=\"".concat(variant.featured_media.id, "\"]"));
            image && image.scrollIntoView({
              behavior: 'smooth'
            });
          } else {
            evx_es_r('product:mediaSelect', function () {
              return {
                selectedMedia: variant.featured_media.position - 1
              };
            });
          }
        } // Show variant
    
    
        if (isFeaturedProduct && variant.featured_media) {
          var featureProductImages = container.querySelectorAll('[data-media-id]');
          featureProductImages.forEach(function (element) {
            element.classList.add('hidden');
          });
    
          var _image = container.querySelector("[data-media-id=\"".concat(variant.featured_media.id, "\"]"));
    
          _image.classList.remove('hidden');
        } // Update store availability
    
        if (availability && isFeaturedProduct || availability && isProductPage) {
          availability.update(variant);
        }

        var klPlacement = formElement.querySelector("klarna-placement");
        if(klPlacement) {
          updateKlarnaPlacements(klPlacement, variant);
        }
      };
    
      var updatePrices = function updatePrices(variant) {
        var target = container ? container : formElement;
        var price = target.querySelectorAll(selector.price);
        var comparePrice = target.querySelectorAll(selector.comparePrice);
        var unavailableString = productForm_strings.product.unavailable;
    
        if (!variant) {
          price.forEach(function (el) {
            return el.innerHTML = unavailableString;
          });
          comparePrice.forEach(function (el) {
            return el.innerHTML = '';
          });
          comparePrice.forEach(function (el) {
            return el.classList.add(productForm_classes.hide);
          });
          return;
        }
    
        price.forEach(function (el) {
          return el.innerHTML = neon_formatMoney(variant.price);
        });
    
        if (variant.compare_at_price > variant.price) {
          comparePrice.forEach(function (el) {
            return el.innerHTML = neon_formatMoney(variant.compare_at_price);
          });
          comparePrice.forEach(function (el) {
            return el.classList.remove(productForm_classes.hide);
          });
        } else {
          comparePrice.forEach(function (el) {
            return el.innerHTML = '';
          });
          comparePrice.forEach(function (el) {
            return el.classList.add(productForm_classes.hide);
          });
        }
      };
    
      var unload = function unload() {
        form.destroy();
      };
    
      return {
        unload: unload
      };
    };
    
    /* harmony default export */ var components_productForm = (productForm_productForm);
    // CONCATENATED MODULE: ./src/scripts/components/productItem.js
    
    
    
    
    var productItem_selector = lib_selectors.product;
    
    var productItem_productItem = function productItem(node) {
      var imageWrapper = node.querySelector('.product-item__images');
      var quickShop = node.querySelector('.quick-shop');
      var quickShopButton = node.querySelector('.product-item__quick-shop-button');
      var productFeaturedImage = null;
    
      if (imageWrapper) {
        initImageHover();
      } // A callback method that is fired whenever the user changes the value of an option input.
    
    
      function _onOptionChange(event) {
        var variant = event.dataset.variant;
    
        if (!variant) {
          updateBuyButton(quickShop);
          product_updatePrices(quickShop, variant);
          return;
        } // We need to set the id input manually so the Dynamic Checkout Button works
    
    
        var selectedVariantOpt = quickShop.querySelector("".concat(productItem_selector.variantSelect, " ").concat(productItem_selector.optionById(variant.id)));
        selectedVariantOpt.selected = true;
    
        if (variant.featured_media) {
          updateQuickShopMedia(quickShop, variant.featured_image.src);
        } else {
          updateQuickShopMedia(quickShop, productFeaturedImage);
        }
    
        product_updatePrices(quickShop, variant);
        updateBuyButton(quickShop, variant);
        unitPricing_updateUnitPrices(quickShop, variant);
      }
    
      function handleOver(e) {
        var second = e.target.querySelector('.not-first');
        second?.classList?.add('visible');
      }
    
      function handleOut(e) {
        var second = e.target.querySelector('.not-first');
        second?.classList?.remove('visible');
      }
    
      function handleQuickShop(e) {
        e.preventDefault();
        var formElement = quickShop.querySelector(productItem_selector.form);
        var productForm = null;
        var productHandle = formElement.dataset.productHandle;
        var productJSON = getProduct(productHandle);
        productJSON(function (data) {
          productForm = components_productForm(formElement, {
            onOptionChange: function onOptionChange(e) {
              return _onOptionChange(e);
            }
          });
          productFeaturedImage = data.featured_image;
          evx_es_r('cart:toggle', function (state) {
            return {
              cartOpen: !state.cartOpen,
              quickShopProduct: quickShop
            };
          });
        });
      }
    
      function initImageHover() {
        imageWrapper.addEventListener('mouseover', handleOver);
        imageWrapper.addEventListener('mouseout', handleOut);
      }
    
      if (quickShopButton) {
        quickShopButton.addEventListener('click', handleQuickShop);
      }
    
      var unload = function unload() {
        if (imageWrapper) {
          imageWrapper.removeEventListener('mouseover', handleOver);
          imageWrapper.removeEventListener('mouseout', handleOut);
        }
    
        if (quickShopButton) {
          quickShopButton.removeEventListener('click', handleQuickShop);
        }
      };
    
      return {
        unload: unload
      };
    };
    
    /* harmony default export */ var components_productItem = (productItem_productItem);
    // CONCATENATED MODULE: ./src/scripts/lib/orderCarouselItems.js
    
    
    var orderCarouselItems_orderCarouselItems = function orderCarouselItems(container, slides) {
      var animationSlides = toConsumableArray_default()(slides);
    
      var _container$dataset = container.dataset,
          textPosition = _container$dataset.textPosition,
          textAlignment = _container$dataset.textAlignment;
      var carouselOverhangs = textPosition === 'top';
      var carouselWraps = container.classList.contains('carousel--columns-wrap-around');
    
      if (carouselWraps && carouselOverhangs) {
        // Animate the last overhanging slide first
        animationSlides.unshift(animationSlides.pop());
      } else if (!carouselOverhangs && textAlignment == 'right') {
        // Reverse animation order
        animationSlides.reverse();
      }
    
      return animationSlides;
    };
    
    /* harmony default export */ var lib_orderCarouselItems = (orderCarouselItems_orderCarouselItems);
    // CONCATENATED MODULE: ./src/scripts/content/collection-list.js
    
    
    
    
    
    var collection_list_selectors = {
      carousel: '[data-carousel]',
      animatedSlides: '.animates',
      products: '.product-item'
    };
    section('collection-list', {
      onLoad: function onLoad() {
        var _this = this;
    
        this.animatedSlides = this.container.querySelectorAll(collection_list_selectors.animatedSlides);
        this.carouselContainer = this.container.querySelector(collection_list_selectors.carouselContainer);
        this.carousel = components_carousel(this.container);
        var products = this.container.querySelectorAll(collection_list_selectors.products);
        this.productItems = [];
        
        products.forEach(function (element) {
          _this.productItems.push(components_productItem(element));
        });
    
        if (this.animatedSlides.length) {
          this._initScrollAnimation(lib_orderCarouselItems(this.container, this.animatedSlides));
        }
      },
      _initScrollAnimation: function _initScrollAnimation(items) {
        var textPosition = this.container.dataset.textPosition; // If the caorusle is inline the animation needs to delay
        // to account for text-block fade in.
    
        var animationDelay = textPosition === 'top' ? 0 : 750;
        this.scrollAnimation = lib_scrollIntoView(this.container, items, animationDelay);
      },
      onBlockSelect: function onBlockSelect(_ref) {
        var slide = _ref.target;
        this.carousel.goToSlide(slide.dataset.index);
      },
      onUnload: function onUnload() {
        this.carousel.unload();
        this.productItems.forEach(function (item) {
          return item.unload();
        });
    
        if (this.animatedSlides.length) {
          this.scrollAnimation.unload();
        }
      }
    });
    // CONCATENATED MODULE: ./src/scripts/content/collection-list-grid.js
    
    
    var collection_list_grid_selectors = {
      animatedItems: '.animates'
    };
    section('collection-list-grid', {
      onLoad: function onLoad() {
        this.animatedItems = this.container.querySelectorAll(collection_list_grid_selectors.animatedItems);
    
        if (this.animatedItems.length) {
          this.scrollAnimation = lib_scrollIntoView(this.container, this.animatedItems);
        }
      },
      onUnload: function onUnload() {
        if (this.animatedItems.length) {
          this.scrollAnimation.unload();
        }
      }
    });
    // CONCATENATED MODULE: ./src/scripts/content/custom-content.js
    
    section('custom-content', {
      onLoad: function onLoad() {},
      onUnload: function onUnload() {}
    });
    // CONCATENATED MODULE: ./src/scripts/content/featured-collection.js
    
    
    
    
    
    var featured_collection_selectors = {
      carouselContainer: '.featured-collection__slides',
      animatedSlides: '.animates',
      products: '.product-item'
    };
    section('featured-collection', {
      onLoad: function onLoad() {
        var _this = this;
    
        this.animatedSlides = this.container.querySelectorAll(featured_collection_selectors.animatedSlides);
        this.carouselContainer = this.container.querySelector(featured_collection_selectors.carouselContainer);
        this.carousel = components_carousel(this.container);
        var products = this.container.querySelectorAll(featured_collection_selectors.products);
        this.productItems = [];
        products.forEach(function (element) {
          _this.productItems.push(components_productItem(element));
        });
    
        if (this.animatedSlides.length) {
          this._initScrollAnimation(lib_orderCarouselItems(this.container, this.animatedSlides));
        }
      },
      _initScrollAnimation: function _initScrollAnimation(items) {
        var textPosition = this.container.dataset.textPosition; // If the caorusle is inline the animation needs to delay
        // to account for text-block fade in.
    
        var animationDelay = textPosition === 'top' ? 0 : 750;
        this.scrollAnimation = lib_scrollIntoView(this.container, items, animationDelay);
      },
      onBlockSelect: function onBlockSelect(_ref) {
        var slide = _ref.target;
        this.carousel.goToSlide(slide.dataset.index);
      },
      onUnload: function onUnload() {
        this.carousel.unload();
        this.productItems.forEach(function (item) {
          return item.unload();
        });
    
        if (this.animatedSlides.length) {
          this.scrollAnimation.unload();
        }
      }
    });
    // CONCATENATED MODULE: ./src/scripts/content/featured-collection-grid.js
    
    
    
    var featured_collection_grid_selectors = {
      products: '.product-item',
      animatedItems: '.animates'
    };
    section('featured-collection-grid', {
      onLoad: function onLoad() {
        var _this = this;
    
        this.animatedItems = this.container.querySelectorAll(featured_collection_grid_selectors.animatedItems);
        var products = this.container.querySelectorAll(featured_collection_grid_selectors.products);
        this.productItems = [];
        products.forEach(function (element) {
          _this.productItems.push(components_productItem(element));
        });
    
        if (this.animatedItems.length) {
          this.scrollAnimation = lib_scrollIntoView(this.container, this.animatedItems);
        }
      },
      onUnload: function onUnload() {
        this.productItems.forEach(function (item) {
          return item.unload();
        });
        this.animatedItems.length && this.scrollAnimation.unload();
      }
    });
    // CONCATENATED MODULE: ./src/scripts/lib/media.js
    
    function Media(node) {
      var _window = window,
          Shopify = _window.Shopify,
          YT = _window.YT;
      var elements = fluorescent_dom_es_t('[data-interactive]', node);
      if (!elements.length) return;
      var acceptedTypes = ['video', 'model', 'external_video'];
      var activeMedia = null;
      var featuresLoaded = false;
      var instances = {};
    
      if (featuresLoaded) {
        elements.forEach(initElement);
      }
    
      window.Shopify.loadFeatures([{
        name: 'model-viewer-ui',
        version: '1.0'
      }, {
        name: 'shopify-xr',
        version: '1.0'
      }, {
        name: 'video-ui',
        version: '1.0'
      }], function () {
        featuresLoaded = true;
    
        if ('YT' in window && Boolean(YT.loaded)) {
          elements.forEach(initElement);
        } else {
          window.onYouTubeIframeAPIReady = function () {
            elements.forEach(initElement);
          };
        }
      });
    
      function initElement(el) {
        var _el$dataset = el.dataset,
            mediaId = _el$dataset.mediaId,
            mediaType = _el$dataset.mediaType;
        if (!mediaType || !acceptedTypes.includes(mediaType)) return;
        if (Object.keys(instances).includes(mediaId)) return;
        var instance = {
          id: mediaId,
          type: mediaType,
          container: el,
          media: el.children[0]
        };
    
        switch (instance.type) {
          case 'video':
            instance.player = new Shopify.Plyr(instance.media, {
              loop: {
                active: el.dataset.loop == 'true'
              }
            });
            break;
    
          case 'external_video':
            instance.player = new YT.Player(instance.media);
            break;
    
          case 'model':
            instance.viewer = new Shopify.ModelViewerUI(fluorescent_dom_es_n('model-viewer', el));
            fluorescent_dom_es_e(fluorescent_dom_es_n('.model-poster', el), 'click', function (e) {
              e.preventDefault();
              playModel(instance);
            });
            break;
        }
    
        instances[mediaId] = instance;
    
        if (instance.player) {
          if (instance.type === 'video') {
            instance.player.on('playing', function () {
              pauseActiveMedia(instance);
              activeMedia = instance;
            });
          } else if (instance.type === 'external_video') {
            instance.player.addEventListener('onStateChange', function (event) {
              if (event.data === 1) {
                pauseActiveMedia(instance);
                activeMedia = instance;
              }
            });
          }
        }
      }
    
      function playModel(instance) {
        pauseActiveMedia(instance);
        instance.viewer.play();
        fluorescent_dom_es_u(instance.container, 'model-active');
        activeMedia = instance;
        setTimeout(function () {
          fluorescent_dom_es_n('model-viewer', instance.container).focus();
        }, 300);
      }
    
      function pauseActiveMedia(instance) {
        if (!activeMedia || instance == activeMedia) return;
    
        if (activeMedia.player) {
          if (activeMedia.type === 'video') {
            activeMedia.player.pause();
          } else if (activeMedia.type === 'external_video') {
            activeMedia.player.pauseVideo();
          }
    
          activeMedia = null;
          return;
        }
    
        if (activeMedia.viewer) {
          fluorescent_dom_es_i(activeMedia.container, 'model-active');
          activeMedia.viewer.pause();
          activeMedia = null;
        }
      }
    
      return {
        pauseActiveMedia: pauseActiveMedia
      };
    }
    // CONCATENATED MODULE: ./src/scripts/components/variantPopup.js
    
    
    
    var variantPopup_selectors = {
      variantPopupTrigger: '[data-variant-popup-trigger]'
    };
    
    var variantPopup_variantPopup = function variantPopup(node) {
      var delegate = new browser_default.a(node);
    
      var _variantPopupHandler = function _variantPopupHandler(e) {
        e.preventDefault();
        var modalContentId = e.target.dataset.modalContentId;
        var moreInfoContent = fluorescent_dom_es_n("#".concat(modalContentId), node);
        evx_es_r('modal:open', null, {
          modalContent: moreInfoContent
        });
      };
    
      var unload = function unload() {
        delegate.destroy();
      };
    
      delegate.on('click', variantPopup_selectors.variantPopupTrigger, _variantPopupHandler);
      return {
        unload: unload
      };
    };
    
    /* harmony default export */ var components_variantPopup = (variantPopup_variantPopup);
    // CONCATENATED MODULE: ./src/scripts/content/featured-product.js
    
    
    
    
    
    
    var featured_product_theme = theme,
        featured_product_strings = featured_product_theme.strings.products;
    var featured_product_selectors = {
      imagesContainer: '.featured-product__media',
      images: '.featured-product__image',
      swatches: '[data-product-swatches]',
      chips: '[data-product-chips]',
      quantityInput: '.product-form__quantity',
      socialSharing: '.share',
      productDetailsWrapper: '.featured-product__meta-inner',
      productDescription: '.featured-product__description',
      accordion: '.accordion',
      productForm: '[data-product-form]'
    };
    section('featured-product', {
      onLoad: function onLoad() {
        this.media = Media(this.container);
        var productFormContainer = this.container.querySelector(featured_product_selectors.productForm);
    
        if (productFormContainer) {
          this.productForm = components_productForm(productFormContainer, {
            isProductPage: false,
            isFeaturedProduct: true,
            container: this.container
          });
          this.swatches = createSwatchGroups.call(this, featured_product_selectors.swatches);
          this.chips = createChipGroups.call(this, featured_product_selectors.chips);
          this.quantityInput = quantityInput.call(this, featured_product_selectors.quantityInput);
          this.variantPopup = components_variantPopup(this.container);
        }
    
        this.productDetails = this.container.querySelector(featured_product_selectors.productDetailsWrapper);
    
        this._checkForAccordions();
      },
      _checkForAccordions: function _checkForAccordions() {
        var productDescription = this.container.querySelector(featured_product_selectors.productDescription);
        if (!productDescription) return;
        var descriptionAccordion = productDescription.querySelector(featured_product_selectors.accordion);
        var socialSharing = this.container.querySelector(featured_product_selectors.socialSharing);
    
        if (socialSharing && descriptionAccordion) {
          this._appendSharingToAccordion(socialSharing, descriptionAccordion);
        }
      },
      _appendSharingToAccordion: function _appendSharingToAccordion(share, accordionWrapper) {
        var shareContent = share.outerHTML;
        var shareHeading = featured_product_strings.product.share_heading;
        var accordionItem = "\n      <div class=\"accordion product__share-accordion\">\n        <div class=\"accordion__group\">\n          <a class=\"accordion__label\">".concat(shareHeading, " </a>\n          <div class=\"accordion__text\">").concat(shareContent, "</div>\n        </div>\n      </div>\n    ");
        accordionWrapper.insertAdjacentHTML('afterend', accordionItem);
        var shareAccordion = this.container.querySelector('.product__share-accordion');
        this.accordion = components_accordion(shareAccordion);
      },
      onUnload: function onUnload() {
        this.swatches && this.swatches();
        this.chips && this.chips();
        this.quantityInput && this.quantityInput();
        this.productForm && this.productForm.unload();
        this.accordion && this.accordion.unload();
        this.variantPopup && this.variantPopup.unload();
      }
    });
    // CONCATENATED MODULE: ./src/scripts/lib/a11y.js
    
    
    var a11y_theme = theme,
        a11y_strings = a11y_theme.strings.accessibility;
    
    var a11y_focusFormStatus = function focusFormStatus(node) {
      var formStatus = fluorescent_dom_es_n(lib_selectors.a11y.formStatus, node);
      if (!formStatus) return;
      var focusElement = fluorescent_dom_es_n('[data-form-status]', formStatus);
      focusElement.focus();
    };
    
    var prefersReducedMotion = function prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    };
    
    function backgroundVideoHandler(container) {
      var pause = fluorescent_dom_es_n('.video-pause', container);
      var video = container.getElementsByTagName('VIDEO')[0];
      if (!pause || !video) return;
      var pauseListener = fluorescent_dom_es_e(pause, 'click', function (e) {
        e.preventDefault();
    
        if (video.paused) {
          video.play();
          pause.innerText = a11y_strings.pause_video;
        } else {
          video.pause();
          pause.innerText = a11y_strings.play_video;
        }
      });
      return function () {
        return pauseListener();
      };
    }
    
    
    // CONCATENATED MODULE: ./src/scripts/content/image-with-text.js
    
    
    
    
    var image_with_text_selectors = {
      image: '.image',
      textBlock: '.image-with-text__text-block',
      video: '.image-with-text__video'
    };
    section('image-with-text', {
      animationObserver: null,
      videoHandler: null,
      onLoad: function onLoad() {
        this.textBlock = this.container.querySelector(image_with_text_selectors.textBlock);
        this.image = this.container.querySelector(image_with_text_selectors.image);
        var videoWrapper = this.container.querySelector(image_with_text_selectors.video);
        var animationEnabled = this.container.dataset.animationEnabled;
        this.observerOptions = {
          root: null,
          rootMargin: '0px',
          threshold: 0
        };
    
        if (animationEnabled === 'true' && this.image) {
          this._onScroll = this._onScroll.bind(this);
          this._updateTextPosition = this._updateTextPosition.bind(this);
          this._updateImageScale = this._updateImageScale.bind(this);
    
          this._initAnimationObserver();
        }
    
        this.scrollAnimation = lib_scrollIntoView(this.container);
    
        if (videoWrapper) {
          this.videoHandler = backgroundVideoHandler(this.container);
        }
      },
      _initAnimationObserver: function _initAnimationObserver() {
        // Disable zoom while in customizer or
        // if reduced motion enabled
        if (Shopify.designMode === true || prefersReducedMotion()) return;
        this.animationObserver = new IntersectionObserver(this._handleAnimation.bind(this), this.observerOptions);
        this.animationObserver.observe(this.container);
      },
      _handleAnimation: function _handleAnimation(entries) {
        var _this = this;
    
        entries.forEach(function (entry) {
          var isIntersecting = entry.isIntersecting;
    
          if (isIntersecting) {
            window.addEventListener('scroll', _this._onScroll, {
              capture: true,
              passive: true
            });
          } else {
            window.removeEventListener('scroll', _this._onScroll, {
              capture: true,
              passive: true
            });
          }
        });
      },
      _onScroll: function _onScroll() {
        this.containerHeight = this.container.clientHeight;
        this.scrollOffset = this._getoffsetTop(this.container);
        this.windowHeight = window.innerHeight || document.documentElement.clientHeight;
        this.containerPosition = window.scrollY - this.scrollOffset + this.windowHeight;
    
        if (breakpoints.isLarge()) {
          requestAnimationFrame(this._updateTextPosition);
        } else {
          this.textBlock.style.transform = 'translateY(0px)';
        }
    
        requestAnimationFrame(this._updateImageScale);
      },
      _updateTextPosition: function _updateTextPosition() {
        var containerOffset = (this.containerHeight + this.windowHeight) / 2;
        var positionMulitiplier = 0.15;
        this.textBlock.style.transform = "translateY(".concat((this.containerPosition - containerOffset) * positionMulitiplier, "px)");
      },
      _updateImageScale: function _updateImageScale() {
        var scaleMulitiplier = 0.00015;
        this.image.style.transform = "scale(".concat(1 + this.containerPosition * scaleMulitiplier, ")");
      },
      _getoffsetTop: function _getoffsetTop(el) {
        var rect = el.getBoundingClientRect();
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return rect.top + scrollTop;
      },
      onUnload: function onUnload() {
        if (this.animationObserver) {
          this.animationObserver.disconnect();
        }
    
        this.videoHandler && this.videoHandler();
        this.scrollAnimation.unload();
      }
    });
    // CONCATENATED MODULE: ./src/scripts/content/newsletter.js
    
    
    
    section('newsletter', {
      onLoad: function onLoad() {
        a11y_focusFormStatus(this.container);
        this.scrollAnimation = lib_scrollIntoView(this.container);
      },
      onUnload: function onUnload() {
        this.scrollAnimation.unload();
      }
    });
    // CONCATENATED MODULE: ./src/scripts/content/product-recommendations.js
    
    
    
    var product_recommendations_slideshowOpts = {
      prevNextButtons: false,
      adaptiveHeight: false,
      pageDots: false,
      cellAlign: 'left'
    };
    var product_recommendations_selectors = {
      section: document.querySelector('[data-section-type="product-recommendations"]')?.getAttribute('data-section-id') || 'product-recommendations--static',
      innerContainer: '.product-recommendations__inner',
      productsContainer: '.product-recommendations__products',
      products: '.product-item'
    };
    section('product-recommendations', {
      onLoad: function onLoad() {
        this._getProductRecommendations();
      },
      _getProductRecommendations: function _getProductRecommendations() {
        var _this = this;
    
        var innerContainer = this.container.querySelector(product_recommendations_selectors.innerContainer);
        var _innerContainer$datas = innerContainer.dataset,
            productId = _innerContainer$datas.productId,
            limit = _innerContainer$datas.limit; // Build request URL
    
        var requestUrl = "".concat(window.theme.routes.productRecommendations, "?section_id=").concat(product_recommendations_selectors.section, "&limit=").concat(limit, "&product_id=").concat(productId); // Create request and submit it using Ajax
    
        var request = new XMLHttpRequest();
        request.open('GET', requestUrl);
    
        request.onload = function () {
          if (request.status >= 200 && request.status < 300) {
            var container = document.createElement('div');
            container.innerHTML = request.response;
            innerContainer.parentElement.innerHTML = container.querySelector('.product-recommendations').innerHTML;
    
            _this._initProductItems();
    
            _this._initSlider();
          }
        };
    
        request.send();
      },
      _initProductItems: function _initProductItems() {
        var _this2 = this;
    
        var products = this.container.querySelectorAll(product_recommendations_selectors.products);
        this.productItems = [];
        products.forEach(function (element) {
          _this2.productItems.push(components_productItem(element));
        });
      },
      _initSlider: function _initSlider() {
        var productsContainer = this.container.querySelector(product_recommendations_selectors.productsContainer);
        this.slider = new js_default.a(productsContainer, product_recommendations_slideshowOpts);
        this.slider.resize();
      },
      onUnload: function onUnload() {
        this.productItems.forEach(function (item) {
          return item.unload();
        });
        this.slider.destroy();
      }
    });
    // CONCATENATED MODULE: ./src/scripts/lib/scrollZoom.js
    
    
    var scrollZoom_scrollZoom = function scrollZoom(container, image) {
      var zoomAnimationEnabled = document.body.dataset.zoomAnimationEnabled; // Disable zoom while in customizer or if reduced motion enabled
    
      if (Shopify.designMode === true || prefersReducedMotion() || zoomAnimationEnabled === 'false') return;
      var containerIsFirstElement = false;
      var containerHeight = null;
      var scrollOffset = null;
      var windowHeight = null;
      var containerPosition = null;
      var multiplier = 0.00015;
      var options = {
        root: null,
        rootMargin: '0px',
        threshold: 0
      };
      var observer = new IntersectionObserver(_onIntersection, options);
      observer.observe(container);
    
      function _onIntersection(entries) {
        entries.forEach(function (entry) {
          var isIntersecting = entry.isIntersecting;
    
          if (isIntersecting) {
            window.addEventListener('scroll', _onScroll, {
              capture: true,
              passive: true
            });
          } else {
            window.removeEventListener('scroll', _onScroll, {
              capture: true,
              passive: true
            });
          }
        });
      }
    
      function _onScroll() {
        containerHeight = container.clientHeight; // Get element position from top
    
        scrollOffset = _getoffsetTop(container);
        windowHeight = window.innerHeight || document.documentElement.clientHeight;
    
        if (windowHeight > scrollOffset) {
          containerIsFirstElement = true;
          windowHeight = 0;
        }
    
        containerPosition = window.scrollY - scrollOffset + windowHeight;
        requestAnimationFrame(_updateImageScale);
      }
    
      function _updateImageScale() {
        if (containerIsFirstElement && containerPosition > 0) {
          image.style.transform = "scale(".concat(1 + containerPosition * multiplier, ")");
        } else if (!containerIsFirstElement) {
          image.style.transform = "scale(".concat(1 + containerPosition * multiplier, ")");
        }
      }
    
      function _getoffsetTop(el) {
        var rect = el.getBoundingClientRect();
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return rect.top + scrollTop;
      }
    
      var unload = function unload() {
        observer.disconnect();
      };
    
      return {
        unload: unload
      };
    };
    
    /* harmony default export */ var lib_scrollZoom = (scrollZoom_scrollZoom);
    // CONCATENATED MODULE: ./src/scripts/lib/homePage.js
    var isFirstSectionOnHomepage = function isFirstSectionOnHomepage(node) {
      var body = document.body;
      if (!body.classList.contains('template-index')) return;
      var firstSection = body.querySelector('.section-dynamic');
      var sectionParent = node.parentNode;
      return firstSection === sectionParent;
    };
    
    /* harmony default export */ var homePage = (isFirstSectionOnHomepage);
    // CONCATENATED MODULE: ./src/scripts/lib/pageDots.js
    
    var pageDots_selectors = {
      dots: '.page-dot'
    };
    
    var pageDots_pageDots = function pageDots(container, slider, slideCount) {
      var pageDots = fluorescent_dom_es_t(pageDots_selectors.dots, container);
      var events = [];
      pageDots.forEach(function (dot) {
        events.push(fluorescent_dom_es_e(dot, 'click', function (e) {
          return _handlePageDot(e);
        }));
      });
    
      var _handlePageDot = function _handlePageDot(e) {
        e.preventDefault();
        if (e.target.classList.contains('is-selected')) return; // 3 or more page dots is handled differently than 2 due to having
        // to load aditional slides because of transition animation
    
        if (slideCount > 2) {
          var slideIndex = e.target.dataset.slideIndex;
          slider.select(slideIndex);
          return;
        } // 2 slides actually loads 4 slides, however we are using
        // 2 page dots to fake only showing 2 slides.
    
    
        if (e.target.classList.contains('next')) {
          slider.next();
        } else {
          slider.previous();
        }
      };
    
      var update = function update(cellIndex) {
        var activeClass = 'is-selected';
        pageDots.forEach(function (dot) {
          return fluorescent_dom_es_i(dot, activeClass);
        });
    
        if (slideCount > 2) {
          fluorescent_dom_es_u(pageDots[cellIndex], activeClass);
          return;
        }
    
        fluorescent_dom_es_u(pageDots[cellIndex % 2], activeClass);
      };
    
      var unload = function unload() {
        events.forEach(function (unsubscribe) {
          return unsubscribe();
        });
      };
    
      return {
        update: update,
        unload: unload
      };
    };
    
    /* harmony default export */ var lib_pageDots = (pageDots_pageDots);
    // CONCATENATED MODULE: ./src/scripts/content/slideshow.js
    
    
    function slideshow_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
    
    function slideshow_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { slideshow_ownKeys(Object(source), true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { slideshow_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
    
    
    
    
    
    
    
    
    
    var slideshow_selectors = {
      slideshow: '.js-slideshow',
      slide: '.slideshow__slide',
      images: '.slideshow__image',
      desktopImages: '.slideshow__image--desktop',
      mobileImages: '.slideshow__image--mobile',
      innerImage: '.image__img',
      video: '.slideshow__video'
    };
    section('slideshow', {
      slideshow: null,
      events: [],
      onLoad: function onLoad() {
        var _this = this;
    
        this.slideshowContainer = this.container.querySelector(slideshow_selectors.slideshow);
        this.slides = this.container.querySelectorAll(slideshow_selectors.slide);
        this.slideImagesDesktop = this.container.querySelectorAll(slideshow_selectors.desktopImages);
        this.slideImagesMobile = this.container.querySelectorAll(slideshow_selectors.mobileImages);
        var docStyle = document.documentElement.style;
        this.transformProp = typeof docStyle.transform == 'string' ? 'transform' : 'WebkitTransform';
    
        if (homePage(this.container)) {
          this.container.classList.add('first-full-height');
        }
    
        this._initSlideshow();
    
        if (!is_mobile_default()() && !prefersReducedMotion()) {
          this.observedItems = this.slides.forEach(function (item) {
            var scrollElement = item.querySelector(slideshow_selectors.images);
            return lib_scrollZoom(item, scrollElement);
          });
        }
    
        this.slides.forEach(function (item) {
          var videoWrapper = item.querySelector(slideshow_selectors.video);
    
          if (videoWrapper) {
            _this.events.push(backgroundVideoHandler(item));
          }
        });
        if(this.slideshowContainer.querySelector('.slideshow__video ~ .slideshow__video')){
          setTimeout(() => {
              window.dispatchEvent(new Event('resize'));
          }, "100");
        }
      },
      _initSlideshow: function _initSlideshow() {
        var _this2 = this;
    
        var slideshowOpts = {
          percentPosition: true,
          wrapAround: true,
          prevNextButtons: false,
          adaptiveHeight: true,
          pageDots: false
        };
        var _this$container$datas = this.container.dataset,
            timer = _this$container$datas.timer,
            slideCount = _this$container$datas.slideCount;
        slideshowOpts.autoPlay = parseInt(timer);
    
        if (this.slides.length > 1) {
          this.slideshow = new js_default.a(this.slideshowContainer, slideshow_objectSpread({}, slideshowOpts));
          this.pageDots = lib_pageDots(this.container, this.slideshow, slideCount);
          this.slideshow.on('scroll', function () {
            if (!prefersReducedMotion()) {
              _this2.slideshow.slides.forEach(function (slide, i) {
                _this2._handleSlideScroll(slide, i);
              });
            }
          });
          this.slideshow.on('select', function () {
            _this2.pageDots.update(_this2.slideshow.selectedIndex);
          });
        } else if (this.slides.length === 1) {
          this.slides[0].classList.add('is-selected');
        }
      },
      _handleSlideScroll: function _handleSlideScroll(slide, index) {
        var img;
    
        if (breakpoints.isSmall()) {
          img = this.slideImagesMobile[index];
        } else {
          img = this.slideImagesDesktop[index];
        }
    
        var x = 0;
    
        if (index === 0) {
          x = Math.abs(this.slideshow.x) > this.slideshow.slidesWidth ? this.slideshow.slidesWidth + this.slideshow.x + this.slideshow.slides[this.slideshow.slides.length - 1].outerWidth + slide.target : slide.target + this.slideshow.x;
        } else if (index === this.slideshow.slides.length - 1) {
          x = Math.abs(this.slideshow.x) + this.slideshow.slides[index].outerWidth < this.slideshow.slidesWidth ? slide.target - this.slideshow.slidesWidth + this.slideshow.x - this.slideshow.slides[index].outerWidth : slide.target + this.slideshow.x;
        } else {
          x = slide.target + this.slideshow.x;
        }
    
        img.style[this.transformProp] = 'translateX(' + x * -1 / 2 + 'px)';
      },
      onUnload: function onUnload() {
        if (this.slideshow) {
          this.slideshow.destroy();
          this.pageDots.unload();
        }
    
        this.atBreakpointChange.unload();
        this.events.forEach(function (unsubscribe) {
          return unsubscribe();
        });
      },
      onBlockSelect: function onBlockSelect(_ref) {
        var slide = _ref.target;
    
        if (this.slideshow) {
          this.slideshow.pausePlayer();
          this.slideshow.select(slide.dataset.index, true, true);
        }
      },
      onBlockDeselect: function onBlockDeselect() {
        if (this.slideshow) {
          this.slideshow.unpausePlayer();
        }
      }
    });
    // CONCATENATED MODULE: ./src/scripts/content/slideshow-split.js
    
    
    function slideshow_split_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
    
    function slideshow_split_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { slideshow_split_ownKeys(Object(source), true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { slideshow_split_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
    
    
    
    
    
    
    
    
    
    
    var slideshow_split_selectors = {
      slideshow: '.slideshow-split__slideshow',
      slide: '.slideshow-split__slide',
      innerImage: '.image__img',
      underlay: '.slideshow-split__underlay',
      video: '.slideshow-split__video'
    };
    section('slideshow-split', {
      events: [],
      onLoad: function onLoad() {
        var _this = this;
    
        this.slideshowContainer = this.container.querySelector(slideshow_split_selectors.slideshow);
        this.slides = this.container.querySelectorAll(slideshow_split_selectors.slide);
        var underlay = this.container.querySelector(slideshow_split_selectors.underlay);
    
        if (homePage(this.container)) {
          this.container.classList.add('first-full-height');
        }
    
        if (this.slides.length > 1) {
          this._initSlideshow();
    
          onImagesLoaded(this.container, function () {
            return underlay.classList.remove('hide');
          });
        }
    
        this.scrollAnimation = lib_scrollIntoView(this.container);
    
        if (!is_mobile_default()() && !prefersReducedMotion()) {
          this.observedItems = this.slides.forEach(function (item) {
            var scrollElement = item.querySelectorAll(slideshow_split_selectors.innerImage);
            scrollElement.forEach(function (element) {
              lib_scrollZoom(item, element);
            });
          });
        }
    
        this.slides.forEach(function (item) {
          var videoWrapper = item.querySelector(slideshow_split_selectors.video);
    
          if (videoWrapper) {
            _this.events.push(backgroundVideoHandler(item));
          }
        });
      },
      _initSlideshow: function _initSlideshow() {
        var _this2 = this;
    
        var slideshowOpts = {
          percentPosition: true,
          wrapAround: true,
          prevNextButtons: false,
          adaptiveHeight: false,
          pageDots: false,
          cellAlign: 'left'
        };
        var _this$container$datas = this.container.dataset,
            timer = _this$container$datas.timer,
            slideCount = _this$container$datas.slideCount;
        slideshowOpts.autoPlay = parseInt(timer);
        this.slideshow = new js_default.a(this.slideshowContainer, slideshow_split_objectSpread({}, slideshowOpts));
        this.pageDots = lib_pageDots(this.container, this.slideshow, slideCount);
        this.slideshow.on('select', function () {
          _this2.pageDots.update(_this2.slideshow.selectedIndex);
        });
      },
      onUnload: function onUnload() {
        this.slideshow && this.slideshow.destroy();
        this.scrollAnimation.unload();
        this.events.forEach(function (unsubscribe) {
          return unsubscribe();
        });
      },
      onBlockSelect: function onBlockSelect(_ref) {
        var slide = _ref.target;
    
        if (this.slideshow) {
          this.slideshow.pausePlayer();
          this.slideshow.select(slide.dataset.index);
        }
      },
      onBlockDeselect: function onBlockDeselect() {
        if (this.slideshow) {
          this.slideshow.unpausePlayer();
        }
      }
    });
    // EXTERNAL MODULE: ./node_modules/youtube-player/dist/index.js
    var dist = __webpack_require__(22);
    var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
    
    // EXTERNAL MODULE: ./node_modules/@vimeo/player/dist/player.es.js
    var player_es = __webpack_require__(23);
    
    // CONCATENATED MODULE: ./node_modules/@fluorescent/video/dist/fluorescent-video.es.js
    /* harmony default export */ var fluorescent_video_es = (function(a,n){void 0===n&&(n={});var u,r=n.id,d=n.playerEl,p=n.type;if(r&&p){var y=evx_es_a(),f=y.on,l=y.emit;return"youtube"===p?((u=dist_default()(d)).loadVideoById({videoId:r,suggestedQuality:"large"}),u.stopVideo(),u.on("stateChange",function(e){1===e.data?l("play"):2===e.data&&l("pause")}),u.on("ready",function(){l("ready"),m()})):"vimeo"===p&&((u=new player_es["a" /* default */](d,{id:r})).on("play",function(){return l("play")}),u.on("pause",function(){return l("pause")}),u.ready().then(function(){l("ready"),m()})),{destroy:function(){},on:f,pause:function(){"youtube"===p?u.pauseVideo():"vimeo"===p&&u.pause()},play:function(){"youtube"===p?u.playVideo():"vimeo"===p&&u.play()}}}function m(){var o=fluorescent_dom_es_n("iframe",a),t=o.height/o.width*100,i=o.parentNode;o.height="100%",o.width="100%","youtube"===p?i.style.paddingTop=t+"%":"vimeo"===p&&(i.parentNode.style.paddingTop=t+"%"),l("resized")}});
    
    // CONCATENATED MODULE: ./src/scripts/content/video.js
    
    
    
    var video_selectors = {
      overlay: '.video__overlay',
      player: '.video__player',
      button: '[data-video-trigger]',
      wrapper: '.video__wrapper'
    };
    section('video', {
      videoType: null,
      videoPlayer: null,
      onLoad: function onLoad() {
        this._initPlayer();
    
        this.scrollAnimation = lib_scrollIntoView(this.container);
      },
      _initPlayer: function _initPlayer() {
        var _this$container$datas = this.container.dataset,
            videoId = _this$container$datas.videoId,
            videoType = _this$container$datas.videoType;
        if (!videoId || !videoType) return;
        var overlay = this.container.querySelector(video_selectors.overlay);
        var player = this.container.querySelector(video_selectors.player);
        this.button = this.container.querySelector(video_selectors.button);
        this.video = fluorescent_video_es(this.container, {
          id: videoId,
          type: videoType,
          playerEl: player
        });
        this.video.on('play', function () {
          overlay.classList.remove('visible');
        });
        this.button && this.button.addEventListener('click', this._playVideo.bind(this));
      },
      _playVideo: function _playVideo(e) {
        e.preventDefault();
        this.video.play();
      },
      onUnload: function onUnload() {
        this.video && this.video.destroy();
        this.button && this.button.removeEventListener('click', this.video.play);
        this.scrollAnimation.unload();
      }
    });
    // CONCATENATED MODULE: ./src/scripts/content/quote.js
    
    
    
    
    var quote_slideshowOpts = {
      prevNextButtons: false,
      adaptiveHeight: false,
      wrapAround: true,
      pageDots: false,
      cellAlign: 'center',
      draggable: false,
      fade: true
    };
    section('quote', {
      listeners: [],
      onLoad: function onLoad() {
        var timer = this.container.dataset.timer;
        quote_slideshowOpts.autoPlay = parseInt(timer);
        var quoteContainer = fluorescent_dom_es_n('.quote__container', this.container);
        this.slideshow = new js_default.a(quoteContainer, quote_slideshowOpts);
        this.scrollAnimation = lib_scrollIntoView(this.container);
    
        this._initNavigation();
      },
      _initNavigation: function _initNavigation() {
        var _this = this;
    
        var navNextButton = fluorescent_dom_es_n('.carousel__next-button', this.container);
        var navPrevButton = fluorescent_dom_es_n('.carousel__previous-button', this.container);
        this.listeners.push(fluorescent_dom_es_e(navPrevButton, 'click', function () {
          return _this.slideshow.previous();
        }));
        this.listeners.push(fluorescent_dom_es_e(navNextButton, 'click', function () {
          return _this.slideshow.next();
        }));
      },
      onBlockSelect: function onBlockSelect(_ref) {
        var slide = _ref.target;
        this.slideshow.select(slide.dataset.index);
        this.slideshow.pausePlayer();
      },
      onBlockDeselect: function onBlockDeselect() {
        this.slideshow.unpausePlayer();
      },
      onUnload: function onUnload() {
        this.slideshow.destroy();
        this.scrollAnimation.unload();
        this.listeners.forEach(function (unsub) {
          return unsub();
        });
      }
    });
    // CONCATENATED MODULE: ./src/scripts/content/gallery.js
    
    
    
    
    var gallery_selectors = {
      carouselContainer: '.gallery__slides',
      animatedSlides: '.animates'
    };
    section('gallery', {
      onLoad: function onLoad() {
        this.animatedSlides = this.container.querySelectorAll(gallery_selectors.animatedSlides);
        this.carouselContainer = this.container.querySelector(gallery_selectors.carouselContainer);
        this.carousel = components_carousel(this.container);
    
        if (this.animatedSlides.length) {
          this._initScrollAnimation(lib_orderCarouselItems(this.container, this.animatedSlides));
        }
      },
      _initScrollAnimation: function _initScrollAnimation(items) {
        var textPosition = this.container.dataset.textPosition; // If the caorusle is inline the animation needs to delay
        // to account for text-block fade in.
    
        var animationDelay = textPosition === 'top' ? 0 : 750;
        this.scrollAnimation = lib_scrollIntoView(this.container, items, animationDelay);
      },
      onBlockSelect: function onBlockSelect(_ref) {
        var slide = _ref.target;
        this.carousel.goToSlide(slide.dataset.index);
      },
      onUnload: function onUnload() {
        this.carousel.unload();
    
        if (this.animatedSlides.length) {
          this.scrollAnimation.unload();
        }
      }
    });
    // EXTERNAL MODULE: ./node_modules/google-maps/lib/Google.js
    var Google = __webpack_require__(9);
    var Google_default = /*#__PURE__*/__webpack_require__.n(Google);
    
    // CONCATENATED MODULE: ./src/scripts/content/location.js
    
    
    
    var location_selectors = {
      mapContainer: '.location__map-container',
      mapElement: '.location__map-element'
    };
    var fullMapURL = 'https://www.google.com/maps/place/';
    section('location', {
      onLoad: function onLoad() {
        this._initMap();
    
        this.scrollAnimation = lib_scrollIntoView(this.container);
      },
      _initMap: function _initMap() {
        var _this = this;
    
        this.mapContainer = this.container.querySelector(location_selectors.mapContainer);
        var address = null;
        var apiKey = null;
    
        if (this.mapContainer) {
          address = this.mapContainer.dataset.address;
          apiKey = this.mapContainer.dataset.apiKey;
        }
    
        if (!apiKey || !address) {
          return;
        }
    
        var sectionId = this.container.dataset.sectionId;
        var styledData = document.querySelector("#map-styles-".concat(sectionId));
        var data = JSON.parse(styledData.innerHTML);
        Google_default.a.KEY = apiKey;
        Google_default.a.VERSION = '3.34';
        Google_default.a.LIBRARIES = ['geocoding-api'];
        Google_default.a.load(function (google) {
          var geocoder = new google.maps.Geocoder();
          geocoder.geocode({
            address: address
          }, function (res, status) {
            if (res.length === 0) {
              return console.error("Google Maps Geocoding failed, reason: ".concat(status));
            }
    
            var location = res[0].geometry.location;
            var latLong = {
              lat: location.lat(),
              lng: location.lng()
            };
    
            _this.mapContainer.classList.add('active');
    
            var map = new google.maps.Map(_this.container.querySelector(location_selectors.mapElement), {
              center: latLong,
              zoom: 12,
              styles: data.styles
            });
            var marker = new google.maps.Marker({
              position: latLong,
              map: map
            });
            marker.addListener('click', function () {
              window.open(fullMapURL + address);
            });
          });
        });
      },
      onUnload: function onUnload() {
        Google_default.a.release();
        this.scrollAnimation.unload();
      }
    });
    // CONCATENATED MODULE: ./src/scripts/content/testimonials.js
    
    
    
    
    var testimonials_selectors = {
      carouselContainer: '.testimonials__slides',
      animatedSlides: '.animates'
    };
    section('testimonials', {
      onLoad: function onLoad() {
        this.animatedSlides = this.container.querySelectorAll(testimonials_selectors.animatedSlides);
        this.carouselContainer = this.container.querySelector(testimonials_selectors.carouselContainer);
        this.carousel = components_carousel(this.container);
    
        if (this.animatedSlides.length) {
          this._initScrollAnimation(lib_orderCarouselItems(this.container, this.animatedSlides));
        }
      },
      _initScrollAnimation: function _initScrollAnimation(slides) {
        var textPosition = this.container.dataset.textPosition; // If the caorusle is inline the animation needs to delay
        // to account for text-block fade in.
    
        var animationDelay = textPosition === 'top' ? 0 : 750;
        this.scrollAnimation = lib_scrollIntoView(this.container, slides, animationDelay);
      },
      onBlockSelect: function onBlockSelect(_ref) {
        var slide = _ref.target;
        this.carousel.goToSlide(slide.dataset.index);
      },
      onUnload: function onUnload() {
        this.carousel.unload();
    
        if (this.animatedSlides.length) {
          this.scrollAnimation.unload();
        }
      }
    });
    // CONCATENATED MODULE: ./src/scripts/content/collage.js
    
    
    
    
    var collage_selectors = {
      collageItems: '.collage__item',
      collageItemInner: '.collage__item-inner',
      video: '.collage__video'
    };
    section('collage', {
      observedItems: null,
      onLoad: function onLoad() {
        var _this = this;
    
        this.collageItems = this.container.querySelectorAll(collage_selectors.collageItems);
        this.videoHandlers = [];
        this.observedItems = this.collageItems.forEach(function (item) {
          var scrollElement = item.querySelector(collage_selectors.collageItemInner);
          return lib_scrollZoom(item, scrollElement);
        });
        this.scrollAnimation = lib_scrollIntoView(this.container, this.collageItems);
        this.collageItems.forEach(function (item) {
          var videoWrapper = item.querySelector(collage_selectors.video);
    
          if (videoWrapper) {
            _this.videoHandlers.push(backgroundVideoHandler(item));
          }
        });
      },
      onUnload: function onUnload() {
        if (this.observedItems) {
          this.observedItems.forEach(function (item) {
            return item.unload();
          });
        }
    
        this.scrollAnimation.unload();
        this.videoHandlers.forEach(function (unsubscribe) {
          return unsubscribe();
        });
      },
      onBlockSelect: function onBlockSelect(_ref) {
        var element = _ref.target;
        var y = element.getBoundingClientRect().top + window.pageYOffset - 15;
        window.scrollTo({
          top: y,
          behavior: 'smooth'
        });
      }
    });
    // CONCATENATED MODULE: ./src/scripts/content/text-columns-with-images.js
    
    
    var text_columns_with_images_selectors = {
      sliderContainer: '.text-columns__content',
      animatedItems: '.animates'
    };
    section('text-columns-with-images', {
      animationPlayedOnLoad: false,
      onLoad: function onLoad() {
        this.animatedItems = this.container.querySelectorAll(text_columns_with_images_selectors.animatedItems);
        this.scrollAnimation = lib_scrollIntoView(this.container, this.animatedItems);
      },
      onUnload: function onUnload() {
        this.scrollAnimation.unload();
      }
    });
    // CONCATENATED MODULE: ./src/scripts/content/rich-text.js
    
    
    section('rich-text', {
      onLoad: function onLoad() {
        this.scrollAnimation = lib_scrollIntoView(this.container);
      },
      onUnload: function onUnload() {
        this.scrollAnimation.unload();
      }
    });
    // CONCATENATED MODULE: ./src/scripts/pages/cart.js
    
    section('cart', {
      onLoad: function onLoad() {},
      onUnload: function onUnload() {}
    });
    // CONCATENATED MODULE: ./src/scripts/components/reviewsDrawer.js
    
    
    
    var reviewsDrawer_theme = theme,
        reviewsDrawer_strings = reviewsDrawer_theme.strings.products;
    var reviewsDrawer_selectors = {
      stars: '.spr-summary-starrating',
      totalReviewsContainer: '.spr-summary-actions-togglereviews'
    };
    
    var reviewsDrawer_reviewsDrawer = function reviewsDrawer(node) {
      var closeBtn = node.querySelector('[data-reviews-close]');
      var focusTrap = createFocusTrap(node, {
        allowOutsideClick: true
      });
    
      var open = function open() {
        node.classList.add('is-visible');
        evx_es_r('drawerOverlay:show');
        var reviewsToggle = node.querySelector('.spr-summary-actions-togglereviews');
    
        if (reviewsToggle) {
          reviewsToggle.tabIndex = -1;
        }
    
        setTimeout(function () {
          focusTrap.activate();
        }, 50);
      };
    
      var close = function close() {
        var hideOverlay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        hideOverlay && evx_es_r('drawerOverlay:hide');
        node.classList.remove('is-visible');
        setTimeout(function () {
          focusTrap.deactivate();
        }, 50);
      };
    
      closeBtn.addEventListener('click', close); // Handle Shopify Reviews injection
    
      var handleInjection = function handleInjection() {
        var starRating = node.querySelector(reviewsDrawer_selectors.stars);
        if (!starRating) return;
        var totalReviewsContainer = node.querySelector(reviewsDrawer_selectors.totalReviewsContainer);
        var totalReviews = reviewsDrawer_strings.product.write_review;
    
        if (totalReviewsContainer) {
          var totalReviewsString = totalReviewsContainer.innerText;
          totalReviews = "".concat(totalReviewsString.match(/\d+/g), " ").concat(reviewsDrawer_strings.product.total_reviews);
        }
    
        evx_es_r(constants_events.reviews.added, function () {
          return {
            starRating: starRating,
            totalReviews: totalReviews
          };
        });
        observer.disconnect();
      };
    
      var observer = new MutationObserver(handleInjection); // Watch for Shopify Reviews inject
    
      observer.observe(node, {
        attributes: true,
        childList: true,
        subtree: true
      });
    
      function handleKeyboard(e) {
        if (!node.classList.contains('is-visible')) return;
    
        if (e.key == 'Escape' || e.keyCode === 27 && drawerOpen) {
          close();
        }
      }
    
      var overlayHideListener = evx_es_c('drawerOverlay:hiding', function () {
        return close(false);
      });
      window.addEventListener('keydown', handleKeyboard);
    
      var unload = function unload() {
        closeBtn.removeEventListener('click', close());
        overlayHideListener();
      };
    
      return {
        unload: unload,
        open: open
      };
    };
    
    /* harmony default export */ var components_reviewsDrawer = (reviewsDrawer_reviewsDrawer);
    // CONCATENATED MODULE: ./src/scripts/components/reviews.js
    
    
    
    var reviews_selectors = {
      reviewsFlyout: '[data-reviews-drawer]',
      reviewsContainers: '.product__reviews',
      reviewStars: '.product__reviews-stars',
      reviewsTriggers: '.product__reviews-trigger'
    };
    
    var reviews_reviews = function reviews(node) {
      var reviewsContainers = node.querySelectorAll(reviews_selectors.reviewsContainers);
      var reviewsFlyout = node.querySelector(reviews_selectors.reviewsFlyout);
      var reviewsTriggers = node.querySelectorAll(reviews_selectors.reviewsTriggers);
      var drawer = components_reviewsDrawer(reviewsFlyout);
      var reviewsListener = evx_es_c(constants_events.reviews.added, function (_ref) {
        var starRating = _ref.starRating,
            totalReviews = _ref.totalReviews;
    
        _addReviewDrawerTrigger(totalReviews);
    
        _addReviewStars(starRating);
    
        reviewsContainers.forEach(function (container) {
          container.classList.remove('hidden');
        });
      });
    
      var _openReviewDrawer = function _openReviewDrawer(e) {
        e.preventDefault();
        drawer.open();
      };
    
      var _addReviewStars = function _addReviewStars(stars) {
        reviewsContainers.forEach(function (container) {
          var reviewStars = container.querySelector(reviews_selectors.reviewStars);
    
          if (stars) {
            var starRating = stars.cloneNode(true);
            reviewStars.classList.remove('hidden');
            reviewStars.appendChild(starRating);
          }
        });
      };
    
      var _addReviewDrawerTrigger = function _addReviewDrawerTrigger(totalReviews) {
        reviewsTriggers.forEach(function (trigger) {
          trigger.innerText = totalReviews;
        });
      };
    
      reviewsTriggers.forEach(function (trigger) {
        trigger.addEventListener('click', _openReviewDrawer);
      });
    
      var unload = function unload() {
        reviewsListener();
        drawer.unload();
        reviewsTriggers.forEach(function (trigger) {
          trigger.removeEventListener('click', _openReviewDrawer);
        });
      };
    
      return {
        unload: unload
      };
    };
    
    /* harmony default export */ var components_reviews = (reviews_reviews);
    // CONCATENATED MODULE: ./src/scripts/lib/lightbox.js
    
    
    
    function Lightbox(node) {
      var events = [fluorescent_dom_es_e(fluorescent_dom_es_n('[data-close]', node), 'click', function (e) {
        e.preventDefault();
        close();
      }), fluorescent_dom_es_e(node, 'keydown', function (_ref) {
        var keyCode = _ref.keyCode;
        if (keyCode === 27) close();
      })];
      var trap = createFocusTrap(node);
    
      function open(to) {
        fluorescent_dom_es_u(node, 'active');
        setTimeout(function () {
          fluorescent_dom_es_u(node, 'visible');
          disableBodyScroll();
          trap.activate(); // Scroll to the active slide
    
          if (to) {
            var image = fluorescent_dom_es_n("[data-id=\"".concat(to, "\"]"), node);
            image && image.scrollIntoView();
          }
        }, 50);
      }
    
      function close() {
        fluorescent_dom_es_i(node, 'visible');
        setTimeout(function () {
          fluorescent_dom_es_i(node, 'active');
          enableBodyScroll();
          trap.deactivate();
        }, 300);
      }
    
      function destroy() {
        events.forEach(function (unsubscribe) {
          return unsubscribe();
        });
      }
    
      return {
        destroy: destroy,
        open: open
      };
    }
    // CONCATENATED MODULE: ./src/scripts/pages/product.js
    
    
    function product_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
    
    function product_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { product_ownKeys(Object(source), true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { product_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    var product_theme = theme,
        product_strings = product_theme.strings.products;
    var product_selectors = {
      sectionWrapper: '.product-page-wrapper',
      imagesContainer: '.product__media',
      images: '.media__image',
      swatches: '[data-product-swatches]',
      chips: '[data-product-chips]',
      quantityInput: '.product-form__quantity',
      socialSharing: '.share',
      productDetailsWrapper: '.product__meta-inner',
      productDescription: '.product__description',
      accordion: '.accordion',
      productForm: '[data-product-form]',
      lightboxTrigger: '.product__media-action-button'
    };
    var product_carouselOpts = {
      adaptiveHeight: false,
      arrowShape: 'M27.64 51.03 42.52 35.13 45.43 37.89 34.83 49.09 71.63 49.09 71.63 53.09 34.83 53.09 45.25 64.12 42.52 67.05 27.64 51.03z',
      wrapAround: true,
      pageDots: false,
      watchCSS: true
    };
    section('product', {
      onLoad: function onLoad() {
        var _this = this;
    
        this.media = Media(this.container);
        var productFormContainer = this.container.querySelector(product_selectors.productForm);
        var inYourSpaceButton = this.container.querySelector('.product__view-in-space');
    
        if (is_mobile_default()() && Boolean(inYourSpaceButton)) {
          inYourSpaceButton.classList.add('visible');
        }
    
        this.productForm = components_productForm(productFormContainer, {
          isProductPage: true,
          container: this.container
        });
        this.reviews = components_reviews(this.container);
        this.swatches = createSwatchGroups.call(this, product_selectors.swatches);
        this.chips = createChipGroups.call(this, product_selectors.chips);
        this.quantityInput = quantityInput.call(this, product_selectors.quantityInput);
        this.sectionWrapper = document.querySelector(product_selectors.sectionWrapper);
        this.productDetails = this.container.querySelector(product_selectors.productDetailsWrapper);
        this.variantPopup = components_variantPopup(this.container);
    
        this._initLightbox();
    
        this._initSlider();
    
        this._checkForAccordions();
    
        this._initHeightObserver();
    
        this._wrapTables();
    
        this.mediaUpateListener = evx_es_c('product:mediaSelect', function (_ref) {
          var selectedMedia = _ref.selectedMedia;
          return _this.carousel.select(selectedMedia);
        });
      },
      _initLightbox: function _initLightbox() {
        var _this2 = this;
    
        this.images = this.container.querySelectorAll(product_selectors.images);
        this.lightboxTrigger = this.container.querySelector(product_selectors.lightboxTrigger);
        var lightbox = this.container.querySelector('[data-lightbox]');
        this.lightbox = Lightbox(lightbox);
        this.images.forEach(function (image) {
          image.addEventListener('click', _this2._handleImageClick.bind(_this2));
        });
        this.lightboxTrigger && this.lightboxTrigger.addEventListener('click', this.lightbox.open);
      },
      _handleImageClick: function _handleImageClick(e) {
        e.preventDefault();
        this.lightbox.open(e.currentTarget.dataset.open);
        this.media && this.media.pauseActiveMedia();
      },
      _initSlider: function _initSlider() {
        var _this3 = this;
    
        var imagesContainer = this.container.querySelector(product_selectors.imagesContainer);
        this.carousel = new js_default.a(imagesContainer, product_objectSpread(product_objectSpread({}, product_carouselOpts), {}, {
          on: {
            ready: function ready() {
              if (this.selectedElement.querySelector('[data-media-type="model"]')) {
                this.unbindDrag();
              }
            },
            change: function change() {
              // Disable dragging so user can interact with model
              if (_this3.carousel.selectedElement.querySelector('[data-media-type="model"]')) {
                _this3.carousel.unbindDrag();
              } else {
                _this3.carousel.bindDrag();
              }
            }
          }
        }));
      },
      _checkForAccordions: function _checkForAccordions() {
        var productDescription = this.container.querySelector(product_selectors.productDescription);
        var descriptionAccordion = productDescription.querySelector(product_selectors.accordion);
        var socialSharing = this.container.querySelector(product_selectors.socialSharing);
    
        if (socialSharing && descriptionAccordion) {
          this._appendSharingToAccordion(socialSharing, descriptionAccordion);
        }
      },
      _appendSharingToAccordion: function _appendSharingToAccordion(share, accordionWrapper) {
        var shareContent = share.outerHTML;
        var shareHeading = product_strings.product.share_heading;
        var accordionItem = "\n      <div class=\"accordion product__share-accordion\">\n        <div class=\"accordion__group\">\n          <a class=\"accordion__label\">".concat(shareHeading, " </a>\n          <div class=\"accordion__text\">").concat(shareContent, "</div>\n        </div>\n      </div>\n    ");
        accordionWrapper.insertAdjacentHTML('afterend', accordionItem);
        var shareAccordion = this.container.querySelector('.product__share-accordion');
        this.accordion = components_accordion(shareAccordion);
      },
      _initHeightObserver: function _initHeightObserver() {
        var _this4 = this;
    
        this._handleSectionHeight();
    
        this.heightObserver = lib_heightObserver(function () {
          _this4._handleSectionHeight();
        });
        this.heightObserver.observe(this.productDetails);
      },
      _handleSectionHeight: function _handleSectionHeight() {
        this.detailsHeight = this.productDetails.clientHeight;
        this.viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    
        this._setSectionWrapperHeight();
      },
      _setSectionWrapperHeight: function _setSectionWrapperHeight() {
        this._setRootVar('--product-page-height', breakpoints.isLarge() ? "".concat(this.detailsHeight, "px") : 'unset');
      },
      _wrapTables: function _wrapTables() {
        var tables = this.container.querySelectorAll('table');
        tables.forEach(function (el) {
          var wrapper = document.createElement('div');
          wrapper.classList.add('rte-table');
          el.parentNode.insertBefore(wrapper, el);
          wrapper.appendChild(el);
        });
      },
      _setRootVar: function _setRootVar(name, value) {
        document.documentElement.style.setProperty(name, "".concat(value));
      },
      onUnload: function onUnload() {
        var _this5 = this;
    
        this.lightbox.destroy();
        this.reviews.unload();
        this.swatches && this.swatches();
        this.chips && this.chips();
        this.quantityInput && this.quantityInput();
        this.productForm.unload();
        this.carousel.destroy();
        this.accordion && this.accordion.unload();
        this.heightObserver.unload();
        this.mediaUpateListener();
        this.variantPopup.unload();
        this.images.forEach(function (image) {
          image.removeEventListener('click', _this5._handleImageClick);
        });
        this.lightboxTrigger && this.lightboxTrigger.removeEventListener('click', this.lightbox.open);
      }
    });
    // EXTERNAL MODULE: ./node_modules/domurl/url.min.js
    var url_min = __webpack_require__(24);
    var url_min_default = /*#__PURE__*/__webpack_require__.n(url_min);
    
    // CONCATENATED MODULE: ./node_modules/@fluorescent/collection/dist/fluorescent-collection.es.js
    /* harmony default export */ 
    var fluorescent_collection_es = function (e) {
      var r = new url_min_default.a(e || window.location.href),
        n = r.paths().indexOf("collections") > 0 ? 3 : 2;
        function o(t) {
            var e = r.paths().slice(0, n);
            r.paths([].concat(e, [t]));
        }
        function u() {
            var t = r.paths().filter(Boolean);
            return t[n] ? t[n].split(" ") : [];
        }
        return {
            getState: function () {
                return { handle: r.paths()[1], page: Number(r.query.page) || 1, sort_by: r.query.sort_by || null, sort_limit: r.query.sort_limit || null, tags: u(), url: r.toString().replace(/%20/g, "+") };
            },
            addTags: function (t, e) {
                return (
                    o(
                        []
                            .concat(u(), t)
                            .filter(function (t, e, r) {
                                return r.indexOf(t) == e;
                            })
                            .join(" ")
                    ),
                    delete r.query.page,
                    e(this.getState())
                );
            },
            removeTags: function (t, e) {
                return (
                    o(
                        u()
                            .filter(function (e) {
                                return !t.includes(e);
                            })
                            .join(" ")
                    ),
                    delete r.query.page,
                    e(this.getState())
                );
            },
            setSort: function (t, e) {
              return (r.query.sort_by = t), e(this.getState());
            },
            setLimit: function(l, e) {
              return (r.query.sort_limit = l), e(this.getState());
            },
            clearLimit: function(t) {
              return delete r.query.sort_limit, t(this.getState());
            },
            clearSort: function (t) {
                return delete r.query.sort_by, t(this.getState());
            },
            clearAll: function (t) {
                return delete r.query.sort_by, o(""), t(this.getState());
            },
        };
    };

    
    // CONCATENATED MODULE: ./node_modules/ajaxinate/src/ajaxinate.js
    /* @preserve
     * https://github.com/Elkfox/Ajaxinate
     * Copyright (c) 2017 Elkfox Co Pty Ltd (elkfox.com)
     * MIT License (do not remove above copyright!)
     */
    
    /* Configurable options;
     *
     * method: scroll or click
     * container: selector of repeating content
     * pagination: selector of pagination container
     * offset: number of pixels before the bottom to start loading more on scroll
     * loadingText: 'Loading', The text shown during when appending new content
     * callback: null, callback function after new content is appended
     *
     * Usage;
     *
     * import {Ajaxinate} from 'ajaxinate';
     *
     * new Ajaxinate({
     *   offset: 5000,
     *   loadingText: 'Loading more...',
     * });
     */
    
    /* eslint-env browser */
    function Ajaxinate(config) {
      const settings = config || {};
    
      const defaults = {
        method: 'scroll',
        container: '#AjaxinateContainer',
        pagination: '#AjaxinatePagination',
        offset: 0,
        loadingText: 'Loading',
        callback: null,
      };
    
      // Merge custom configs with defaults
      this.settings = Object.assign(defaults, settings);
    
      // Functions
      this.addScrollListeners = this.addScrollListeners.bind(this);
      this.addClickListener = this.addClickListener.bind(this);
      this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this);
      this.preventMultipleClicks = this.preventMultipleClicks.bind(this);
      this.removeClickListener = this.removeClickListener.bind(this);
      this.removeScrollListener = this.removeScrollListener.bind(this);
      this.removePaginationElement = this.removePaginationElement.bind(this);
      this.destroy = this.destroy.bind(this);
    
      // Selectors
      this.containerElement = document.querySelector(this.settings.container);
      this.paginationElement = document.querySelector(this.settings.pagination);
      this.initialize();
    }
    
    Ajaxinate.prototype.initialize = function initialize() {
      if (!this.containerElement) { return; }
    
      const initializers = {
        click: this.addClickListener,
        scroll: this.addScrollListeners,
      };
    
      initializers[this.settings.method]();
    };
    
    Ajaxinate.prototype.addScrollListeners = function addScrollListeners() {
      if (!this.paginationElement) { return; }
    
      document.addEventListener('scroll', this.checkIfPaginationInView);
      window.addEventListener('resize', this.checkIfPaginationInView);
      window.addEventListener('orientationchange', this.checkIfPaginationInView);
    };
    
    Ajaxinate.prototype.addClickListener = function addClickListener() {
      if (!this.paginationElement) { return; }
    
      this.nextPageLinkElement = this.paginationElement.querySelector('a');
      this.clickActive = true;
    
      if (typeof this.nextPageLinkElement !== 'undefined' && this.nextPageLinkElement !== null) {
        this.nextPageLinkElement.addEventListener('click', this.preventMultipleClicks);
      }
    };
    
    Ajaxinate.prototype.preventMultipleClicks = function preventMultipleClicks(event) {
      event.preventDefault();
    
      if (!this.clickActive) { return; }
    
      this.nextPageLinkElement.innerText = this.settings.loadingText;
      this.nextPageUrl = this.nextPageLinkElement.href;
      this.clickActive = false;
    
      this.loadMore();
    };
    
    Ajaxinate.prototype.checkIfPaginationInView = function checkIfPaginationInView() {
      const top = this.paginationElement.getBoundingClientRect().top - this.settings.offset;
      const bottom = this.paginationElement.getBoundingClientRect().bottom + this.settings.offset;
    
      if (top <= window.innerHeight && bottom >= 0) {
        this.nextPageLinkElement = this.paginationElement.querySelector('a');
        this.removeScrollListener();
    
        if (this.nextPageLinkElement) {
          this.nextPageLinkElement.innerText = this.settings.loadingText;
          this.nextPageUrl = this.nextPageLinkElement.href;
    
          this.loadMore();
        }
      }
    };
    
    Ajaxinate.prototype.loadMore = function loadMore() {
      this.request = new XMLHttpRequest();
    
      this.request.onreadystatechange = function success() {
        if (!this.request.responseXML) { return; }
        if (!this.request.readyState === 4 || !this.request.status === 200) { return; }
    
        const newContainer = this.request.responseXML.querySelectorAll(this.settings.container)[0];
        const newPagination = this.request.responseXML.querySelectorAll(this.settings.pagination)[0];
    
        this.containerElement.insertAdjacentHTML('beforeend', newContainer.innerHTML);
    
        if (typeof newPagination === 'undefined') {
          this.removePaginationElement();
        } else {
          this.paginationElement.innerHTML = newPagination.innerHTML;
    
          if (this.settings.callback && typeof this.settings.callback === 'function') {
            this.settings.callback(this.request.responseXML);
          }
    
          this.initialize();
        }
      }.bind(this);
    
      this.request.open('GET', this.nextPageUrl);
      this.request.responseType = 'document';
      this.request.send();
    };
    
    Ajaxinate.prototype.removeClickListener = function removeClickListener() {
      this.nextPageLinkElement.removeEventListener('click', this.preventMultipleClicks);
    };
    
    Ajaxinate.prototype.removePaginationElement = function removePaginationElement() {
      this.paginationElement.innerHTML = '';
      this.destroy();
    };
    
    Ajaxinate.prototype.removeScrollListener = function removeScrollListener() {
      document.removeEventListener('scroll', this.checkIfPaginationInView);
      window.removeEventListener('resize', this.checkIfPaginationInView);
      window.removeEventListener('orientationchange', this.checkIfPaginationInView);
    };
    
    Ajaxinate.prototype.destroy = function destroy() {
      const destroyers = {
        click: this.removeClickListener,
        scroll: this.removeScrollListener,
      };
    
      destroyers[this.settings.method]();
    
      return this;
    };
    
    /* harmony default export */ var ajaxinate = (Ajaxinate);
    
    // CONCATENATED MODULE: ./src/scripts/lib/shame.js
    // Ajaxinate custmoizer fix https://github.com/Elkfox/Ajaxinate/issues/26
    var AjaxinateShim = function AjaxinateShim(lib) {
      lib.prototype.loadMore = function getTheHtmlOfTheNextPageWithAnAjaxRequest() {
        this.request = new XMLHttpRequest();
    
        this.request.onreadystatechange = function success() {
          if (this.request.readyState === 4 && this.request.status === 200) {
            var parser = new DOMParser();
            var htmlDoc = parser.parseFromString(this.request.responseText, 'text/html');
            var newContainer = htmlDoc.querySelectorAll(this.settings.container)[0];
            var newPagination = htmlDoc.querySelectorAll(this.settings.pagination)[0];
            this.containerElement.insertAdjacentHTML('beforeend', newContainer.innerHTML);
            this.paginationElement.innerHTML = newPagination.innerHTML;
    
            if (this.settings.callback && typeof this.settings.callback === 'function') {
              this.settings.callback(this.request.responseXML);
            }
    
            this.initialize();
            (new Yotpo.API(yotpo)).refreshWidgets();
          }
        }.bind(this);
    
        this.request.open('GET', this.nextPageUrl, false);
        this.request.send();
      };
    };
    // CONCATENATED MODULE: ./node_modules/@fluorescent/storage/dist/fluorescent-storage.es.js
    function fluorescent_storage_es_t(){try{return localStorage.setItem("test","test"),localStorage.removeItem("test"),!0}catch(t){return!1}}function fluorescent_storage_es_e(e){if(fluorescent_storage_es_t())return JSON.parse(localStorage.getItem("neon_"+e))}function fluorescent_storage_es_r(e,r){if(fluorescent_storage_es_t())return localStorage.setItem("neon_"+e,r)}
    
    // CONCATENATED MODULE: ./src/scripts/lib/collection/events.js
    
    var FILTERS_ADD = 'collection:filters:add';
    var FILTERS_REMOVE = 'collection:filters:remove';
    var SORT_SET = 'collection:sort:set';
    var SORT_CLEAR = 'collection:sort:clear';
    var EVERYTHING_CLEAR = 'collection:clear';
    var SORT_SET_PRICE_LIMIT = 'collection:limit:set';
    var SORT_CLEAR_LIMIT = 'collection:limit:clear';
    var events_addFilters = function addFilters(tags) {
      return evx_es_r(FILTERS_ADD, null, {
        tags: tags
      });
    };
    var events_removeFilters = function removeFilters(tags) {
      var fetch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return evx_es_r(FILTERS_REMOVE, null, {
        tags: tags,
        fetch: fetch
      });
    };
    var events_setLimit = function setLimit(value) {
      return evx_es_r(SORT_SET_PRICE_LIMIT, null, {
        limit: value
      });
    };
    var events_clearLimit = function clearLimit() {
      return evx_es_r(SORT_CLEAR_LIMIT, null);
    };
    var events_setSort = function setSort(method) {
      return evx_es_r(SORT_SET, null, {
        method: method
      });
    };    
    var events_clearSort = function clearSort() {
      return evx_es_r(SORT_CLEAR, null);
    };
    var events_clearAll = function clearAll() {
      return evx_es_r(EVERYTHING_CLEAR);
    };    
    var events_filtersAdded = function filtersAdded(cb) {
      return evx_es_c(FILTERS_ADD, cb);
    };
    var events_filtersRemoved = function filtersRemoved(cb) {
      return evx_es_c(FILTERS_REMOVE, cb);
    };
    var events_sortLimitSet = function(cb) {
      return evx_es_c(SORT_SET_PRICE_LIMIT, cb);
    };
    var events_sortLimitCleared = function(cb) {
      return evx_es_c(SORT_CLEAR_LIMIT, cb);
    };
    var events_sortSet = function sortSet(cb) {
      return evx_es_c(SORT_SET, cb);
    };
    var events_sortCleared = function sortCleared(cb) {
      return evx_es_c(SORT_CLEAR, cb);
    };
    var events_everythingCleared = function everythingCleared(cb) {
      return evx_es_c(EVERYTHING_CLEAR, cb);
    };
    // CONCATENATED MODULE: ./src/scripts/lib/collection/sidebar.js
    
    
    
    
    
    
    var sidebar_classes = {
      active: 'active',
      closed: 'closed'
    };
    var sidebar_ls = {
      getClosed: function getClosed() {
        return fluorescent_storage_es_e('closed_sidebar_groups') || [];
      },
      setClosed: function setClosed(val) {
        return fluorescent_storage_es_r('closed_sidebar_groups', JSON.stringify(val));
      }
    };
    var sidebar_sel = {
      heading: '[data-heading]',
      tag: '[data-tag]',
      sort: '[data-sort]',
      limit: '[data-price-limit]',
      getGroup: function getGroup(group) {
        return "[data-group=\"".concat(group, "\"]");
      }
    };
    /* harmony default export */ var sidebar = (function (node) {
      if (!node) return Function();
      var filters = fluorescent_dom_es_t(sidebar_sel.tag, node);
      var sort = fluorescent_dom_es_t(sidebar_sel.sort, node);
      var limit = fluorescent_dom_es_t(sidebar_sel.limit, node);
      var click = fluorescent_dom_es_e(node, 'click', handleClick); // Reconcile filter item ui state
    
      var tagSubscription = evx_es_c('tags', function (_ref) {
        var tags = _ref.tags;
        return filters.forEach(function (f) {
          return fluorescent_dom_es_l(f.parentElement, sidebar_classes.active, tags.includes(f.dataset.tag));
        });
      }); // Reconcile sort item ui state
    
      var sortSubscription = evx_es_c('sort_by', function (_ref2) {
        var sort_by = _ref2.sort_by;
        return sort.forEach(function (m) {
          return fluorescent_dom_es_l(m.parentElement, sidebar_classes.active, m.dataset.sort === sort_by);
        });
      }); // Hide groups that were previously closed by the user
    
      var sortLimitSubscription = evx_es_c('sort_price', function (_ref3) {
        var limit = _ref3.limit;        
        return limit.forEach(function (m) {
          return fluorescent_dom_es_l(m.parentElement, sidebar_classes.active, m.dataset.price_limit === limit);
        });
      });

      var hiddenGroups = sidebar_ls.getClosed();
      hiddenGroups.forEach(function (group) {
        var g = fluorescent_dom_es_n(sidebar_sel.getGroup(group), node);
    
        if (g) {
          fluorescent_dom_es_u(fluorescent_dom_es_n(sidebar_sel.heading, g), sidebar_classes.closed);
          slideUp(g.querySelector('ul'), {
            duration: 1
          });
        }
      });
    
      function handleClick(e) {
        e.preventDefault();
        var _e$target$dataset = e.target.dataset,
            heading = _e$target$dataset.heading,
            tag = _e$target$dataset.tag,
            sort = _e$target$dataset.sort,
            limit = _e$target$dataset.price_limit,
            clear = _e$target$dataset.clear;

        if (clear) {
          events_clearAll();
        }
        if (tag) {
          evx_es_u().tags.includes(tag) ? events_removeFilters([tag]) : events_addFilters([tag]);
        }
    
        if (sort) {
          evx_es_u().sort_by === sort ? events_clearSort() : events_setSort(sort);
        }

        if (limit) {
          evx_es_u().sort_limit === limit ? events_clearLimit() : events_setLimit(limit);
        }
    
        if (heading) {
          var content = e.target.nextElementSibling;
          slideStop(content);
          var current = sidebar_ls.getClosed();
    
          if (isVisible(content)) {
            fluorescent_dom_es_u(e.target, sidebar_classes.closed);
            slideUp(content);
            sidebar_ls.setClosed([].concat(toConsumableArray_default()(current), [heading]));
          } else {
            fluorescent_dom_es_i(e.target, sidebar_classes.closed);
            slideDown(content);
            sidebar_ls.setClosed(current.filter(function (item) {
              return item !== heading;
            }));
          }
        }
      }
    
      return function () {
        click();
        tagSubscription();
        sortSubscription();
        sortLimitSubscription();
      };
    });
    // CONCATENATED MODULE: ./src/scripts/lib/collection/filtering.js
    
    
    
    
    
    
    var filtering_sel = {
      filter: '[data-filter]',
      flyouts: '[data-filter-flyout]',
      button: '[data-button]',
      wash: '[data-filter-wash]',
      tag: '[data-tag]',
      sort: '[data-sort]',
      limit: '[data-price_limit]',
      close: '[data-close-icon]'
    };
    var filtering_classes = {
      active: 'active'
    };
    /* harmony default export */ var filtering = (function (node) {
      var flyouts = fluorescent_dom_es_t(filtering_sel.flyouts, node);
      var wash = fluorescent_dom_es_n(filtering_sel.wash, node);
      var filters = fluorescent_dom_es_t(filtering_sel.tag, node);
      var limit = fluorescent_dom_es_t(filtering_sel.limit, node);
      var sortMethods = fluorescent_dom_es_t("[data-filter-flyout=\"__sort\"] ".concat(filtering_sel.sort));
      var focusTrap = null;
      var events = [fluorescent_dom_es_e(fluorescent_dom_es_t(filtering_sel.filter, node), 'click', clickFlyoutTrigger), fluorescent_dom_es_e(filters, 'click', clickFilter), fluorescent_dom_es_e(sortMethods, 'click', clickSort), fluorescent_dom_es_e(limit, 'click', clickSortPrice), fluorescent_dom_es_e(wash, 'click', clickWash), fluorescent_dom_es_e(fluorescent_dom_es_t(filtering_sel.button, node), 'click', clickButton), fluorescent_dom_es_e(fluorescent_dom_es_t(filtering_sel.close, node), 'click', clickWash)]; // Reconcile filter item ui state
    
      var tagSubscription = evx_es_c('tags', function (_ref) {
        var tags = _ref.tags;
        return filters.forEach(function (f) {
          return fluorescent_dom_es_l(f.parentElement, filtering_classes.active, tags.includes(f.dataset.tag));
        });
      }); // Reconcile sort item ui state
    
      var sortSubscription = evx_es_c('sort_by', function (_ref2) {
        var sort_by = _ref2.sort_by;
        return sortMethods.forEach(function (m) {
          return fluorescent_dom_es_l(m.parentElement, filtering_classes.active, m.dataset.sort === sort_by);
        });
      });

      
      var sortLimitSubscription = evx_es_c('sort_price', function (_ref3) {
        var limit = _ref3.limit;        
        return limit.forEach(function (m) {
          return fluorescent_dom_es_l(m.parentElement, filtering_classes.active, m.dataset.priceLimit === limit);
        });
      });
    
      function clickFlyoutTrigger(e) {
        e.preventDefault();
        var filter = e.currentTarget.dataset.filter;
        var drawer = fluorescent_dom_es_n("[data-filter-flyout=\"".concat(filter, "\"]"), node);
        focusTrap = createFocusTrap(drawer, {
          allowOutsideClick: true
        });
        focusTrap.activate();
        fluorescent_dom_es_u(wash, filtering_classes.active);
        fluorescent_dom_es_u(drawer, filtering_classes.active);
        disableBodyScroll(node, {
          allowTouchMove: function allowTouchMove(el) {
            while (el && el !== document.body) {
              if (el.getAttribute('data-scroll-lock-ignore') !== null) {
                return true;
              }
    
              el = el.parentNode;
            }
          },
          reserveScrollBarGap: true
        });
      }
    
      function clickWash(e) {
        e && e.preventDefault();
        focusTrap && focusTrap.deactivate();
        fluorescent_dom_es_i([].concat(toConsumableArray_default()(flyouts), [wash]), filtering_classes.active);
        enableBodyScroll(node);
      }
    
      function clickFilter(e) {
        e.preventDefault();
        fluorescent_dom_es_l(e.target.parentNode, filtering_classes.active);
      }

      function clickSortPrice(e) {
        e.preventDefault();
        if (fluorescent_dom_es_a(e.currentTarget.parentNode, filtering_classes.active)) return;
        limit.forEach(function (el) {
          return fluorescent_dom_es_l(el.parentNode, filtering_classes.active, el === e.currentTarget);
        });
      }
    
      function clickSort(e) {
        e.preventDefault();
        if (fluorescent_dom_es_a(e.currentTarget.parentNode, filtering_classes.active)) return;
        sortMethods.forEach(function (el) {
          return fluorescent_dom_es_l(el.parentNode, filtering_classes.active, el === e.currentTarget);
        });
      }
    
      function clickButton(e) {
        e.preventDefault();
        var button = e.currentTarget.dataset.button;
        var buttonTarget = e.currentTarget.filter;
        var scope = e.currentTarget.closest(filtering_sel.flyouts);
        var filterFlyout = scope?.dataset?.filterFlyout; // Sort flyouts
    
        if (filterFlyout === '__sort') {
          if (button === 'clear') {

            // Regular filter flyout
            var _filters = fluorescent_dom_es_t(filtering_sel.tag, scope);

            if(_filters.length > 0) {
              fluorescent_dom_es_i(_filters.map(function (f) {
                return f.parentNode;
              }), filtering_classes.active);            
            }
            
            fluorescent_dom_es_i(sortMethods.map(function (el) {
              return el.parentNode;
            }), filtering_classes.active);
          }
    
          if (button === 'apply') {
            var active = fluorescent_dom_es_n(".".concat(filtering_classes.active), scope);

            // Regular filter flyout
            var _filters = fluorescent_dom_es_t(filtering_sel.tag, scope);

            var _limit = fluorescent_dom_es_t(filtering_sel.limit, scope);

            if(_filters.length > 0) {
              var _active = [];
              var inactive = [];
      
              _filters.forEach(function (_ref3) {
                var parentNode = _ref3.parentNode,
                    tag = _ref3.dataset.tag;
                fluorescent_dom_es_a(parentNode, filtering_classes.active) ? _active.push(tag) : inactive.push(tag);
              });
      
              if (inactive.length > 0) {
                events_removeFilters(inactive, _active.length <= 0);
              }
      
              if (_active.length > 0) {
                events_addFilters(_active);
              }
            }

            if(_limit.length > 0) {
              var price = null;

              _limit.forEach(function (_ref4) {
                var parentNode = _ref4.parentNode,
                    limit = _ref4.dataset.price_limit;
                price = fluorescent_dom_es_a(parentNode, filtering_classes.active) ? limit : price;
              });
      
              if (price > 0) {
                events_setLimit(price);
              } else {
                events_clearLimit();
              }
            }

            if (active) {
              events_setSort(active.firstElementChild.dataset.sort);
            } else {
              events_clearSort();
            }
    
            clickWash();
            return;
          }
        } else {
          // Regular filter flyout
          var _filters = fluorescent_dom_es_t(filtering_sel.tag, scope);
    
          if (button === 'clear') {
            if(buttonTarget === 'price') {
              console.log('Clearing The Limit');
              
            } else {
              fluorescent_dom_es_i(_filters.map(function (f) {
                return f.parentNode;
              }), filtering_classes.active);
            }
          }
    
          if (button === 'apply') {
            var _active = [];
            var inactive = [];
    
            _filters.forEach(function (_ref3) {
              var parentNode = _ref3.parentNode,
                  tag = _ref3.dataset.tag;
              fluorescent_dom_es_a(parentNode, filtering_classes.active) ? _active.push(tag) : inactive.push(tag);
            });
    
            if (inactive.length > 0) {
              events_removeFilters(inactive, _active.length <= 0);
            }
    
            if (_active.length > 0) {
              events_addFilters(_active);
            }
    
            clickWash();
          }
        }
      }
    
      return function () {
        // Unsubscribe
        tagSubscription();
        sortSubscription(); // Remove event listeners
        sortLimitSubscription();
        events.forEach(function (unsubscribe) {
          return unsubscribe();
        });
      };
    });
    // CONCATENATED MODULE: ./src/scripts/pages/collection.js
    
    
    
    
    
    
    
    
    
    
    
    var collection_selectors = {
      products: '.product-item',
      infiniteScrollContainer: '.collection__infinite-container',
      infiniteScrollTrigger: '.collection__infinite-trigger',
      sidebar: '[data-sidebar]',
      sidebarStatus: '[data-filter-status]',
      sidebarStatusSource: '[data-filter-status-source]',
      partial: '[data-partial]'      
    };
    section('collection', {
      infiniteScroll: null,
      onLoad: function onLoad() {
        var _this = this;
    
        var paginationType = this.container.dataset.paginationType;
        this.paginationType = paginationType;
        this.infiniteScrollTrigger = fluorescent_dom_es_n(collection_selectors.infiniteScrollTrigger, this.container);
        this.collection = fluorescent_collection_es(window.location.href);
        this.sidebar = sidebar(this.container.querySelector(collection_selectors.sidebar));
        this.filtering = filtering(this.container); // Set initial evx state from collection url object
        this.sidebarStatusBar =  fluorescent_dom_es_n(collection_selectors.sidebarStatus, this.container);

        evx_es_o(this.collection.getState());
        this.partial = fluorescent_dom_es_n(collection_selectors.partial, this.container);
        this.subscriptions = [events_filtersAdded(function (state, _ref) {
          var tags = _ref.tags;
          return _this.collection.addTags(tags, function (data) {
            _this._renderView(data.url);
    
            evx_es_o(data)();
          });
        }), events_filtersRemoved(function (state, _ref2) {
          var tags = _ref2.tags,
              fetch = _ref2.fetch;
    
          _this.collection.removeTags(tags, function (data) {
            if (fetch) {
              _this._renderView(data.url);
    
              evx_es_o(data)();
            }
          });
        }), events_sortSet(function (_, _ref3) {
          var method = _ref3.method;
    
          _this.collection.setSort(method, function (data) {
            _this._renderView(data.url);
    
            evx_es_o(data)();
          });
        }), events_sortLimitSet(function (_, _ref4) {
          var limit = _ref4.limit;
    
          _this.collection.setLimit(limit, function (data) {
            _this._renderView(data.url);
    
            evx_es_o(data)();
          });
        }), events_sortLimitCleared(function () {
          _this.collection.clearLimit(function (data) {
            _this._renderView(data.url);
    
            evx_es_o(data)();
          });
        }), events_sortCleared(function () {
          _this.collection.clearSort(function (data) {
            _this._renderView(data.url);
    
            evx_es_o(data)();
          });
        }), events_everythingCleared(function () {
          _this.collection.clearAll(function (data) {
            _this._renderView(data.url);
    
            evx_es_o(data)();
          });
        })];
        this.delegate = new browser_default.a(this.partial);
        this.delegate.on('click', '[data-pill="filter"]', function (e) {
          e.preventDefault();
          var tag = e.target.dataset.tag;
          events_removeFilters([tag]);
        });
        this.delegate.on('click', '[data-pill="filter"]', function(e){
          e.preventDefault();
          events_clearAll();
        });
        this.delegate.on('click', '[data-pill="sort"]', function (e) {
          e.preventDefault();
          events_clearSort();
        });
        this.delegate.on('click', '[data-clear]', function (e) {
          e.preventDefault();
          events_clearAll();
        });
        this.delegate.on('click', '[data-pagination]', function (e) {
          e.preventDefault();
    
          _this._renderView(e.target.href);
        });
    
        this._initInfiniteScroll();
    
        this._initProductItems();

        this._initUpToFilter();
      },
      _initUpToFilter: function _initUpToFilter() {
        var updateUpTo = function() {
          var params = new URLSearchParams(window.location.search);
          if( params.has('sort_limit') ) {
            var sortLimit = parseInt(params.get('sort_limit'));
            Number.isNaN(sortLimit)
              ? sortLimit = params.get('sort_limit').toString()
              : sortLimit = sortLimit;
            var activeFilter = document.querySelectorAll(`.filter-item [data-price_limit="${sortLimit}"]`);
            var activePriceTag = document.querySelector('[data-pill="price_limit"]');
            if(typeof activeFilter !== "undefined") {              
              Array.from(document.querySelectorAll(`.filter-item [data-price_limit]`)).map(
                  element => { 
                    element.parentNode.classList.remove('active'); 
                  }
              );             
              
              Array.from(activeFilter).map(filter => {
                var activeFilterItem = filter.parentNode;
                activeFilterItem.classList.add('active');
              });
              
              if (sortLimit != 'none') activePriceTag.querySelector('.price_limit').textContent = sortLimit;

              (document.querySelectorAll('.product-item') || []).forEach(productItem => {
                var priceMax = productItem.dataset.maxPrice;
                if(priceMax > sortLimit) {
                  productItem.remove();
                }
              });
            }            
          }
        }
        evx_es_c('collection:updated', updateUpTo);
        updateUpTo();
      },
      _initInfiniteScroll: function _initInfiniteScroll() {
        var paginated = this.paginationType === 'paginated';
        if (paginated) return;
        var infiniteScrollOptions = {
          container: collection_selectors.infiniteScrollContainer,
          pagination: collection_selectors.infiniteScrollTrigger,
          loadingText: 'Loading...',
          callback: function callback() {
            document.dispatchEvent(new Event('attachDOMEvents'));
            return evx_es_r('collection:updated');
          }
        };
    
        if (this.paginationType === 'click') {
          infiniteScrollOptions.method = 'click';
        }
    
        AjaxinateShim(Ajaxinate);
        this.infiniteScroll = new Ajaxinate(infiniteScrollOptions);
      },
      _initProductItems: function _initProductItems() {        
        var _this2 = this;

        if(document.readyState === "complete") {         
          var products = this.container.querySelectorAll(collection_selectors.products);
          this.productItems = [];
          
          products.forEach(function (element) {
            _this2.productItems.push(components_productItem(element));
          });

          var loadCollectionForm = function() {
            if(typeof attachCollectionEvents == "function") {
              const event = new Event('attachDOMEvents');
              document.dispatchEvent(event);
            }
          }  
          evx_es_c('collection:updated', loadCollectionForm);
        } else {
          setTimeout(function() {
            _this2._initProductItems();
          }.bind(_this2), 2000);
        }
      },
      _renderView: function _renderView(url) {
        var _this3 = this;
    
        var loading = fluorescent_dom_es_n('.collection__loading', this.container);
        fluorescent_dom_es_u(loading, 'is-active');
        fetch(url, {
          credentials: 'include'
        }).then(function (res) {
          return res.text();
        }).then(function (res) {
          window.history.pushState({}, '', url);
          var doc = new window.DOMParser().parseFromString(res, 'text/html');
          var contents = fluorescent_dom_es_n(collection_selectors.partial, doc).innerHTML;

          var filterStatus = fluorescent_dom_es_n(collection_selectors.sidebarStatusSource, doc).innerHTML;

          _this3.sidebarStatusBar.innerHTML = filterStatus;
          _this3.partial.innerHTML = contents;
          _this3.infiniteScrollTrigger.innerHTML = '';
    
          _this3._initInfiniteScroll();
    
          fluorescent_dom_es_i(loading, 'is-active');
          evx_es_r('collection:updated');
        });
      },
      onUnload: function onUnload() {
        this.infiniteScroll && this.infiniteScroll.destroy();
        this.productItems.forEach(function (item) {
          return item.unload();
        });
        this.sidebar();
        this.filtering();
        this.delegate.off();
        this.subscriptions.forEach(function (unsubscribe) {
          return unsubscribe();
        });
        this.collectionUpdatedHanlder();
      }
    });
    // CONCATENATED MODULE: ./src/scripts/pages/customers/login.js
    
    var login_selectors = {
      recoverPasswordLink: '#RecoverPassword',
      recoverPasswordForm: '#RecoverPasswordForm',
      hideRecoverPasswordLink: '#HideRecoverPasswordLink',
      customerLoginForm: '#CustomerLoginForm',
      resetFormState: '.reset-password-success',
      resetFormMessage: '#ResetSuccess'
    };
    section('login', {
      onLoad: function onLoad() {
        this.recoverPasswordLink = this.container.querySelector(login_selectors.recoverPasswordLink);
        this.hideRecoverPasswordLink = this.container.querySelector(login_selectors.hideRecoverPasswordLink);
        this.customerLoginForm = this.container.querySelector(login_selectors.customerLoginForm);
        this._onShowHidePasswordForm = this._onShowHidePasswordForm.bind(this);
    
        if (this.recoverPasswordLink) {
          this._checkUrlHash();
    
          this._resetPasswordSuccess();
    
          this.recoverPasswordLink.addEventListener('click', this._onShowHidePasswordForm);
          this.hideRecoverPasswordLink.addEventListener('click', this._onShowHidePasswordForm);
        }
      },
      _onShowHidePasswordForm: function _onShowHidePasswordForm(evt) {
        evt.preventDefault();
    
        this._toggleRecoverPasswordForm();
      },
      _checkUrlHash: function _checkUrlHash() {
        var hash = window.location.hash; // Allow deep linking to recover password form
    
        if (hash === '#recover') {
          this._toggleRecoverPasswordForm();
        }
      },
    
      /**
       *  Show/Hide recover password form
       */
      _toggleRecoverPasswordForm: function _toggleRecoverPasswordForm() {
        var recoverPasswordForm = this.container.querySelector(login_selectors.recoverPasswordForm);
        recoverPasswordForm.classList.toggle('hide');
        this.customerLoginForm.classList.toggle('hide');
      },
    
      /**
       *  Show reset password success message
       */
      _resetPasswordSuccess: function _resetPasswordSuccess() {
        var formState = this.container.querySelector(login_selectors.resetFormState);
        var formMessage = this.container.querySelector(login_selectors.resetFormMessage); // check if reset password form was successfully submited.
    
        if (!formState) {
          return;
        } // show success message
    
    
        formMessage.classList.remove('hide');
      },
      onUnload: function onUnload() {}
    });
    // CONCATENATED MODULE: ./node_modules/@shopify/theme-addresses/theme-addresses.js
    /**
     * CountryProvinceSelector Constructor
     * @param {String} countryOptions the country options in html string
     */
    function CountryProvinceSelector(countryOptions) {
      if (typeof countryOptions !== 'string') {
        throw new TypeError(countryOptions + ' is not a string.');
      }
      this.countryOptions = countryOptions;
    }
    
    /**
     * Builds the country and province selector with the given node element
     * @param {Node} countryNodeElement The <select> element for country
     * @param {Node} provinceNodeElement The <select> element for province
     * @param {Object} options Additional settings available
     * @param {CountryProvinceSelector~onCountryChange} options.onCountryChange callback after a country `change` event
     * @param {CountryProvinceSelector~onProvinceChange} options.onProvinceChange callback after a province `change` event
     */
    CountryProvinceSelector.prototype.build = function (countryNodeElement, provinceNodeElement, options) {
      if (typeof countryNodeElement !== 'object') {
        throw new TypeError(countryNodeElement + ' is not a object.');
      }
    
      if (typeof provinceNodeElement !== 'object') {
        throw new TypeError(provinceNodeElement + ' is not a object.');
      }
    
      var defaultValue = countryNodeElement.getAttribute('data-default');
      options = options || {}
    
      countryNodeElement.innerHTML = this.countryOptions;
      countryNodeElement.value = defaultValue;
    
      if (defaultValue && getOption(countryNodeElement, defaultValue)) {
        var provinces = buildProvince(countryNodeElement, provinceNodeElement, defaultValue);
        options.onCountryChange && options.onCountryChange(provinces, provinceNodeElement, countryNodeElement);
      }
    
      // Listen for value change on the country select
      countryNodeElement.addEventListener('change', function (event) {
        var target = event.target;
        var selectedValue = target.value;
        
        var provinces = buildProvince(target, provinceNodeElement, selectedValue);
        options.onCountryChange && options.onCountryChange(provinces, provinceNodeElement, countryNodeElement);
      });
    
      options.onProvinceChange && provinceNodeElement.addEventListener('change', options.onProvinceChange);
    }
    
    /**
     * This callback is called after a user interacted with a country `<select>`
     * @callback CountryProvinceSelector~onCountryChange
     * @param {array} provinces the parsed provinces
     * @param {Node} provinceNodeElement province `<select>` element
     * @param {Node} countryNodeElement country `<select>` element
     */
    
     /**
     * This callback is called after a user interacted with a province `<select>`
     * @callback CountryProvinceSelector~onProvinceChange
     * @param {Event} event the province selector `change` event object
     */
    
    /**
     * Returns the <option> with the specified value from the
     * given node element
     * A null is returned if no such <option> is found
     */
    function getOption(nodeElement, value) {
      return nodeElement.querySelector('option[value="' + value +'"]')
    }
    
    /**
     * Builds the options for province selector
     */
    function buildOptions (provinceNodeElement, provinces) {
      var defaultValue = provinceNodeElement.getAttribute('data-default');
    
      provinces.forEach(function (option) {
        var optionElement = document.createElement('option');
        optionElement.value = option[0];
        optionElement.textContent = option[1];
    
        provinceNodeElement.appendChild(optionElement);
      })
    
      if (defaultValue && getOption(provinceNodeElement, defaultValue)) {
        provinceNodeElement.value = defaultValue;
      }
    }
    
    /**
     * Builds the province selector
     */
    function buildProvince (countryNodeElement, provinceNodeElement, selectedValue) {
      var selectedOption = getOption(countryNodeElement, selectedValue);
      var provinces = JSON.parse(selectedOption.getAttribute('data-provinces'));
    
      provinceNodeElement.options.length = 0;
    
      if (provinces.length) {
        buildOptions(provinceNodeElement, provinces)
      }
    
      return provinces;
    }
    
    // CONCATENATED MODULE: ./src/scripts/pages/customers/addresses.js
    /**
     * Customer Addresses Script
     * ------------------------------------------------------------------------------
     * A file that contains scripts highly couple code to the Customer Addresses
     * template.
     *
     * @namespace customerAddresses
     */
    
    
    var addresses_selectors = {
      addressContainer: '[data-address]',
      addressToggle: '[data-address-toggle]',
      addressCountry: '[data-address-country]',
      addressProvince: '[data-address-province]',
      addressProvinceWrapper: '[data-address-province-wrapper]',
      addressForm: '[data-address-form]',
      addressDeleteForm: '[data-address-delete-form]'
    };
    var hideClass = 'hide';
    section('addresses', {
      onLoad: function onLoad() {
        var _this = this;
    
        var addresses = this.container.querySelectorAll(addresses_selectors.addressContainer);
    
        if (addresses.length) {
          var countryProvinceSelector = new CountryProvinceSelector(window.theme.allCountryOptionTags);
          addresses.forEach(function (addressContainer) {
            _this._initializeAddressForm(countryProvinceSelector, addressContainer);
          });
        }
      },
      _initializeAddressForm: function _initializeAddressForm(countryProvinceSelector, container) {
        var countrySelector = container.querySelector(addresses_selectors.addressCountry);
        var provinceSelector = container.querySelector(addresses_selectors.addressProvince);
        var provinceWrapper = container.querySelector(addresses_selectors.addressProvinceWrapper);
        var addressForm = container.querySelector(addresses_selectors.addressForm);
        var deleteForm = container.querySelector(addresses_selectors.addressDeleteForm);
        countryProvinceSelector.build(countrySelector, provinceSelector, {
          onCountryChange: function onCountryChange(provinces) {
            return provinceWrapper.classList.toggle(hideClass, !provinces.length);
          }
        });
        container.querySelectorAll(addresses_selectors.addressToggle).forEach(function (button) {
          button.addEventListener('click', function () {
            addressForm.classList.toggle(hideClass);
          });
        });
    
        if (deleteForm) {
          deleteForm.addEventListener('submit', function (event) {
            var confirmMessage = deleteForm.getAttribute('data-confirm-message');
    
            if (!window.confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
              event.preventDefault();
            }
          });
        }
      },
      onUnload: function onUnload() {}
    });
    // CONCATENATED MODULE: ./src/scripts/pages/page.js
    
    section('page', {
      onLoad: function onLoad() {},
      onUnload: function onUnload() {}
    });
    // CONCATENATED MODULE: ./src/scripts/pages/password.js
    
    var password_sel = {
      toggle: '[data-js-toggle]'
    };
    section('password', {
      onLoad: function onLoad() {
        var _this = this;
    
        this.toggleButton = this.container.querySelector(password_sel.toggle);
        this.toggleButton.addEventListener('click', function (e) {
          return _this.toggleView(e);
        });
      },
      onUnload: function onUnload() {
        var _this2 = this;
    
        this.toggleButton.removeEventListener('click', function (e) {
          return _this2.toggleView(e);
        });
      },
      toggleView: function toggleView(e) {
        e.preventDefault();
        this.container.classList.toggle('welcome');
      }
    });
    // CONCATENATED MODULE: ./src/scripts/sections.js
    // Frame sections
    
    
    
     // Content sections
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
     // Pages
    
    
    
    
    
    
    
    
    // CONCATENATED MODULE: ./src/scripts/index.js
    
    
    
    
    
    
    
    
    
     // Import all theme styles
    
     // Initialize lazysizes
    
    
    
    
    
    
     // Import sections
    
     // Load all sections
    
    document.addEventListener('DOMContentLoaded', function () {
      load('*'); // Get cart state before initializing quick cart
    
      fetchCart().then(function (cart) {
        evx_es_o({
          cart: cart
        }); // Setup cart drawer
    
        var cartDrawerElement = document.querySelector('[data-cart-drawer]');
        components_cartDrawer(cartDrawerElement);
      });
    }); // Make it easy to see exactly what theme version
    // this is by commit SHA
    
    window.SHA = "unknown"; // Detect theme editor
    
    if (Shopify.designMode === true) {
      document.documentElement.classList.add('theme-editor');
    } else {
      var scripts_el = document.querySelector('.theme-editor-scroll-offset');
      scripts_el && scripts_el.remove();
    } // Handle all accordion shortcodes
    
    
    var accordions = document.querySelectorAll('.accordion');
    
    if (accordions.length) {
      accordions.forEach(function (item) {
        components_accordion(item);
      });
    } // Setup sticky header
    
    
    var scripts_headerWrapper = document.querySelector('.header-container');
    components_stickyHeader(scripts_headerWrapper); // Setup header overlay
    
    var headerOverlayContainer = document.querySelector('[data-header-overlay]');
    components_headerOverlay(headerOverlayContainer); // Setup drawer overlay
    
    var drawerOverlayContainer = document.querySelector('[data-drawer-overlay]');
    components_drawerOverlay(drawerOverlayContainer); // Setup modal
    
    var modalElement = document.querySelector('[data-modal]');
    components_modal(modalElement); // Prdocut availabilty drawer
    
    var availabilityDrawer = document.querySelector('[data-store-availability-drawer]');
    components_storeAvailabilityDrawer(availabilityDrawer); // Determine if the user is a mouse or keyboard user
    
    function handleFirstTab(e) {
      if (e.keyCode === 9) {
        document.body.classList.add('user-is-tabbing');
        window.removeEventListener('keydown', handleFirstTab);
        window.addEventListener('mousedown', handleMouseDownOnce);
      }
    }
    
    function handleMouseDownOnce() {
      document.body.classList.remove('user-is-tabbing');
      window.removeEventListener('mousedown', handleMouseDownOnce);
      window.addEventListener('keydown', handleFirstTab);
    }
    
    window.addEventListener('keydown', handleFirstTab); // Disable auto zoom on input field for ios devices.
    // https://stackoverflow.com/a/57527009
    
    var addMaximumScaleToMetaViewport = function addMaximumScaleToMetaViewport() {
      var el = document.querySelector('meta[name=viewport]');
    
      if (el !== null) {
        var content = el.getAttribute('content');
        var re = /maximum\-scale=[0-9\.]+/g;
    
        if (re.test(content)) {
          content = content.replace(re, 'maximum-scale=1.0');
        } else {
          content = [content, 'maximum-scale=1.0'].join(', ');
        }
    
        el.setAttribute('content', content);
      }
    };
    
    var disableIosTextFieldZoom = addMaximumScaleToMetaViewport; // https://stackoverflow.com/questions/9038625/detect-if-device-is-ios/9039885#9039885
    
    var checkIsIOS = function checkIsIOS() {
      return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    };
    
    if (checkIsIOS()) {
      disableIosTextFieldZoom();
    } // Wrap all tables
    
    
    var tables = document.querySelectorAll('table');
    tables.forEach(function (el) {
      var wrapper = document.createElement('div');
      wrapper.classList.add('rte-table');
      el.parentNode.insertBefore(wrapper, el);
      wrapper.appendChild(el);
    });
    
    /***/ })
    /******/ ]);
